import React, { useEffect, useMemo, useRef, useState } from 'react';
import { BASE_URL } from '../../../config/axios';
import axios from 'axios';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { AddTransportationInvoice, DutyTravelInvoice, OfficeRentInvoice, OfficeSuppliesInvoice, OfficeFurnitureInvoice, DeleteDutyTravelInvoice, UpdateTransportationInvoice, UpdateDutyTravelInvoice, DeleteTransportationInvoice, ReportsPrinttInvoice, RoadSurveyEquipmentInvoice, UpdateOfficeRentInvoice, DeleteOfficeRent, UpdateOfficeSuppliesInvoice, DeleteOfficeSuppliesInvoice, UpdateFurnitureInvoice, DeleteFurnitureInvoice, UpdateReportsPrinttInvoice, DeleteReportsPrinttInvoice, UpdateRoadSurveyEquipmentInvoice, DeleteRoadSurveyEquipmentInvoice, AddEmployeeInvoice, AddContingenciesinvoice, UpdateContingenciestinvoice, DeleteUpdateContingenciestinvoice, DeleteEmployee, DeleteEmployeeDeduction, DeleteTransportationInvoiceDeduction, DeleteDutyTravelInvoiceDeduction, DeleteOfficeRentDeduction, DeleteOfficeSuppliesInvoiceDeduction, DeleteFurnitureInvoiceDeduction, DeleteReportsPrinttInvoiceDeduction, DeleteRoadSurveyEquipmentInvoiceDeduction, UpdateEmployeeInvoice, UpdateOfficeFurnitureInvoice, RoadSurveyEquipmentInvoiceUpdate, UpdateNewEmployeeInvoice } from './ConsultancyInvoiceComponents';
import ReactToPrint from 'react-to-print';
import { calculateTotal, formatCurrencyIndian, getMonthName, handleErrorToast, isMoreThan24Hours } from '../../CustomFunctions';
import { PaymentReceipt } from './PaymentReceipts';
import usePermission from '../../../config/permissions';
import { UpdateEmployeeDeductionInvoice, UpdateFurnitureDeductionInvoice, UpdateRentDeductionInvoice, UpdateReportsDeductionInvoice, UpdateRoadSurveyDeductionInvoice, UpdateSuppliesDeductionInvoice, UpdateTransportDeductionInvoice, UpdateTravelDeductionInvoice } from './UpdateDeductionInvoices';
import Item from 'antd/es/list/Item';
import { formatDateDD_MM_YYYY, formatDateDDMMYYYY } from '../../Date';
import { FileText } from 'lucide-react';
// import * as XLSX from 'xlsx';           // ← styles ignored
import * as XLSX from 'xlsx-js-style';
import { useImperativeHandle } from 'react';

const ConsultantInvoiceTable = ({ client, p_id, invoice_id, month, year, invoice_num }) => {
    const [consultantInvoiceData, setConsultantInvoiceData] = useState(null);
    const [projectbyid, setprojectbyid] = useState({});

    const project = sessionStorage.getItem('sitemanagement_project');

    const getConsultantInvoice = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/invoice-summary-stats/${p_id ? p_id : project}/${invoice_id}/`
            );
            setConsultantInvoiceData(res.data);
        } catch (err) {
            console.error("Error fetching consultant invoice data:", err);
        }
    };

    const getProjectById = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/siteproject/project/${p_id ? p_id : project}/`);
            setprojectbyid(response.data);
        } catch (error) {
            console.error("Error fetching project by ID:", error);
            handleErrorToast(error);
        }
    };

    useEffect(() => {

        getProjectById();
    }, [p_id, project]);

    useEffect(() => {
        getConsultantInvoice();
    }, [p_id, invoice_id, project]);

    if (!consultantInvoiceData) {
        return <div>Loading...</div>;
    }






    const getDescription = (model) => {
        const descriptions = {
            "Employee": "Remuneration for Local Professional Staff",
            "Transportation": "Transportation",
            "DutyTravel": "Duty Travel to Site",
            "OfficeRent": "Office Rent",
            "OfficeSupplies": "Office Supplies, Utilities and Communication",
            "OfficeFurnitureAndEquipment": "Office Furniture and Equipment",
            "ReportsAndDocumentPrinting": "Report and Document Printing",
            "RoadSurveyEquipment": "Road Survey Equipment",
            "Contingencies": "Contingencies"
        };
        return descriptions[model] || model;  // Default to model name if description not found
    };



    const renderInvoiceRows = () => {
        return consultantInvoiceData.map((item, index) => (
            <tr key={index}>
                <td>{index + 1}</td>
                <td>{getDescription(item.model)}</td>
                <td>{item.contract_amount.toLocaleString()}</td>
                <td>{item.cumulative_preceding.toLocaleString()}</td>
                <td>{item.this_period.toLocaleString()}</td>
                <td>{item.cumulative_including_current.toLocaleString()}</td>
                <td>{item.remaining_amount.toLocaleString()}</td>
            </tr>
        ));
    };



    return (
        <>
            {/* <br /> */}
            <div className='table-css-backgrounds'>
                <div className='print-center show-on-print'>
                    <div className='heading-conslt'>

                        <div className='consultant-heading'>
                            <h5>Client Name: {client}</h5>
                            <h5>Consultant (AE):</h5>
                            <h5>GSTIN No.:</h5>

                            <h5>Ref. No.:</h5>
                            <h5>Approval Date:</h5>
                        </div>
                        <div className='consultant-heading'>
                            <h5>Last date of bid submission:</h5>
                            <h5>Date: {getMonthName(month)}-{year}</h5>
                            <h5>Invoice Number: {invoice_num}</h5>
                        </div>
                    </div>
                </div>
                <div className="table-css-background">
                    <div className='invoice-heading'>
                        <h6>Final Summary Of Consultant Invoice</h6>
                    </div>
                    <table className="nested-table-lightblue">
                        <thead>
                            <tr>
                                <th>S.No.</th>
                                <th>Description</th>
                                <th>Contract Amount</th>
                                <th>Cumulated Total of Preceding Months</th>
                                <th>This Period</th>
                                <th>Cumulated Total including current Invoice</th>
                                <th>Remaining amount against contract value</th>
                            </tr>
                        </thead>
                        <tbody>
                            {renderInvoiceRows()}

                            <tr className='total-amount'>
                                <td></td>
                                <td>Total Amount</td>
                                <td>{consultantInvoiceData.reduce((total, item) => total + item.contract_amount, 0).toLocaleString()}</td>
                                <td>{consultantInvoiceData.reduce((total, item) => total + item.cumulative_preceding, 0).toLocaleString()}</td>
                                <td>{consultantInvoiceData.reduce((total, item) => total + item.this_period, 0).toLocaleString()}</td>
                                <td>{consultantInvoiceData.reduce((total, item) => total + item.cumulative_including_current, 0).toLocaleString()}</td>
                                <td>{consultantInvoiceData.reduce((total, item) => total + item.remaining_amount, 0).toLocaleString()}</td>
                            </tr>
                        </tbody>
                    </table>
                    <br />
                    {/* <div>
                        <h6>Account Details:-</h6>
                    </div>
                    <table className="nested-table-lightblue width-50vw">
                        <tbody>
                            <tr>
                                <td>Name of Account Holder</td>
                                <td>Dhruv Consultancy</td>
                            </tr>
                            <tr>
                                <td>Account No.</td>
                                <td>50200000212287</td>
                            </tr>
                            <tr>
                                <td>Type of Account</td>
                                <td>Current Account</td>
                            </tr>
                            <tr>
                                <td>Name of Bank</td>
                                <td>HDFC Bank LTD.</td>
                            </tr>
                            <tr>
                                <td>IFSC Code</td>
                                <td>HDFC0000830</td>
                            </tr>
                        </tbody>
                    </table> */}
                </div>
            </div>
        </>
    );
};

const ProfessionalStaff = ({ deductionData, p_id, invoice_id, projectData, year, month, invoice_num, logData,
    setPreviousAmount,
    setCurrentAmount,
    setRemainingAmount,
    setContractAmount,
    setCumulated,
    setEotDetails,
    setExcelRows,

    usefor
}) => {
    const [employees, setEmployees] = useState([]);
    const role = sessionStorage.getItem("sitemanagement_role");
    const project = sessionStorage.getItem("sitemanagement_project");

    const getEmployeeInvoice = async () => {
        try {
            let data;

            if (usefor === "generateinvoice") {
                const res = await axios.get(
                    `${BASE_URL}/siteproject/invoiceemployeebyprojectstatus/${p_id ? p_id : project}/${month}/${year}/`
                );
                data = res.data;
            } else {
                const response2 = await axios.get(
                    `${BASE_URL}/siteproject/newinvoiceemployeefiltermonthyear/${invoice_id}/${month}/${year}/`
                );
                data = response2.data;
            }

            const isAnyBoqJsonNull = data.length !== 0 && data.every(item => item.boq_json === null);
            const selectedTransportationData = isAnyBoqJsonNull ? data : data;
            const sortedData = [...selectedTransportationData].sort((a, b) => (a.boq_designation ?? 0) - (b.boq_designation ?? 0));

            setEmployees(sortedData);
        } catch (err) { }
    };

    useEffect(() => {
        getEmployeeInvoice();
    }, [p_id, month, year, project, invoice_id]);

    const normalizeArray = (arr, targetLength) => {
        const normalized = [...arr];
        while (normalized.length < targetLength) {
            normalized.push(0);
        }
        return normalized;
    };

    const renderEmployeeRows = (type) => {
        const grouped = {};

        employees
            .filter(emp => emp.employee_details?.professional_type === type)
            .forEach(emp => {
                const empId = emp.employee;
                if (!grouped[empId]) {
                    grouped[empId] = {
                        base: emp,
                        currentMonths: [],
                        currentInvoices: [],
                        names: [],
                        empcodes: [],
                    };
                }

                grouped[empId].names.push(emp.boq_name_employee);
                grouped[empId].empcodes.push(emp.boq_empcode);
                grouped[empId].currentMonths.push(parseFloat(emp.actual_month || 0));
                grouped[empId].currentInvoices.push(parseFloat(emp.invoice_amount || 0));
            });

        return Object.values(grouped).map((group, index) => {
            const { base, names, empcodes, currentMonths, currentInvoices } = group;

            const ed = base.employee_details;
            const eot = base.eot_details;
            const replacement = base.replacement_deduction;
            const NAME = base.boq_name_employee_two;
            const targetLength = NAME.length || 0;
            const previous_month_list = normalizeArray(base.actual_month_total_previous_two || [], targetLength);
            const previous_amount_list = normalizeArray(base.previous_invoice_total_two || [], targetLength);
            const actual_month_list = normalizeArray(base.actual_month_two || [], targetLength);
            const actual_amount_list = normalizeArray(base.current_invoice_amount_two || [], targetLength);
            const cumulated_month_list = normalizeArray(base.actual_month_cumulative_total_two || [], targetLength);
            const cumulated_amount_list = normalizeArray(base.actual_amount_cumulative_total || [], targetLength);
            const boqRate = parseFloat(base.boq_rate ?? ed.rate) || 0;
            const boqConst = parseFloat(base.boq_construction_period ?? ed.MM_construction_period) || 0;
            const boqOM = parseFloat(base.boq_OM_period ?? ed.MM_OM_period) || 0;
            const totalMM = boqConst + boqOM;
            const totalAmt = boqRate * totalMM;

            const matchedDeductions = deductionData?.filter(
                (d) => d.item_id === base.id
            ) || [];

            const deductionAmount = usefor !== "generateinvoice" && matchedDeductions;
            const deductionMonth = usefor !== "generateinvoice" && matchedDeductions;
            const CREATED_AT = base.created_at;

            const prevInvoiceTotal = parseFloat(base.previous_invoice_total || 0);
            const actualMonthPrev = parseFloat(base.actual_month_total_previous || 0);
            const cumulativeAmt = parseFloat(base.cumulative_invoice_total || 0);
            const cumulativeMonth = parseFloat(base.actual_month_cumulative_total || 0);
            const remainingMonth = parseFloat(base.actual_month_remaining || 0);
            const remainingAmt = parseFloat(base.remaining_amount || 0);

            return (
                <tr className="boc-modern-row" key={base.id + "-" + index}>
                    {/* S.No */}
                    <td className="boc-modern-td text-center">{index + 1}.</td>

                    {/* Position */}
                    <td className="boc-modern-td">
                        <div style={{ width: "100px", whiteSpace: "normal" }}>{ed.designation_name}</div>
                    </td>

                    {/* Name — zebra per item */}
                    <td className="boc-modern-td" style={{ padding: 0 }}>
                        {NAME.length > 0
                            ? NAME.map((n, i) => (
                                <div key={i} className="boc-multi-item">
                                    {n}
                                </div>
                            ))
                            : <div className="boc-multi-item">TBN</div>
                        }
                    </td>

                    {/* Rate */}
                    <td className="boc-modern-td boc-nowrap boc-modern-currency text-right">
                        ₹ {formatCurrencyIndian(boqRate.toFixed(0))}
                    </td>

                    {/* Const */}
                    <td className="boc-modern-td boc-nowrap text-right">{boqConst.toFixed(0)}</td>

                    {/* Maint */}
                    <td className="boc-modern-td boc-nowrap text-right">{boqOM.toFixed(0)}</td>

                    {/* No. of MM */}
                    <td className="boc-modern-td boc-nowrap text-right">{totalMM.toFixed(0)}</td>

                    {/* Total Amount */}
                    <td className="boc-modern-td boc-nowrap text-right">
                        <span className="boc-modern-td boc-nowrap boc-modern-currency boc-modern-total-highlight text-right">
                            ₹ {formatCurrencyIndian(totalAmt)}
                        </span>
                    </td>

                    {/* Replacement — zebra per item */}
                    <td className="boc-modern-td boc-nowrap text-right justify-end" style={{ padding: 0 }}>
                        {replacement.length > 0
                            ? replacement.map((r, i) => (
                                <div key={i} className="boc-multi-item boc-nowrap">
                                    {r ? formatCurrencyIndian(r) : "0"}
                                </div>
                            ))
                            : <div className="boc-multi-item">0</div>
                        }
                    </td>

                    {/* Deduction Month — zebra per item */}
                    {usefor !== "generateinvoice" && (
                        <td className="boc-modern-td boc-nowrap text-right justify-end" style={{ padding: 0 }}>
                            {deductionMonth?.length > 0
                                ? deductionMonth.map((n, i) => (
                                    <div key={i} className="boc-multi-item boc-nowrap">
                                        {Number(n.deduction_month).toFixed(2) ?? 0}
                                    </div>
                                ))
                                : <div className="boc-multi-item">0</div>
                            }
                        </td>
                    )}

                    {/* Deduction Amount — zebra per item */}
                    {usefor !== "generateinvoice" && (
                        <td className="boc-modern-td boc-nowrap text-right justify-end" style={{ padding: 0 }}>
                            {deductionAmount?.length > 0
                                ? deductionAmount.map((n, i) => (
                                    <div key={i} className="boc-multi-item boc-nowrap">
                                        {Number(n.deduction_amount) + Number(n.withheld_deduction_amount) || 0}
                                    </div>
                                ))
                                : <div className="boc-multi-item">0</div>
                            }
                        </td>
                    )}

                    {/* EOT */}
                    {eot?.length > 0 && eot.map((i, idx) => (
                        <React.Fragment key={idx}>
                            <td className="boc-modern-td boc-nowrap text-right">{i.cp}</td>
                            <td className="boc-modern-td boc-nowrap text-right">{i.dlp}</td>
                            <td className="boc-modern-td boc-nowrap text-right">{i.t_month}</td>
                            <td className="boc-modern-td boc-nowrap boc-modern-currency text-right justify-end">
                                ₹ {formatCurrencyIndian(Number(i.rate) || 0)}
                            </td>
                            <td className="boc-modern-td boc-nowrap boc-modern-currency text-right justify-end">
                                ₹ {formatCurrencyIndian(Number(i.total_amount) || 0)}
                            </td>
                        </React.Fragment>
                    ))}

                    {/* Previous Month — zebra per item */}
                    <td className="boc-modern-td boc-nowrap text-right justify-end" style={{ padding: 0 }}>
                        {previous_month_list.length > 0
                            ? previous_month_list.map((n, i) => (
                                <div key={i} className="boc-multi-item boc-nowrap">
                                    {Number(n).toFixed(2) || 0}
                                </div>
                            ))
                            : <div className="boc-multi-item">0</div>
                        }
                    </td>

                    {/* Previous Amount — zebra per item */}
                    <td className="boc-modern-td boc-nowrap boc-modern-currency text-right justify-end" style={{ padding: 0 }}>
                        {previous_amount_list.length > 0
                            ? previous_amount_list.map((n, i) => (
                                <div key={i} className="boc-multi-item boc-nowrap">
                                    {n}
                                </div>
                            ))
                            : <div className="boc-multi-item">0</div>
                        }
                    </td>

                    {/* Current Month — zebra per item */}
                    <td className="boc-modern-td boc-nowrap text-right justify-end" style={{ padding: 0 }}>
                        {actual_month_list.length > 0
                            ? actual_month_list.map((n, i) => (
                                <div key={i} className="boc-multi-item boc-nowrap">
                                    {Number(n).toFixed(2) || 0}
                                </div>
                            ))
                            : <div className="boc-multi-item">0</div>
                        }
                    </td>

                    {/* Current Amount — zebra per item */}
                    <td className="boc-modern-td boc-nowrap boc-modern-currency text-right justify-end" style={{ padding: 0 }}>
                        {actual_amount_list.length > 0
                            ? actual_amount_list.map((n, i) => (
                                <div key={i} className="boc-multi-item boc-nowrap">
                                    {formatCurrencyIndian(Number(n)) || 0}
                                </div>
                            ))
                            : <div className="boc-multi-item">0</div>
                        }
                    </td>

                    {/* Cumulative Month — zebra per item */}
                    <td className="boc-modern-td boc-nowrap text-right" style={{ padding: 0 }}>
                        {cumulated_month_list.length > 0
                            ? cumulated_month_list.map((n, i) => (
                                <div key={i} className="boc-multi-item boc-nowrap justify-end">
                                    {Number(n).toFixed(2) || 0}
                                </div>
                            ))
                            : <div className="boc-multi-item">0</div>
                        }
                    </td>

                    {/* Cumulative Amount — zebra per item */}
                    <td className="boc-modern-td boc-nowrap " style={{ padding: 0 }}>

                        {cumulated_amount_list.length > 0
                            ? cumulated_amount_list.map((n, i) => (
                                <div key={i} className="boc-multi-item boc-nowrap  justify-end">
                                    <span>
                                        {formatCurrencyIndian(Number(n)) || 0}
                                    </span>
                                </div>
                            ))
                            : <div className="boc-multi-item">0</div>
                        }
                    </td>

                    {/* Remaining Month */}
                    <td className="boc-modern-td boc-nowrap text-right">{remainingMonth.toFixed(2)}</td>

                    {/* Remaining Amount */}
                    <td className="boc-modern-td boc-nowrap text-right">
                        <span className="boc-modern-td boc-nowrap boc-modern-currency boc-modern-total-highlight text-right">
                            ₹{formatCurrencyIndian(remainingAmt)}
                        </span>
                    </td>


                    {/* Action */}
                    {(usefor === "generateinvoice" || role !== "ViewAccess") && (
                        <>
                            {(!["Checker", "SiteManagement"].includes(role)) ||
                                (role === "Checker" && !isMoreThan24Hours(CREATED_AT)) ? (
                                <td className="boc-modern-td text-center hide-on-print">
                                    {usefor !== "generateinvoice"
                                        ? <DeleteEmployeeDeduction i={base} getData={getEmployeeInvoice} deductionData={deductionData} />
                                        : <DeleteEmployee i={base} getData={getEmployeeInvoice} />
                                    }
                                </td>
                            ) : (
                                <td className="boc-modern-td text-center hide-on-print">-</td>
                            )}
                        </>
                    )}
                </tr>
            );
        });
    };

    const [eotTotal, setEotTotal] = useState([]);

    const calculateTotals = () => {
        let totalRate = 0;
        let totalConst = 0;
        let totalMaint = 0;
        let totalMonth = 0;
        let totalAmount = 0;

        let totalPreviousMonth = 0;
        let totalPreviousAmount = 0;
        let totalCumulativeMonth = 0;
        let totalCumulativeAmount = 0;
        let totalRemainingMonth = 0;
        let totalRemainingAmount = 0;

        let totalCurrentMonth = 0;
        let totalCurrentAmount = 0;

        const processedEmp = new Set();
        let eotTotals = [];
        let totalDeduction = 0;

        employees.forEach(emp => {
            const empId = emp.employee;
            if (!processedEmp.has(empId)) {
                processedEmp.add(empId);

                const ed = emp.employee_details || {};
                const eotDetails = emp.eot_details || [];

                const matchedDeductions = deductionData?.filter(
                    (d) => d.item_id === emp.id
                ) || [];

                const deductionTotalForEmp = matchedDeductions
                    .reduce((sum, d) => sum + (Number(d?.deduction_amount) + Number(d?.withheld_deduction_amount) || 0), 0);

                totalDeduction += deductionTotalForEmp;

                eotDetails.forEach((item, idx) => {
                    if (!eotTotals[idx]) {
                        eotTotals[idx] = { total_amount: 0, rate: 0, t_month: 0, dlp: 0, cp: 0 };
                    }
                    eotTotals[idx].total_amount += Number(item?.total_amount) || 0;
                    eotTotals[idx].rate += Number(item?.rate) || 0;
                    eotTotals[idx].t_month += Number(item?.t_month) || 0;
                    eotTotals[idx].dlp += Number(item?.dlp) || 0;
                    eotTotals[idx].cp += Number(item?.cp) || 0;
                });

                const rate = parseFloat(emp.boq_rate ?? ed.rate) || 0;
                const constMM = parseFloat(emp.boq_construction_period ?? ed.MM_construction_period) || 0;
                const omMM = parseFloat(emp.boq_OM_period ?? ed.MM_OM_period) || 0;
                const fullMonth = constMM + omMM;
                const fullAmt = rate * fullMonth;

                totalRate += rate;
                totalConst += constMM;
                totalMaint += omMM;
                totalMonth += fullMonth;
                totalAmount += fullAmt;

                totalPreviousMonth += parseFloat(emp.actual_month_total_previous || 0);
                totalPreviousAmount += parseFloat(emp.previous_invoice_total || 0);
                totalCumulativeMonth += parseFloat(emp.actual_month_cumulative_total || 0);
                totalCumulativeAmount += parseFloat(emp.cumulative_invoice_total || 0);
                totalRemainingMonth += parseFloat(emp.actual_month_remaining || 0);
                totalRemainingAmount += parseFloat(emp.remaining_amount || 0);
            }

            totalCurrentMonth += parseFloat(emp.actual_month || 0);
            totalCurrentAmount += parseFloat(emp.invoice_amount || 0);
        });

        return {
            totalRate, totalConst, totalMaint, totalMonth, totalAmount,
            totalPreviousMonth, totalPreviousAmount,
            totalCurrentMonth, totalCurrentAmount,
            totalCumulativeMonth, totalCumulativeAmount,
            totalRemainingMonth, totalRemainingAmount,
            eotTotals, totalDeduction
        };
    };

    useEffect(() => {
        if (employees.length > 0) {
            const totals = calculateTotals();
            setPreviousAmount(totals.totalPreviousAmount);
            setCurrentAmount(totals.totalCurrentAmount);
            setRemainingAmount(totals.totalRemainingAmount);
            setContractAmount(totals.totalAmount);
            setCumulated(totals.totalCumulativeAmount);
            setEotDetails(totals.eotTotals);
        }
    }, [employees]);

    const isEotDataTrue = employees?.some(i =>
        (i.eot_details?.length > 0) || (i.data?.eot_details?.length > 0)
    );

    const eotLengths = Math.max(
        ...employees.map(i => i?.eot_details?.length || i?.data?.eot_details?.length || 0),
        0


    );

    const groupEmployeesByType = (type) => {
        const grouped = {};

        employees
            .filter(emp => emp.employee_details?.professional_type === type)
            .forEach(emp => {
                const empId = emp.employee;
                if (!grouped[empId]) {
                    grouped[empId] = {
                        base: emp,
                        currentMonths: [],
                        currentInvoices: [],
                        names: [],
                        empcodes: [],
                    };
                }

                grouped[empId].names.push(emp.boq_name_employee);
                grouped[empId].empcodes.push(emp.boq_empcode);
                grouped[empId].currentMonths.push(parseFloat(emp.actual_month || 0));
                grouped[empId].currentInvoices.push(parseFloat(emp.invoice_amount || 0));
            });

        return Object.values(grouped);
    };

    const r2 = (val) => {
        const n = Number(val);
        return isNaN(n) ? 0 : Math.round(n * 100) / 100;
    };
    // ── Builds a fully formatted AOA sheet (merged headers, section rows) ──
    // Layout mirrors the on-screen table exactly, with all numbers rounded to 2 decimals.
    const buildExcelSheetData = () => {
        const showDeduction = usefor !== "generateinvoice";

        // ---- figure out column layout ----
        let col = 0;
        const SNO_COL = col++;                  // 0
        const POS_COL = col++;                  // 1
        const NAME_COL = col++;                 // 2
        const CONTRACT_START = col; col += 5;   // Rate, Const, Maint, No. of MM, Total Amount
        const REVISED_COL = col++;              // Revised Rate After Statutory Deductions
        let DED_MONTH_COL = -1, DED_AMT_COL = -1;
        if (showDeduction) {
            DED_MONTH_COL = col++;
            DED_AMT_COL = col++;
        }
        const EOT_START = col; col += eotLengths * 5;   // 5 cols per EOT group
        const PREV_START = col; col += 2;   // Month, Amount
        const CUR_START = col; col += 2;
        const CUM_START = col; col += 2;
        const REM_START = col; col += 2;
        const TOTAL_COLS = col;

        const blankRow = () => new Array(TOTAL_COLS).fill("");

        // ---- header row 1 (group labels) ----
        const row1 = blankRow();
        row1[SNO_COL] = "S.No.";
        row1[POS_COL] = "Position";
        row1[NAME_COL] = "Name";
        row1[CONTRACT_START] = "Contract Amount";
        row1[REVISED_COL] = "Revised Rate After Statutory Deductions on Replacement";
        if (showDeduction) {
            row1[DED_MONTH_COL] = "Deduction Month";
            row1[DED_AMT_COL] = "Deduction Amount";
        }
        for (let i = 0; i < eotLengths; i++) {
            row1[EOT_START + i * 5] = `EOT ${i + 1}`;
        }
        row1[PREV_START] = "Cumulative Total of Previous Months";
        row1[CUR_START] = "This Period";
        row1[CUM_START] = "Cumulative Total Including Current Invoice";
        row1[REM_START] = "Remaining Amount Against Contract Value";

        // ---- header row 2 (sub labels) ----
        const row2 = blankRow();
        row2[CONTRACT_START] = "Rate";
        row2[CONTRACT_START + 1] = "Const";
        row2[CONTRACT_START + 2] = "Maint";
        row2[CONTRACT_START + 3] = "No. of MM";
        row2[CONTRACT_START + 4] = "Total Amount";
        for (let i = 0; i < eotLengths; i++) {
            const c = EOT_START + i * 5;
            row2[c] = "Const";
            row2[c + 1] = "Maint";
            row2[c + 2] = "Total MM";
            row2[c + 3] = "Rate";
            row2[c + 4] = "Total Amount";
        }
        row2[PREV_START] = "Month"; row2[PREV_START + 1] = "Amount";
        row2[CUR_START] = "Month"; row2[CUR_START + 1] = "Amount";
        row2[CUM_START] = "Month"; row2[CUM_START + 1] = "Amount";
        row2[REM_START] = "Month"; row2[REM_START + 1] = "Amount";

        // ---- merges for the two header rows ----
        const merges = [];
        const vMerge = (c) => merges.push({ s: { r: 0, c }, e: { r: 1, c } }); // rowspan 2
        const hMerge = (c1, c2) => merges.push({ s: { r: 0, c: c1 }, e: { r: 0, c: c2 } }); // colspan on row1

        vMerge(SNO_COL); vMerge(POS_COL); vMerge(NAME_COL); vMerge(REVISED_COL);
        if (showDeduction) { vMerge(DED_MONTH_COL); vMerge(DED_AMT_COL); }
        hMerge(CONTRACT_START, CONTRACT_START + 4);
        for (let i = 0; i < eotLengths; i++) {
            const c = EOT_START + i * 5;
            hMerge(c, c + 4);
        }
        hMerge(PREV_START, PREV_START + 1);
        hMerge(CUR_START, CUR_START + 1);
        hMerge(CUM_START, CUM_START + 1);
        hMerge(REM_START, REM_START + 1);

        // ---- data rows ----
        const rows = [row1, row2];

        const addSectionRow = (label) => {
            const r = blankRow();
            r[0] = label;
            rows.push(r);
            merges.push({ s: { r: rows.length - 1, c: 0 }, e: { r: rows.length - 1, c: TOTAL_COLS - 1 } });
        };

        const addEmployeeRows = (type) => {
            const grouped = groupEmployeesByType(type);
            grouped.forEach((group, index) => {
                const { base } = group;
                const ed = base.employee_details;
                const eot = base.eot_details || [];
                const replacement = base.replacement_deduction || [];
                const NAME = base.boq_name_employee_two || [];
                const targetLength = NAME.length || 0;

                const previous_month_list = normalizeArray(base.actual_month_total_previous_two || [], targetLength);
                const previous_amount_list = normalizeArray(base.previous_invoice_total_two || [], targetLength);
                const actual_month_list = normalizeArray(base.actual_month_two || [], targetLength);
                const actual_amount_list = normalizeArray(base.current_invoice_amount_two || [], targetLength);
                const cumulated_month_list = normalizeArray(base.actual_month_cumulative_total_two || [], targetLength);
                const cumulated_amount_list = normalizeArray(base.actual_amount_cumulative_total || [], targetLength);

                const boqRate = parseFloat(base.boq_rate ?? ed.rate) || 0;
                const boqConst = parseFloat(base.boq_construction_period ?? ed.MM_construction_period) || 0;
                const boqOM = parseFloat(base.boq_OM_period ?? ed.MM_OM_period) || 0;
                const totalMM = boqConst + boqOM;
                const totalAmt = boqRate * totalMM;

                const matchedDeductions = deductionData?.filter((d) => d.item_id === base.id) || [];
                const deductionMonthSum = matchedDeductions.reduce((s, n) => s + (Number(n.deduction_month) || 0), 0);
                const deductionAmountSum = matchedDeductions.reduce((s, n) => s + ((Number(n.deduction_amount) + Number(n.withheld_deduction_amount)) || 0), 0);

                const r = blankRow();
                r[SNO_COL] = index + 1;
                r[POS_COL] = ed?.designation_name || "";
                r[NAME_COL] = (NAME.length > 0 ? NAME : ["TBN"]).join(", ");
                r[CONTRACT_START] = r2(boqRate);
                r[CONTRACT_START + 1] = r2(boqConst);
                r[CONTRACT_START + 2] = r2(boqOM);
                r[CONTRACT_START + 3] = r2(totalMM);
                r[CONTRACT_START + 4] = r2(totalAmt);
                r[REVISED_COL] = replacement.map(v => r2(v)).join(", ");
                if (showDeduction) {
                    r[DED_MONTH_COL] = r2(deductionMonthSum);
                    r[DED_AMT_COL] = r2(deductionAmountSum);
                }
                eot.forEach((e, i) => {
                    const c = EOT_START + i * 5;
                    r[c] = r2(e.cp);
                    r[c + 1] = r2(e.dlp);
                    r[c + 2] = r2(e.t_month);
                    r[c + 3] = r2(e.rate);
                    r[c + 4] = r2(e.total_amount);
                });
                r[PREV_START] = previous_month_list.map(n => r2(n)).join(", ");
                r[PREV_START + 1] = previous_amount_list.map(n => r2(n)).join(", ");
                r[CUR_START] = actual_month_list.map(n => r2(n)).join(", ");
                r[CUR_START + 1] = actual_amount_list.map(n => r2(n)).join(", ");
                r[CUM_START] = cumulated_month_list.map(n => r2(n)).join(", ");
                r[CUM_START + 1] = cumulated_amount_list.map(n => r2(n)).join(", ");
                r[REM_START] = r2(base.actual_month_remaining);
                r[REM_START + 1] = r2(base.remaining_amount);

                rows.push(r);
            });
        };

        addSectionRow("Key Professional Staff (A)");
        addEmployeeRows("Key Professional");
        addSectionRow("Sub Professional Staff (B)");
        addEmployeeRows("Sub Professional");
        addSectionRow("Support Staff (C)");
        addEmployeeRows("Support Staff");

        // ---- totals row ----
        const totals = calculateTotals();
        const totalRow = blankRow();
        totalRow[POS_COL] = "Total:";
        totalRow[CONTRACT_START] = r2(totals.totalRate);
        totalRow[CONTRACT_START + 1] = r2(totals.totalConst);
        totalRow[CONTRACT_START + 2] = r2(totals.totalMaint);
        totalRow[CONTRACT_START + 3] = r2(totals.totalMonth);
        totalRow[CONTRACT_START + 4] = r2(totals.totalAmount);
        if (showDeduction) {
            totalRow[DED_AMT_COL] = r2(totals.totalDeduction);
        }
        (totals.eotTotals || []).forEach((val, i) => {
            const c = EOT_START + i * 5;
            if (c + 4 < TOTAL_COLS) {
                totalRow[c] = r2(val.cp); totalRow[c + 1] = r2(val.dlp); totalRow[c + 2] = r2(val.t_month);
                totalRow[c + 3] = r2(val.rate); totalRow[c + 4] = r2(val.total_amount);
            }
        });
        totalRow[PREV_START] = r2(totals.totalPreviousMonth);
        totalRow[PREV_START + 1] = r2(totals.totalPreviousAmount);
        totalRow[CUR_START] = r2(totals.totalCurrentMonth);
        totalRow[CUR_START + 1] = r2(totals.totalCurrentAmount);
        totalRow[CUM_START] = r2(totals.totalCumulativeMonth);
        totalRow[CUM_START + 1] = r2(totals.totalCumulativeAmount);
        totalRow[REM_START] = r2(totals.totalRemainingMonth);
        totalRow[REM_START + 1] = r2(totals.totalRemainingAmount);
        rows.push(totalRow);

        const colWidths = new Array(TOTAL_COLS).fill({ wch: 14 });
        colWidths[SNO_COL] = { wch: 6 };
        colWidths[POS_COL] = { wch: 18 };
        colWidths[NAME_COL] = { wch: 22 };
        colWidths[REVISED_COL] = { wch: 18 };

        return { rows, merges, colWidths, sheetName: "Professional Staff" };
    };

    useEffect(() => {
        if (employees.length > 0) {
            const totals = calculateTotals();
            setPreviousAmount(totals.totalPreviousAmount);
            setCurrentAmount(totals.totalCurrentAmount);
            setRemainingAmount(totals.totalRemainingAmount);
            setContractAmount(totals.totalAmount);
            setCumulated(totals.totalCumulativeAmount);
            setEotDetails(totals.eotTotals);

            if (typeof setExcelRows === "function") {
                setExcelRows(buildExcelSheetData());
            }
        }
    }, [employees, deductionData]);


    return (
        <div className="boc-modern-wrapper" style={{ minHeight: "30vh" }}>
            <div className="boc-modern-card">


                {/* Print header */}

                <div className="boc-modern-header bocx-modern-footer-total">
                    <div className="boc-modern-header-content">
                        <div className="boc-modern-project-info">
                            <h3 className="boc-modern-project-title">{projectData?.project_name}</h3>
                            <div className="boc-modern-project-meta">
                                <div className="boc-modern-meta-item">
                                    <span className="boc-modern-meta-label">Client:</span>
                                    <span className="boc-modern-meta-value">{projectData?.client_name}</span>
                                </div>
                                <div className="boc-modern-meta-divider"></div>
                                <div className="boc-modern-meta-item">
                                    <span className="boc-modern-meta-label">Consultant (AE):</span>
                                    <span className="boc-modern-meta-value">
                                        {projectData?.lead}
                                        {projectData?.jv ? ` JV with ${projectData?.jv}.` : ""}
                                        {projectData?.association ? ` Association with ${projectData?.association}` : ""}
                                    </span>
                                </div>
                                <div className="boc-modern-meta-divider"></div>
                                <div className="boc-modern-meta-item">
                                    <span className="boc-modern-meta-label">GSTIN:</span>
                                    <span className="boc-modern-meta-value">{projectData?.gst_no}</span>
                                </div>
                                <div className="boc-modern-meta-divider"></div>
                                <div className="boc-modern-meta-item">
                                    <span className="boc-modern-meta-label">PAN:</span>
                                    <span className="boc-modern-meta-value">{projectData?.pan_no}</span>
                                </div>
                                <div className="boc-modern-meta-divider"></div>
                                <div className="boc-modern-meta-item">
                                    <span className="boc-modern-meta-label">Bid Due:</span>
                                    <span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.bid_due_date)}</span>
                                </div>
                                <div className="boc-modern-meta-divider"></div>
                                <div className="boc-modern-meta-item">
                                    <span className="boc-modern-meta-label">Agreement:</span>
                                    <span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.agreement_date)}</span>
                                </div>
                                <div className="boc-modern-meta-divider"></div>
                                <div className="boc-modern-meta-item">
                                    <span className="boc-modern-meta-label">Start:</span>
                                    <span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.commencement_date)}</span>
                                </div>
                                <div className="boc-modern-meta-divider"></div>
                                <div className="boc-modern-meta-item">
                                    <span className="boc-modern-meta-label">Invoice Number: </span>
                                    <span className="boc-modern-meta-value">{invoice_num}</span>
                                </div>
                                <div className="boc-modern-meta-divider"></div>
                                <div className="boc-modern-meta-item">
                                    <span className="boc-modern-meta-label">Date: </span>
                                    <span className="boc-modern-meta-value">{getMonthName(month)}-{year}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Section heading + action button */}
                <div className="boc-modern-description-section">
                    <div className="boc-modern-controls">
                        <div className="boc-modern-controls-left">

                            <h6 className="boc-modern-main-heading">I- Remuneration for Local Professional Staff</h6>
                        </div>
                        <>
                            {/* {role !== "ViewAccess" && (
                                <div className="hide-on-print">
                                    {usefor === "generateinvoice" ?
                                        <AddEmployeeInvoice
                                            getEmployeeInvoice={getEmployeeInvoice}
                                            invoice_id={invoice_id}
                                            month={month}
                                            year={year}
                                            usedfor="InvoiceandDeduction"
                                            p_id={p_id ? p_id : project}
                                            logData={logData}
                                            invoiceData={employees}
                                        />
                                        :
                                        <>
                                            {employees.length === 0 ?
                                                <AddEmployeeInvoice
                                                    getEmployeeInvoice={getEmployeeInvoice}
                                                    invoice_id={invoice_id}
                                                    month={month}
                                                    year={year}
                                                    usedfor="OnlyDeduction"
                                                    p_id={p_id ? p_id : project}
                                                    logData={logData}
                                                    invoiceData={employees}
                                                />
                                                :
                                                <UpdateEmployeeDeductionInvoice invoiceData={employees} getData={getEmployeeInvoice} />
                                            }
                                        </>
                                    }
                                </div>
                            )} */
                            }
                            {role !== "ViewAccess" && (
                                <div className="hide-on-print">
                                    {usefor === "generateinvoice" ? (
                                        employees.length === 0 ? (
                                            <AddEmployeeInvoice
                                                getEmployeeInvoice={getEmployeeInvoice}
                                                invoice_id={invoice_id}
                                                month={month}
                                                year={year}
                                                usedfor="InvoiceandDeduction"
                                                p_id={p_id ? p_id : project}
                                                logData={logData}
                                                invoiceData={employees}
                                            />
                                        ) : (

                                            <>

                                                <UpdateEmployeeInvoice
                                                    getEmployeeInvoice={getEmployeeInvoice}
                                                    month={month}
                                                    year={year}
                                                    usedfor="InvoiceandDeduction"
                                                    p_id={p_id ? p_id : project}
                                                    invoice_id={invoice_id}

                                                />
                                            </>
                                        )
                                    ) : (
                                        <>
                                            {employees.length === 0 ? (
                                                <AddEmployeeInvoice
                                                    getEmployeeInvoice={getEmployeeInvoice}
                                                    invoice_id={invoice_id}
                                                    month={month}
                                                    year={year}
                                                    usedfor="OnlyDeduction"
                                                    p_id={p_id ? p_id : project}
                                                    logData={logData}
                                                    invoiceData={employees}
                                                />
                                            ) : (
                                                <>
                                                    <UpdateNewEmployeeInvoice
                                                        getEmployeeInvoice={getEmployeeInvoice}
                                                        month={month}
                                                        year={year}
                                                        p_id={p_id ? p_id : project}
                                                        invoice_id={invoice_id}
                                                    />
                                                    <UpdateEmployeeDeductionInvoice invoiceData={employees} getData={getEmployeeInvoice} />
                                                </>
                                            )}
                                        </>
                                    )}
                                </div>
                            )}
                        </>
                    </div>
                </div>

                <div className="boc-modern-table-wrapper">
                    {/* Table */}
                    <div className="boc-modern-table-scroll">
                        <table className="boc-modern-table">
                            <thead>
                                {/* Row 1 */}
                                <tr className="boc-modern-table-header">
                                    <th className="boc-modern-th text-center" rowSpan="4">S.No.</th>
                                    <th className="boc-modern-th text-center" rowSpan="4">Position</th>
                                    <th className="boc-modern-th text-center" rowSpan="4">Name</th>
                                    <th className="boc-modern-th text-center" colSpan="5">Contract Amount</th>
                                    <th className="boc-modern-th text-center" rowSpan="4">
                                        Revised Rate After<br />Statutory Deductions<br />on Replacement
                                    </th>
                                    {usefor !== "generateinvoice" && (
                                        <>
                                            <th className="boc-modern-th text-center" rowSpan="4">Deduction Month</th>
                                            <th className="boc-modern-th text-center" rowSpan="4">Deduction Amount</th>
                                        </>
                                    )}
                                    {isEotDataTrue && (
                                        <th className="boc-modern-th text-center" colSpan={eotLengths * 5 || 1}>
                                            Revised Contract Values (after COS/EOT)
                                        </th>
                                    )}
                                    <th className="boc-modern-th text-center" colSpan="2">Cumulative Total of Previous Months</th>
                                    <th className="boc-modern-th text-center" colSpan="2">This Period</th>
                                    <th className="boc-modern-th text-center" colSpan="2">Cumulative Total Including Current Invoice</th>
                                    <th className="boc-modern-th text-center" colSpan="2">Remaining Amount Against Contract Value</th>
                                    {role !== "SiteManagement" && role !== "ViewAccess" && (
                                        <th className="boc-modern-th text-center hide-on-print" rowSpan="4">Action</th>
                                    )}
                                </tr>

                                {/* Row 2 */}
                                <tr className="boc-modern-table-subheader">
                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Rate</th>
                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Const</th>
                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Maint</th>
                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">No. of MM</th>
                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Total Amount</th>
                                    {Array.from({ length: eotLengths }).map((_, idx) => (
                                        <th key={idx} className="boc-modern-th text-center boc-nowrap" colSpan={5}>
                                            {`EOT ${idx + 1}`}
                                        </th>
                                    ))}
                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Month</th>
                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Amount</th>
                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Month</th>
                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Amount</th>
                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Month</th>
                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Amount</th>
                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Month</th>
                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Amount</th>
                                </tr>

                                {/* Row 3 - EOT sub-cols */}
                                <tr className="boc-modern-table-subheader">
                                    {Array.from({ length: eotLengths }).map((_, idx) => (
                                        <React.Fragment key={idx}>
                                            <th rowSpan="2" className="boc-modern-th boc-nowrap">Const</th>
                                            <th rowSpan="2" className="boc-modern-th boc-nowrap">Maint</th>
                                            <th rowSpan="2" className="boc-modern-th boc-nowrap">Total MM</th>
                                            <th rowSpan="2" className="boc-modern-th boc-nowrap">Rate</th>
                                            <th rowSpan="2" className="boc-modern-th boc-nowrap">Total Amount</th>
                                        </React.Fragment>
                                    ))}
                                </tr>
                            </thead>

                            <tbody>
                                {/* Key Professional Staff */}
                                <tr>
                                    <td
                                        colSpan={(eotLengths * 5) + (usefor === "generateinvoice" ? 17 : 19) + 1}
                                        className="boc-modern-pre-heading"
                                        style={{ background: "transparent" }}
                                    >
                                        <span className="boc-modern-pre-heading-text">Key Professional Staff (A)</span>
                                    </td>
                                    {role !== "SiteManagement" && role !== "ViewAccess" && (
                                        <td className="hide-on-print boc-modern-td"></td>
                                    )}
                                </tr>
                                {renderEmployeeRows("Key Professional")}

                                {/* Sub Professional Staff */}
                                <tr>
                                    <td
                                        colSpan={(eotLengths * 5) + (usefor === "generateinvoice" ? 17 : 19) + 1}
                                        className="boc-modern-pre-heading"
                                        style={{ background: "transparent" }}
                                    >
                                        <span className="boc-modern-pre-heading-text">Sub Professional Staff (B)</span>
                                    </td>
                                    {role !== "SiteManagement" && role !== "ViewAccess" && (
                                        <td className="hide-on-print boc-modern-td"></td>
                                    )}
                                </tr>
                                {renderEmployeeRows("Sub Professional")}

                                {/* Support Staff */}
                                <tr>
                                    <td
                                        colSpan={(eotLengths * 5) + (usefor === "generateinvoice" ? 17 : 19) + 1}
                                        className="boc-modern-pre-heading"
                                        style={{ background: "transparent" }}
                                    >
                                        <span className="boc-modern-pre-heading-text">Support Staff (C)</span>
                                    </td>
                                    {role !== "SiteManagement" && role !== "ViewAccess" && (
                                        <td className="hide-on-print boc-modern-td"></td>
                                    )}
                                </tr>
                                {renderEmployeeRows("Support Staff")}
                            </tbody>

                            <tfoot>
                                <tr className="boc-modern-footer">
                                    <td colSpan="3" className="boc-modern-footer-label">Total:</td>

                                    <td className="boc-modern-td boc-nowrap text-right">
                                        <span className="boc-modern-td boc-nowrap boc-modern-currency boc-modern-footer-total text-right">
                                            ₹ {formatCurrencyIndian(calculateTotals().totalRate.toFixed(0))}
                                        </span>
                                    </td>
                                    <td className="boc-modern-td boc-nowrap text-right">{calculateTotals().totalConst.toFixed(0)}</td>
                                    <td className="boc-modern-td boc-nowrap text-right">{calculateTotals().totalMaint.toFixed(0)}</td>
                                    <td className="boc-modern-td boc-nowrap text-right">{calculateTotals().totalMonth.toFixed(0)}</td>
                                    <td className="boc-modern-td boc-nowrap text-right">
                                        <span className="boc-modern-td boc-nowrap boc-modern-currency boc-modern-footer-total text-right">
                                            ₹ {formatCurrencyIndian(calculateTotals().totalAmount.toFixed(0))}
                                        </span>
                                    </td>
                                    <td className="boc-modern-td"></td>

                                    {usefor !== "generateinvoice" && (
                                        <>
                                            <td className="boc-modern-td"></td>
                                            <td className="boc-modern-td boc-nowrap text-right">
                                                <span className="boc-modern-td boc-nowrap boc-modern-currency boc-modern-footer-total text-right">
                                                    ₹{formatCurrencyIndian(calculateTotals().totalDeduction.toFixed(0))}
                                                </span>
                                            </td>
                                        </>
                                    )}

                                    {isEotDataTrue && (
                                        <>
                                            {calculateTotals().eotTotals?.map((val, idx) => (
                                                <React.Fragment key={idx}>
                                                    <td className="boc-modern-td boc-nowrap text-right">{val.cp}</td>
                                                    <td className="boc-modern-td boc-nowrap text-right">{val.dlp}</td>
                                                    <td className="boc-modern-td boc-nowrap text-right">{val.t_month}</td>
                                                    <td className="boc-modern-td boc-nowrap text-right">
                                                        ₹{formatCurrencyIndian(val.rate)}
                                                    </td>
                                                    <td className="boc-modern-td boc-nowrap text-right">
                                                        <span className="boc-modern-td boc-nowrap boc-modern-currency boc-modern-footer-total text-right">
                                                            ₹{formatCurrencyIndian(val.total_amount)}
                                                        </span>
                                                    </td>
                                                </React.Fragment>
                                            ))}
                                        </>
                                    )}

                                    <td className="boc-modern-td boc-nowrap text-right">{calculateTotals().totalPreviousMonth.toFixed(2)}</td>
                                    <td className="boc-modern-td boc-nowrap text-right">
                                        <span className="boc-modern-td boc-nowrap boc-modern-currency boc-modern-footer-total text-right">
                                            ₹ {formatCurrencyIndian(calculateTotals().totalPreviousAmount.toFixed(0))}
                                        </span>
                                    </td>

                                    <td className="boc-modern-td boc-nowrap text-right">{calculateTotals().totalCurrentMonth.toFixed(2)}</td>
                                    <td className="boc-modern-td boc-nowrap text-right">
                                        <span className="boc-modern-td boc-nowrap boc-modern-currency boc-modern-footer-total text-right">
                                            ₹ {formatCurrencyIndian(calculateTotals().totalCurrentAmount.toFixed(0))}
                                        </span>
                                    </td>

                                    <td className="boc-modern-td boc-nowrap text-right">{calculateTotals().totalCumulativeMonth.toFixed(2)}</td>
                                    <td className="boc-modern-td boc-nowrap text-right">
                                        <span className="boc-modern-td boc-nowrap boc-modern-currency boc-modern-footer-total text-right">  ₹ {formatCurrencyIndian(calculateTotals().totalCumulativeAmount.toFixed(0))}
                                        </span>
                                    </td>

                                    <td className="boc-modern-td boc-nowrap text-right">{calculateTotals().totalRemainingMonth.toFixed(2)}</td>
                                    <td className="boc-modern-td boc-nowrap text-right">
                                        <span className="boc-modern-td boc-nowrap boc-modern-currency boc-modern-footer-total text-right">
                                            ₹ {formatCurrencyIndian(calculateTotals().totalRemainingAmount.toFixed(0))}
                                        </span>
                                    </td>

                                    {role !== "SiteManagement" && role !== "ViewAccess" && (
                                        <td className="hide-on-print boc-modern-td"></td>
                                    )}
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
        </div>

    );
};


// const Transportation = ({ deductionData, projectData, setEotDetails, client, p_id, invoice_id, invoice_num, month, year, logData,
//     setPreviousAmount,
//     setCurrentAmount,
//     setRemainingAmount,
//     setContractAmount,
//     setCumulated,
//     usefor,
//     setExcelRows,

// }) => {

//     const currentDate = new Date();
//     const isFirstWeek = currentDate.getDate() <= 7;
//     const [transportations, setTransportations] = useState([]);

//     const role = sessionStorage.getItem('sitemanagement_role');





//     const calculateContractAmount = calculateTotal(transportations, (item) => Number(item.boq_rate ?? item.transport_details.rate) * (Number(item.boq_during_construction_period ?? item.transport_details.during_construction_period) + Number(item.boq_during_dlp_OM_period ?? item.transport_details.during_dlp_OM_period)))
//     setContractAmount(calculateContractAmount);
//     const calculatePreviousAmount = calculateTotal(transportations, (item) => Number(item.previous_invoice_total))
//     setPreviousAmount(calculatePreviousAmount);
//     const calculateCurrentAmount = calculateTotal(transportations, (item) => Number(item.invoice_amount ?? item.current_invoice_amount))
//     setCurrentAmount(calculateCurrentAmount);
//     const calculateCumulated = calculateTotal(transportations, (item) => Number(item.cumulative_invoice_total))
//     setCumulated(calculateCumulated);
//     const calculateRemaining = calculateTotal(transportations, (item) => Number(item.remaining_amount))
//     setRemainingAmount(calculateRemaining);

//     useEffect(() => {
//         const eotGroups = [];
//         transportations.forEach(item => {
//             (item?.eot_details || []).forEach((eot, idx) => {
//                 if (!eotGroups[idx]) {
//                     eotGroups[idx] = { ...eot, total_amount: 0 };
//                 }
//                 eotGroups[idx].total_amount += Number(eot.total_amount || 0);
//             });
//         });

//         setEotDetails(eotGroups);
//         console.log("Transport EOT Groups:", eotGroups);
//     }, [transportations]);


//     const getTransportationInvoice = async () => {

//         try {
//             let data;

//             if (usefor === "generateinvoice") {
//                 const res = await axios.get(
//                     `${BASE_URL}/siteproject/invoicetransportbyprojectstatus/${p_id ? p_id : project}/${month}/${year}/`
//                 );
//                 data = res.data;
//             } else {
//                 const response2 = await axios.get(
//                     `${BASE_URL}/siteproject/newinvoicetransportationfiltermonthyear/${invoice_id}/null/null/`
//                 );
//                 data = response2.data;
//             }

//             const isAnyBoqJsonNull = data.length !== 0 && data.every(item => item.boq_json === null);


//             const selectedTransportationData = isAnyBoqJsonNull ? data : data;
//             setTransportations(selectedTransportationData);
//         } catch (err) { }
//     };

//     useEffect(() => {

//         // getdocument();
//         getTransportationInvoice();
//         // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, []);

//     const project = sessionStorage.getItem('sitemanagement_project');
//     const isEotDataTrue = transportations.some(i =>
//         (i.eot_details?.length > 0) || (i.data?.eot_details?.length > 0)
//     );





//     const eotLengths = Math.max(
//         ...transportations.map(i => i?.eot_details?.length || i?.data?.eot_details?.length || 0),
//         0
//     );

//     // Display-only helpers: calculations and API values retain their original precision.
//     // Months are displayed with exactly two decimal places (for example, 0.322211 -> 0.32).
//     const formatMonth2 = (value) => {
//         const n = Number(value ?? 0);
//         return Number.isFinite(n) ? n.toFixed(2) : "0.00";
//     };

//     // Indian currency grouping with exactly two decimal places (for example, 1234 -> 1,234.00).
//     const formatAmount2 = (value) => {
//         const n = Number(value ?? 0);
//         return Number.isFinite(n)
//             ? n.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
//             : "0.00";
//     };

//     // Excel AOA values are formatted as text to reliably retain trailing zeros.
//     // For numeric Excel cells with a "0.00" number format, the workbook writer must apply cell.z.
//     const r2 = (value) => formatMonth2(value);

//     // ── Builds a fully formatted AOA sheet (merged headers, flat rows) ──
//     // Transportation has no employee-type sections, so it's a flat list unlike ProfessionalStaff.
//     const buildExcelSheetData = () => {
//         const showDeduction = usefor !== "generateinvoice";

//         // ---- figure out column layout ----
//         let col = 0;
//         const SNO_COL = col++;                  // 0
//         const DESC_COL = col++;                 // 1
//         const CONTRACT_START = col; col += 6;   // No. of Vehicles, Rate, Const, Maint, No. of MM, Total Amount
//         let DED_MONTH_COL = -1, DED_AMT_COL = -1;
//         if (showDeduction) {
//             DED_MONTH_COL = col++;
//             DED_AMT_COL = col++;
//         }
//         const EOT_START = col; col += eotLengths * 5;   // 5 cols per EOT group
//         const PREV_START = col; col += 2;   // Month, Amount
//         const CUR_START = col; col += 2;
//         const CUM_START = col; col += 2;
//         const REM_START = col; col += 2;
//         const TOTAL_COLS = col;

//         const blankRow = () => new Array(TOTAL_COLS).fill("");

//         // ---- header row 1 (group labels) ----
//         const row1 = blankRow();
//         row1[SNO_COL] = "S.No";
//         row1[DESC_COL] = "Description of Vehicles";
//         row1[CONTRACT_START] = "Contract Amount";
//         if (showDeduction) {
//             row1[DED_MONTH_COL] = "Deduction Month";
//             row1[DED_AMT_COL] = "Deduction Amount";
//         }
//         for (let i = 0; i < eotLengths; i++) {
//             row1[EOT_START + i * 5] = `EOT ${i + 1}`;
//         }
//         row1[PREV_START] = "Cumulative Total of Previous Months";
//         row1[CUR_START] = "This Period";
//         row1[CUM_START] = "Cumulative Total Including Current Invoice";
//         row1[REM_START] = "Remaining Amount Against Contract Value";

//         // ---- header row 2 (sub labels) ----
//         const row2 = blankRow();
//         row2[CONTRACT_START] = "No. of Vehicles";
//         row2[CONTRACT_START + 1] = "Rate";
//         row2[CONTRACT_START + 2] = "Const";
//         row2[CONTRACT_START + 3] = "Maint";
//         row2[CONTRACT_START + 4] = "No. of MM";
//         row2[CONTRACT_START + 5] = "Total Amount";
//         for (let i = 0; i < eotLengths; i++) {
//             const c = EOT_START + i * 5;
//             row2[c] = "Const";
//             row2[c + 1] = "Maint";
//             row2[c + 2] = "Total MM";
//             row2[c + 3] = "Rate";
//             row2[c + 4] = "Total Amount";
//         }
//         row2[PREV_START] = "Month"; row2[PREV_START + 1] = "Amount";
//         row2[CUR_START] = "Month"; row2[CUR_START + 1] = "Amount";
//         row2[CUM_START] = "Month"; row2[CUM_START + 1] = "Amount";
//         row2[REM_START] = "Month"; row2[REM_START + 1] = "Amount";

//         // ---- merges for the two header rows ----
//         const merges = [];
//         const vMerge = (c) => merges.push({ s: { r: 0, c }, e: { r: 1, c } });
//         const hMerge = (c1, c2) => merges.push({ s: { r: 0, c: c1 }, e: { r: 0, c: c2 } });

//         vMerge(SNO_COL); vMerge(DESC_COL);
//         if (showDeduction) { vMerge(DED_MONTH_COL); vMerge(DED_AMT_COL); }
//         hMerge(CONTRACT_START, CONTRACT_START + 5);
//         for (let i = 0; i < eotLengths; i++) {
//             const c = EOT_START + i * 5;
//             hMerge(c, c + 4);
//         }
//         hMerge(PREV_START, PREV_START + 1);
//         hMerge(CUR_START, CUR_START + 1);
//         hMerge(CUM_START, CUM_START + 1);
//         hMerge(REM_START, REM_START + 1);

//         // ---- data rows (flat — no sections for transportation) ----
//         const rows = [row1, row2];

//         transportations.forEach((item, index) => {
//             const rate = Number(item.boq_rate ?? item.transport_details.rate) || 0;
//             const constMM = Number(item.boq_during_construction_period ?? item.transport_details.during_construction_period) || 0;
//             const omMM = Number(item.boq_during_dlp_OM_period ?? item.transport_details.during_dlp_OM_period) || 0;
//             const totalMM = constMM + omMM;
//             const totalAmt = rate * totalMM;

//             const matchedDeductions = deductionData?.filter((d) => d.item_id === item.id) || [];
//             const deductionMonthSum = matchedDeductions.reduce((s, n) => s + (Number(n.deduction_month) || 0), 0);
//             const deductionAmountSum = matchedDeductions.reduce((s, n) => s + ((Number(n.deduction_amount) + Number(n.withheld_deduction_amount)) || 0), 0);

//             const r = blankRow();
//             r[SNO_COL] = index + 1;
//             r[DESC_COL] = item.boq_vehicle_description ?? item.transport_details.vehicle_description ?? "";
//             r[CONTRACT_START] = Number(item.no_of_vehicle) || 0;
//             r[CONTRACT_START + 1] = r2(rate);
//             r[CONTRACT_START + 2] = r2(constMM);
//             r[CONTRACT_START + 3] = r2(omMM);
//             r[CONTRACT_START + 4] = r2(totalMM);
//             r[CONTRACT_START + 5] = r2(totalAmt);
//             if (showDeduction) {
//                 r[DED_MONTH_COL] = r2(deductionMonthSum);
//                 r[DED_AMT_COL] = r2(deductionAmountSum);
//             }
//             (item.eot_details || []).forEach((e, i) => {
//                 const c = EOT_START + i * 5;
//                 r[c] = r2(e.cp);
//                 r[c + 1] = r2(e.dlp);
//                 r[c + 2] = r2(e.t_month);
//                 r[c + 3] = r2(e.rate);
//                 r[c + 4] = r2(e.total_amount);
//             });
//             r[PREV_START] = (item.actual_month_total_previous_two || []).map(n => r2(n)).join(", ");
//             r[PREV_START + 1] = (item.previous_invoice_total_two || []).map(n => r2(n)).join(", ");
//             r[CUR_START] = (item.actual_month_two || []).map(n => r2(n)).join(", ");
//             r[CUR_START + 1] = (item.current_invoice_amount_two || []).map(n => r2(n)).join(", ");
//             r[CUM_START] = (item.actual_month_cumulative_total_two || []).map(n => r2(n)).join(", ");
//             r[CUM_START + 1] = (item.actual_amount_cumulative_total || []).map(n => r2(n)).join(", ");
//             r[REM_START] = r2(item.actual_month_remaining);
//             r[REM_START + 1] = r2(item.remaining_amount);

//             rows.push(r);
//         });

//         // ---- totals row ----
//         const totalRow = blankRow();
//         totalRow[DESC_COL] = "Total:";
//         totalRow[CONTRACT_START] = Number(calculateTotal(transportations, item => Number(item.no_of_vehicle))) || 0;
//         totalRow[CONTRACT_START + 1] = r2(calculateTotal(transportations, item => Number(item.boq_rate ?? item.transport_details.rate)));
//         totalRow[CONTRACT_START + 2] = r2(calculateTotal(transportations, item => Number(item.boq_during_construction_period ?? item.transport_details.during_construction_period)));
//         totalRow[CONTRACT_START + 3] = r2(calculateTotal(transportations, item => Number(item.boq_during_dlp_OM_period ?? item.transport_details.during_dlp_OM_period)));
//         totalRow[CONTRACT_START + 4] = r2(calculateTotal(transportations, item => Number(item.boq_during_construction_period ?? item.transport_details.during_construction_period) + Number(item.boq_during_dlp_OM_period ?? item.transport_details.during_dlp_OM_period)));
//         totalRow[CONTRACT_START + 5] = r2(calculateContractAmount);

//         if (showDeduction) {
//             totalRow[DED_MONTH_COL] = r2(transportations.reduce((gt, item) => {
//                 const matched = deductionData?.filter(d => d.item_id === item.id) || [];
//                 return gt + matched.reduce((s, d) => s + (Number(d?.deduction_month) || 0), 0);
//             }, 0));
//             totalRow[DED_AMT_COL] = r2(transportations.reduce((gt, item) => {
//                 const matched = deductionData?.filter(d => d.item_id === item.id) || [];
//                 return gt + matched.reduce((s, d) => s + ((Number(d?.deduction_amount) || 0) + (Number(d?.withheld_deduction_amount) || 0)), 0);
//             }, 0));
//         }

//         for (let eotIdx = 0; eotIdx < eotLengths; eotIdx++) {
//             const totals = transportations.reduce((acc, emp) => {
//                 const details = emp.eot_details?.length > 0 ? emp.eot_details : emp.data?.eot_details || [];
//                 const eot = details[eotIdx];
//                 if (!eot) return acc;
//                 acc.cp += Number(eot?.cp) || 0;
//                 acc.dlp += Number(eot?.dlp) || 0;
//                 acc.t_month += Number(eot?.t_month) || 0;
//                 acc.rate += Number(eot?.rate) || 0;
//                 acc.total_amount += Number(eot?.total_amount) || 0;
//                 return acc;
//             }, { cp: 0, dlp: 0, t_month: 0, rate: 0, total_amount: 0 });
//             const c = EOT_START + eotIdx * 5;
//             totalRow[c] = r2(totals.cp);
//             totalRow[c + 1] = r2(totals.dlp);
//             totalRow[c + 2] = r2(totals.t_month);
//             totalRow[c + 3] = r2(totals.rate);
//             totalRow[c + 4] = r2(totals.total_amount);
//         }

//         totalRow[PREV_START] = r2(calculateTotal(transportations, item => Number(item.actual_month_total_previous)));
//         totalRow[PREV_START + 1] = r2(calculatePreviousAmount);
//         totalRow[CUR_START] = r2(calculateTotal(transportations, item => Number(item.actual_month)));
//         totalRow[CUR_START + 1] = r2(calculateCurrentAmount);
//         totalRow[CUM_START] = r2(calculateTotal(transportations, item => Number(item.actual_month_cumulative_total)));
//         totalRow[CUM_START + 1] = r2(calculateCumulated);
//         totalRow[REM_START] = r2(calculateTotal(transportations, item => Number(item.actual_month_remaining)));
//         totalRow[REM_START + 1] = r2(calculateRemaining);
//         rows.push(totalRow);

//         const colWidths = new Array(TOTAL_COLS).fill({ wch: 14 });
//         colWidths[SNO_COL] = { wch: 6 };
//         colWidths[DESC_COL] = { wch: 22 };

//         return { rows, merges, colWidths, sheetName: "Transportation" };
//     };

//     useEffect(() => {
//         if (transportations.length > 0 && typeof setExcelRows === "function") {
//             setExcelRows(buildExcelSheetData());
//         }
//     }, [transportations]);




//     // return (
//     //     <div className='table-css-backgrounds'>
//     //         <div className='print-center'>

//     //             <div className="table-css-background show-on-print ">
//     //                 <div className='flex-column'>
//     //                     <div>
//     //                         <h3 style={{ fontSize: "15px", textAlign: "justify" }}>{projectData?.project_name}</h3>
//     //                     </div>
//     //                     <div className='flex-row justify-between' style={{ width: "90vw" }}>

//     //                         <div className='consultant-heading'>
//     //                             <h6>Client Name:{projectData?.client_name}</h6>
//     //                             <h6>Consultant (AE):{projectData?.lead}{projectData?.jv ? ` JV with ${projectData?.jv}.` : ""}{projectData?.association ? ` Association with ${projectData?.association}` : ""}</h6>
//     //                             <h6>GSTIN No:{projectData?.gst_no}</h6>
//     //                             <h6>PAN No:{projectData?.pan_no}</h6>
//     //                             <h6>Bid Due Submission Date:{formatDateDD_MM_YYYY(projectData?.bid_due_date)}</h6>
//     //                             <div className='flex-row justify-between' style={{ width: "86vw" }}>
//     //                                 <div>
//     //                                     <h6>Agreement Date:{formatDateDD_MM_YYYY(projectData?.agreement_date)}</h6>
//     //                                     <h6>Project Start Date:{formatDateDD_MM_YYYY(projectData?.commencement_date)}</h6>
//     //                                 </div>
//     //                                 <div>
//     //                                     <h6>Date: {getMonthName(month)}-{year}</h6>
//     //                                     <h6>Invoice Number: {invoice_num}</h6>
//     //                                 </div>

//     //                             </div>
//     //                         </div>

//     //                     </div>
//     //                 </div>
//     //                 <div className='heads-div'>
//     //                     <h5 className='title-heading'>3- Transportation(Fixed rate on rental basis) <br /></h5>
//     //                     {role !== "ViewAccess" &&
//     //                         <div className="hide-on-print">
//     //                             {usefor === "generateinvoice" ?
//     //                                 <AddTransportationInvoice usedfor="InvoiceandDeduction" p_id={p_id ? p_id : project} invoice_id={invoice_id} getTransportationInvoice={getTransportationInvoice} month={month} year={year} logData={logData} />

//     //                                 :
//     //                                 <>
//     //                                     {transportations.length === 0 ?

//     //                                         <AddTransportationInvoice usedfor="OnlyDeduction" invoiceData={transportations} p_id={p_id ? p_id : project} invoice_id={invoice_id} getTransportationInvoice={getTransportationInvoice} month={month} year={year} logData={logData} />
//     //                                         :
//     //                                         <UpdateTransportDeductionInvoice invoiceData={transportations} getData={getTransportationInvoice} />
//     //                                     }
//     //                                 </>

//     //                             }
//     //                         </div>
//     //                     }


//     //                 </div>
//     //                 <div className='table-box scroll-container-table'>
//     //                     <table className=" nested-table-lightblue  ">
//     //                         <thead className=''>
//     //                             <tr className='theading'>
//     //                                 <th className='table-heading-text text-center' rowSpan="4">S.No</th>
//     //                                 <th className='table-heading-text text-center' rowSpan="4">Description of Vehicles</th>
//     //                                 <th className='table-heading-text text-center' colSpan="6" >Contract Amount</th>
//     //                                 {usefor !== "generateinvoice" && (
//     //                                     <>
//     //                                         <th className='table-heading-text text-center' rowSpan="5">Deduction Month</th>
//     //                                         <th className='table-heading-text text-center' rowSpan="5">Deduction Amount</th>

//     //                                     </>
//     //                                 )}
//     //                                 {isEotDataTrue &&
//     //                                     <th
//     //                                         className="table-heading-text text-center"
//     //                                         colSpan={eotLengths * 5 || 1}
//     //                                     >
//     //                                         ( COS/EOT)
//     //                                     </th>
//     //                                 }
//     //                                 <th className='table-heading-text text-center' colSpan="2" >Cumulative Total of Previous Months</th>
//     //                                 <th className='table-heading-text text-center' colSpan="2" >This Period</th>
//     //                                 <th className='table-heading-text text-center' colSpan="2" >Cumulative total Including Current Invoice</th>
//     //                                 <th className='table-heading-text text-center' colSpan="2" >Remaining amount against contract value</th>
//     //                                 {role !== "SiteManagement" && role !== "ViewAccess" &&
//     //                                     <th className='table-heading-text text-center hide-on-print' rowSpan="4" >Action</th>
//     //                                 }
//     //                             </tr>
//     //                             <tr className='nested-heading'>
//     //                                 {/* <th>No. of Vehicle</th> */}
//     //                                 <th rowSpan="2" className='table-heading-text'>No.of Vehicles</th>
//     //                                 <th rowSpan="2" className='table-heading-text'>Rate</th>
//     //                                 <th rowSpan="2" className='table-heading-text'>Const</th>
//     //                                 <th rowSpan="2" className='table-heading-text'>Maint</th>
//     //                                 <th rowSpan="2" className='table-heading-text'>nO. OF MM</th>
//     //                                 <th rowSpan="2" className='table-heading-text'>Total Amount</th>
//     //                                 {Array.from({ length: eotLengths }).map((_, idx) => (
//     //                                     <th key={idx} className="table-heading-text text-center" colSpan={5}>
//     //                                         {`Revised Contract Amount as per EOT ${idx + 1}`}
//     //                                     </th>
//     //                                 ))}
//     //                                 <th rowSpan="2" className='table-heading-text'>Month</th>
//     //                                 <th rowSpan="2" className='table-heading-text'>Amount</th>
//     //                                 <th rowSpan="2" className='table-heading-text'>Month</th>
//     //                                 <th rowSpan="2" className='table-heading-text'>Amount</th>
//     //                                 <th rowSpan="2" className='table-heading-text'>Month</th>
//     //                                 <th rowSpan="2" className='table-heading-text'>Amount</th>
//     //                                 <th rowSpan="2" className='table-heading-text'>Month</th>
//     //                                 <th rowSpan="2" className='table-heading-text'>Amount</th>


//     //                             </tr>
//     //                             <tr className='nested-heading'>
//     //                                 {Array.from({ length: eotLengths }).map((_, idx) => (
//     //                                     <React.Fragment key={idx}>
//     //                                         <th rowSpan="2" className='table-heading-text'>Const</th>
//     //                                         <th rowSpan="2" className='table-heading-text'>Maint</th>
//     //                                         <th rowSpan="2" className='table-heading-text'>Total MM</th>
//     //                                         <th rowSpan="2" className='table-heading-text'>Rate</th>

//     //                                         <th rowSpan="2" className='table-heading-text'>Total Amount</th>
//     //                                     </React.Fragment>
//     //                                 ))}

//     //                             </tr>
//     //                         </thead>
//     //                         <tbody>
//     //                             {transportations.map((item, index) => {
//     //                                 const matchedDeductions = deductionData?.filter(
//     //                                     (d) => d.item_id === item.id
//     //                                 ) || [];

//     //                                 return (


//     //                                     <tr className='tbody' key={item.id}>
//     //                                         <td className='table-body'>{index + 1}.</td>
//     //                                         <td className='table-body'><div className='whitespace-normal' style={{ width: "100px" }}>{item.boq_vehicle_description ?? item.transport_details.vehicle_description}</div></td>
//     //                                         {/* <td className='align-right'>1</td> */}
//     //                                         <td className='table-body'>{item.no_of_vehicle}</td>
//     //                                         <td className='table-body text-end'>₹ {formatCurrencyIndian(Number(item.boq_rate ?? item.transport_details.rate))}</td>
//     //                                         <td className='table-body text-end'>{item.boq_during_construction_period ?? item.transport_details.during_construction_period}</td>
//     //                                         <td className='table-body text-end'>{item.boq_during_dlp_OM_period ?? item.transport_details.during_dlp_OM_period}</td>
//     //                                         <td className='table-body text-end'>{Number(item.boq_during_construction_period ?? item.transport_details.during_construction_period) + Number(item.boq_during_dlp_OM_period ?? item.transport_details.during_dlp_OM_period)}</td>
//     //                                         <td className='table-body text-end'>₹ {formatCurrencyIndian(Number(item.boq_rate ?? item.transport_details.rate) * (Number(item.boq_during_construction_period ?? item.transport_details.during_construction_period) + Number(item.boq_during_dlp_OM_period ?? item.transport_details.during_dlp_OM_period)))}</td>
//     //                                         {usefor !== "generateinvoice" && (
//     //                                             <td className='table-body text-end'>
//     //                                                 {matchedDeductions.length > 0 ?
//     //                                                     matchedDeductions.map((n, i) => (
//     //                                                         <td key={i} className='flex-column' style={{ marginBottom: "4px" }}>
//     //                                                             {n.deduction_month ?? "-"}
//     //                                                         </td>
//     //                                                     ))
//     //                                                     : <td className='flex-column' style={{ marginBottom: "4px" }}>-</td>
//     //                                                 }
//     //                                             </td>
//     //                                         )}

//     //                                         {usefor !== "generateinvoice" && (
//     //                                             <td className='table-body text-end'>
//     //                                                 {matchedDeductions?.length > 0 ?
//     //                                                     <>
//     //                                                         {matchedDeductions.map((n, i) => (
//     //                                                             <td key={i} className='flex-column' style={{ marginBottom: "4px" }}>
//     //                                                                 {Number(n.deduction_amount) + Number(n.withheld_deduction_amount) || 0}
//     //                                                             </td>
//     //                                                         ))}
//     //                                                     </>
//     //                                                     : <td className='flex-column' style={{ marginBottom: "4px" }}>0</td>
//     //                                                 }
//     //                                             </td>
//     //                                         )}

//     //                                         {item?.eot_details?.length > 0 ?
//     //                                             <>
//     //                                                 {item.eot_details.map((i) => (
//     //                                                     <>
//     //                                                         <td className="align-right">{i.cp} </td>
//     //                                                         <td className="align-right">{i.dlp} </td>
//     //                                                         <td className="align-right">{i.t_month} </td>
//     //                                                         <td className="align-right">{i.rate} </td>
//     //                                                         <td className="align-right">{i.total_amount} </td>
//     //                                                     </>
//     //                                                 ))}
//     //                                             </> :
//     //                                             <></>
//     //                                         }
//     //                                         <td className='table-body text-end'>
//     //                                             {item?.actual_month_total_previous_two?.length > 0 ?
//     //                                                 <>
//     //                                                     {item?.actual_month_total_previous_two?.map((n, i) => (
//     //                                                         <td key={i} className='flex-column ' style={{ marginBottom: "4px" }}>
//     //                                                             {n}
//     //                                                         </td>
//     //                                                     ))}
//     //                                                 </>
//     //                                                 : <td className='flex-column ' style={{ marginBottom: "4px" }}>
//     //                                                     0
//     //                                                 </td>

//     //                                             }

//     //                                         </td>
//     //                                         <td className='table-body text-end'>
//     //                                             {item?.previous_invoice_total_two?.length > 0 ?
//     //                                                 <>
//     //                                                     {item?.previous_invoice_total_two?.map((n, i) => (
//     //                                                         <td key={i} className='flex-column ' style={{ marginBottom: "4px" }}>
//     //                                                             ₹ {formatCurrencyIndian(n)}
//     //                                                         </td>
//     //                                                     ))}
//     //                                                 </>
//     //                                                 : <td className='flex-column ' style={{ marginBottom: "4px" }}>
//     //                                                     ₹0
//     //                                                 </td>
//     //                                             }

//     //                                         </td>
//     //                                         <td className='table-body text-end'>
//     //                                             {item?.actual_month_two?.length > 0 ?
//     //                                                 <>
//     //                                                     {item?.actual_month_two?.map((n, i) => (
//     //                                                         <td key={i} className='flex-column ' style={{ marginBottom: "4px" }}>
//     //                                                             {(n)}
//     //                                                         </td>
//     //                                                     ))}
//     //                                                 </>
//     //                                                 : <td className='flex-column ' style={{ marginBottom: "4px" }}>
//     //                                                     ₹0
//     //                                                 </td>
//     //                                             }

//     //                                         </td>
//     //                                         <td className='table-body text-end'>
//     //                                             {item?.current_invoice_amount_two?.length > 0 ?
//     //                                                 <>
//     //                                                     {item?.current_invoice_amount_two?.map((n, i) => (
//     //                                                         <td key={i} className='flex-column ' style={{ marginBottom: "4px" }}>
//     //                                                             ₹ {formatCurrencyIndian(Number(n).toFixed(2))}
//     //                                                         </td>
//     //                                                     ))}
//     //                                                 </>
//     //                                                 : <td className='flex-column ' style={{ marginBottom: "4px" }}>
//     //                                                     ₹0
//     //                                                 </td>
//     //                                             }

//     //                                         </td>
//     //                                         <td className='table-body text-end'>
//     //                                             {item?.actual_month_cumulative_total_two?.length > 0 ?
//     //                                                 <>
//     //                                                     {item?.actual_month_cumulative_total_two?.map((n, i) => (
//     //                                                         <td key={i} className='flex-column ' style={{ marginBottom: "4px" }}>
//     //                                                             {formatCurrencyIndian(n)}
//     //                                                         </td>
//     //                                                     ))}
//     //                                                 </>
//     //                                                 : <td className='flex-column ' style={{ marginBottom: "4px" }}>
//     //                                                     ₹0
//     //                                                 </td>
//     //                                             }

//     //                                         </td>
//     //                                         <td className='table-body text-end'>
//     //                                             {item?.actual_amount_cumulative_total?.length > 0 ?
//     //                                                 <>
//     //                                                     {item?.actual_amount_cumulative_total?.map((n, i) => (
//     //                                                         <td key={i} className='flex-column ' style={{ marginBottom: "4px" }}>
//     //                                                             ₹ {formatCurrencyIndian(Number(n).toFixed(2))}
//     //                                                         </td>
//     //                                                     ))}
//     //                                                 </>
//     //                                                 : <td className='flex-column ' style={{ marginBottom: "4px" }}>
//     //                                                     ₹0
//     //                                                 </td>
//     //                                             }

//     //                                         </td>

//     //                                         <td className='table-body text-end'>{item.actual_month_remaining}</td>
//     //                                         <td className='table-body text-end'>₹ {formatCurrencyIndian(Number(item.remaining_amount))}</td>
//     //                                         {usefor === "generateinvoice" || role !== "ViewAccess" ?
//     //                                             <>
//     //                                                 {(!["Checker", "SiteManagement"].includes(role) && true) ||
//     //                                                     (role === "Checker" && !isMoreThan24Hours(item.created_at)) ?
//     //                                                     <td className='table-body text-end hide-on-print'>
//     //                                                         {usefor === "generateinvoice" ?
//     //                                                             <DeleteTransportationInvoice i={item} getTransportationInvoice={getTransportationInvoice} /> :
//     //                                                             <DeleteTransportationInvoiceDeduction i={item} getTransportationInvoice={getTransportationInvoice} />}
//     //                                                     </td>
//     //                                                     :
//     //                                                     <td className=" text-center hide-on-print">
//     //                                                         -
//     //                                                     </td>
//     //                                                 }
//     //                                             </>
//     //                                             : <></>}

//     //                                     </tr>
//     //                                 )

//     //                             }
//     //                             )}
//     //                         </tbody>
//     //                         <tfoot>
//     //                             <tr className='tbody'>
//     //                                 <td></td>
//     //                                 <td></td>
//     //                                 <td colSpan="" className="total-label">Total:</td>
//     //                                 {/* <td>{transportation.reduce(
//     //                             (total, item) => total + (item.during_construction_period + item.during_dlp_OM_period) * item.rate,
//     //                             0
//     //                         )}</td> */}
//     //                                 <td className='align-right'>₹{formatCurrencyIndian(calculateTotal(transportations, (item) => Number(item.boq_rate ?? item.transport_details.rate)))}</td>
//     //                                 <td className='align-right'>{(calculateTotal(transportations, (item) => Number(item.boq_during_construction_period ?? item.transport_details.during_construction_period)))}</td>
//     //                                 <td className='align-right'>{(calculateTotal(transportations, (item) => Number(item.boq_during_dlp_OM_period ?? item.transport_details.during_dlp_OM_period)))}</td>
//     //                                 <td className='align-right'>
//     //                                     {formatCurrencyIndian(calculateTotal(transportations, (item) => Number(item.boq_during_construction_period ?? item.transport_details.during_construction_period) + Number(item.boq_during_dlp_OM_period ?? item.transport_details.during_dlp_OM_period)))}
//     //                                 </td>
//     //                                 <td className='align-right'>₹
//     //                                     {formatCurrencyIndian(calculateTotal(transportations, (item) => Number(item.boq_rate ?? item.transport_details.rate) * (Number(item.boq_during_construction_period ?? item.transport_details.during_construction_period) + Number(item.boq_during_dlp_OM_period ?? item.transport_details.during_dlp_OM_period))))}

//     //                                     {/* {formatCurrencyIndian(
//     //                                         transportations.reduce((total, item) => total + Number(item.transport_details.rate) * (Number(item.transport_details.during_construction_period) + Number(item.transport_details.during_dlp_OM_period)), 0)
//     //                                     )} */}
//     //                                 </td>
//     //                                 {usefor !== "generateinvoice" && (
//     //                                     <>
//     //                                         <td className="align-right">
//     //                                             {/* ✅ Use deductionData instead of item.deduction_amount */}
//     //                                             {(
//     //                                                 transportations.reduce((grandTotal, item) => {
//     //                                                     const matchedDeductions = deductionData?.filter(
//     //                                                         (d) => d.item_id === item.id
//     //                                                     ) || [];
//     //                                                     const rowTotal = matchedDeductions.reduce(
//     //                                                         (sum, d) => sum + (Number(d?.deduction_month) || 0), 0
//     //                                                     );
//     //                                                     return grandTotal + rowTotal;
//     //                                                 }, 0)
//     //                                             )}
//     //                                         </td>
//     //                                         <td className="align-right">
//     //                                             {/* ✅ Use deductionData instead of item.deduction_amount */}
//     //                                             ₹{formatCurrencyIndian(
//     //                                                 transportations.reduce((grandTotal, item) => {
//     //                                                     const matchedDeductions = deductionData?.filter(
//     //                                                         (d) => d.item_id === item.id
//     //                                                     ) || [];
//     //                                                     const rowTotal = matchedDeductions.reduce(
//     //                                                         (sum, d) => sum + (Number(d?.deduction_amount) || 0), 0
//     //                                                     );
//     //                                                     return grandTotal + rowTotal;
//     //                                                 }, 0)
//     //                                             )}
//     //                                         </td>
//     //                                     </>
//     //                                 )}
//     //                                 {isEotDataTrue && (
//     //                                     <>
//     //                                         {Array.from({ length: eotLengths }).map((_, eotIdx) => {
//     //                                             const totals = transportations.reduce(
//     //                                                 (acc, emp) => {
//     //                                                     const details =
//     //                                                         emp.eot_details?.length > 0
//     //                                                             ? emp.eot_details
//     //                                                             : emp.data?.eot_details || [];
//     //                                                     const eot = details[eotIdx];

//     //                                                     if (!eot) return acc;

//     //                                                     acc.cp += Number(eot?.cp) || 0;
//     //                                                     acc.dlp += Number(eot?.dlp) || 0;
//     //                                                     acc.t_month += Number(eot?.t_month) || 0;
//     //                                                     acc.rate += Number(eot?.rate) || 0;
//     //                                                     acc.total_amount += Number(eot?.total_amount) || 0;

//     //                                                     return acc;
//     //                                                 },
//     //                                                 { cp: 0, dlp: 0, t_month: 0, rate: 0, total_amount: 0 }
//     //                                             );

//     //                                             const grandTotal =
//     //                                                 totals.cp + totals.dlp + totals.t_month * totals.rate;

//     //                                             return (
//     //                                                 <React.Fragment key={eotIdx}>
//     //                                                     <td className="align-right">{formatCurrencyIndian(totals.cp)}</td>
//     //                                                     <td className="align-right">{formatCurrencyIndian(totals.dlp)}</td>
//     //                                                     <td className="align-right">{totals.t_month}</td>
//     //                                                     <td className="align-right">₹{formatCurrencyIndian(totals.rate)}</td>
//     //                                                     <td className="align-right">₹{formatCurrencyIndian(totals.total_amount)}</td>

//     //                                                 </React.Fragment>
//     //                                             );
//     //                                         })}
//     //                                     </>
//     //                                 )}

//     //                                 <td className='align-right'>{formatCurrencyIndian(calculateTotal(transportations, (item) => Number(item.actual_month_total_previous)))}</td>
//     //                                 {/* <td className='align-right'>{formatCurrencyIndian(calculateTotal(transportations, (item) => item.previous_invoice_total))}</td> */}
//     //                                 <td className='align-right'>₹{formatCurrencyIndian(calculateTotal(transportations, (item) => Number(item.previous_invoice_total)))}</td>
//     //                                 <td className='align-right'>{formatCurrencyIndian(calculateTotal(transportations, (item) => Number(item.actual_month)))}</td>
//     //                                 <td className='align-right'>₹{formatCurrencyIndian(calculateTotal(transportations, (item) => Number(item.invoice_amount ?? item.current_invoice_amount)))}</td>
//     //                                 <td className='align-right'>{formatCurrencyIndian(calculateTotal(transportations, (item) => Number(item.actual_month_cumulative_total)))}</td>
//     //                                 <td className='align-right'>₹{formatCurrencyIndian(calculateTotal(transportations, (item) => Number(item.cumulative_invoice_total)))}</td>
//     //                                 <td className='align-right'>{formatCurrencyIndian(calculateTotal(transportations, (item) => Number(item.actual_month_remaining)))}</td>
//     //                                 <td className='align-right'>₹{formatCurrencyIndian(calculateTotal(transportations, (item) => Number(item.remaining_amount)))}</td>
//     //                                 {role !== "SiteManagement" && role !== "ViewAccess" &&

//     //                                     <td className='hide-on-print'></td>
//     //                                 }
//     //                             </tr>
//     //                         </tfoot>
//     //                     </table>
//     //                 </div>
//     //             </div>
//     //         </div>

//     //     </div>
//     // );




//     return (
//         <div className="boc-modern-wrapper" style={{ minHeight: "30vh" }}>
//             <div className="boc-modern-card">

//                 {/* Print header */}
//                 <div className="boc-modern-header bocx-modern-footer-total">
//                     <div className="boc-modern-header-content">
//                         <div className="boc-modern-project-info">
//                             <h3 className="boc-modern-project-title">{projectData?.project_name}</h3>
//                             <div className="boc-modern-project-meta">
//                                 <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Client:</span><span className="boc-modern-meta-value">{projectData?.client_name}</span></div>
//                                 <div className="boc-modern-meta-divider"></div>
//                                 <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Consultant (AE):</span><span className="boc-modern-meta-value">{projectData?.lead}{projectData?.jv ? ` JV with ${projectData?.jv}.` : ""}{projectData?.association ? ` Association with ${projectData?.association}` : ""}</span></div>
//                                 <div className="boc-modern-meta-divider"></div>
//                                 <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">GSTIN:</span><span className="boc-modern-meta-value">{projectData?.gst_no}</span></div>
//                                 <div className="boc-modern-meta-divider"></div>
//                                 <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">PAN:</span><span className="boc-modern-meta-value">{projectData?.pan_no}</span></div>
//                                 <div className="boc-modern-meta-divider"></div>
//                                 <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Bid Due:</span><span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.bid_due_date)}</span></div>
//                                 <div className="boc-modern-meta-divider"></div>
//                                 <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Agreement:</span><span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.agreement_date)}</span></div>
//                                 <div className="boc-modern-meta-divider"></div>
//                                 <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Start:</span><span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.commencement_date)}</span></div>
//                                 <div className="boc-modern-meta-divider"></div>
//                                 <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Invoice Number:</span><span className="boc-modern-meta-value">{invoice_num}</span></div>
//                                 <div className="boc-modern-meta-divider"></div>
//                                 <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Date:</span><span className="boc-modern-meta-value">{getMonthName(month)}-{year}</span></div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>

//                 {/* Section heading + action */}
//                 <div className="boc-modern-description-section">
//                     <div className="boc-modern-controls">
//                         <div className="boc-modern-controls-left">
//                             <h6 className="boc-modern-main-heading">3- Transportation (Fixed rate on rental basis)</h6>
//                         </div>
//                         {role !== "ViewAccess" && (
//                             <div className="hide-on-print">
//                                 {usefor === "generateinvoice" ?
//                                     <AddTransportationInvoice usedfor="InvoiceandDeduction" p_id={p_id ? p_id : project} invoice_id={invoice_id} getTransportationInvoice={getTransportationInvoice} month={month} year={year} logData={logData} />
//                                     :
//                                     <>
//                                         {transportations.length === 0
//                                             ? <AddTransportationInvoice usedfor="OnlyDeduction" invoiceData={transportations} p_id={p_id ? p_id : project} invoice_id={invoice_id} getTransportationInvoice={getTransportationInvoice} month={month} year={year} logData={logData} />
//                                             : <UpdateTransportDeductionInvoice invoiceData={transportations} getData={getTransportationInvoice} />
//                                         }
//                                     </>
//                                 }
//                             </div>
//                         )}
//                     </div>
//                 </div>

//                 <div className="boc-modern-table-wrapper">
//                     <div className="boc-modern-table-scroll">
//                         <table className="boc-modern-table">
//                             <thead>
//                                 <tr className="boc-modern-table-header">
//                                     <th className="boc-modern-th text-center" rowSpan="4">S.No</th>
//                                     <th className="boc-modern-th text-center" rowSpan="4">Description of Vehicles</th>
//                                     <th className="boc-modern-th text-center" colSpan="6">Contract Amount</th>
//                                     {usefor !== "generateinvoice" && (
//                                         <>
//                                             <th className="boc-modern-th text-center" rowSpan="4">Deduction Month</th>
//                                             <th className="boc-modern-th text-center" rowSpan="4">Deduction Amount</th>
//                                         </>
//                                     )}
//                                     {isEotDataTrue && (
//                                         <th className="boc-modern-th text-center" colSpan={eotLengths * 5 || 1}>(COS/EOT)</th>
//                                     )}
//                                     <th className="boc-modern-th text-center" colSpan="2">Cumulative Total of Previous Months</th>
//                                     <th className="boc-modern-th text-center" colSpan="2">This Period</th>
//                                     <th className="boc-modern-th text-center" colSpan="2">Cumulative Total Including Current Invoice</th>
//                                     <th className="boc-modern-th text-center" colSpan="2">Remaining Amount Against Contract Value</th>
//                                     {role !== "SiteManagement" && role !== "ViewAccess" && (
//                                         <th className="boc-modern-th text-center hide-on-print" rowSpan="4">Action</th>
//                                     )}
//                                 </tr>
//                                 <tr className="boc-modern-table-subheader">
//                                     <th rowSpan="2" className="boc-modern-th boc-nowrap">No. of Vehicles</th>
//                                     <th rowSpan="2" className="boc-modern-th boc-nowrap">Rate</th>
//                                     <th rowSpan="2" className="boc-modern-th boc-nowrap">Const</th>
//                                     <th rowSpan="2" className="boc-modern-th boc-nowrap">Maint</th>
//                                     <th rowSpan="2" className="boc-modern-th boc-nowrap">No. of MM</th>
//                                     <th rowSpan="2" className="boc-modern-th boc-nowrap">Total Amount</th>
//                                     {Array.from({ length: eotLengths }).map((_, idx) => (
//                                         <th key={idx} className="boc-modern-th text-center boc-nowrap" colSpan={5}>{`EOT ${idx + 1}`}</th>
//                                     ))}
//                                     <th rowSpan="2" className="boc-modern-th boc-nowrap">Month</th>
//                                     <th rowSpan="2" className="boc-modern-th boc-nowrap">Amount</th>
//                                     <th rowSpan="2" className="boc-modern-th boc-nowrap">Month</th>
//                                     <th rowSpan="2" className="boc-modern-th boc-nowrap">Amount</th>
//                                     <th rowSpan="2" className="boc-modern-th boc-nowrap">Month</th>
//                                     <th rowSpan="2" className="boc-modern-th boc-nowrap">Amount</th>
//                                     <th rowSpan="2" className="boc-modern-th boc-nowrap">Month</th>
//                                     <th rowSpan="2" className="boc-modern-th boc-nowrap">Amount</th>
//                                 </tr>
//                                 <tr className="boc-modern-table-subheader">
//                                     {Array.from({ length: eotLengths }).map((_, idx) => (
//                                         <React.Fragment key={idx}>
//                                             <th rowSpan="2" className="boc-modern-th boc-nowrap">Const</th>
//                                             <th rowSpan="2" className="boc-modern-th boc-nowrap">Maint</th>
//                                             <th rowSpan="2" className="boc-modern-th boc-nowrap">Total MM</th>
//                                             <th rowSpan="2" className="boc-modern-th boc-nowrap">Rate</th>
//                                             <th rowSpan="2" className="boc-modern-th boc-nowrap">Total Amount</th>
//                                         </React.Fragment>
//                                     ))}
//                                 </tr>
//                             </thead>

//                             <tbody>
//                                 {transportations.map((item, index) => {
//                                     const matchedDeductions = deductionData?.filter(d => d.item_id === item.id) || [];
//                                     return (
//                                         <tr className="boc-modern-row" key={item.id}>
//                                             <td className="boc-modern-td text-center">{index + 1}.</td>
//                                             <td className="boc-modern-td"><div style={{ width: "100px", whiteSpace: "normal" }}>{item.boq_vehicle_description ?? item.transport_details.vehicle_description}</div></td>
//                                             <td className="boc-modern-td boc-nowrap text-right">{item.no_of_vehicle}</td>
//                                             <td className="boc-modern-td boc-nowrap boc-modern-currency text-right">₹ {formatAmount2(Number(item.boq_rate ?? item.transport_details.rate))}</td>
//                                             <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(item.boq_during_construction_period ?? item.transport_details.during_construction_period)}</td>
//                                             <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(item.boq_during_dlp_OM_period ?? item.transport_details.during_dlp_OM_period)}</td>
//                                             <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(Number(item.boq_during_construction_period ?? item.transport_details.during_construction_period) + Number(item.boq_during_dlp_OM_period ?? item.transport_details.during_dlp_OM_period))}</td>
//                                             <td className="boc-modern-td boc-nowrap text-right">
//                                                 <span className="boc-modern-currency boc-modern-total-highlight">
//                                                     ₹ {formatAmount2(Number(item.boq_rate ?? item.transport_details.rate) * (Number(item.boq_during_construction_period ?? item.transport_details.during_construction_period) + Number(item.boq_during_dlp_OM_period ?? item.transport_details.during_dlp_OM_period)))}
//                                                 </span>
//                                             </td>

//                                             {/* Deduction Month */}
//                                             {usefor !== "generateinvoice" && (
//                                                 <td className="boc-modern-td boc-nowrap text-right justify-end" style={{ padding: 0 }}>
//                                                     {matchedDeductions.length > 0
//                                                         ? matchedDeductions.map((n, i) => (
//                                                             <div key={i} className="boc-multi-item boc-nowrap">{n.deduction_month == null ? "-" : formatMonth2(n.deduction_month)}</div>
//                                                         ))
//                                                         : <div className="boc-multi-item">-</div>
//                                                     }
//                                                 </td>
//                                             )}

//                                             {/* Deduction Amount */}
//                                             {usefor !== "generateinvoice" && (
//                                                 <td className="boc-modern-td boc-nowrap text-right justify-end" style={{ padding: 0 }}>
//                                                     {matchedDeductions.length > 0
//                                                         ? matchedDeductions.map((n, i) => (
//                                                             <div key={i} className="boc-multi-item boc-nowrap">{formatAmount2((Number(n.deduction_amount) || 0) + (Number(n.withheld_deduction_amount) || 0))}</div>
//                                                         ))
//                                                         : <div className="boc-multi-item">0.00</div>
//                                                     }
//                                                 </td>
//                                             )}

//                                             {/* EOT */}
//                                             {item?.eot_details?.length > 0 && item.eot_details.map((i, idx) => (
//                                                 <React.Fragment key={idx}>
//                                                     <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(i.cp)}</td>
//                                                     <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(i.dlp)}</td>
//                                                     <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(i.t_month)}</td>
//                                                     <td className="boc-modern-td boc-nowrap boc-modern-currency text-right">₹ {formatAmount2(Number(i.rate))}</td>
//                                                     <td className="boc-modern-td boc-nowrap boc-modern-currency text-right">₹ {formatAmount2(Number(i.total_amount))}</td>
//                                                 </React.Fragment>
//                                             ))}

//                                             {/* Previous Month */}
//                                             <td className="boc-modern-td boc-nowrap text-right justify-end" style={{ padding: 0 }}>
//                                                 {item?.actual_month_total_previous_two?.length > 0
//                                                     ? item.actual_month_total_previous_two.map((n, i) => <div key={i} className="boc-multi-item boc-nowrap">{formatMonth2(n)}</div>)
//                                                     : <div className="boc-multi-item">0.00</div>
//                                                 }
//                                             </td>
//                                             {/* Previous Amount */}
//                                             <td className="boc-modern-td boc-nowrap boc-modern-currency text-right justify-end" style={{ padding: 0 }}>
//                                                 {item?.previous_invoice_total_two?.length > 0
//                                                     ? item.previous_invoice_total_two.map((n, i) => <div key={i} className="boc-multi-item boc-nowrap">₹ {formatAmount2(n)}</div>)
//                                                     : <div className="boc-multi-item">₹ 0.00</div>
//                                                 }
//                                             </td>
//                                             {/* Current Month */}
//                                             <td className="boc-modern-td boc-nowrap text-right justify-end" style={{ padding: 0 }}>
//                                                 {item?.actual_month_two?.length > 0
//                                                     ? item.actual_month_two.map((n, i) => <div key={i} className="boc-multi-item boc-nowrap">{formatMonth2(n)}</div>)
//                                                     : <div className="boc-multi-item">0.00</div>
//                                                 }
//                                             </td>
//                                             {/* Current Amount */}
//                                             <td className="boc-modern-td boc-nowrap boc-modern-currency text-right justify-end" style={{ padding: 0 }}>
//                                                 {item?.current_invoice_amount_two?.length > 0
//                                                     ? item.current_invoice_amount_two.map((n, i) => <div key={i} className="boc-multi-item boc-nowrap">₹ {formatAmount2(n)}</div>)
//                                                     : <div className="boc-multi-item">₹ 0.00</div>
//                                                 }
//                                             </td>
//                                             {/* Cumulative Month */}
//                                             <td className="boc-modern-td boc-nowrap text-right justify-end" style={{ padding: 0 }}>
//                                                 {item?.actual_month_cumulative_total_two?.length > 0
//                                                     ? item.actual_month_cumulative_total_two.map((n, i) => <div key={i} className="boc-multi-item boc-nowrap">{formatMonth2(n)}</div>)
//                                                     : <div className="boc-multi-item">0.00</div>
//                                                 }
//                                             </td>
//                                             {/* Cumulative Amount */}
//                                             <td className="boc-modern-td boc-nowrap boc-modern-currency text-right justify-end" style={{ padding: 0 }}>
//                                                 {item?.actual_amount_cumulative_total?.length > 0
//                                                     ? item.actual_amount_cumulative_total.map((n, i) => <div key={i} className="boc-multi-item boc-nowrap">₹ {formatAmount2(n)}</div>)
//                                                     : <div className="boc-multi-item">₹ 0.00</div>
//                                                 }
//                                             </td>
//                                             {/* Remaining */}
//                                             <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(item.actual_month_remaining)}</td>
//                                             <td className="boc-modern-td boc-nowrap text-right">
//                                                 <span className="boc-modern-currency boc-modern-total-highlight">
//                                                     ₹ {formatAmount2(Number(item.remaining_amount))}
//                                                 </span>
//                                             </td>

//                                             {/* Action */}
//                                             {(usefor === "generateinvoice" || role !== "ViewAccess") && (
//                                                 <>
//                                                     {(!["Checker", "SiteManagement"].includes(role)) ||
//                                                         (role === "Checker" && !isMoreThan24Hours(item.created_at)) ? (
//                                                         <td className="boc-modern-td text-center hide-on-print">
//                                                             {usefor === "generateinvoice"
//                                                                 ? <DeleteTransportationInvoice i={item} getTransportationInvoice={getTransportationInvoice} />
//                                                                 : <DeleteTransportationInvoiceDeduction i={item} getTransportationInvoice={getTransportationInvoice} />
//                                                             }
//                                                         </td>
//                                                     ) : (
//                                                         <td className="boc-modern-td text-center hide-on-print">-</td>
//                                                     )}
//                                                 </>
//                                             )}
//                                         </tr>
//                                     );
//                                 })}
//                             </tbody>

//                             <tfoot>
//                                 <tr className="boc-modern-footer">
//                                     <td colSpan="2" className="boc-modern-footer-label">Total:</td>
//                                     <td className="boc-modern-td boc-nowrap text-right">{/* no_of_vehicle total not available per item, leave blank or sum if available */}</td>
//                                     <td className="boc-modern-td boc-nowrap text-right">
//                                         <span className="boc-modern-currency boc-modern-footer-total">
//                                             ₹ {formatAmount2(calculateTotal(transportations, item => Number(item.boq_rate ?? item.transport_details.rate)))}
//                                         </span>
//                                     </td>
//                                     <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(calculateTotal(transportations, item => Number(item.boq_during_construction_period ?? item.transport_details.during_construction_period)))}</td>
//                                     <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(calculateTotal(transportations, item => Number(item.boq_during_dlp_OM_period ?? item.transport_details.during_dlp_OM_period)))}</td>
//                                     <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(calculateTotal(transportations, item => Number(item.boq_during_construction_period ?? item.transport_details.during_construction_period) + Number(item.boq_during_dlp_OM_period ?? item.transport_details.during_dlp_OM_period)))}</td>
//                                     <td className="boc-modern-td boc-nowrap text-right">
//                                         <span className="boc-modern-currency boc-modern-footer-total">
//                                             ₹ {formatAmount2(calculateTotal(transportations, item => Number(item.boq_rate ?? item.transport_details.rate) * (Number(item.boq_during_construction_period ?? item.transport_details.during_construction_period) + Number(item.boq_during_dlp_OM_period ?? item.transport_details.during_dlp_OM_period))))}
//                                         </span>
//                                     </td>

//                                     {usefor !== "generateinvoice" && (
//                                         <>
//                                             <td className="boc-modern-td boc-nowrap text-right">
//                                                 {formatMonth2(transportations.reduce((gt, item) => {
//                                                     const matched = deductionData?.filter(d => d.item_id === item.id) || [];
//                                                     return gt + matched.reduce((s, d) => s + (Number(d?.deduction_month) || 0), 0);
//                                                 }, 0))}
//                                             </td>
//                                             <td className="boc-modern-td boc-nowrap text-right">
//                                                 <span className="boc-modern-currency boc-modern-footer-total">
//                                                     ₹ {formatAmount2(
//                                                         transportations.reduce((gt, item) => {
//                                                             const matched = deductionData?.filter(d => d.item_id === item.id) || [];
//                                                             return gt + matched.reduce((s, d) => s + ((Number(d?.deduction_amount) || 0) + (Number(d?.withheld_deduction_amount) || 0)), 0);
//                                                         }, 0)
//                                                     )}
//                                                 </span>
//                                             </td>
//                                         </>
//                                     )}

//                                     {isEotDataTrue && Array.from({ length: eotLengths }).map((_, eotIdx) => {
//                                         const totals = transportations.reduce((acc, emp) => {
//                                             const details = emp.eot_details?.length > 0 ? emp.eot_details : emp.data?.eot_details || [];
//                                             const eot = details[eotIdx];
//                                             if (!eot) return acc;
//                                             acc.cp += Number(eot?.cp) || 0;
//                                             acc.dlp += Number(eot?.dlp) || 0;
//                                             acc.t_month += Number(eot?.t_month) || 0;
//                                             acc.rate += Number(eot?.rate) || 0;
//                                             acc.total_amount += Number(eot?.total_amount) || 0;
//                                             return acc;
//                                         }, { cp: 0, dlp: 0, t_month: 0, rate: 0, total_amount: 0 });
//                                         return (
//                                             <React.Fragment key={eotIdx}>
//                                                 <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(totals.cp)}</td>
//                                                 <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(totals.dlp)}</td>
//                                                 <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(totals.t_month)}</td>
//                                                 <td className="boc-modern-td boc-nowrap text-right">₹ {formatAmount2(totals.rate)}</td>
//                                                 <td className="boc-modern-td boc-nowrap text-right">
//                                                     <span className="boc-modern-currency boc-modern-footer-total">₹ {formatAmount2(totals.total_amount)}</span>
//                                                 </td>
//                                             </React.Fragment>
//                                         );
//                                     })}

//                                     <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(calculateTotal(transportations, item => Number(item.actual_month_total_previous)))}</td>
//                                     <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatAmount2(calculateTotal(transportations, item => Number(item.previous_invoice_total)))}</span></td>
//                                     <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(calculateTotal(transportations, item => Number(item.actual_month)))}</td>
//                                     <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatAmount2(calculateTotal(transportations, item => Number(item.invoice_amount ?? item.current_invoice_amount)))}</span></td>
//                                     <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(calculateTotal(transportations, item => Number(item.actual_month_cumulative_total)))}</td>
//                                     <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatAmount2(calculateTotal(transportations, item => Number(item.cumulative_invoice_total)))}</span></td>
//                                     <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(calculateTotal(transportations, item => Number(item.actual_month_remaining)))}</td>
//                                     <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatAmount2(calculateTotal(transportations, item => Number(item.remaining_amount)))}</span></td>

//                                     {role !== "SiteManagement" && role !== "ViewAccess" && (
//                                         <td className="hide-on-print boc-modern-td"></td>
//                                     )}
//                                 </tr>
//                             </tfoot>
//                         </table>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };


const Transportation = ({ deductionData, projectData, setEotDetails, client, p_id, invoice_id, invoice_num, month, year, logData,
    setPreviousAmount,
    setCurrentAmount,
    setRemainingAmount,
    setContractAmount,
    setCumulated,
    usefor,
    setExcelRows,

}) => {

    const currentDate = new Date();
    const isFirstWeek = currentDate.getDate() <= 7;
    const [transportations, setTransportations] = useState([]);

    const role = sessionStorage.getItem('sitemanagement_role');





    const calculateContractAmount = calculateTotal(transportations, (item) => Number(item.boq_rate ?? item.transport_details.rate) * (Number(item.boq_during_construction_period ?? item.transport_details.during_construction_period) + Number(item.boq_during_dlp_OM_period ?? item.transport_details.during_dlp_OM_period)))
    setContractAmount(calculateContractAmount);
    const calculatePreviousAmount = calculateTotal(transportations, (item) => Number(item.previous_invoice_total))
    setPreviousAmount(calculatePreviousAmount);
    const calculateCurrentAmount = calculateTotal(transportations, (item) => Number(item.invoice_amount ?? item.current_invoice_amount))
    setCurrentAmount(calculateCurrentAmount);
    const calculateCumulated = calculateTotal(transportations, (item) => Number(item.cumulative_invoice_total))
    setCumulated(calculateCumulated);
    const calculateRemaining = calculateTotal(transportations, (item) => Number(item.remaining_amount))
    setRemainingAmount(calculateRemaining);

    useEffect(() => {
        const eotGroups = [];
        transportations.forEach(item => {
            (item?.eot_details || []).forEach((eot, idx) => {
                if (!eotGroups[idx]) {
                    eotGroups[idx] = { ...eot, total_amount: 0 };
                }
                eotGroups[idx].total_amount += Number(eot.total_amount || 0);
            });
        });

        setEotDetails(eotGroups);
        console.log("Transport EOT Groups:", eotGroups);
    }, [transportations]);


    const getTransportationInvoice = async () => {

        try {
            let data;

            if (usefor === "generateinvoice") {
                const res = await axios.get(
                    `${BASE_URL}/siteproject/invoicetransportbyprojectstatus/${p_id ? p_id : project}/${month}/${year}/`
                );
                data = res.data;
            } else {
                const response2 = await axios.get(
                    `${BASE_URL}/siteproject/newinvoicetransportationfiltermonthyear/${invoice_id}/null/null/`
                );
                data = response2.data;
            }

            const isAnyBoqJsonNull = data.length !== 0 && data.every(item => item.boq_json === null);


            const selectedTransportationData = isAnyBoqJsonNull ? data : data;
            setTransportations(selectedTransportationData);
        } catch (err) { }
    };

    useEffect(() => {

        // getdocument();
        getTransportationInvoice();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const project = sessionStorage.getItem('sitemanagement_project');
    const isEotDataTrue = transportations.some(i =>
        (i.eot_details?.length > 0) || (i.data?.eot_details?.length > 0)
    );





    const eotLengths = Math.max(
        ...transportations.map(i => i?.eot_details?.length || i?.data?.eot_details?.length || 0),
        0
    );

    // Display-only helpers: calculations and API values retain their original precision.
    // Months are displayed with exactly two decimal places (for example, 0.322211 -> 0.32).
    const formatMonth2 = (value) => {
        const n = Number(value ?? 0);
        return Number.isFinite(n) ? n.toFixed(2) : "0.00";
    };

    // Round monetary amounts to nearest full rupee, only at display/export time.
    // Internal calculations, state, and API data retain their original precision.
    // Examples: 38571.43 -> 38571, 38571.54 -> 38572.
    const roundAmount0 = (value) => {
        const n = Number(value ?? 0);
        if (!Number.isFinite(n)) return 0;
        // Handle negative deduction amounts symmetrically at the 0.5 boundary.
        return Math.sign(n) * Math.round(Math.abs(n));
    };

    const formatAmount0 = (value) =>
        roundAmount0(value).toLocaleString("en-IN", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        });

    // Excel month/quantity cells preserve two decimal places as strings.
    // Excel amount cells contain whole-rupee numeric values (not pre-rounded math).
    const r2 = (value) => formatMonth2(value);
    const rAmount0 = (value) => roundAmount0(value);

    // ── Builds a fully formatted AOA sheet (merged headers, flat rows) ──
    // Transportation has no employee-type sections, so it's a flat list unlike ProfessionalStaff.
    const buildExcelSheetData = () => {
        const showDeduction = usefor !== "generateinvoice";

        // ---- figure out column layout ----
        let col = 0;
        const SNO_COL = col++;                  // 0
        const DESC_COL = col++;                 // 1
        const CONTRACT_START = col; col += 6;   // No. of Vehicles, Rate, Const, Maint, No. of MM, Total Amount
        let DED_MONTH_COL = -1, DED_AMT_COL = -1;
        if (showDeduction) {
            DED_MONTH_COL = col++;
            DED_AMT_COL = col++;
        }
        const EOT_START = col; col += eotLengths * 5;   // 5 cols per EOT group
        const PREV_START = col; col += 2;   // Month, Amount
        const CUR_START = col; col += 2;
        const CUM_START = col; col += 2;
        const REM_START = col; col += 2;
        const TOTAL_COLS = col;

        const blankRow = () => new Array(TOTAL_COLS).fill("");

        // ---- header row 1 (group labels) ----
        const row1 = blankRow();
        row1[SNO_COL] = "S.No";
        row1[DESC_COL] = "Description of Vehicles";
        row1[CONTRACT_START] = "Contract Amount";
        if (showDeduction) {
            row1[DED_MONTH_COL] = "Deduction Month";
            row1[DED_AMT_COL] = "Deduction Amount";
        }
        for (let i = 0; i < eotLengths; i++) {
            row1[EOT_START + i * 5] = `EOT ${i + 1}`;
        }
        row1[PREV_START] = "Cumulative Total of Previous Months";
        row1[CUR_START] = "This Period";
        row1[CUM_START] = "Cumulative Total Including Current Invoice";
        row1[REM_START] = "Remaining Amount Against Contract Value";

        // ---- header row 2 (sub labels) ----
        const row2 = blankRow();
        row2[CONTRACT_START] = "No. of Vehicles";
        row2[CONTRACT_START + 1] = "Rate";
        row2[CONTRACT_START + 2] = "Const";
        row2[CONTRACT_START + 3] = "Maint";
        row2[CONTRACT_START + 4] = "No. of MM";
        row2[CONTRACT_START + 5] = "Total Amount";
        for (let i = 0; i < eotLengths; i++) {
            const c = EOT_START + i * 5;
            row2[c] = "Const";
            row2[c + 1] = "Maint";
            row2[c + 2] = "Total MM";
            row2[c + 3] = "Rate";
            row2[c + 4] = "Total Amount";
        }
        row2[PREV_START] = "Month"; row2[PREV_START + 1] = "Amount";
        row2[CUR_START] = "Month"; row2[CUR_START + 1] = "Amount";
        row2[CUM_START] = "Month"; row2[CUM_START + 1] = "Amount";
        row2[REM_START] = "Month"; row2[REM_START + 1] = "Amount";

        // ---- merges for the two header rows ----
        const merges = [];
        const vMerge = (c) => merges.push({ s: { r: 0, c }, e: { r: 1, c } });
        const hMerge = (c1, c2) => merges.push({ s: { r: 0, c: c1 }, e: { r: 0, c: c2 } });

        vMerge(SNO_COL); vMerge(DESC_COL);
        if (showDeduction) { vMerge(DED_MONTH_COL); vMerge(DED_AMT_COL); }
        hMerge(CONTRACT_START, CONTRACT_START + 5);
        for (let i = 0; i < eotLengths; i++) {
            const c = EOT_START + i * 5;
            hMerge(c, c + 4);
        }
        hMerge(PREV_START, PREV_START + 1);
        hMerge(CUR_START, CUR_START + 1);
        hMerge(CUM_START, CUM_START + 1);
        hMerge(REM_START, REM_START + 1);

        // ---- data rows (flat — no sections for transportation) ----
        const rows = [row1, row2];

        transportations.forEach((item, index) => {
            const rate = Number(item.boq_rate ?? item.transport_details.rate) || 0;
            const constMM = Number(item.boq_during_construction_period ?? item.transport_details.during_construction_period) || 0;
            const omMM = Number(item.boq_during_dlp_OM_period ?? item.transport_details.during_dlp_OM_period) || 0;
            const totalMM = constMM + omMM;
            const totalAmt = rate * totalMM;

            const matchedDeductions = deductionData?.filter((d) => d.item_id === item.id) || [];
            const deductionMonthSum = matchedDeductions.reduce((s, n) => s + (Number(n.deduction_month) || 0), 0);
            const deductionAmountSum = matchedDeductions.reduce((s, n) => s + ((Number(n.deduction_amount) + Number(n.withheld_deduction_amount)) || 0), 0);

            const r = blankRow();
            r[SNO_COL] = index + 1;
            r[DESC_COL] = item.boq_vehicle_description ?? item.transport_details.vehicle_description ?? "";
            r[CONTRACT_START] = Number(item.no_of_vehicle) || 0;
            r[CONTRACT_START + 1] = rAmount0(rate);
            r[CONTRACT_START + 2] = r2(constMM);
            r[CONTRACT_START + 3] = r2(omMM);
            r[CONTRACT_START + 4] = r2(totalMM);
            r[CONTRACT_START + 5] = rAmount0(totalAmt);
            if (showDeduction) {
                r[DED_MONTH_COL] = r2(deductionMonthSum);
                r[DED_AMT_COL] = rAmount0(deductionAmountSum);
            }
            (item.eot_details || []).forEach((e, i) => {
                const c = EOT_START + i * 5;
                r[c] = r2(e.cp);
                r[c + 1] = r2(e.dlp);
                r[c + 2] = r2(e.t_month);
                r[c + 3] = rAmount0(e.rate);
                r[c + 4] = rAmount0(e.total_amount);
            });
            r[PREV_START] = (item.actual_month_total_previous_two || []).map(n => r2(n)).join(", ");
            r[PREV_START + 1] = (item.previous_invoice_total_two || []).map(n => rAmount0(n)).join(", ");
            r[CUR_START] = (item.actual_month_two || []).map(n => r2(n)).join(", ");
            r[CUR_START + 1] = (item.current_invoice_amount_two || []).map(n => rAmount0(n)).join(", ");
            r[CUM_START] = (item.actual_month_cumulative_total_two || []).map(n => r2(n)).join(", ");
            r[CUM_START + 1] = (item.actual_amount_cumulative_total || []).map(n => rAmount0(n)).join(", ");
            r[REM_START] = r2(item.actual_month_remaining);
            r[REM_START + 1] = rAmount0(item.remaining_amount);

            rows.push(r);
        });

        // ---- totals row ----
        const totalRow = blankRow();
        totalRow[DESC_COL] = "Total:";
        totalRow[CONTRACT_START] = Number(calculateTotal(transportations, item => Number(item.no_of_vehicle))) || 0;
        totalRow[CONTRACT_START + 1] = rAmount0(calculateTotal(transportations, item => Number(item.boq_rate ?? item.transport_details.rate)));
        totalRow[CONTRACT_START + 2] = r2(calculateTotal(transportations, item => Number(item.boq_during_construction_period ?? item.transport_details.during_construction_period)));
        totalRow[CONTRACT_START + 3] = r2(calculateTotal(transportations, item => Number(item.boq_during_dlp_OM_period ?? item.transport_details.during_dlp_OM_period)));
        totalRow[CONTRACT_START + 4] = r2(calculateTotal(transportations, item => Number(item.boq_during_construction_period ?? item.transport_details.during_construction_period) + Number(item.boq_during_dlp_OM_period ?? item.transport_details.during_dlp_OM_period)));
        totalRow[CONTRACT_START + 5] = rAmount0(calculateContractAmount);

        if (showDeduction) {
            totalRow[DED_MONTH_COL] = r2(transportations.reduce((gt, item) => {
                const matched = deductionData?.filter(d => d.item_id === item.id) || [];
                return gt + matched.reduce((s, d) => s + (Number(d?.deduction_month) || 0), 0);
            }, 0));
            totalRow[DED_AMT_COL] = rAmount0(transportations.reduce((gt, item) => {
                const matched = deductionData?.filter(d => d.item_id === item.id) || [];
                return gt + matched.reduce((s, d) => s + ((Number(d?.deduction_amount) || 0) + (Number(d?.withheld_deduction_amount) || 0)), 0);
            }, 0));
        }

        for (let eotIdx = 0; eotIdx < eotLengths; eotIdx++) {
            const totals = transportations.reduce((acc, emp) => {
                const details = emp.eot_details?.length > 0 ? emp.eot_details : emp.data?.eot_details || [];
                const eot = details[eotIdx];
                if (!eot) return acc;
                acc.cp += Number(eot?.cp) || 0;
                acc.dlp += Number(eot?.dlp) || 0;
                acc.t_month += Number(eot?.t_month) || 0;
                acc.rate += Number(eot?.rate) || 0;
                acc.total_amount += Number(eot?.total_amount) || 0;
                return acc;
            }, { cp: 0, dlp: 0, t_month: 0, rate: 0, total_amount: 0 });
            const c = EOT_START + eotIdx * 5;
            totalRow[c] = r2(totals.cp);
            totalRow[c + 1] = r2(totals.dlp);
            totalRow[c + 2] = r2(totals.t_month);
            totalRow[c + 3] = rAmount0(totals.rate);
            totalRow[c + 4] = rAmount0(totals.total_amount);
        }

        totalRow[PREV_START] = r2(calculateTotal(transportations, item => Number(item.actual_month_total_previous)));
        totalRow[PREV_START + 1] = rAmount0(calculatePreviousAmount);
        totalRow[CUR_START] = r2(calculateTotal(transportations, item => Number(item.actual_month)));
        totalRow[CUR_START + 1] = rAmount0(calculateCurrentAmount);
        totalRow[CUM_START] = r2(calculateTotal(transportations, item => Number(item.actual_month_cumulative_total)));
        totalRow[CUM_START + 1] = rAmount0(calculateCumulated);
        totalRow[REM_START] = r2(calculateTotal(transportations, item => Number(item.actual_month_remaining)));
        totalRow[REM_START + 1] = rAmount0(calculateRemaining);
        rows.push(totalRow);

        const colWidths = new Array(TOTAL_COLS).fill({ wch: 14 });
        colWidths[SNO_COL] = { wch: 6 };
        colWidths[DESC_COL] = { wch: 22 };

        return { rows, merges, colWidths, sheetName: "Transportation" };
    };

    useEffect(() => {
        if (transportations.length > 0 && typeof setExcelRows === "function") {
            setExcelRows(buildExcelSheetData());
        }
    }, [transportations]);






    return (
        <div className="boc-modern-wrapper" style={{ minHeight: "30vh" }}>
            <div className="boc-modern-card">

                {/* Print header */}
                <div className="boc-modern-header bocx-modern-footer-total">
                    <div className="boc-modern-header-content">
                        <div className="boc-modern-project-info">
                            <h3 className="boc-modern-project-title">{projectData?.project_name}</h3>
                            <div className="boc-modern-project-meta">
                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Client:</span><span className="boc-modern-meta-value">{projectData?.client_name}</span></div>
                                <div className="boc-modern-meta-divider"></div>
                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Consultant (AE):</span><span className="boc-modern-meta-value">{projectData?.lead}{projectData?.jv ? ` JV with ${projectData?.jv}.` : ""}{projectData?.association ? ` Association with ${projectData?.association}` : ""}</span></div>
                                <div className="boc-modern-meta-divider"></div>
                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">GSTIN:</span><span className="boc-modern-meta-value">{projectData?.gst_no}</span></div>
                                <div className="boc-modern-meta-divider"></div>
                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">PAN:</span><span className="boc-modern-meta-value">{projectData?.pan_no}</span></div>
                                <div className="boc-modern-meta-divider"></div>
                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Bid Due:</span><span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.bid_due_date)}</span></div>
                                <div className="boc-modern-meta-divider"></div>
                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Agreement:</span><span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.agreement_date)}</span></div>
                                <div className="boc-modern-meta-divider"></div>
                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Start:</span><span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.commencement_date)}</span></div>
                                <div className="boc-modern-meta-divider"></div>
                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Invoice Number:</span><span className="boc-modern-meta-value">{invoice_num}</span></div>
                                <div className="boc-modern-meta-divider"></div>
                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Date:</span><span className="boc-modern-meta-value">{getMonthName(month)}-{year}</span></div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Section heading + action */}
                <div className="boc-modern-description-section">
                    <div className="boc-modern-controls">
                        <div className="boc-modern-controls-left">
                            <h6 className="boc-modern-main-heading">3- Transportation (Fixed rate on rental basis)</h6>
                        </div>
                        {/* {role !== "ViewAccess" && (
                            <div className="hide-on-print">
                                {usefor === "generateinvoice" ?
                                    <AddTransportationInvoice usedfor="InvoiceandDeduction" p_id={p_id ? p_id : project} invoice_id={invoice_id} getTransportationInvoice={getTransportationInvoice} month={month} year={year} logData={logData} />
                                    :
                                    <>
                                        {transportations.length === 0
                                            ? <AddTransportationInvoice usedfor="OnlyDeduction" invoiceData={transportations} p_id={p_id ? p_id : project} invoice_id={invoice_id} getTransportationInvoice={getTransportationInvoice} month={month} year={year} logData={logData} />
                                            : <UpdateTransportDeductionInvoice invoiceData={transportations} getData={getTransportationInvoice} />
                                        }
                                    </>
                                }
                            </div>
                        )} */}
                        {role !== "ViewAccess" && (
                            <div className="hide-on-print">
                                {usefor === "generateinvoice" ? (
                                    transportations.length === 0 ? (
                                        <AddTransportationInvoice
                                            usedfor="InvoiceandDeduction"
                                            p_id={p_id ? p_id : project}
                                            invoice_id={invoice_id}
                                            getTransportationInvoice={getTransportationInvoice}
                                            month={month}
                                            year={year}
                                            logData={logData}
                                        />
                                    ) : (
                                        <UpdateTransportationInvoice
                                            usedfor="InvoiceandDeduction"
                                            p_id={p_id ? p_id : project}
                                            invoice_id={invoice_id}
                                            getTransportationInvoice={getTransportationInvoice}
                                            month={month}
                                            year={year}
                                            logData={logData}
                                            invoiceData={transportations}
                                        />
                                    )
                                ) : (
                                    <>
                                        {transportations.length === 0 ? (
                                            <AddTransportationInvoice
                                                usedfor="OnlyDeduction"
                                                invoiceData={transportations}
                                                p_id={p_id ? p_id : project}
                                                invoice_id={invoice_id}
                                                getTransportationInvoice={getTransportationInvoice}
                                                month={month}
                                                year={year}
                                                logData={logData}
                                            />
                                        ) : (
                                            <UpdateTransportDeductionInvoice invoiceData={transportations} getData={getTransportationInvoice} />
                                        )}
                                    </>
                                )}
                            </div>
                        )}
                    </div>
                </div>

                <div className="boc-modern-table-wrapper">
                    <div className="boc-modern-table-scroll">
                        <table className="boc-modern-table">
                            <thead>
                                <tr className="boc-modern-table-header">
                                    <th className="boc-modern-th text-center" rowSpan="4">S.No</th>
                                    <th className="boc-modern-th text-center" rowSpan="4">Description of Vehicles</th>
                                    <th className="boc-modern-th text-center" colSpan="6">Contract Amount</th>
                                    {usefor !== "generateinvoice" && (
                                        <>
                                            <th className="boc-modern-th text-center" rowSpan="4">Deduction Month</th>
                                            <th className="boc-modern-th text-center" rowSpan="4">Deduction Amount</th>
                                        </>
                                    )}
                                    {isEotDataTrue && (
                                        <th className="boc-modern-th text-center" colSpan={eotLengths * 5 || 1}>(COS/EOT)</th>
                                    )}
                                    <th className="boc-modern-th text-center" colSpan="2">Cumulative Total of Previous Months</th>
                                    <th className="boc-modern-th text-center" colSpan="2">This Period</th>
                                    <th className="boc-modern-th text-center" colSpan="2">Cumulative Total Including Current Invoice</th>
                                    <th className="boc-modern-th text-center" colSpan="2">Remaining Amount Against Contract Value</th>
                                    {role !== "SiteManagement" && role !== "ViewAccess" && (
                                        <th className="boc-modern-th text-center hide-on-print" rowSpan="4">Action</th>
                                    )}
                                </tr>
                                <tr className="boc-modern-table-subheader">
                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">No. of Vehicles</th>
                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Rate</th>
                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Const</th>
                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Maint</th>
                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">No. of MM</th>
                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Total Amount</th>
                                    {Array.from({ length: eotLengths }).map((_, idx) => (
                                        <th key={idx} className="boc-modern-th text-center boc-nowrap" colSpan={5}>{`EOT ${idx + 1}`}</th>
                                    ))}
                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Month</th>
                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Amount</th>
                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Month</th>
                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Amount</th>
                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Month</th>
                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Amount</th>
                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Month</th>
                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Amount</th>
                                </tr>
                                <tr className="boc-modern-table-subheader">
                                    {Array.from({ length: eotLengths }).map((_, idx) => (
                                        <React.Fragment key={idx}>
                                            <th rowSpan="2" className="boc-modern-th boc-nowrap">Const</th>
                                            <th rowSpan="2" className="boc-modern-th boc-nowrap">Maint</th>
                                            <th rowSpan="2" className="boc-modern-th boc-nowrap">Total MM</th>
                                            <th rowSpan="2" className="boc-modern-th boc-nowrap">Rate</th>
                                            <th rowSpan="2" className="boc-modern-th boc-nowrap">Total Amount</th>
                                        </React.Fragment>
                                    ))}
                                </tr>
                            </thead>

                            <tbody>
                                {transportations.map((item, index) => {
                                    const matchedDeductions = deductionData?.filter(d => d.item_id === item.id) || [];
                                    return (
                                        <tr className="boc-modern-row" key={item.id}>
                                            <td className="boc-modern-td text-center">{index + 1}.</td>
                                            <td className="boc-modern-td"><div style={{ width: "100px", whiteSpace: "normal" }}>{item.boq_vehicle_description ?? item.transport_details.vehicle_description}</div></td>
                                            <td className="boc-modern-td boc-nowrap text-right">{item.no_of_vehicle}</td>
                                            <td className="boc-modern-td boc-nowrap boc-modern-currency text-right">₹ {formatAmount0(Number(item.boq_rate ?? item.transport_details.rate))}</td>
                                            <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(item.boq_during_construction_period ?? item.transport_details.during_construction_period)}</td>
                                            <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(item.boq_during_dlp_OM_period ?? item.transport_details.during_dlp_OM_period)}</td>
                                            <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(Number(item.boq_during_construction_period ?? item.transport_details.during_construction_period) + Number(item.boq_during_dlp_OM_period ?? item.transport_details.during_dlp_OM_period))}</td>
                                            <td className="boc-modern-td boc-nowrap text-right">
                                                <span className="boc-modern-currency boc-modern-total-highlight">
                                                    ₹ {formatAmount0(Number(item.boq_rate ?? item.transport_details.rate) * (Number(item.boq_during_construction_period ?? item.transport_details.during_construction_period) + Number(item.boq_during_dlp_OM_period ?? item.transport_details.during_dlp_OM_period)))}
                                                </span>
                                            </td>

                                            {/* Deduction Month */}
                                            {usefor !== "generateinvoice" && (
                                                <td className="boc-modern-td boc-nowrap text-right justify-end" style={{ padding: 0 }}>
                                                    {matchedDeductions.length > 0
                                                        ? matchedDeductions.map((n, i) => (
                                                            <div key={i} className="boc-multi-item boc-nowrap">{n.deduction_month == null ? "-" : formatMonth2(n.deduction_month)}</div>
                                                        ))
                                                        : <div className="boc-multi-item">-</div>
                                                    }
                                                </td>
                                            )}

                                            {/* Deduction Amount */}
                                            {usefor !== "generateinvoice" && (
                                                <td className="boc-modern-td boc-nowrap text-right justify-end" style={{ padding: 0 }}>
                                                    {matchedDeductions.length > 0
                                                        ? matchedDeductions.map((n, i) => (
                                                            <div key={i} className="boc-multi-item boc-nowrap">{formatAmount0((Number(n.deduction_amount) || 0) + (Number(n.withheld_deduction_amount) || 0))}</div>
                                                        ))
                                                        : <div className="boc-multi-item">0.00</div>
                                                    }
                                                </td>
                                            )}

                                            {/* EOT */}
                                            {item?.eot_details?.length > 0 && item.eot_details.map((i, idx) => (
                                                <React.Fragment key={idx}>
                                                    <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(i.cp)}</td>
                                                    <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(i.dlp)}</td>
                                                    <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(i.t_month)}</td>
                                                    <td className="boc-modern-td boc-nowrap boc-modern-currency text-right">₹ {formatAmount0(Number(i.rate))}</td>
                                                    <td className="boc-modern-td boc-nowrap boc-modern-currency text-right">₹ {formatAmount0(Number(i.total_amount))}</td>
                                                </React.Fragment>
                                            ))}

                                            {/* Previous Month */}
                                            <td className="boc-modern-td boc-nowrap text-right justify-end" style={{ padding: 0 }}>
                                                {item?.actual_month_total_previous_two?.length > 0
                                                    ? item.actual_month_total_previous_two.map((n, i) => <div key={i} className="boc-multi-item boc-nowrap">{formatMonth2(n)}</div>)
                                                    : <div className="boc-multi-item">0.00</div>
                                                }
                                            </td>
                                            {/* Previous Amount */}
                                            <td className="boc-modern-td boc-nowrap boc-modern-currency text-right justify-end" style={{ padding: 0 }}>
                                                {item?.previous_invoice_total_two?.length > 0
                                                    ? item.previous_invoice_total_two.map((n, i) => <div key={i} className="boc-multi-item boc-nowrap">₹ {formatAmount0(n)}</div>)
                                                    : <div className="boc-multi-item">₹ 0</div>
                                                }
                                            </td>
                                            {/* Current Month */}
                                            <td className="boc-modern-td boc-nowrap text-right justify-end" style={{ padding: 0 }}>
                                                {item?.actual_month_two?.length > 0
                                                    ? item.actual_month_two.map((n, i) => <div key={i} className="boc-multi-item boc-nowrap">{formatMonth2(n)}</div>)
                                                    : <div className="boc-multi-item">0.00</div>
                                                }
                                            </td>
                                            {/* Current Amount */}
                                            <td className="boc-modern-td boc-nowrap boc-modern-currency text-right justify-end" style={{ padding: 0 }}>
                                                {item?.current_invoice_amount_two?.length > 0
                                                    ? item.current_invoice_amount_two.map((n, i) => <div key={i} className="boc-multi-item boc-nowrap">₹ {formatAmount0(n)}</div>)
                                                    : <div className="boc-multi-item">₹ 0</div>
                                                }
                                            </td>
                                            {/* Cumulative Month */}
                                            <td className="boc-modern-td boc-nowrap text-right justify-end" style={{ padding: 0 }}>
                                                {item?.actual_month_cumulative_total_two?.length > 0
                                                    ? item.actual_month_cumulative_total_two.map((n, i) => <div key={i} className="boc-multi-item boc-nowrap">{formatMonth2(n)}</div>)
                                                    : <div className="boc-multi-item">0.00</div>
                                                }
                                            </td>
                                            {/* Cumulative Amount */}
                                            <td className="boc-modern-td boc-nowrap boc-modern-currency text-right justify-end" style={{ padding: 0 }}>
                                                {item?.actual_amount_cumulative_total?.length > 0
                                                    ? item.actual_amount_cumulative_total.map((n, i) => <div key={i} className="boc-multi-item boc-nowrap">₹ {formatAmount0(n)}</div>)
                                                    : <div className="boc-multi-item">₹ 0</div>
                                                }
                                            </td>
                                            {/* Remaining */}
                                            <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(item.actual_month_remaining)}</td>
                                            <td className="boc-modern-td boc-nowrap text-right">
                                                <span className="boc-modern-currency boc-modern-total-highlight">
                                                    ₹ {formatAmount0(Number(item.remaining_amount))}
                                                </span>
                                            </td>

                                            {/* Action */}
                                            {(usefor === "generateinvoice" || role !== "ViewAccess") && (
                                                <>
                                                    {(!["Checker", "SiteManagement"].includes(role)) ||
                                                        (role === "Checker" && !isMoreThan24Hours(item.created_at)) ? (
                                                        <td className="boc-modern-td text-center hide-on-print">
                                                            {usefor === "generateinvoice"
                                                                ? <DeleteTransportationInvoice i={item} getTransportationInvoice={getTransportationInvoice} />
                                                                : <DeleteTransportationInvoiceDeduction i={item} getTransportationInvoice={getTransportationInvoice} />
                                                            }
                                                        </td>
                                                    ) : (
                                                        <td className="boc-modern-td text-center hide-on-print">-</td>
                                                    )}
                                                </>
                                            )}
                                        </tr>
                                    );
                                })}
                            </tbody>

                            <tfoot>
                                <tr className="boc-modern-footer">
                                    <td colSpan="2" className="boc-modern-footer-label">Total:</td>
                                    <td className="boc-modern-td boc-nowrap text-right">{/* no_of_vehicle total not available per item, leave blank or sum if available */}</td>
                                    <td className="boc-modern-td boc-nowrap text-right">
                                        <span className="boc-modern-currency boc-modern-footer-total">
                                            ₹ {formatAmount0(calculateTotal(transportations, item => Number(item.boq_rate ?? item.transport_details.rate)))}
                                        </span>
                                    </td>
                                    <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(calculateTotal(transportations, item => Number(item.boq_during_construction_period ?? item.transport_details.during_construction_period)))}</td>
                                    <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(calculateTotal(transportations, item => Number(item.boq_during_dlp_OM_period ?? item.transport_details.during_dlp_OM_period)))}</td>
                                    <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(calculateTotal(transportations, item => Number(item.boq_during_construction_period ?? item.transport_details.during_construction_period) + Number(item.boq_during_dlp_OM_period ?? item.transport_details.during_dlp_OM_period)))}</td>
                                    <td className="boc-modern-td boc-nowrap text-right">
                                        <span className="boc-modern-currency boc-modern-footer-total">
                                            ₹ {formatAmount0(calculateTotal(transportations, item => Number(item.boq_rate ?? item.transport_details.rate) * (Number(item.boq_during_construction_period ?? item.transport_details.during_construction_period) + Number(item.boq_during_dlp_OM_period ?? item.transport_details.during_dlp_OM_period))))}
                                        </span>
                                    </td>

                                    {usefor !== "generateinvoice" && (
                                        <>
                                            <td className="boc-modern-td boc-nowrap text-right">
                                                {formatMonth2(transportations.reduce((gt, item) => {
                                                    const matched = deductionData?.filter(d => d.item_id === item.id) || [];
                                                    return gt + matched.reduce((s, d) => s + (Number(d?.deduction_month) || 0), 0);
                                                }, 0))}
                                            </td>
                                            <td className="boc-modern-td boc-nowrap text-right">
                                                <span className="boc-modern-currency boc-modern-footer-total">
                                                    ₹ {formatAmount0(
                                                        transportations.reduce((gt, item) => {
                                                            const matched = deductionData?.filter(d => d.item_id === item.id) || [];
                                                            return gt + matched.reduce((s, d) => s + ((Number(d?.deduction_amount) || 0) + (Number(d?.withheld_deduction_amount) || 0)), 0);
                                                        }, 0)
                                                    )}
                                                </span>
                                            </td>
                                        </>
                                    )}

                                    {isEotDataTrue && Array.from({ length: eotLengths }).map((_, eotIdx) => {
                                        const totals = transportations.reduce((acc, emp) => {
                                            const details = emp.eot_details?.length > 0 ? emp.eot_details : emp.data?.eot_details || [];
                                            const eot = details[eotIdx];
                                            if (!eot) return acc;
                                            acc.cp += Number(eot?.cp) || 0;
                                            acc.dlp += Number(eot?.dlp) || 0;
                                            acc.t_month += Number(eot?.t_month) || 0;
                                            acc.rate += Number(eot?.rate) || 0;
                                            acc.total_amount += Number(eot?.total_amount) || 0;
                                            return acc;
                                        }, { cp: 0, dlp: 0, t_month: 0, rate: 0, total_amount: 0 });
                                        return (
                                            <React.Fragment key={eotIdx}>
                                                <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(totals.cp)}</td>
                                                <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(totals.dlp)}</td>
                                                <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(totals.t_month)}</td>
                                                <td className="boc-modern-td boc-nowrap text-right">₹ {formatAmount0(totals.rate)}</td>
                                                <td className="boc-modern-td boc-nowrap text-right">
                                                    <span className="boc-modern-currency boc-modern-footer-total">₹ {formatAmount0(totals.total_amount)}</span>
                                                </td>
                                            </React.Fragment>
                                        );
                                    })}

                                    <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(calculateTotal(transportations, item => Number(item.actual_month_total_previous)))}</td>
                                    <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatAmount0(calculateTotal(transportations, item => Number(item.previous_invoice_total)))}</span></td>
                                    <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(calculateTotal(transportations, item => Number(item.actual_month)))}</td>
                                    <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatAmount0(calculateTotal(transportations, item => Number(item.invoice_amount ?? item.current_invoice_amount)))}</span></td>
                                    <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(calculateTotal(transportations, item => Number(item.actual_month_cumulative_total)))}</td>
                                    <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatAmount0(calculateTotal(transportations, item => Number(item.cumulative_invoice_total)))}</span></td>
                                    <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(calculateTotal(transportations, item => Number(item.actual_month_remaining)))}</td>
                                    <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatAmount0(calculateTotal(transportations, item => Number(item.remaining_amount)))}</span></td>

                                    {role !== "SiteManagement" && role !== "ViewAccess" && (
                                        <td className="hide-on-print boc-modern-td"></td>
                                    )}
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};


const DutyTravel = ({ setEotDetails, deductionData, projectData, client, p_id, invoice_id, i, invoice_num, year, month, logData,

    setPreviousAmount,

    setCurrentAmount,

    setRemainingAmount,

    setContractAmount,

    setExcelRows,

    setCumulated,

    usefor

}) => {



    const project = sessionStorage.getItem('sitemanagement_project');







    // let { id } = useParams();

    const currentDate = new Date();

    const isFirstWeek = currentDate.getDate() <= 7;



    const role = sessionStorage.getItem('sitemanagement_role');



    const [dutyTravelinvoice, setDutyTravelinvoice] = useState([]);







    const calculateContractAmount = calculateTotal(dutyTravelinvoice, (item) => Number(item.boq_rate_per_trip ?? item.duty_travel_details.rate_per_trip) * Number(item.boq_num_of_min_trip ?? item.duty_travel_details.num_of_min_trip))

    setContractAmount(calculateContractAmount);

    const calculatePreviousAmount = calculateTotal(dutyTravelinvoice, (item) => Number(item.previous_invoice_total))

    setPreviousAmount(calculatePreviousAmount);

    const calculateCurrentAmount = calculateTotal(dutyTravelinvoice, (item) => Number(item.invoice_amount ?? item.current_invoice_amount))

    setCurrentAmount(calculateCurrentAmount);

    const calculateCumulated = calculateTotal(dutyTravelinvoice, (item) => Number(item.cumulative_invoice_total))

    setCumulated(calculateCumulated);

    const calculateRemaining = calculateTotal(dutyTravelinvoice, (item) => Number(item.remaining_amount))

    setRemainingAmount(calculateRemaining);



    useEffect(() => {

        const eotGroups = [];

        dutyTravelinvoice.forEach(item => {

            (item?.eot_details || []).forEach((eot, idx) => {

                if (!eotGroups[idx]) {

                    eotGroups[idx] = { ...eot, total_amount: 0 };

                }

                eotGroups[idx].total_amount += Number(eot.total_amount || 0);

            });

        });



        setEotDetails(eotGroups);

        console.log("Transport EOT Groups:", eotGroups);

    }, [dutyTravelinvoice]);







    const getDutyTravelinvoice = async () => {



        try {

            let data;



            if (usefor === "generateinvoice") {

                const res = await axios.get(

                    `${BASE_URL}/siteproject/invoicedutybyprojectstatus/${p_id ? p_id : project}/${month}/${year}/`

                );

                data = res.data;

            } else {

                const response2 = await axios.get(

                    `${BASE_URL}/siteproject/newinvoicedutytravelfiltermonthyear/${invoice_id}/null/null/`

                );

                data = response2.data;

            }



            const isAnyBoqJsonNull = data.length !== 0 && data.every(item => item.boq_json === null);





            const selectedData = isAnyBoqJsonNull ? data : data;

            setDutyTravelinvoice(selectedData);

        } catch (err) { }



    };





    console.log(dutyTravelinvoice)





    useEffect(() => {



        // getdocument();

        getDutyTravelinvoice();

        // eslint-disable-next-line react-hooks/exhaustive-deps

    }, []);





    console.log(dutyTravelinvoice)

    const isEotDataTrue = dutyTravelinvoice.some(i =>

        (i.eot_details?.length > 0) || (i.data?.eot_details?.length > 0)

    );











    const eotLengths = Math.max(

        ...dutyTravelinvoice.map(i => i?.eot_details?.length || i?.data?.eot_details?.length || 0),

        0

    );

    // Display/export helpers only. Keep all calculation values and API data unchanged.
    // Trip quantities retain two decimals; rupee amounts/rates round to whole rupees.
    const formatTrip2 = (value) => {
        const n = Number(value ?? 0);
        return Number.isFinite(n) ? n.toFixed(2) : "0.00";
    };

    const roundRupee = (value) => {
        const n = Number(value ?? 0);
        return Number.isFinite(n) ? Math.round(n) : 0;
    };

    const formatAmount0 = (value) =>
        roundRupee(value).toLocaleString("en-IN", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        });

    // Excel AOA export: numeric rounded rupees and fixed 2-decimal trip text.
    // Trip text preserves the trailing zeros with the existing worksheet exporter.
    const r0 = roundRupee;
    const r2 = formatTrip2;



    // ── Builds a fully formatted AOA sheet (merged headers, flat rows) ──

    const buildExcelSheetData = () => {

        const showDeduction = usefor !== "generateinvoice";



        // ---- figure out column layout ----

        let col = 0;

        const SNO_COL = col++;                  // 0

        const TRIPS_DESC_COL = col++;           // 1 (the "Trips" description column)

        const CONTRACT_START = col; col += 3;   // Rate, Trips, Total Amount

        let DED_TRIP_COL = -1, DED_AMT_COL = -1;

        if (showDeduction) {

            DED_TRIP_COL = col++;

            DED_AMT_COL = col++;

        }

        const EOT_START = col; col += eotLengths * 3;   // 3 cols per EOT group

        const PREV_START = col; col += 2;   // Trip, Amount

        const CUR_START = col; col += 2;

        const CUM_START = col; col += 2;

        const REM_START = col; col += 2;

        const TOTAL_COLS = col;



        const blankRow = () => new Array(TOTAL_COLS).fill("");



        // ---- header row 1 (group labels) ----

        const row1 = blankRow();

        row1[SNO_COL] = "S.No";

        row1[TRIPS_DESC_COL] = "Trips";

        row1[CONTRACT_START] = "Contract Amount";

        if (showDeduction) {

            row1[DED_TRIP_COL] = "Deduction Trip";

            row1[DED_AMT_COL] = "Deduction Amount";

        }

        for (let i = 0; i < eotLengths; i++) {

            row1[EOT_START + i * 3] = `EOT ${i + 1}`;

        }

        row1[PREV_START] = "Cumulative Total of Previous Months";

        row1[CUR_START] = "This Period";

        row1[CUM_START] = "Cumulative Total Including Current Invoice";

        row1[REM_START] = "Remaining Amount Against Contract Value";



        // ---- header row 2 (sub labels) ----

        const row2 = blankRow();

        row2[CONTRACT_START] = "Rate";

        row2[CONTRACT_START + 1] = "Trips";

        row2[CONTRACT_START + 2] = "Total Amount";

        for (let i = 0; i < eotLengths; i++) {

            const c = EOT_START + i * 3;

            row2[c] = "Rate";

            row2[c + 1] = "Trips";

            row2[c + 2] = "Total Amount";

        }

        row2[PREV_START] = "Trip"; row2[PREV_START + 1] = "Amount";

        row2[CUR_START] = "Trip"; row2[CUR_START + 1] = "Amount";

        row2[CUM_START] = "Trip"; row2[CUM_START + 1] = "Amount";

        row2[REM_START] = "Trip"; row2[REM_START + 1] = "Amount";



        // ---- merges for the two header rows ----

        const merges = [];

        const vMerge = (c) => merges.push({ s: { r: 0, c }, e: { r: 1, c } });

        const hMerge = (c1, c2) => merges.push({ s: { r: 0, c: c1 }, e: { r: 0, c: c2 } });



        vMerge(SNO_COL); vMerge(TRIPS_DESC_COL);

        if (showDeduction) { vMerge(DED_TRIP_COL); vMerge(DED_AMT_COL); }

        hMerge(CONTRACT_START, CONTRACT_START + 2);

        for (let i = 0; i < eotLengths; i++) {

            const c = EOT_START + i * 3;

            hMerge(c, c + 2);

        }

        hMerge(PREV_START, PREV_START + 1);

        hMerge(CUR_START, CUR_START + 1);

        hMerge(CUM_START, CUM_START + 1);

        hMerge(REM_START, REM_START + 1);



        // ---- data rows (flat — no sections for duty travel) ----

        const rows = [row1, row2];



        dutyTravelinvoice.forEach((item, index) => {

            const rate = Number(item.boq_rate_per_trip ?? item.duty_travel_details.rate_per_trip) || 0;

            const trips = Number(item.boq_num_of_min_trip ?? item.duty_travel_details.num_of_min_trip) || 0;

            const totalAmt = rate * trips;



            const matchedDeductions = deductionData?.filter((d) => d.item_id === item.id) || [];

            const deductionTripSum = matchedDeductions.reduce((s, n) => s + (Number(n.deduction_month) || 0), 0);

            const deductionAmountSum = matchedDeductions.reduce((s, n) => s + ((Number(n.deduction_amount) + Number(n.withheld_deduction_amount)) || 0), 0);



            const r = blankRow();

            r[SNO_COL] = index + 1;

            r[TRIPS_DESC_COL] = item.boq_trips ?? item.duty_travel_details.trips ?? "";

            r[CONTRACT_START] = r2(rate);

            r[CONTRACT_START + 1] = r2(trips);

            r[CONTRACT_START + 2] = r2(totalAmt);

            if (showDeduction) {

                r[DED_TRIP_COL] = r2(deductionTripSum);

                r[DED_AMT_COL] = r2(deductionAmountSum);

            }

            (item.eot_details || []).forEach((e, i) => {

                const c = EOT_START + i * 3;

                r[c] = r2(e.rate);

                r[c + 1] = r2(e.t_trips);

                r[c + 2] = r2(e.total_amount);

            });

            r[PREV_START] = r2(item.actual_month_total_previous);

            r[PREV_START + 1] = r2(item.previous_invoice_total);

            r[CUR_START] = r2(item.actual_trip);

            r[CUR_START + 1] = r2(item.invoice_amount);

            r[CUM_START] = r2(item.actual_month_cumulative_total);

            r[CUM_START + 1] = r2(item.cumulative_invoice_total);

            r[REM_START] = r2(item.actual_month_remaining);

            r[REM_START + 1] = r2(item.remaining_amount);



            rows.push(r);

        });



        // ---- totals row ----

        const totalRow = blankRow();

        totalRow[TRIPS_DESC_COL] = "Total:";

        totalRow[CONTRACT_START] = r2(calculateTotal(dutyTravelinvoice, item => Number(item.boq_rate_per_trip ?? item.duty_travel_details.rate_per_trip)));

        totalRow[CONTRACT_START + 1] = r2(calculateTotal(dutyTravelinvoice, item => Number(item.boq_num_of_min_trip ?? item.duty_travel_details.num_of_min_trip)));

        totalRow[CONTRACT_START + 2] = r2(calculateContractAmount);



        if (showDeduction) {

            totalRow[DED_TRIP_COL] = r2(dutyTravelinvoice.reduce((gt, item) => {

                const matched = deductionData?.filter(d => d.item_id === item.id) || [];

                return gt + matched.reduce((s, d) => s + (Number(d?.deduction_month) || 0), 0);

            }, 0));

            totalRow[DED_AMT_COL] = r2(dutyTravelinvoice.reduce((gt, item) => {

                const matched = deductionData?.filter(d => d.item_id === item.id) || [];

                return gt + matched.reduce((s, d) => s + ((Number(d?.deduction_amount) || 0) + (Number(d?.withheld_deduction_amount) || 0)), 0);

            }, 0));

        }



        for (let eotIdx = 0; eotIdx < eotLengths; eotIdx++) {

            const totals = dutyTravelinvoice.reduce((acc, emp) => {

                const details = emp.eot_details?.length > 0 ? emp.eot_details : emp.data?.eot_details || [];

                const eot = details[eotIdx];

                if (!eot) return acc;

                acc.rate += Number(eot?.rate) || 0;

                acc.t_trips += Number(eot?.t_trips) || 0;

                acc.total_amount += Number(eot?.total_amount) || 0;

                return acc;

            }, { rate: 0, t_trips: 0, total_amount: 0 });

            const c = EOT_START + eotIdx * 3;

            totalRow[c] = r2(totals.rate);

            totalRow[c + 1] = r2(totals.t_trips);

            totalRow[c + 2] = r2(totals.total_amount);

        }



        totalRow[PREV_START] = r2(calculateTotal(dutyTravelinvoice, item => Number(item.actual_month_total_previous)));

        totalRow[PREV_START + 1] = r2(calculatePreviousAmount);

        totalRow[CUR_START] = r2(calculateTotal(dutyTravelinvoice, item => Number(item.actual_trip)));

        totalRow[CUR_START + 1] = r2(calculateCurrentAmount);

        totalRow[CUM_START] = r2(calculateTotal(dutyTravelinvoice, item => Number(item.actual_month_cumulative_total)));

        totalRow[CUM_START + 1] = r2(calculateCumulated);

        totalRow[REM_START] = r2(calculateTotal(dutyTravelinvoice, item => Number(item.actual_month_remaining)));

        totalRow[REM_START + 1] = r2(calculateRemaining);

        rows.push(totalRow);



        const colWidths = new Array(TOTAL_COLS).fill({ wch: 14 });

        colWidths[SNO_COL] = { wch: 6 };

        colWidths[TRIPS_DESC_COL] = { wch: 22 };



        return { rows, merges, colWidths, sheetName: "Duty Travel" };

    };



    useEffect(() => {

        if (dutyTravelinvoice.length > 0 && typeof setExcelRows === "function") {

            setExcelRows(buildExcelSheetData());

        }

    }, [dutyTravelinvoice, deductionData]);



    return (

        <div className="boc-modern-wrapper" style={{ minHeight: "30vh" }}>

            <div className="boc-modern-card">



                {/* Print header */}

                <div className="boc-modern-header bocx-modern-footer-total">

                    <div className="boc-modern-header-content">

                        <div className="boc-modern-project-info">

                            <h3 className="boc-modern-project-title">{projectData?.project_name}</h3>

                            <div className="boc-modern-project-meta">

                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Client:</span><span className="boc-modern-meta-value">{projectData?.client_name}</span></div>

                                <div className="boc-modern-meta-divider"></div>

                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Consultant (AE):</span><span className="boc-modern-meta-value">{projectData?.lead}{projectData?.jv ? ` JV with ${projectData?.jv}.` : ""}{projectData?.association ? ` Association with ${projectData?.association}` : ""}</span></div>

                                <div className="boc-modern-meta-divider"></div>

                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">GSTIN:</span><span className="boc-modern-meta-value">{projectData?.gst_no}</span></div>

                                <div className="boc-modern-meta-divider"></div>

                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">PAN:</span><span className="boc-modern-meta-value">{projectData?.pan_no}</span></div>

                                <div className="boc-modern-meta-divider"></div>

                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Bid Due:</span><span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.bid_due_date)}</span></div>

                                <div className="boc-modern-meta-divider"></div>

                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Agreement:</span><span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.agreement_date)}</span></div>

                                <div className="boc-modern-meta-divider"></div>

                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Start:</span><span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.commencement_date)}</span></div>

                                <div className="boc-modern-meta-divider"></div>

                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Invoice Number:</span><span className="boc-modern-meta-value">{invoice_num}</span></div>

                                <div className="boc-modern-meta-divider"></div>

                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Date:</span><span className="boc-modern-meta-value">{getMonthName(month)}-{year}</span></div>

                            </div>

                        </div>

                    </div>

                </div>



                {/* Section heading + action */}

                <div className="boc-modern-description-section">

                    <div className="boc-modern-controls">

                        <div className="boc-modern-controls-left">

                            <h6 className="boc-modern-main-heading">4- Duty Travel to Site (Fixed Costs) — Professional and Sub-professional Staff</h6>

                        </div>

                        <div className="hide-on-print">
                            {usefor === "generateinvoice" ? (
                                <>
                                    {dutyTravelinvoice.length === 0
                                        ? <DutyTravelInvoice usedfor="InvoiceandDeduction" p_id={p_id ? p_id : project} invoice_id={invoice_id} getDutyTravelinvoice={getDutyTravelinvoice} month={month} year={year} logData={logData} />
                                        : <UpdateDutyTravelInvoice usedfor="InvoiceandDeduction" invoiceData={dutyTravelinvoice} p_id={p_id ? p_id : project} invoice_id={invoice_id} getDutyTravelinvoice={getDutyTravelinvoice} month={month} year={year} logData={logData} />
                                    }
                                </>
                            ) : (
                                <>
                                    {dutyTravelinvoice.length === 0
                                        ? <DutyTravelInvoice usedfor="OnlyDeduction" invoiceData={dutyTravelinvoice} p_id={p_id ? p_id : project} invoice_id={invoice_id} getDutyTravelinvoice={getDutyTravelinvoice} month={month} year={year} logData={logData} />
                                        : <UpdateTravelDeductionInvoice invoiceData={dutyTravelinvoice} getData={getDutyTravelinvoice} />
                                    }
                                </>
                            )}
                        </div>
                    </div>

                </div>



                <div className="boc-modern-table-wrapper">

                    <div className="boc-modern-table-scroll">

                        <table className="boc-modern-table">

                            <thead>

                                <tr className="boc-modern-table-header">

                                    <th className="boc-modern-th text-center" rowSpan="4">S.No</th>

                                    <th className="boc-modern-th text-center" rowSpan="4">Trips</th>

                                    <th className="boc-modern-th text-center" colSpan="3">Contract Amount</th>

                                    {usefor !== "generateinvoice" && (

                                        <>

                                            <th className="boc-modern-th text-center" rowSpan="4">Deduction Trip</th>

                                            <th className="boc-modern-th text-center" rowSpan="4">Deduction Amount</th>

                                        </>

                                    )}

                                    {isEotDataTrue && (

                                        <th className="boc-modern-th text-center" colSpan={eotLengths * 3 || 1}>(COS/EOT)</th>

                                    )}

                                    <th className="boc-modern-th text-center" colSpan="2">Cumulative Total of Previous Months</th>

                                    <th className="boc-modern-th text-center" colSpan="2">This Period</th>

                                    <th className="boc-modern-th text-center" colSpan="2">Cumulative Total Including Current Invoice</th>

                                    <th className="boc-modern-th text-center" colSpan="2">Remaining Amount Against Contract Value</th>

                                    {role !== "SiteManagement" && role !== "ViewAccess" && (

                                        <th className="boc-modern-th text-center hide-on-print" rowSpan="4">Action</th>

                                    )}

                                </tr>

                                <tr className="boc-modern-table-subheader">

                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Rate</th>

                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Trips</th>

                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Total Amount</th>

                                    {Array.from({ length: eotLengths }).map((_, idx) => (

                                        <th key={idx} className="boc-modern-th text-center boc-nowrap" colSpan={3}>{`EOT ${idx + 1}`}</th>

                                    ))}

                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Trip</th>

                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Amount</th>

                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Trip</th>

                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Amount</th>

                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Trip</th>

                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Amount</th>

                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Trip</th>

                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Amount</th>

                                </tr>

                                <tr className="boc-modern-table-subheader">

                                    {Array.from({ length: eotLengths }).map((_, idx) => (

                                        <React.Fragment key={idx}>

                                            <th rowSpan="2" className="boc-modern-th boc-nowrap">Rate</th>

                                            <th rowSpan="2" className="boc-modern-th boc-nowrap">Trips</th>

                                            <th rowSpan="2" className="boc-modern-th boc-nowrap">Total Amount</th>

                                        </React.Fragment>

                                    ))}

                                </tr>

                            </thead>



                            <tbody>

                                {dutyTravelinvoice.map((item, index) => {

                                    const matchedDeductions = deductionData?.filter(d => d.item_id === item.id) || [];

                                    return (

                                        <tr className="boc-modern-row" key={item.id}>

                                            <td className="boc-modern-td text-center">{index + 1}.</td>

                                            <td className="boc-modern-td"><div style={{ whiteSpace: "normal" }}>{item.boq_trips ?? item.duty_travel_details.trips}</div></td>

                                            <td className="boc-modern-td boc-nowrap boc-modern-currency text-right">₹ {formatAmount0(Number(item.boq_rate_per_trip ?? item.duty_travel_details.rate_per_trip))}</td>

                                            <td className="boc-modern-td boc-nowrap text-right">{formatTrip2(Number(item.boq_num_of_min_trip ?? item.duty_travel_details.num_of_min_trip))}</td>

                                            <td className="boc-modern-td boc-nowrap text-right">

                                                <span className="boc-modern-currency boc-modern-total-highlight">

                                                    ₹ {formatAmount0(Number(item.boq_num_of_min_trip ?? item.duty_travel_details.num_of_min_trip) * Number(item.boq_rate_per_trip ?? item.duty_travel_details.rate_per_trip))}

                                                </span>

                                            </td>



                                            {/* Deduction Trip */}

                                            {usefor !== "generateinvoice" && (

                                                <td className="boc-modern-td boc-nowrap text-right justify-end" style={{ padding: 0 }}>

                                                    {matchedDeductions.length > 0

                                                        ? matchedDeductions.map((n, i) => <div key={i} className="boc-multi-item boc-nowrap">{n.deduction_month == null ? "-" : formatTrip2(n.deduction_month)}</div>)

                                                        : <div className="boc-multi-item">-</div>

                                                    }

                                                </td>

                                            )}

                                            {/* Deduction Amount */}

                                            {usefor !== "generateinvoice" && (

                                                <td className="boc-modern-td boc-nowrap text-right justify-end" style={{ padding: 0 }}>

                                                    {matchedDeductions.length > 0

                                                        ? matchedDeductions.map((n, i) => <div key={i} className="boc-multi-item boc-nowrap">{formatAmount0((Number(n.deduction_amount) || 0) + (Number(n.withheld_deduction_amount) || 0))}</div>)

                                                        : <div className="boc-multi-item">0</div>

                                                    }

                                                </td>

                                            )}



                                            {/* EOT */}

                                            {item?.eot_details?.length > 0 && item.eot_details.map((i, idx) => (

                                                <React.Fragment key={idx}>

                                                    <td className="boc-modern-td boc-nowrap boc-modern-currency text-right">₹ {formatAmount0(Number(i.rate))}</td>

                                                    <td className="boc-modern-td boc-nowrap text-right">{formatTrip2(i.t_trips)}</td>

                                                    <td className="boc-modern-td boc-nowrap boc-modern-currency text-right">₹ {formatAmount0(Number(i.total_amount))}</td>

                                                </React.Fragment>

                                            ))}



                                            <td className="boc-modern-td boc-nowrap text-right">{formatTrip2(Number(item.actual_month_total_previous))}</td>

                                            <td className="boc-modern-td boc-nowrap boc-modern-currency text-right">₹ {formatAmount0(Number(item.previous_invoice_total))}</td>

                                            <td className="boc-modern-td boc-nowrap text-right">{formatTrip2(Number(item.actual_trip))}</td>

                                            <td className="boc-modern-td boc-nowrap boc-modern-currency text-right">₹ {formatAmount0(Number(item.invoice_amount))}</td>

                                            <td className="boc-modern-td boc-nowrap text-right">{formatTrip2(Number(item.actual_month_cumulative_total))}</td>

                                            <td className="boc-modern-td boc-nowrap boc-modern-currency text-right">₹ {formatAmount0(Number(item.cumulative_invoice_total))}</td>

                                            <td className="boc-modern-td boc-nowrap text-right">{formatTrip2(Number(item.actual_month_remaining))}</td>

                                            <td className="boc-modern-td boc-nowrap text-right">

                                                <span className="boc-modern-currency boc-modern-total-highlight">₹ {formatAmount0(Number(item.remaining_amount))}</span>

                                            </td>



                                            {/* Action */}

                                            {(usefor === "generateinvoice" || role !== "ViewAccess") && (

                                                <>

                                                    {(!["Checker", "SiteManagement"].includes(role)) ||

                                                        (role === "Checker" && !isMoreThan24Hours(item.created_at)) ? (

                                                        <td className="boc-modern-td text-center hide-on-print">

                                                            {usefor === "generateinvoice"

                                                                ? <DeleteDutyTravelInvoice i={item} getDutyTravelinvoice={getDutyTravelinvoice} />

                                                                : <DeleteDutyTravelInvoiceDeduction i={item} getDutyTravelinvoice={getDutyTravelinvoice} />

                                                            }

                                                        </td>

                                                    ) : (

                                                        <td className="boc-modern-td text-center hide-on-print">-</td>

                                                    )}

                                                </>

                                            )}

                                        </tr>

                                    );

                                })}

                            </tbody>



                            <tfoot>

                                <tr className="boc-modern-footer">

                                    <td colSpan="2" className="boc-modern-footer-label">Total:</td>

                                    <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatAmount0(calculateTotal(dutyTravelinvoice, item => Number(item.boq_rate_per_trip ?? item.duty_travel_details.rate_per_trip)))}</span></td>

                                    <td className="boc-modern-td boc-nowrap text-right">{formatTrip2(calculateTotal(dutyTravelinvoice, item => Number(item.boq_num_of_min_trip ?? item.duty_travel_details.num_of_min_trip)))}</td>

                                    <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatAmount0(calculateTotal(dutyTravelinvoice, item => Number(item.boq_rate_per_trip ?? item.duty_travel_details.rate_per_trip) * Number(item.boq_num_of_min_trip ?? item.duty_travel_details.num_of_min_trip)))}</span></td>

                                    {usefor !== "generateinvoice" && (

                                        <>

                                            <td className="boc-modern-td boc-nowrap text-right">

                                                {formatTrip2(dutyTravelinvoice.reduce((gt, item) => {

                                                    const matched = deductionData?.filter(d => d.item_id === item.id) || [];

                                                    return gt + matched.reduce((s, d) => s + (Number(d?.deduction_month) || 0), 0);

                                                }, 0))}

                                            </td>

                                            <td className="boc-modern-td boc-nowrap text-right">

                                                <span className="boc-modern-currency boc-modern-footer-total">

                                                    ₹ {formatAmount0(dutyTravelinvoice.reduce((gt, item) => {

                                                        const matched = deductionData?.filter(d => d.item_id === item.id) || [];

                                                        return gt + matched.reduce((s, d) => s + ((Number(d?.deduction_amount) || 0) + (Number(d?.withheld_deduction_amount) || 0)), 0);

                                                    }, 0))}

                                                </span>

                                            </td>

                                        </>

                                    )}



                                    {isEotDataTrue && Array.from({ length: eotLengths }).map((_, eotIdx) => {

                                        const totals = dutyTravelinvoice.reduce((acc, emp) => {

                                            const details = emp.eot_details?.length > 0 ? emp.eot_details : emp.data?.eot_details || [];

                                            const eot = details[eotIdx];

                                            if (!eot) return acc;

                                            acc.rate += Number(eot?.rate) || 0;

                                            acc.t_trips += Number(eot?.t_trips) || 0;

                                            acc.total_amount += Number(eot?.total_amount) || 0;

                                            return acc;

                                        }, { rate: 0, t_trips: 0, total_amount: 0 });

                                        return (

                                            <React.Fragment key={eotIdx}>

                                                <td className="boc-modern-td boc-nowrap text-right">₹ {formatAmount0(totals.rate)}</td>

                                                <td className="boc-modern-td boc-nowrap text-right">{formatTrip2(totals.t_trips)}</td>

                                                <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatAmount0(totals.total_amount)}</span></td>

                                            </React.Fragment>

                                        );

                                    })}



                                    <td className="boc-modern-td boc-nowrap text-right">{formatTrip2(calculateTotal(dutyTravelinvoice, item => Number(item.actual_month_total_previous)))}</td>

                                    <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatAmount0(calculateTotal(dutyTravelinvoice, item => Number(item.previous_invoice_total)))}</span></td>

                                    <td className="boc-modern-td boc-nowrap text-right">{formatTrip2(calculateTotal(dutyTravelinvoice, item => Number(item.actual_trip)))}</td>

                                    <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatAmount0(calculateTotal(dutyTravelinvoice, item => Number(item.invoice_amount ?? item.current_invoice_amount)))}</span></td>

                                    <td className="boc-modern-td boc-nowrap text-right">{formatTrip2(calculateTotal(dutyTravelinvoice, item => Number(item.actual_month_cumulative_total)))}</td>

                                    <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatAmount0(calculateTotal(dutyTravelinvoice, item => Number(item.cumulative_invoice_total)))}</span></td>

                                    <td className="boc-modern-td boc-nowrap text-right">{formatTrip2(calculateTotal(dutyTravelinvoice, item => Number(item.actual_month_remaining)))}</td>

                                    <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatAmount0(calculateTotal(dutyTravelinvoice, item => Number(item.remaining_amount)))}</span></td>



                                    {role !== "SiteManagement" && role !== "ViewAccess" && (

                                        <td className="hide-on-print boc-modern-td"></td>

                                    )}

                                </tr>

                            </tfoot>

                        </table>

                    </div>

                </div>

            </div>

        </div>

    );

};

// const OfficeRent = ({ setEotDetails, deductionData, projectData, client, p_id, invoice_id, invoice_num, month, year, logData,
//     setPreviousAmount,
//     setCurrentAmount,
//     setRemainingAmount,
//     setContractAmount,
//     setExcelRows,
//     usefor,
//     setCumulated }) => {

//     const role = sessionStorage.getItem('sitemanagement_role');
//     const project = sessionStorage.getItem('sitemanagement_project');

//     const currentDate = new Date();
//     const isFirstWeek = currentDate.getDate() <= 7;



//     const [officeRentinvoice, setOfficeRentinvoice] = useState([]);

//     const calculateContractAmount = calculateTotal(officeRentinvoice, (item) => Number(item.boq_rate_per_month ?? item.officerent_details.rate_per_month) * (Number(item.boq_num_of_months ?? item.officerent_details.num_of_months)))
//     setContractAmount(calculateContractAmount);
//     const calculatePreviousAmount = calculateTotal(officeRentinvoice, (item) => Number(item.previous_invoice_total))
//     setPreviousAmount(calculatePreviousAmount);
//     const calculateCurrentAmount = calculateTotal(officeRentinvoice, (item) => Number(item.invoice_amount ?? item.current_invoice_amount))
//     setCurrentAmount(calculateCurrentAmount);
//     const calculateCumulated = calculateTotal(officeRentinvoice, (item) => Number(item.cumulative_invoice_total))
//     setCumulated(calculateCumulated);
//     const calculateRemaining = calculateTotal(officeRentinvoice, (item) => Number(item.remaining_amount))
//     setRemainingAmount(calculateRemaining);

//     useEffect(() => {
//         const eotGroups = [];
//         officeRentinvoice.forEach(item => {
//             (item?.eot_details || []).forEach((eot, idx) => {
//                 if (!eotGroups[idx]) {
//                     eotGroups[idx] = { ...eot, total_amount: 0 };
//                 }
//                 eotGroups[idx].total_amount += Number(eot.total_amount || 0);
//             });
//         });

//         setEotDetails(eotGroups);
//         console.log("Transport EOT Groups:", eotGroups);
//     }, [officeRentinvoice]);

//     const getOfficeRentinvoice = async () => {
//         try {
//             let data;

//             if (usefor === "generateinvoice") {
//                 const res = await axios.get(
//                     `${BASE_URL}/siteproject/invoiceofficerentbyprojectstatus/${p_id ? p_id : project}/${month}/${year}/`
//                 );
//                 data = res.data;
//             } else {
//                 const response2 = await axios.get(
//                     `${BASE_URL}/siteproject/newinvoiceofficerentfiltermonthyear/${invoice_id}/null/null/`
//                 );
//                 data = response2.data;
//             }

//             const isAnyBoqJsonNull = data.length !== 0 && data.every(item => item.boq_json === null);


//             const selectedData = isAnyBoqJsonNull ? data : data;
//             setOfficeRentinvoice(selectedData);
//         } catch (err) { }

//     };

//     useEffect(() => {

//         // getdocument();
//         getOfficeRentinvoice();
//         // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, []);

//     const isEotDataTrue = officeRentinvoice.some(i =>
//         (i.eot_details?.length > 0) || (i.data?.eot_details?.length > 0)
//     );





//     const eotLengths = Math.max(
//         ...officeRentinvoice.map(i => i?.eot_details?.length || i?.data?.eot_details?.length || 0),
//         0
//     );
//     const r2 = (val) => {
//         const n = Number(val);
//         return isNaN(n) ? 0 : Math.round(n * 100) / 100;
//     };

//     // ── Builds a fully formatted AOA sheet (merged headers, flat rows) ──
//     const buildExcelSheetData = () => {
//         const showDeduction = usefor !== "generateinvoice";

//         // ---- figure out column layout ----
//         let col = 0;
//         const SNO_COL = col++;                  // 0
//         const CONTRACT_START = col; col += 5;   // Rate, Const, Maint, No. of MM, Total Amount
//         let DED_MONTH_COL = -1, DED_AMT_COL = -1;
//         if (showDeduction) {
//             DED_MONTH_COL = col++;
//             DED_AMT_COL = col++;
//         }
//         const EOT_START = col; col += eotLengths * 5;   // 5 cols per EOT group (Rate, Const, Maint, Total MM, Total Amount)
//         const PREV_START = col; col += 2;   // Month, Amount
//         const CUR_START = col; col += 2;
//         const CUM_START = col; col += 2;
//         const REM_START = col; col += 2;
//         const TOTAL_COLS = col;

//         const blankRow = () => new Array(TOTAL_COLS).fill("");

//         // ---- header row 1 (group labels) ----
//         const row1 = blankRow();
//         row1[SNO_COL] = "S.No";
//         row1[CONTRACT_START] = "Contract Amount";
//         if (showDeduction) {
//             row1[DED_MONTH_COL] = "Deduction Month";
//             row1[DED_AMT_COL] = "Deduction Amount";
//         }
//         for (let i = 0; i < eotLengths; i++) {
//             row1[EOT_START + i * 5] = `EOT ${i + 1}`;
//         }
//         row1[PREV_START] = "Cumulative Total of Previous Months";
//         row1[CUR_START] = "This Period";
//         row1[CUM_START] = "Cumulative Total Including Current Invoice";
//         row1[REM_START] = "Remaining Amount Against Contract Value";

//         // ---- header row 2 (sub labels) ----
//         const row2 = blankRow();
//         row2[CONTRACT_START] = "Rate";
//         row2[CONTRACT_START + 1] = "Const";
//         row2[CONTRACT_START + 2] = "Maint";
//         row2[CONTRACT_START + 3] = "No. of MM";
//         row2[CONTRACT_START + 4] = "Total Amount";
//         for (let i = 0; i < eotLengths; i++) {
//             const c = EOT_START + i * 5;
//             row2[c] = "Rate";
//             row2[c + 1] = "Const";
//             row2[c + 2] = "Maint";
//             row2[c + 3] = "Total MM";
//             row2[c + 4] = "Total Amount";
//         }
//         row2[PREV_START] = "Month"; row2[PREV_START + 1] = "Amount";
//         row2[CUR_START] = "Month"; row2[CUR_START + 1] = "Amount";
//         row2[CUM_START] = "Month"; row2[CUM_START + 1] = "Amount";
//         row2[REM_START] = "Month"; row2[REM_START + 1] = "Amount";

//         // ---- merges for the two header rows ----
//         const merges = [];
//         const vMerge = (c) => merges.push({ s: { r: 0, c }, e: { r: 1, c } });
//         const hMerge = (c1, c2) => merges.push({ s: { r: 0, c: c1 }, e: { r: 0, c: c2 } });

//         vMerge(SNO_COL);
//         if (showDeduction) { vMerge(DED_MONTH_COL); vMerge(DED_AMT_COL); }
//         hMerge(CONTRACT_START, CONTRACT_START + 4);
//         for (let i = 0; i < eotLengths; i++) {
//             const c = EOT_START + i * 5;
//             hMerge(c, c + 4);
//         }
//         hMerge(PREV_START, PREV_START + 1);
//         hMerge(CUR_START, CUR_START + 1);
//         hMerge(CUM_START, CUM_START + 1);
//         hMerge(REM_START, REM_START + 1);

//         // ---- data rows (flat — no sections for office rent) ----
//         const rows = [row1, row2];

//         officeRentinvoice.forEach((item, index) => {
//             const rate = Number(item.boq_rate_per_month ?? item.officerent_details.rate_per_month) || 0;
//             const constMM = Number(item.boq_during_construction_period ?? item.officerent_details.during_construction_period) || 0;
//             const omMM = Number(item.boq_during_dlp_OM_period ?? item.officerent_details.during_dlp_OM_period) || 0;
//             const numMonths = Number(item.boq_num_of_months ?? item.officerent_details.num_of_months) || 0;
//             const totalAmt = rate * numMonths;

//             const matchedDeductions = deductionData?.filter((d) => d.item_id === item.id) || [];
//             const deductionMonthSum = matchedDeductions.reduce((s, n) => s + (Number(n.deduction_month) || 0), 0);
//             const deductionAmountSum = matchedDeductions.reduce((s, n) => s + ((Number(n.deduction_amount) + Number(n.withheld_deduction_amount)) || 0), 0);

//             const r = blankRow();
//             r[SNO_COL] = index + 1;
//             r[CONTRACT_START] = r2(rate);
//             r[CONTRACT_START + 1] = r2(constMM);
//             r[CONTRACT_START + 2] = r2(omMM);
//             r[CONTRACT_START + 3] = r2(numMonths);
//             r[CONTRACT_START + 4] = r2(totalAmt);
//             if (showDeduction) {
//                 r[DED_MONTH_COL] = r2(deductionMonthSum);
//                 r[DED_AMT_COL] = r2(deductionAmountSum);
//             }
//             (item.eot_details || []).forEach((e, i) => {
//                 const c = EOT_START + i * 5;
//                 r[c] = r2(e.rate);
//                 r[c + 1] = r2(e.cp);
//                 r[c + 2] = r2(e.dlp);
//                 r[c + 3] = r2(e.t_month);
//                 r[c + 4] = r2(e.total_amount);
//             });
//             r[PREV_START] = r2(item.actual_month_total_previous);
//             r[PREV_START + 1] = r2(item.previous_invoice_total);
//             r[CUR_START] = r2(item.actual_month);
//             r[CUR_START + 1] = r2(item.invoice_amount);
//             r[CUM_START] = r2(item.actual_month_cumulative_total);
//             r[CUM_START + 1] = r2(item.cumulative_invoice_total);
//             r[REM_START] = r2(item.actual_month_remaining);
//             r[REM_START + 1] = r2(item.remaining_amount);

//             rows.push(r);
//         });

//         // ---- totals row ----
//         const totalRow = blankRow();
//         totalRow[SNO_COL] = "Total:";
//         totalRow[CONTRACT_START] = r2(calculateTotal(officeRentinvoice, item => Number(item.boq_rate_per_month ?? item.officerent_details.rate_per_month)));
//         totalRow[CONTRACT_START + 1] = r2(calculateTotal(officeRentinvoice, item => Number(item.boq_during_construction_period ?? item.officerent_details.during_construction_period)));
//         totalRow[CONTRACT_START + 2] = r2(calculateTotal(officeRentinvoice, item => Number(item.boq_during_dlp_OM_period ?? item.officerent_details.during_dlp_OM_period)));
//         totalRow[CONTRACT_START + 3] = r2(calculateTotal(officeRentinvoice, item => Number(item.boq_num_of_months ?? item.officerent_details.num_of_months)));
//         totalRow[CONTRACT_START + 4] = r2(calculateContractAmount);

//         if (showDeduction) {
//             totalRow[DED_MONTH_COL] = r2(officeRentinvoice.reduce((gt, item) => {
//                 const matched = deductionData?.filter(d => d.item_id === item.id) || [];
//                 return gt + matched.reduce((s, d) => s + (Number(d?.deduction_month) || 0), 0);
//             }, 0));
//             totalRow[DED_AMT_COL] = r2(officeRentinvoice.reduce((gt, item) => {
//                 const matched = deductionData?.filter(d => d.item_id === item.id) || [];
//                 return gt + matched.reduce((s, d) => s + (Number(d?.deduction_amount) || 0), 0);
//             }, 0));
//         }

//         for (let eotIdx = 0; eotIdx < eotLengths; eotIdx++) {
//             const totals = officeRentinvoice.reduce((acc, emp) => {
//                 const details = emp.eot_details?.length > 0 ? emp.eot_details : emp.data?.eot_details || [];
//                 const eot = details[eotIdx];
//                 if (!eot) return acc;
//                 acc.cp += Number(eot?.cp) || 0;
//                 acc.dlp += Number(eot?.dlp) || 0;
//                 acc.t_month += Number(eot?.t_month) || 0;
//                 acc.rate += Number(eot?.rate) || 0;
//                 acc.total_amount += Number(eot?.total_amount) || 0;
//                 return acc;
//             }, { cp: 0, dlp: 0, t_month: 0, rate: 0, total_amount: 0 });
//             const c = EOT_START + eotIdx * 5;
//             totalRow[c] = r2(totals.rate);
//             totalRow[c + 1] = r2(totals.cp);
//             totalRow[c + 2] = r2(totals.dlp);
//             totalRow[c + 3] = r2(totals.t_month);
//             totalRow[c + 4] = r2(totals.total_amount);
//         }

//         totalRow[PREV_START] = r2(calculateTotal(officeRentinvoice, item => Number(item.actual_month_total_previous)));
//         totalRow[PREV_START + 1] = r2(calculatePreviousAmount);
//         totalRow[CUR_START] = r2(calculateTotal(officeRentinvoice, item => Number(item.actual_month)));
//         totalRow[CUR_START + 1] = r2(calculateCurrentAmount);
//         totalRow[CUM_START] = r2(calculateTotal(officeRentinvoice, item => Number(item.actual_month_cumulative_total)));
//         totalRow[CUM_START + 1] = r2(calculateCumulated);
//         totalRow[REM_START] = r2(calculateTotal(officeRentinvoice, item => Number(item.actual_month_remaining)));
//         totalRow[REM_START + 1] = r2(calculateRemaining);
//         rows.push(totalRow);

//         const colWidths = new Array(TOTAL_COLS).fill({ wch: 14 });
//         colWidths[SNO_COL] = { wch: 6 };

//         return { rows, merges, colWidths, sheetName: "Office Rent" };
//     };
//     useEffect(() => {
//         if (officeRentinvoice.length > 0 && typeof setExcelRows === "function") {
//             setExcelRows(buildExcelSheetData());
//         }
//     }, [officeRentinvoice, deductionData]);

//     // return (
//     //     <div className='table-css-backgrounds'>
//     //         <div className='print-center'>

//     //             <div className="table-css-background show-on-print">
//     //                 <div className='flex-column'>
//     //                     <div>
//     //                         <h3 style={{ fontSize: "15px", textAlign: "justify" }}>{projectData?.project_name}</h3>
//     //                     </div>
//     //                     <div className='flex-row justify-between' style={{ width: "90vw" }}>

//     //                         <div className='consultant-heading'>
//     //                             <h6>Client Name:{projectData?.client_name}</h6>
//     //                             <h6>Consultant (AE):{projectData?.lead}{projectData?.jv ? ` JV with ${projectData?.jv}.` : ""}{projectData?.association ? ` Association with ${projectData?.association}` : ""}</h6>
//     //                             <h6>GSTIN No:{projectData?.gst_no}</h6>
//     //                             <h6>PAN No:{projectData?.pan_no}</h6>
//     //                             <h6>Bid Due Submission Date:{formatDateDD_MM_YYYY(projectData?.bid_due_date)}</h6>
//     //                             <div className='flex-row justify-between' style={{ width: "86vw" }}>
//     //                                 <div>
//     //                                     <h6>Agreement Date:{formatDateDD_MM_YYYY(projectData?.agreement_date)}</h6>
//     //                                     <h6>Project Start Date:{formatDateDD_MM_YYYY(projectData?.commencement_date)}</h6>
//     //                                 </div>
//     //                                 <div>
//     //                                     <h6>Date: {getMonthName(month)}-{year}</h6>
//     //                                     <h6>Invoice Number: {invoice_num}</h6>
//     //                                 </div>

//     //                             </div>
//     //                         </div>

//     //                     </div>
//     //                 </div>

//     //                 <div className='heads-div'>
//     //                     <h5>5- Office Rent(Fixed Cost)-(Minimum 200 sqm area of office shall be rented. )
//     //                     </h5>

//     //                     <div className='hide-on-print'>
//     //                         {usefor === "generateinvoice" ?
//     //                             <OfficeRentInvoice usedfor="InvoiceandDeduction" p_id={p_id ? p_id : project} invoice_id={invoice_id} getOfficeRentinvoice={getOfficeRentinvoice} month={month} year={year} logData={logData} />

//     //                             :
//     //                             <>
//     //                                 {officeRentinvoice.length === 0 ?
//     //                                     <OfficeRentInvoice p_id={p_id ? p_id : project} invoiceData={officeRentinvoice} usedfor="OnlyDeduction" invoice_id={invoice_id} getOfficeRentinvoice={getOfficeRentinvoice} month={month} year={year} logData={logData} />

//     //                                     :
//     //                                     <UpdateRentDeductionInvoice invoiceData={officeRentinvoice} getData={getOfficeRentinvoice} />
//     //                                 }
//     //                             </>

//     //                         }

//     //                     </div>

//     //                 </div>
//     //                 <div className='table-box scroll-container-table'>
//     //                     <table className=" nested-table-lightblue">
//     //                         <thead>
//     //                             <tr className='theading'>
//     //                                 <th className='table-heading-text' rowSpan="2">S.No</th>

//     //                                 <th colSpan="5" className='table-heading-text text-center'>Contract Amount</th>
//     //                                 {usefor !== "generateinvoice" && (
//     //                                     <>
//     //                                         <th className='table-heading-text text-center' rowSpan="4">Deduction Month</th>
//     //                                         <th className='table-heading-text text-center' rowSpan="4">Deduction Amount</th>

//     //                                     </>
//     //                                 )}
//     //                                 {isEotDataTrue &&

//     //                                     <th
//     //                                         className="table-heading-text text-center"
//     //                                         colSpan={eotLengths * 5 || 1}
//     //                                     >
//     //                                         ( COS/EOT)
//     //                                     </th>
//     //                                 }
//     //                                 <th colSpan="2" className='table-heading-text text-center'>Cumulative Total of Previous Months</th>
//     //                                 <th colSpan="2" className='table-heading-text text-center'>This Period</th>
//     //                                 <th colSpan="2" className='table-heading-text text-center'>Cumulative total Including Current Invoice</th>
//     //                                 <th colSpan="2" className='table-heading-text text-center'>Remaining amount against contract value</th>
//     //                                 {role !== "SiteManagement" && role !== "ViewAccess" &&

//     //                                     <th rowSpan="4" className='table-heading-text text-center hide-on-print'>Action</th>
//     //                                 }
//     //                             </tr>
//     //                             <tr className='nested-heading'>
//     //                                 <th rowSpan="2" className='table-heading-text'>Rate</th>

//     //                                 <th rowSpan="2" className='table-heading-text'>Const</th>
//     //                                 <th rowSpan="2" className='table-heading-text'>Maint</th>
//     //                                 <th rowSpan="2" className='table-heading-text'>nO. OF MM</th>
//     //                                 {/*  <th className='table-heading-text'>Const</th>
//     //                              <th className='table-heading-text'>Mint</th>
//     //                              <th className='table-heading-text'>Total MM</th> */}
//     //                                 <th className='table-heading-text'>Total Amount</th>
//     //                                 {Array.from({ length: eotLengths }).map((_, idx) => (
//     //                                     <th key={idx} className="table-heading-text text-center" colSpan={5}>
//     //                                         {`Revised Contract Amount as per EOT ${idx + 1}`}
//     //                                     </th>
//     //                                 ))}
//     //                                 <th rowSpan="2" className='table-heading-text'>Month</th>
//     //                                 <th rowSpan="2" className='table-heading-text'>Amount</th>
//     //                                 <th rowSpan="2" className='table-heading-text'>Month</th>
//     //                                 <th rowSpan="2" className='table-heading-text'>Amount</th>
//     //                                 <th rowSpan="2" className='table-heading-text'>Month</th>
//     //                                 <th rowSpan="2" className='table-heading-text'>Amount</th>
//     //                                 <th rowSpan="2" className='table-heading-text'>Month</th>
//     //                                 <th rowSpan="2" className='table-heading-text'>Amount</th>


//     //                             </tr>
//     //                             <tr className='nested-heading'>
//     //                                 {Array.from({ length: eotLengths }).map((_, idx) => (
//     //                                     <React.Fragment key={idx}>
//     //                                         <th rowSpan="2" className='table-heading-text'>Rate</th>

//     //                                         <th rowSpan="2" className='table-heading-text'>Const</th>
//     //                                         <th rowSpan="2" className='table-heading-text'>Maint</th>
//     //                                         <th rowSpan="2" className='table-heading-text'>Total MM</th>

//     //                                         <th rowSpan="2" className='table-heading-text'>Total Amount</th>
//     //                                     </React.Fragment>
//     //                                 ))}

//     //                             </tr>
//     //                         </thead>
//     //                         <tbody>
//     //                             {officeRentinvoice.map((item, index) => {
//     //                                 const matchedDeductions = deductionData?.filter(
//     //                                     (d) => d.item_id === item.id
//     //                                 ) || [];
//     //                                 return (
//     //                                     <tr className='tbody' key={item.id}>
//     //                                         <td className='table-body '>{index + 1}.</td>
//     //                                         <td className='table-body text-end'>₹{formatCurrencyIndian(Number(item.boq_rate_per_month ?? item.officerent_details.rate_per_month))}</td>

//     //                                         <td className='table-body text-end'>{formatCurrencyIndian(Number(item.boq_during_construction_period ?? item.officerent_details.during_construction_period))}</td>
//     //                                         <td className='table-body text-end'>{formatCurrencyIndian(Number(item.boq_during_dlp_OM_period ?? item.officerent_details.during_dlp_OM_period))}</td>
//     //                                         <td className='table-body text-end'>{formatCurrencyIndian(Number(item.boq_num_of_months ?? item.officerent_details.num_of_months))}</td>
//     //                                         <td className='table-body text-end'>₹{formatCurrencyIndian(Number(item.boq_rate_per_month ?? item.officerent_details.rate_per_month) * Number(item.boq_num_of_months ?? item.officerent_details.num_of_months))}</td>
//     //                                         {usefor !== "generateinvoice" && (
//     //                                             <td className='table-body text-end'>
//     //                                                 {matchedDeductions.length > 0 ?
//     //                                                     matchedDeductions.map((n, i) => (
//     //                                                         <td key={i} className='flex-column' style={{ marginBottom: "4px" }}>
//     //                                                             {n.deduction_month ?? "-"}
//     //                                                         </td>
//     //                                                     ))
//     //                                                     : <td className='flex-column' style={{ marginBottom: "4px" }}>-</td>
//     //                                                 }
//     //                                             </td>
//     //                                         )}

//     //                                         {usefor !== "generateinvoice" && (
//     //                                             <td className='table-body text-end'>
//     //                                                 {matchedDeductions?.length > 0 ?
//     //                                                     <>
//     //                                                         {matchedDeductions.map((n, i) => (
//     //                                                             <td key={i} className='flex-column' style={{ marginBottom: "4px" }}>
//     //                                                                 {Number(n.deduction_amount) + Number(n.withheld_deduction_amount) || 0}
//     //                                                             </td>
//     //                                                         ))}
//     //                                                     </>
//     //                                                     : <td className='flex-column' style={{ marginBottom: "4px" }}>0</td>
//     //                                                 }
//     //                                             </td>
//     //                                         )}
//     //                                         {item?.eot_details?.length > 0 ?
//     //                                             <>
//     //                                                 {item.eot_details.map((i) => (
//     //                                                     <>

//     //                                                         <td className="align-right">{i.cp} </td>
//     //                                                         <td className="align-right">{i.dlp} </td>
//     //                                                         <td className="align-right">{i.t_month} </td>
//     //                                                         <td className="align-right">{i.rate} </td>
//     //                                                         <td className="align-right">{i.total_amount} </td>

//     //                                                     </>
//     //                                                 ))}
//     //                                             </> :
//     //                                             <></>
//     //                                         }
//     //                                         <td className='table-body text-end'>{formatCurrencyIndian(Number(item.actual_month_total_previous))}</td>
//     //                                         <td className='table-body text-end'>₹{formatCurrencyIndian(Number(item.previous_invoice_total))}</td>
//     //                                         <td className='table-body text-end'>{formatCurrencyIndian(Number(item.actual_month))}</td>
//     //                                         <td className='table-body text-end'>₹{formatCurrencyIndian(Number(item.invoice_amount))}</td>
//     //                                         <td className='table-body text-end'>{formatCurrencyIndian(Number(item.actual_month_cumulative_total))}</td>
//     //                                         <td className='table-body text-end'>₹{formatCurrencyIndian(Number(item.cumulative_invoice_total))}</td>
//     //                                         <td className='table-body text-end'>{formatCurrencyIndian(Number(item.actual_month_remaining))}</td>
//     //                                         <td className='table-body text-end'>₹{formatCurrencyIndian(Number(item.remaining_amount))}</td>

//     //                                         {usefor === "generateinvoice" || role !== "ViewAccess" ?
//     //                                             <>
//     //                                                 {(!["Checker", "SiteManagement"].includes(role) && true) ||
//     //                                                     (role === "Checker" && !isMoreThan24Hours(item.created_at)) ?
//     //                                                     <td className='table-body text-end hide-on-print'>
//     //                                                         {usefor === "generateinvoice" ?


//     //                                                             <DeleteOfficeRent i={item} getOfficeRentinvoice={getOfficeRentinvoice} /> :
//     //                                                             <DeleteOfficeRentDeduction i={item} getOfficeRentinvoice={getOfficeRentinvoice} />
//     //                                                         }
//     //                                                     </td>
//     //                                                     :
//     //                                                     <td className=" text-center hide-on-print">
//     //                                                         -
//     //                                                     </td>
//     //                                                 }
//     //                                             </> :
//     //                                             <></>
//     //                                         }

//     //                                     </tr>
//     //                                 )
//     //                             })}
//     //                         </tbody>
//     //                         <tfoot>
//     //                             <tr className='tbody'>

//     //                                 <td className="total-label table-body">Total:</td>
//     //                                 <td className='table-body text-end'>₹{formatCurrencyIndian(calculateTotal(officeRentinvoice, (item) => Number(item.boq_rate_per_month ?? item.officerent_details.rate_per_month)))}</td>

//     //                                 <td className='table-body text-end'>{formatCurrencyIndian(calculateTotal(officeRentinvoice, (item) => Number(item.boq_during_construction_period ?? item.officerent_details.during_construction_period)))}</td>
//     //                                 <td className='table-body text-end'>{formatCurrencyIndian(calculateTotal(officeRentinvoice, (item) => Number(item.boq_during_dlp_OM_period ?? item.officerent_details.during_dlp_OM_period)))}</td>
//     //                                 <td className='table-body text-end'>{formatCurrencyIndian(calculateTotal(officeRentinvoice, (item) => Number(item.boq_num_of_months ?? item.officerent_details.num_of_months)))}</td>
//     //                                 <td className='table-body text-end'>₹{formatCurrencyIndian(calculateTotal(officeRentinvoice, (item) => Number(item.boq_rate_per_month ?? item.officerent_details.rate_per_month) * Number(item.boq_num_of_months ?? item.officerent_details.num_of_months)))}</td>
//     //                                 {usefor !== "generateinvoice" && (
//     //                                     <>
//     //                                         <td className="align-right">
//     //                                             {/* ✅ Use deductionData instead of item.deduction_amount */}
//     //                                             {(
//     //                                                 officeRentinvoice.reduce((grandTotal, item) => {
//     //                                                     const matchedDeductions = deductionData?.filter(
//     //                                                         (d) => d.item_id === item.id
//     //                                                     ) || [];
//     //                                                     const rowTotal = matchedDeductions.reduce(
//     //                                                         (sum, d) => sum + (Number(d?.deduction_month) || 0), 0
//     //                                                     );
//     //                                                     return grandTotal + rowTotal;
//     //                                                 }, 0)
//     //                                             )}
//     //                                         </td>
//     //                                         <td className="align-right">
//     //                                             {/* ✅ Use deductionData instead of item.deduction_amount */}
//     //                                             ₹{formatCurrencyIndian(
//     //                                                 officeRentinvoice.reduce((grandTotal, item) => {
//     //                                                     const matchedDeductions = deductionData?.filter(
//     //                                                         (d) => d.item_id === item.id
//     //                                                     ) || [];
//     //                                                     const rowTotal = matchedDeductions.reduce(
//     //                                                         (sum, d) => sum + (Number(d?.deduction_amount) || 0), 0
//     //                                                     );
//     //                                                     return grandTotal + rowTotal;
//     //                                                 }, 0)
//     //                                             )}
//     //                                         </td>
//     //                                     </>
//     //                                 )}
//     //                                 {isEotDataTrue && (
//     //                                     <>
//     //                                         {Array.from({ length: eotLengths }).map((_, eotIdx) => {
//     //                                             const totals = officeRentinvoice.reduce(
//     //                                                 (acc, emp) => {
//     //                                                     const details =
//     //                                                         emp.eot_details?.length > 0
//     //                                                             ? emp.eot_details
//     //                                                             : emp.data?.eot_details || [];
//     //                                                     const eot = details[eotIdx];

//     //                                                     if (!eot) return acc;

//     //                                                     acc.cp += Number(eot?.cp) || 0;
//     //                                                     acc.dlp += Number(eot?.dlp) || 0;
//     //                                                     acc.t_month += Number(eot?.t_month) || 0;
//     //                                                     acc.rate += Number(eot?.rate) || 0;
//     //                                                     acc.total_amount += Number(eot?.total_amount) || 0;

//     //                                                     return acc;
//     //                                                 },
//     //                                                 { cp: 0, dlp: 0, t_month: 0, rate: 0, total_amount: 0 }
//     //                                             );

//     //                                             const grandTotal =
//     //                                                 totals.t_month * totals.rate;

//     //                                             return (
//     //                                                 <React.Fragment key={eotIdx}>
//     //                                                     <td className="align-right">{formatCurrencyIndian(totals.cp)}</td>
//     //                                                     <td className="align-right">{formatCurrencyIndian(totals.dlp)}</td>
//     //                                                     <td className="align-right">{totals.t_month}</td>
//     //                                                     <td className="align-right">₹{formatCurrencyIndian(totals.rate)}</td>
//     //                                                     <td className="align-right">₹{formatCurrencyIndian(totals.total_amount)}</td>

//     //                                                 </React.Fragment>
//     //                                             );
//     //                                         })}
//     //                                     </>
//     //                                 )}
//     //                                 <td className='table-body text-end'>{formatCurrencyIndian(calculateTotal(officeRentinvoice, (item) => Number(item.actual_month_total_previous)))}</td>
//     //                                 <td className='table-body text-end'>₹{formatCurrencyIndian(calculateTotal(officeRentinvoice, (item) => Number(item.previous_invoice_total)))}</td>
//     //                                 <td className='table-body text-end'>{formatCurrencyIndian(calculateTotal(officeRentinvoice, (item) => Number(item.actual_month)))}</td>
//     //                                 <td className='table-body text-end'>₹{formatCurrencyIndian(calculateTotal(officeRentinvoice, (item) => Number(item.invoice_amount)))}</td>
//     //                                 <td className='table-body text-end'>{formatCurrencyIndian(calculateTotal(officeRentinvoice, (item) => Number(item.actual_month_cumulative_total)))}</td>
//     //                                 <td className='table-body text-end'>₹{formatCurrencyIndian(calculateTotal(officeRentinvoice, (item) => Number(item.cumulative_invoice_total)))}</td>
//     //                                 <td className='table-body text-end'>{formatCurrencyIndian(calculateTotal(officeRentinvoice, (item) => Number(item.actual_month_remaining)))}</td>
//     //                                 <td className='table-body text-end'>₹{formatCurrencyIndian(calculateTotal(officeRentinvoice, (item) => Number(item.remaining_amount)))}</td>
//     //                                 {role !== "SiteManagement" && role !== "ViewAccess" &&

//     //                                     <td className="hide-on-print"></td>
//     //                                 }
//     //                             </tr>
//     //                         </tfoot>
//     //                     </table>
//     //                 </div>
//     //             </div>
//     //         </div>

//     //     </div>
//     // );

//     return (
//         <div className="boc-modern-wrapper" style={{ minHeight: "30vh" }}>
//             <div className="boc-modern-card">

//                 {/* Print header */}
//                 <div className="boc-modern-header bocx-modern-footer-total">
//                     <div className="boc-modern-header-content">
//                         <div className="boc-modern-project-info">
//                             <h3 className="boc-modern-project-title">{projectData?.project_name}</h3>
//                             <div className="boc-modern-project-meta">
//                                 <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Client:</span><span className="boc-modern-meta-value">{projectData?.client_name}</span></div>
//                                 <div className="boc-modern-meta-divider"></div>
//                                 <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Consultant (AE):</span><span className="boc-modern-meta-value">{projectData?.lead}{projectData?.jv ? ` JV with ${projectData?.jv}.` : ""}{projectData?.association ? ` Association with ${projectData?.association}` : ""}</span></div>
//                                 <div className="boc-modern-meta-divider"></div>
//                                 <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">GSTIN:</span><span className="boc-modern-meta-value">{projectData?.gst_no}</span></div>
//                                 <div className="boc-modern-meta-divider"></div>
//                                 <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">PAN:</span><span className="boc-modern-meta-value">{projectData?.pan_no}</span></div>
//                                 <div className="boc-modern-meta-divider"></div>
//                                 <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Bid Due:</span><span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.bid_due_date)}</span></div>
//                                 <div className="boc-modern-meta-divider"></div>
//                                 <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Agreement:</span><span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.agreement_date)}</span></div>
//                                 <div className="boc-modern-meta-divider"></div>
//                                 <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Start:</span><span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.commencement_date)}</span></div>
//                                 <div className="boc-modern-meta-divider"></div>
//                                 <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Invoice Number:</span><span className="boc-modern-meta-value">{invoice_num}</span></div>
//                                 <div className="boc-modern-meta-divider"></div>
//                                 <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Date:</span><span className="boc-modern-meta-value">{getMonthName(month)}-{year}</span></div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>

//                 {/* Section heading + action */}
//                 <div className="boc-modern-description-section">
//                     <div className="boc-modern-controls">
//                         <div className="boc-modern-controls-left">
//                             <h6 className="boc-modern-main-heading">5- Office Rent (Fixed Cost) — Minimum 200 sqm area of office shall be rented</h6>
//                         </div>
//                         <div className="hide-on-print">
//                             {usefor === "generateinvoice" ?
//                                 <OfficeRentInvoice usedfor="InvoiceandDeduction" p_id={p_id ? p_id : project} invoice_id={invoice_id} getOfficeRentinvoice={getOfficeRentinvoice} month={month} year={year} logData={logData} />
//                                 :
//                                 <>
//                                     {officeRentinvoice.length === 0
//                                         ? <OfficeRentInvoice p_id={p_id ? p_id : project} invoiceData={officeRentinvoice} usedfor="OnlyDeduction" invoice_id={invoice_id} getOfficeRentinvoice={getOfficeRentinvoice} month={month} year={year} logData={logData} />
//                                         : <UpdateRentDeductionInvoice invoiceData={officeRentinvoice} getData={getOfficeRentinvoice} />
//                                     }
//                                 </>
//                             }
//                         </div>
//                     </div>
//                 </div>

//                 <div className="boc-modern-table-wrapper">
//                     <div className="boc-modern-table-scroll">
//                         <table className="boc-modern-table">
//                             <thead>
//                                 <tr className="boc-modern-table-header">
//                                     <th className="boc-modern-th text-center" rowSpan="3">S.No</th>
//                                     <th className="boc-modern-th text-center" colSpan="5">Contract Amount</th>
//                                     {usefor !== "generateinvoice" && (
//                                         <>
//                                             <th className="boc-modern-th text-center" rowSpan="3">Deduction Month</th>
//                                             <th className="boc-modern-th text-center" rowSpan="3">Deduction Amount</th>
//                                         </>
//                                     )}
//                                     {isEotDataTrue && (
//                                         <th className="boc-modern-th text-center" colSpan={eotLengths * 5 || 1}>(COS/EOT)</th>
//                                     )}
//                                     <th className="boc-modern-th text-center" colSpan="2">Cumulative Total of Previous Months</th>
//                                     <th className="boc-modern-th text-center" colSpan="2">This Period</th>
//                                     <th className="boc-modern-th text-center" colSpan="2">Cumulative Total Including Current Invoice</th>
//                                     <th className="boc-modern-th text-center" colSpan="2">Remaining Amount Against Contract Value</th>
//                                     {role !== "SiteManagement" && role !== "ViewAccess" && (
//                                         <th className="boc-modern-th text-center hide-on-print" rowSpan="3">Action</th>
//                                     )}
//                                 </tr>
//                                 <tr className="boc-modern-table-subheader">
//                                     <th rowSpan="2" className="boc-modern-th boc-nowrap">Rate</th>
//                                     <th rowSpan="2" className="boc-modern-th boc-nowrap">Const</th>
//                                     <th rowSpan="2" className="boc-modern-th boc-nowrap">Maint</th>
//                                     <th rowSpan="2" className="boc-modern-th boc-nowrap">No. of MM</th>
//                                     <th rowSpan="2" className="boc-modern-th boc-nowrap">Total Amount</th>
//                                     {Array.from({ length: eotLengths }).map((_, idx) => (
//                                         <th key={idx} className="boc-modern-th text-center boc-nowrap" colSpan={5}>{`EOT ${idx + 1}`}</th>
//                                     ))}
//                                     <th rowSpan="2" className="boc-modern-th boc-nowrap">Month</th>
//                                     <th rowSpan="2" className="boc-modern-th boc-nowrap">Amount</th>
//                                     <th rowSpan="2" className="boc-modern-th boc-nowrap">Month</th>
//                                     <th rowSpan="2" className="boc-modern-th boc-nowrap">Amount</th>
//                                     <th rowSpan="2" className="boc-modern-th boc-nowrap">Month</th>
//                                     <th rowSpan="2" className="boc-modern-th boc-nowrap">Amount</th>
//                                     <th rowSpan="2" className="boc-modern-th boc-nowrap">Month</th>
//                                     <th rowSpan="2" className="boc-modern-th boc-nowrap">Amount</th>
//                                 </tr>
//                                 <tr className="boc-modern-table-subheader">
//                                     {Array.from({ length: eotLengths }).map((_, idx) => (
//                                         <React.Fragment key={idx}>
//                                             <th rowSpan="2" className="boc-modern-th boc-nowrap">Rate</th>
//                                             <th rowSpan="2" className="boc-modern-th boc-nowrap">Const</th>
//                                             <th rowSpan="2" className="boc-modern-th boc-nowrap">Maint</th>
//                                             <th rowSpan="2" className="boc-modern-th boc-nowrap">Total MM</th>
//                                             <th rowSpan="2" className="boc-modern-th boc-nowrap">Total Amount</th>
//                                         </React.Fragment>
//                                     ))}
//                                 </tr>
//                             </thead>

//                             <tbody>
//                                 {officeRentinvoice.map((item, index) => {
//                                     const matchedDeductions = deductionData?.filter(d => d.item_id === item.id) || [];
//                                     return (
//                                         <tr className="boc-modern-row" key={item.id}>
//                                             <td className="boc-modern-td text-center">{index + 1}.</td>
//                                             <td className="boc-modern-td boc-nowrap boc-modern-currency text-right">₹ {formatCurrencyIndian(Number(item.boq_rate_per_month ?? item.officerent_details.rate_per_month))}</td>
//                                             <td className="boc-modern-td boc-nowrap text-right">{formatCurrencyIndian(Number(item.boq_during_construction_period ?? item.officerent_details.during_construction_period))}</td>
//                                             <td className="boc-modern-td boc-nowrap text-right">{formatCurrencyIndian(Number(item.boq_during_dlp_OM_period ?? item.officerent_details.during_dlp_OM_period))}</td>
//                                             <td className="boc-modern-td boc-nowrap text-right">{formatCurrencyIndian(Number(item.boq_num_of_months ?? item.officerent_details.num_of_months))}</td>
//                                             <td className="boc-modern-td boc-nowrap text-right">
//                                                 <span className="boc-modern-currency boc-modern-total-highlight">
//                                                     ₹ {formatCurrencyIndian(Number(item.boq_rate_per_month ?? item.officerent_details.rate_per_month) * Number(item.boq_num_of_months ?? item.officerent_details.num_of_months))}
//                                                 </span>
//                                             </td>

//                                             {/* Deduction Month */}
//                                             {usefor !== "generateinvoice" && (
//                                                 <td className="boc-modern-td boc-nowrap text-right justify-end" style={{ padding: 0 }}>
//                                                     {matchedDeductions.length > 0
//                                                         ? matchedDeductions.map((n, i) => <div key={i} className="boc-multi-item boc-nowrap">{n.deduction_month ?? "-"}</div>)
//                                                         : <div className="boc-multi-item">-</div>
//                                                     }
//                                                 </td>
//                                             )}
//                                             {/* Deduction Amount */}
//                                             {usefor !== "generateinvoice" && (
//                                                 <td className="boc-modern-td boc-nowrap text-right justify-end" style={{ padding: 0 }}>
//                                                     {matchedDeductions.length > 0
//                                                         ? matchedDeductions.map((n, i) => <div key={i} className="boc-multi-item boc-nowrap">{Number(n.deduction_amount) + Number(n.withheld_deduction_amount) || 0}</div>)
//                                                         : <div className="boc-multi-item">0</div>
//                                                     }
//                                                 </td>
//                                             )}

//                                             {/* EOT */}
//                                             {item?.eot_details?.length > 0 && item.eot_details.map((i, idx) => (
//                                                 <React.Fragment key={idx}>
//                                                     <td className="boc-modern-td boc-nowrap boc-modern-currency text-right">₹ {formatCurrencyIndian(Number(i.rate))}</td>
//                                                     <td className="boc-modern-td boc-nowrap text-right">{i.cp}</td>
//                                                     <td className="boc-modern-td boc-nowrap text-right">{i.dlp}</td>
//                                                     <td className="boc-modern-td boc-nowrap text-right">{i.t_month}</td>
//                                                     <td className="boc-modern-td boc-nowrap boc-modern-currency text-right">₹ {formatCurrencyIndian(Number(i.total_amount))}</td>
//                                                 </React.Fragment>
//                                             ))}

//                                             <td className="boc-modern-td boc-nowrap text-right">{formatCurrencyIndian(Number(item.actual_month_total_previous))}</td>
//                                             <td className="boc-modern-td boc-nowrap boc-modern-currency text-right">₹ {formatCurrencyIndian(Number(item.previous_invoice_total))}</td>
//                                             <td className="boc-modern-td boc-nowrap text-right">{formatCurrencyIndian(Number(item.actual_month))}</td>
//                                             <td className="boc-modern-td boc-nowrap boc-modern-currency text-right">₹ {formatCurrencyIndian(Number(item.invoice_amount))}</td>
//                                             <td className="boc-modern-td boc-nowrap text-right">{formatCurrencyIndian(Number(item.actual_month_cumulative_total))}</td>
//                                             <td className="boc-modern-td boc-nowrap boc-modern-currency text-right">₹ {formatCurrencyIndian(Number(item.cumulative_invoice_total))}</td>
//                                             <td className="boc-modern-td boc-nowrap text-right">{formatCurrencyIndian(Number(item.actual_month_remaining))}</td>
//                                             <td className="boc-modern-td boc-nowrap text-right">
//                                                 <span className="boc-modern-currency boc-modern-total-highlight">₹ {formatCurrencyIndian(Number(item.remaining_amount))}</span>
//                                             </td>

//                                             {/* Action */}
//                                             {(usefor === "generateinvoice" || role !== "ViewAccess") && (
//                                                 <>
//                                                     {(!["Checker", "SiteManagement"].includes(role)) ||
//                                                         (role === "Checker" && !isMoreThan24Hours(item.created_at)) ? (
//                                                         <td className="boc-modern-td text-center hide-on-print">
//                                                             {usefor === "generateinvoice"
//                                                                 ? <DeleteOfficeRent i={item} getOfficeRentinvoice={getOfficeRentinvoice} />
//                                                                 : <DeleteOfficeRentDeduction i={item} getOfficeRentinvoice={getOfficeRentinvoice} />
//                                                             }
//                                                         </td>
//                                                     ) : (
//                                                         <td className="boc-modern-td text-center hide-on-print">-</td>
//                                                     )}
//                                                 </>
//                                             )}
//                                         </tr>
//                                     );
//                                 })}
//                             </tbody>

//                             <tfoot>
//                                 <tr className="boc-modern-footer">
//                                     <td className="boc-modern-footer-label">Total:</td>
//                                     <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatCurrencyIndian(calculateTotal(officeRentinvoice, item => Number(item.boq_rate_per_month ?? item.officerent_details.rate_per_month)))}</span></td>
//                                     <td className="boc-modern-td boc-nowrap text-right">{formatCurrencyIndian(calculateTotal(officeRentinvoice, item => Number(item.boq_during_construction_period ?? item.officerent_details.during_construction_period)))}</td>
//                                     <td className="boc-modern-td boc-nowrap text-right">{formatCurrencyIndian(calculateTotal(officeRentinvoice, item => Number(item.boq_during_dlp_OM_period ?? item.officerent_details.during_dlp_OM_period)))}</td>
//                                     <td className="boc-modern-td boc-nowrap text-right">{formatCurrencyIndian(calculateTotal(officeRentinvoice, item => Number(item.boq_num_of_months ?? item.officerent_details.num_of_months)))}</td>
//                                     <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatCurrencyIndian(calculateTotal(officeRentinvoice, item => Number(item.boq_rate_per_month ?? item.officerent_details.rate_per_month) * Number(item.boq_num_of_months ?? item.officerent_details.num_of_months)))}</span></td>
//                                     {usefor !== "generateinvoice" && (
//                                         <>
//                                             <td className="boc-modern-td boc-nowrap text-right">
//                                                 {officeRentinvoice.reduce((gt, item) => {
//                                                     const matched = deductionData?.filter(d => d.item_id === item.id) || [];
//                                                     return gt + matched.reduce((s, d) => s + (Number(d?.deduction_month) || 0), 0);
//                                                 }, 0)}
//                                             </td>
//                                             <td className="boc-modern-td boc-nowrap text-right">
//                                                 <span className="boc-modern-currency boc-modern-footer-total">
//                                                     ₹ {formatCurrencyIndian(
//                                                         officeRentinvoice.reduce((gt, item) => {
//                                                             const matched = deductionData?.filter(d => d.item_id === item.id) || [];
//                                                             return gt + matched.reduce((s, d) => s + (Number(d?.deduction_amount) || 0), 0);
//                                                         }, 0)
//                                                     )}
//                                                 </span>
//                                             </td>
//                                         </>
//                                     )}

//                                     {isEotDataTrue && Array.from({ length: eotLengths }).map((_, eotIdx) => {
//                                         const totals = officeRentinvoice.reduce((acc, emp) => {
//                                             const details = emp.eot_details?.length > 0 ? emp.eot_details : emp.data?.eot_details || [];
//                                             const eot = details[eotIdx];
//                                             if (!eot) return acc;
//                                             acc.cp += Number(eot?.cp) || 0;
//                                             acc.dlp += Number(eot?.dlp) || 0;
//                                             acc.t_month += Number(eot?.t_month) || 0;
//                                             acc.rate += Number(eot?.rate) || 0;
//                                             acc.total_amount += Number(eot?.total_amount) || 0;
//                                             return acc;
//                                         }, { cp: 0, dlp: 0, t_month: 0, rate: 0, total_amount: 0 });
//                                         return (
//                                             <React.Fragment key={eotIdx}>
//                                                 <td className="boc-modern-td boc-nowrap text-right">₹ {formatCurrencyIndian(totals.rate)}</td>
//                                                 <td className="boc-modern-td boc-nowrap text-right">{formatCurrencyIndian(totals.cp)}</td>
//                                                 <td className="boc-modern-td boc-nowrap text-right">{formatCurrencyIndian(totals.dlp)}</td>
//                                                 <td className="boc-modern-td boc-nowrap text-right">{totals.t_month}</td>
//                                                 <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatCurrencyIndian(totals.total_amount)}</span></td>
//                                             </React.Fragment>
//                                         );
//                                     })}

//                                     <td className="boc-modern-td boc-nowrap text-right">{formatCurrencyIndian(Number(calculateTotal(officeRentinvoice, item => Number(item.actual_month_total_previous)).toFixed(2)))}</td>
//                                     <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatCurrencyIndian(Number(calculateTotal(officeRentinvoice, item => Number(item.previous_invoice_total)).toFixed(2)))}</span></td>
//                                     <td className="boc-modern-td boc-nowrap text-right">{formatCurrencyIndian(Number(calculateTotal(officeRentinvoice, item => Number(item.actual_month)).toFixed(2)))}</td>
//                                     <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatCurrencyIndian(Number(calculateTotal(officeRentinvoice, item => Number(item.invoice_amount)).toFixed(2)))}</span></td>
//                                     <td className="boc-modern-td boc-nowrap text-right">{formatCurrencyIndian(Number(calculateTotal(officeRentinvoice, item => Number(item.actual_month_cumulative_total)).toFixed(2)))}</td>
//                                     <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatCurrencyIndian(Number(calculateTotal(officeRentinvoice, item => Number(item.cumulative_invoice_total)).toFixed(2)))}</span></td>
//                                     <td className="boc-modern-td boc-nowrap text-right">{formatCurrencyIndian(Number(calculateTotal(officeRentinvoice, item => Number(item.actual_month_remaining)).toFixed(2)))}</td>
//                                     <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatCurrencyIndian(Number(calculateTotal(officeRentinvoice, item => Number(item.remaining_amount)).toFixed(2)))}</span></td>
//                                     {role !== "SiteManagement" && role !== "ViewAccess" && (
//                                         <td className="hide-on-print boc-modern-td"></td>
//                                     )}
//                                 </tr>
//                             </tfoot>
//                         </table>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );

// };


const OfficeRent = ({ setEotDetails, deductionData, projectData, client, p_id, invoice_id, invoice_num, month, year, logData,

    setPreviousAmount,

    setCurrentAmount,

    setRemainingAmount,

    setContractAmount,

    setExcelRows,

    usefor,

    setCumulated }) => {



    const role = sessionStorage.getItem('sitemanagement_role');

    const project = sessionStorage.getItem('sitemanagement_project');



    const currentDate = new Date();

    const isFirstWeek = currentDate.getDate() <= 7;







    const [officeRentinvoice, setOfficeRentinvoice] = useState([]);



    const calculateContractAmount = calculateTotal(officeRentinvoice, (item) => Number(item.boq_rate_per_month ?? item.officerent_details.rate_per_month) * (Number(item.boq_num_of_months ?? item.officerent_details.num_of_months)))

    setContractAmount(calculateContractAmount);

    const calculatePreviousAmount = calculateTotal(officeRentinvoice, (item) => Number(item.previous_invoice_total))

    setPreviousAmount(calculatePreviousAmount);

    const calculateCurrentAmount = calculateTotal(officeRentinvoice, (item) => Number(item.invoice_amount ?? item.current_invoice_amount))

    setCurrentAmount(calculateCurrentAmount);

    const calculateCumulated = calculateTotal(officeRentinvoice, (item) => Number(item.cumulative_invoice_total))

    setCumulated(calculateCumulated);

    const calculateRemaining = calculateTotal(officeRentinvoice, (item) => Number(item.remaining_amount))

    setRemainingAmount(calculateRemaining);



    useEffect(() => {

        const eotGroups = [];

        officeRentinvoice.forEach(item => {

            (item?.eot_details || []).forEach((eot, idx) => {

                if (!eotGroups[idx]) {

                    eotGroups[idx] = { ...eot, total_amount: 0 };

                }

                eotGroups[idx].total_amount += Number(eot.total_amount || 0);

            });

        });



        setEotDetails(eotGroups);

        console.log("Transport EOT Groups:", eotGroups);

    }, [officeRentinvoice]);



    const getOfficeRentinvoice = async () => {

        try {

            let data;



            if (usefor === "generateinvoice") {

                const res = await axios.get(

                    `${BASE_URL}/siteproject/invoiceofficerentbyprojectstatus/${p_id ? p_id : project}/${month}/${year}/`

                );

                data = res.data;

            } else {

                const response2 = await axios.get(

                    `${BASE_URL}/siteproject/newinvoiceofficerentfiltermonthyear/${invoice_id}/null/null/`

                );

                data = response2.data;

            }



            const isAnyBoqJsonNull = data.length !== 0 && data.every(item => item.boq_json === null);





            const selectedData = isAnyBoqJsonNull ? data : data;

            setOfficeRentinvoice(selectedData);

        } catch (err) { }



    };



    useEffect(() => {



        // getdocument();

        getOfficeRentinvoice();

        // eslint-disable-next-line react-hooks/exhaustive-deps

    }, []);



    const isEotDataTrue = officeRentinvoice.some(i =>

        (i.eot_details?.length > 0) || (i.data?.eot_details?.length > 0)

    );











    const eotLengths = Math.max(

        ...officeRentinvoice.map(i => i?.eot_details?.length || i?.data?.eot_details?.length || 0),

        0

    );


    // Display/Excel formatting only. Never round during invoice calculations.
    // Example: 38571.43 -> 38,571; 38571.54 -> 38,572.
    const formatAmount0 = (value) => {
        const n = Number(value ?? 0);
        return Number.isFinite(n)
            ? Math.round(n).toLocaleString("en-IN", { maximumFractionDigits: 0 })
            : "0";
    };

    const formatMonth2 = (value) => {
        const n = Number(value ?? 0);
        return Number.isFinite(n) ? n.toFixed(2) : "0.00";
    };

    // Excel AOA: rupee columns use numeric integers; month cells display two digits.
    const r0 = (value) => {
        const n = Number(value ?? 0);
        return Number.isFinite(n) ? Math.round(n) : 0;
    };
    const r2 = (value) => formatMonth2(value);




    // ── Builds a fully formatted AOA sheet (merged headers, flat rows) ──

    const buildExcelSheetData = () => {

        const showDeduction = usefor !== "generateinvoice";



        // ---- figure out column layout ----

        let col = 0;

        const SNO_COL = col++;                  // 0

        const CONTRACT_START = col; col += 5;   // Rate, Const, Maint, No. of MM, Total Amount

        let DED_MONTH_COL = -1, DED_AMT_COL = -1;

        if (showDeduction) {

            DED_MONTH_COL = col++;

            DED_AMT_COL = col++;

        }

        const EOT_START = col; col += eotLengths * 5;   // 5 cols per EOT group (Rate, Const, Maint, Total MM, Total Amount)

        const PREV_START = col; col += 2;   // Month, Amount

        const CUR_START = col; col += 2;

        const CUM_START = col; col += 2;

        const REM_START = col; col += 2;

        const TOTAL_COLS = col;



        const blankRow = () => new Array(TOTAL_COLS).fill("");



        // ---- header row 1 (group labels) ----

        const row1 = blankRow();

        row1[SNO_COL] = "S.No";

        row1[CONTRACT_START] = "Contract Amount";

        if (showDeduction) {

            row1[DED_MONTH_COL] = "Deduction Month";

            row1[DED_AMT_COL] = "Deduction Amount";

        }

        for (let i = 0; i < eotLengths; i++) {

            row1[EOT_START + i * 5] = `EOT ${i + 1}`;

        }

        row1[PREV_START] = "Cumulative Total of Previous Months";

        row1[CUR_START] = "This Period";

        row1[CUM_START] = "Cumulative Total Including Current Invoice";

        row1[REM_START] = "Remaining Amount Against Contract Value";



        // ---- header row 2 (sub labels) ----

        const row2 = blankRow();

        row2[CONTRACT_START] = "Rate";

        row2[CONTRACT_START + 1] = "Const";

        row2[CONTRACT_START + 2] = "Maint";

        row2[CONTRACT_START + 3] = "No. of MM";

        row2[CONTRACT_START + 4] = "Total Amount";

        for (let i = 0; i < eotLengths; i++) {

            const c = EOT_START + i * 5;

            row2[c] = "Rate";

            row2[c + 1] = "Const";

            row2[c + 2] = "Maint";

            row2[c + 3] = "Total MM";

            row2[c + 4] = "Total Amount";

        }

        row2[PREV_START] = "Month"; row2[PREV_START + 1] = "Amount";

        row2[CUR_START] = "Month"; row2[CUR_START + 1] = "Amount";

        row2[CUM_START] = "Month"; row2[CUM_START + 1] = "Amount";

        row2[REM_START] = "Month"; row2[REM_START + 1] = "Amount";



        // ---- merges for the two header rows ----

        const merges = [];

        const vMerge = (c) => merges.push({ s: { r: 0, c }, e: { r: 1, c } });

        const hMerge = (c1, c2) => merges.push({ s: { r: 0, c: c1 }, e: { r: 0, c: c2 } });



        vMerge(SNO_COL);

        if (showDeduction) { vMerge(DED_MONTH_COL); vMerge(DED_AMT_COL); }

        hMerge(CONTRACT_START, CONTRACT_START + 4);

        for (let i = 0; i < eotLengths; i++) {

            const c = EOT_START + i * 5;

            hMerge(c, c + 4);

        }

        hMerge(PREV_START, PREV_START + 1);

        hMerge(CUR_START, CUR_START + 1);

        hMerge(CUM_START, CUM_START + 1);

        hMerge(REM_START, REM_START + 1);



        // ---- data rows (flat — no sections for office rent) ----

        const rows = [row1, row2];



        officeRentinvoice.forEach((item, index) => {

            const rate = Number(item.boq_rate_per_month ?? item.officerent_details.rate_per_month) || 0;

            const constMM = Number(item.boq_during_construction_period ?? item.officerent_details.during_construction_period) || 0;

            const omMM = Number(item.boq_during_dlp_OM_period ?? item.officerent_details.during_dlp_OM_period) || 0;

            const numMonths = Number(item.boq_num_of_months ?? item.officerent_details.num_of_months) || 0;

            const totalAmt = rate * numMonths;



            const matchedDeductions = deductionData?.filter((d) => d.item_id === item.id) || [];

            const deductionMonthSum = matchedDeductions.reduce((s, n) => s + (Number(n.deduction_month) || 0), 0);

            const deductionAmountSum = matchedDeductions.reduce((s, n) => s + ((Number(n.deduction_amount) + Number(n.withheld_deduction_amount)) || 0), 0);



            const r = blankRow();

            r[SNO_COL] = index + 1;

            r[CONTRACT_START] = r0(rate);

            r[CONTRACT_START + 1] = r2(constMM);

            r[CONTRACT_START + 2] = r2(omMM);

            r[CONTRACT_START + 3] = r2(numMonths);

            r[CONTRACT_START + 4] = r0(totalAmt);

            if (showDeduction) {

                r[DED_MONTH_COL] = r2(deductionMonthSum);

                r[DED_AMT_COL] = r0(deductionAmountSum);

            }

            (item.eot_details || []).forEach((e, i) => {

                const c = EOT_START + i * 5;

                r[c] = r0(e.rate);

                r[c + 1] = r2(e.cp);

                r[c + 2] = r2(e.dlp);

                r[c + 3] = r2(e.t_month);

                r[c + 4] = r0(e.total_amount);

            });

            r[PREV_START] = r2(item.actual_month_total_previous);

            r[PREV_START + 1] = r0(item.previous_invoice_total);

            r[CUR_START] = r2(item.actual_month);

            r[CUR_START + 1] = r0(item.invoice_amount);

            r[CUM_START] = r2(item.actual_month_cumulative_total);

            r[CUM_START + 1] = r0(item.cumulative_invoice_total);

            r[REM_START] = r2(item.actual_month_remaining);

            r[REM_START + 1] = r0(item.remaining_amount);



            rows.push(r);

        });



        // ---- totals row ----

        const totalRow = blankRow();

        totalRow[SNO_COL] = "Total:";

        totalRow[CONTRACT_START] = r0(calculateTotal(officeRentinvoice, item => Number(item.boq_rate_per_month ?? item.officerent_details.rate_per_month)));

        totalRow[CONTRACT_START + 1] = r2(calculateTotal(officeRentinvoice, item => Number(item.boq_during_construction_period ?? item.officerent_details.during_construction_period)));

        totalRow[CONTRACT_START + 2] = r2(calculateTotal(officeRentinvoice, item => Number(item.boq_during_dlp_OM_period ?? item.officerent_details.during_dlp_OM_period)));

        totalRow[CONTRACT_START + 3] = r2(calculateTotal(officeRentinvoice, item => Number(item.boq_num_of_months ?? item.officerent_details.num_of_months)));

        totalRow[CONTRACT_START + 4] = r0(calculateContractAmount);



        if (showDeduction) {

            totalRow[DED_MONTH_COL] = r2(officeRentinvoice.reduce((gt, item) => {

                const matched = deductionData?.filter(d => d.item_id === item.id) || [];

                return gt + matched.reduce((s, d) => s + (Number(d?.deduction_month) || 0), 0);

            }, 0));

            totalRow[DED_AMT_COL] = r0(officeRentinvoice.reduce((gt, item) => {

                const matched = deductionData?.filter(d => d.item_id === item.id) || [];

                return gt + matched.reduce((s, d) => s + (Number(d?.deduction_amount) || 0) + (Number(d?.withheld_deduction_amount) || 0), 0);

            }, 0));

        }



        for (let eotIdx = 0; eotIdx < eotLengths; eotIdx++) {

            const totals = officeRentinvoice.reduce((acc, emp) => {

                const details = emp.eot_details?.length > 0 ? emp.eot_details : emp.data?.eot_details || [];

                const eot = details[eotIdx];

                if (!eot) return acc;

                acc.cp += Number(eot?.cp) || 0;

                acc.dlp += Number(eot?.dlp) || 0;

                acc.t_month += Number(eot?.t_month) || 0;

                acc.rate += Number(eot?.rate) || 0;

                acc.total_amount += Number(eot?.total_amount) || 0;

                return acc;

            }, { cp: 0, dlp: 0, t_month: 0, rate: 0, total_amount: 0 });

            const c = EOT_START + eotIdx * 5;

            totalRow[c] = r0(totals.rate);

            totalRow[c + 1] = r2(totals.cp);

            totalRow[c + 2] = r2(totals.dlp);

            totalRow[c + 3] = r2(totals.t_month);

            totalRow[c + 4] = r0(totals.total_amount);

        }



        totalRow[PREV_START] = r2(calculateTotal(officeRentinvoice, item => Number(item.actual_month_total_previous)));

        totalRow[PREV_START + 1] = r0(calculatePreviousAmount);

        totalRow[CUR_START] = r2(calculateTotal(officeRentinvoice, item => Number(item.actual_month)));

        totalRow[CUR_START + 1] = r0(calculateCurrentAmount);

        totalRow[CUM_START] = r2(calculateTotal(officeRentinvoice, item => Number(item.actual_month_cumulative_total)));

        totalRow[CUM_START + 1] = r0(calculateCumulated);

        totalRow[REM_START] = r2(calculateTotal(officeRentinvoice, item => Number(item.actual_month_remaining)));

        totalRow[REM_START + 1] = r0(calculateRemaining);

        rows.push(totalRow);



        const colWidths = new Array(TOTAL_COLS).fill({ wch: 14 });

        colWidths[SNO_COL] = { wch: 6 };



        return { rows, merges, colWidths, sheetName: "Office Rent" };

    };

    useEffect(() => {

        if (officeRentinvoice.length > 0 && typeof setExcelRows === "function") {

            setExcelRows(buildExcelSheetData());

        }

    }, [officeRentinvoice, deductionData]);


    return (

        <div className="boc-modern-wrapper" style={{ minHeight: "30vh" }}>

            <div className="boc-modern-card">



                {/* Print header */}

                <div className="boc-modern-header bocx-modern-footer-total">

                    <div className="boc-modern-header-content">

                        <div className="boc-modern-project-info">

                            <h3 className="boc-modern-project-title">{projectData?.project_name}</h3>

                            <div className="boc-modern-project-meta">

                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Client:</span><span className="boc-modern-meta-value">{projectData?.client_name}</span></div>

                                <div className="boc-modern-meta-divider"></div>

                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Consultant (AE):</span><span className="boc-modern-meta-value">{projectData?.lead}{projectData?.jv ? ` JV with ${projectData?.jv}.` : ""}{projectData?.association ? ` Association with ${projectData?.association}` : ""}</span></div>

                                <div className="boc-modern-meta-divider"></div>

                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">GSTIN:</span><span className="boc-modern-meta-value">{projectData?.gst_no}</span></div>

                                <div className="boc-modern-meta-divider"></div>

                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">PAN:</span><span className="boc-modern-meta-value">{projectData?.pan_no}</span></div>

                                <div className="boc-modern-meta-divider"></div>

                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Bid Due:</span><span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.bid_due_date)}</span></div>

                                <div className="boc-modern-meta-divider"></div>

                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Agreement:</span><span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.agreement_date)}</span></div>

                                <div className="boc-modern-meta-divider"></div>

                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Start:</span><span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.commencement_date)}</span></div>

                                <div className="boc-modern-meta-divider"></div>

                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Invoice Number:</span><span className="boc-modern-meta-value">{invoice_num}</span></div>

                                <div className="boc-modern-meta-divider"></div>

                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Date:</span><span className="boc-modern-meta-value">{getMonthName(month)}-{year}</span></div>

                            </div>

                        </div>

                    </div>

                </div>



                {/* Section heading + action */}

                <div className="boc-modern-description-section">

                    <div className="boc-modern-controls">

                        <div className="boc-modern-controls-left">

                            <h6 className="boc-modern-main-heading">5- Office Rent (Fixed Cost) — Minimum 200 sqm area of office shall be rented</h6>

                        </div>

                        <div className="hide-on-print">
                            {usefor === "generateinvoice" ? (
                                <>
                                    {officeRentinvoice.length === 0
                                        ? <OfficeRentInvoice usedfor="InvoiceandDeduction" p_id={p_id ? p_id : project} invoice_id={invoice_id} getOfficeRentinvoice={getOfficeRentinvoice} month={month} year={year} logData={logData} />
                                        : <UpdateOfficeRentInvoice usedfor="InvoiceandDeduction" invoiceData={officeRentinvoice} p_id={p_id ? p_id : project} invoice_id={invoice_id} getOfficeRentinvoice={getOfficeRentinvoice} month={month} year={year} logData={logData} />
                                    }
                                </>
                            ) : (
                                <>
                                    {officeRentinvoice.length === 0
                                        ? <OfficeRentInvoice p_id={p_id ? p_id : project} invoiceData={officeRentinvoice} usedfor="OnlyDeduction" invoice_id={invoice_id} getOfficeRentinvoice={getOfficeRentinvoice} month={month} year={year} logData={logData} />
                                        : <UpdateRentDeductionInvoice invoiceData={officeRentinvoice} getData={getOfficeRentinvoice} />
                                    }
                                </>
                            )}
                        </div>

                    </div>

                </div>



                <div className="boc-modern-table-wrapper">

                    <div className="boc-modern-table-scroll">

                        <table className="boc-modern-table">

                            <thead>

                                <tr className="boc-modern-table-header">

                                    <th className="boc-modern-th text-center" rowSpan="3">S.No</th>

                                    <th className="boc-modern-th text-center" colSpan="5">Contract Amount</th>

                                    {usefor !== "generateinvoice" && (

                                        <>

                                            <th className="boc-modern-th text-center" rowSpan="3">Deduction Month</th>

                                            <th className="boc-modern-th text-center" rowSpan="3">Deduction Amount</th>

                                        </>

                                    )}

                                    {isEotDataTrue && (

                                        <th className="boc-modern-th text-center" colSpan={eotLengths * 5 || 1}>(COS/EOT)</th>

                                    )}

                                    <th className="boc-modern-th text-center" colSpan="2">Cumulative Total of Previous Months</th>

                                    <th className="boc-modern-th text-center" colSpan="2">This Period</th>

                                    <th className="boc-modern-th text-center" colSpan="2">Cumulative Total Including Current Invoice</th>

                                    <th className="boc-modern-th text-center" colSpan="2">Remaining Amount Against Contract Value</th>

                                    {role !== "SiteManagement" && role !== "ViewAccess" && (

                                        <th className="boc-modern-th text-center hide-on-print" rowSpan="3">Action</th>

                                    )}

                                </tr>

                                <tr className="boc-modern-table-subheader">

                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Rate</th>

                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Const</th>

                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Maint</th>

                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">No. of MM</th>

                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Total Amount</th>

                                    {Array.from({ length: eotLengths }).map((_, idx) => (

                                        <th key={idx} className="boc-modern-th text-center boc-nowrap" colSpan={5}>{`EOT ${idx + 1}`}</th>

                                    ))}

                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Month</th>

                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Amount</th>

                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Month</th>

                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Amount</th>

                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Month</th>

                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Amount</th>

                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Month</th>

                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Amount</th>

                                </tr>

                                <tr className="boc-modern-table-subheader">

                                    {Array.from({ length: eotLengths }).map((_, idx) => (

                                        <React.Fragment key={idx}>

                                            <th rowSpan="2" className="boc-modern-th boc-nowrap">Rate</th>

                                            <th rowSpan="2" className="boc-modern-th boc-nowrap">Const</th>

                                            <th rowSpan="2" className="boc-modern-th boc-nowrap">Maint</th>

                                            <th rowSpan="2" className="boc-modern-th boc-nowrap">Total MM</th>

                                            <th rowSpan="2" className="boc-modern-th boc-nowrap">Total Amount</th>

                                        </React.Fragment>

                                    ))}

                                </tr>

                            </thead>



                            <tbody>

                                {officeRentinvoice.map((item, index) => {

                                    const matchedDeductions = deductionData?.filter(d => d.item_id === item.id) || [];

                                    return (

                                        <tr className="boc-modern-row" key={item.id}>

                                            <td className="boc-modern-td text-center">{index + 1}.</td>

                                            <td className="boc-modern-td boc-nowrap boc-modern-currency text-right">₹ {formatAmount0(Number(item.boq_rate_per_month ?? item.officerent_details.rate_per_month))}</td>

                                            <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(Number(item.boq_during_construction_period ?? item.officerent_details.during_construction_period))}</td>

                                            <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(Number(item.boq_during_dlp_OM_period ?? item.officerent_details.during_dlp_OM_period))}</td>

                                            <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(Number(item.boq_num_of_months ?? item.officerent_details.num_of_months))}</td>

                                            <td className="boc-modern-td boc-nowrap text-right">

                                                <span className="boc-modern-currency boc-modern-total-highlight">

                                                    ₹ {formatAmount0(Number(item.boq_rate_per_month ?? item.officerent_details.rate_per_month) * Number(item.boq_num_of_months ?? item.officerent_details.num_of_months))}

                                                </span>

                                            </td>



                                            {/* Deduction Month */}

                                            {usefor !== "generateinvoice" && (

                                                <td className="boc-modern-td boc-nowrap text-right justify-end" style={{ padding: 0 }}>

                                                    {matchedDeductions.length > 0

                                                        ? matchedDeductions.map((n, i) => <div key={i} className="boc-multi-item boc-nowrap">{n.deduction_month == null ? "-" : formatMonth2(n.deduction_month)}</div>)

                                                        : <div className="boc-multi-item">-</div>

                                                    }

                                                </td>

                                            )}

                                            {/* Deduction Amount */}

                                            {usefor !== "generateinvoice" && (

                                                <td className="boc-modern-td boc-nowrap text-right justify-end" style={{ padding: 0 }}>

                                                    {matchedDeductions.length > 0

                                                        ? matchedDeductions.map((n, i) => <div key={i} className="boc-multi-item boc-nowrap">{formatAmount0((Number(n.deduction_amount) || 0) + (Number(n.withheld_deduction_amount) || 0))}</div>)

                                                        : <div className="boc-multi-item">0</div>

                                                    }

                                                </td>

                                            )}



                                            {/* EOT */}

                                            {item?.eot_details?.length > 0 && item.eot_details.map((i, idx) => (

                                                <React.Fragment key={idx}>

                                                    <td className="boc-modern-td boc-nowrap boc-modern-currency text-right">₹ {formatAmount0(Number(i.rate))}</td>

                                                    <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(i.cp)}</td>

                                                    <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(i.dlp)}</td>

                                                    <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(i.t_month)}</td>

                                                    <td className="boc-modern-td boc-nowrap boc-modern-currency text-right">₹ {formatAmount0(Number(i.total_amount))}</td>

                                                </React.Fragment>

                                            ))}



                                            <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(Number(item.actual_month_total_previous))}</td>

                                            <td className="boc-modern-td boc-nowrap boc-modern-currency text-right">₹ {formatAmount0(Number(item.previous_invoice_total))}</td>

                                            <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(Number(item.actual_month))}</td>

                                            <td className="boc-modern-td boc-nowrap boc-modern-currency text-right">₹ {formatAmount0(Number(item.invoice_amount))}</td>

                                            <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(Number(item.actual_month_cumulative_total))}</td>

                                            <td className="boc-modern-td boc-nowrap boc-modern-currency text-right">₹ {formatAmount0(Number(item.cumulative_invoice_total))}</td>

                                            <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(Number(item.actual_month_remaining))}</td>

                                            <td className="boc-modern-td boc-nowrap text-right">

                                                <span className="boc-modern-currency boc-modern-total-highlight">₹ {formatAmount0(Number(item.remaining_amount))}</span>

                                            </td>



                                            {/* Action */}

                                            {(usefor === "generateinvoice" || role !== "ViewAccess") && (

                                                <>

                                                    {(!["Checker", "SiteManagement"].includes(role)) ||

                                                        (role === "Checker" && !isMoreThan24Hours(item.created_at)) ? (

                                                        <td className="boc-modern-td text-center hide-on-print">

                                                            {usefor === "generateinvoice"

                                                                ? <DeleteOfficeRent i={item} getOfficeRentinvoice={getOfficeRentinvoice} />

                                                                : <DeleteOfficeRentDeduction i={item} getOfficeRentinvoice={getOfficeRentinvoice} />

                                                            }

                                                        </td>

                                                    ) : (

                                                        <td className="boc-modern-td text-center hide-on-print">-</td>

                                                    )}

                                                </>

                                            )}

                                        </tr>

                                    );

                                })}

                            </tbody>



                            <tfoot>

                                <tr className="boc-modern-footer">

                                    <td className="boc-modern-footer-label">Total:</td>

                                    <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatAmount0(calculateTotal(officeRentinvoice, item => Number(item.boq_rate_per_month ?? item.officerent_details.rate_per_month)))}</span></td>

                                    <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(calculateTotal(officeRentinvoice, item => Number(item.boq_during_construction_period ?? item.officerent_details.during_construction_period)))}</td>

                                    <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(calculateTotal(officeRentinvoice, item => Number(item.boq_during_dlp_OM_period ?? item.officerent_details.during_dlp_OM_period)))}</td>

                                    <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(calculateTotal(officeRentinvoice, item => Number(item.boq_num_of_months ?? item.officerent_details.num_of_months)))}</td>

                                    <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatAmount0(calculateTotal(officeRentinvoice, item => Number(item.boq_rate_per_month ?? item.officerent_details.rate_per_month) * Number(item.boq_num_of_months ?? item.officerent_details.num_of_months)))}</span></td>

                                    {usefor !== "generateinvoice" && (

                                        <>

                                            <td className="boc-modern-td boc-nowrap text-right">

                                                {formatMonth2(officeRentinvoice.reduce((gt, item) => {

                                                    const matched = deductionData?.filter(d => d.item_id === item.id) || [];

                                                    return gt + matched.reduce((s, d) => s + (Number(d?.deduction_month) || 0), 0);

                                                }, 0))}

                                            </td>

                                            <td className="boc-modern-td boc-nowrap text-right">

                                                <span className="boc-modern-currency boc-modern-footer-total">

                                                    ₹ {formatAmount0(

                                                        officeRentinvoice.reduce((gt, item) => {

                                                            const matched = deductionData?.filter(d => d.item_id === item.id) || [];

                                                            return gt + matched.reduce((s, d) => s + (Number(d?.deduction_amount) || 0) + (Number(d?.withheld_deduction_amount) || 0), 0);

                                                        }, 0)

                                                    )}

                                                </span>

                                            </td>

                                        </>

                                    )}



                                    {isEotDataTrue && Array.from({ length: eotLengths }).map((_, eotIdx) => {

                                        const totals = officeRentinvoice.reduce((acc, emp) => {

                                            const details = emp.eot_details?.length > 0 ? emp.eot_details : emp.data?.eot_details || [];

                                            const eot = details[eotIdx];

                                            if (!eot) return acc;

                                            acc.cp += Number(eot?.cp) || 0;

                                            acc.dlp += Number(eot?.dlp) || 0;

                                            acc.t_month += Number(eot?.t_month) || 0;

                                            acc.rate += Number(eot?.rate) || 0;

                                            acc.total_amount += Number(eot?.total_amount) || 0;

                                            return acc;

                                        }, { cp: 0, dlp: 0, t_month: 0, rate: 0, total_amount: 0 });

                                        return (

                                            <React.Fragment key={eotIdx}>

                                                <td className="boc-modern-td boc-nowrap text-right">₹ {formatAmount0(totals.rate)}</td>

                                                <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(totals.cp)}</td>

                                                <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(totals.dlp)}</td>

                                                <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(totals.t_month)}</td>

                                                <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatAmount0(totals.total_amount)}</span></td>

                                            </React.Fragment>

                                        );

                                    })}



                                    <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(calculateTotal(officeRentinvoice, item => Number(item.actual_month_total_previous)))}</td>

                                    <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatAmount0(calculateTotal(officeRentinvoice, item => Number(item.previous_invoice_total)))}</span></td>

                                    <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(calculateTotal(officeRentinvoice, item => Number(item.actual_month)))}</td>

                                    <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatAmount0(calculateTotal(officeRentinvoice, item => Number(item.invoice_amount)))}</span></td>

                                    <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(calculateTotal(officeRentinvoice, item => Number(item.actual_month_cumulative_total)))}</td>

                                    <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatAmount0(calculateTotal(officeRentinvoice, item => Number(item.cumulative_invoice_total)))}</span></td>

                                    <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(calculateTotal(officeRentinvoice, item => Number(item.actual_month_remaining)))}</td>

                                    <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatAmount0(calculateTotal(officeRentinvoice, item => Number(item.remaining_amount)))}</span></td>

                                    {role !== "SiteManagement" && role !== "ViewAccess" && (

                                        <td className="hide-on-print boc-modern-td"></td>

                                    )}

                                </tr>

                            </tfoot>

                        </table>

                    </div>

                </div>

            </div>

        </div>

    );



};


// const OfficeSupplies = ({ setEotDetails, deductionData, projectData, client, p_id, invoice_id, month, year, invoice_num, logData,
//     setPreviousAmount,
//     setCurrentAmount,
//     setRemainingAmount,
//     setContractAmount,
//     setExcelRows,
//     setCumulated,
//     usefor
// }) => {

//     // let { id } = useParams();

//     const role = sessionStorage.getItem('sitemanagement_role');
//     const project = sessionStorage.getItem('sitemanagement_project');


//     const [officeSuppliesinvoice, setOfficeSuppliesinvoice] = useState([]);

//     const currentDate = new Date();
//     const isFirstWeek = currentDate.getDate() <= 7;

//     const calculateContractAmount = calculateTotal(officeSuppliesinvoice, (item) => Number(item.boq_monthly_rate ?? item.officesupplies_details.monthly_rate) * (Number(item.boq_months ?? item.officesupplies_details.months)))
//     setContractAmount(calculateContractAmount);
//     const calculatePreviousAmount = calculateTotal(officeSuppliesinvoice, (item) => Number(item.previous_invoice_total))
//     setPreviousAmount(calculatePreviousAmount);
//     const calculateCurrentAmount = calculateTotal(officeSuppliesinvoice, (item) => Number(item.invoice_amount ?? item.current_invoice_amount))
//     setCurrentAmount(calculateCurrentAmount);
//     const calculateCumulated = calculateTotal(officeSuppliesinvoice, (item) => Number(item.cumulative_invoice_total))
//     setCumulated(calculateCumulated);
//     const calculateRemaining = calculateTotal(officeSuppliesinvoice, (item) => Number(item.remaining_amount))
//     setRemainingAmount(calculateRemaining);
//     useEffect(() => {
//         const eotGroups = [];
//         officeSuppliesinvoice.forEach(item => {
//             (item?.eot_details || []).forEach((eot, idx) => {
//                 if (!eotGroups[idx]) {
//                     eotGroups[idx] = { ...eot, total_amount: 0 };
//                 }
//                 eotGroups[idx].total_amount += Number(eot.total_amount || 0);
//             });
//         });

//         setEotDetails(eotGroups);
//     }, [officeSuppliesinvoice]);

//     const getOfficeSuppliesinvoice = async () => {
//         try {
//             let data;

//             if (usefor === "generateinvoice") {
//                 const res = await axios.get(
//                     `${BASE_URL}/siteproject/invoiceofficesuppliesbyprojectstatus/${p_id ? p_id : project}/${month}/${year}/`
//                 );
//                 data = res.data;
//             } else {
//                 const response2 = await axios.get(
//                     `${BASE_URL}/siteproject/newinvoiceofficesuppliesfiltermonthyear/${invoice_id}/null/null/`
//                 );
//                 data = response2.data;
//             }

//             const isAnyBoqJsonNull = data.length !== 0 && data.every(item => item.boq_json === null);


//             const selectedData = isAnyBoqJsonNull ? data : data;
//             setOfficeSuppliesinvoice(selectedData);
//         } catch (err) { }

//     };

//     useEffect(() => {

//         // getdocument();
//         getOfficeSuppliesinvoice();
//         // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, []);
//     const isEotDataTrue = officeSuppliesinvoice.some(i =>
//         (i.eot_details?.length > 0) || (i.data?.eot_details?.length > 0)
//     );





//     const eotLengths = Math.max(
//         ...officeSuppliesinvoice.map(i => i?.eot_details?.length || i?.data?.eot_details?.length || 0),
//         0
//     );
//     const r2 = (val) => {
//         const n = Number(val);
//         return isNaN(n) ? 0 : Math.round(n * 100) / 100;
//     };

//     // ── Builds a fully formatted AOA sheet (merged headers, flat rows) ──
//     const buildExcelSheetData = () => {
//         const showDeduction = usefor !== "generateinvoice";

//         // ---- figure out column layout ----
//         let col = 0;
//         const SNO_COL = col++;                  // 0
//         const DESC_COL = col++;                 // 1
//         const CONTRACT_START = col; col += 5;   // Const, Maint, No. of MM, Rate, Total Amount
//         let DED_MONTH_COL = -1, DED_AMT_COL = -1;
//         if (showDeduction) {
//             DED_MONTH_COL = col++;
//             DED_AMT_COL = col++;
//         }
//         const EOT_START = col; col += eotLengths * 5;   // 5 cols per EOT group (cp, dlp, t_month, rate, total_amount)
//         const PREV_START = col; col += 2;   // Month, Amount
//         const CUR_START = col; col += 2;
//         const CUM_START = col; col += 2;
//         const REM_START = col; col += 2;
//         const TOTAL_COLS = col;

//         const blankRow = () => new Array(TOTAL_COLS).fill("");

//         // ---- header row 1 (group labels) ----
//         const row1 = blankRow();
//         row1[SNO_COL] = "S.No";
//         row1[DESC_COL] = "Description";
//         row1[CONTRACT_START] = "Contract Amount";
//         if (showDeduction) {
//             row1[DED_MONTH_COL] = "Deduction Month";
//             row1[DED_AMT_COL] = "Deduction Amount";
//         }
//         for (let i = 0; i < eotLengths; i++) {
//             row1[EOT_START + i * 5] = `EOT ${i + 1}`;
//         }
//         row1[PREV_START] = "Cumulative Total of Previous Months";
//         row1[CUR_START] = "This Period";
//         row1[CUM_START] = "Cumulative Total Including Current Invoice";
//         row1[REM_START] = "Remaining Amount Against Contract Value";

//         // ---- header row 2 (sub labels) ----
//         const row2 = blankRow();
//         row2[CONTRACT_START] = "Const";
//         row2[CONTRACT_START + 1] = "Maint";
//         row2[CONTRACT_START + 2] = "No. of MM";
//         row2[CONTRACT_START + 3] = "Rate";
//         row2[CONTRACT_START + 4] = "Total Amount";
//         for (let i = 0; i < eotLengths; i++) {
//             const c = EOT_START + i * 5;
//             row2[c] = "Const";
//             row2[c + 1] = "Maint";
//             row2[c + 2] = "Total MM";
//             row2[c + 3] = "Rate";
//             row2[c + 4] = "Total Amount";
//         }
//         row2[PREV_START] = "Month"; row2[PREV_START + 1] = "Amount";
//         row2[CUR_START] = "Month"; row2[CUR_START + 1] = "Amount";
//         row2[CUM_START] = "Month"; row2[CUM_START + 1] = "Amount";
//         row2[REM_START] = "Month"; row2[REM_START + 1] = "Amount";

//         // ---- merges for the two header rows ----
//         const merges = [];
//         const vMerge = (c) => merges.push({ s: { r: 0, c }, e: { r: 1, c } });
//         const hMerge = (c1, c2) => merges.push({ s: { r: 0, c: c1 }, e: { r: 0, c: c2 } });

//         vMerge(SNO_COL); vMerge(DESC_COL);
//         if (showDeduction) { vMerge(DED_MONTH_COL); vMerge(DED_AMT_COL); }
//         hMerge(CONTRACT_START, CONTRACT_START + 4);
//         for (let i = 0; i < eotLengths; i++) {
//             const c = EOT_START + i * 5;
//             hMerge(c, c + 4);
//         }
//         hMerge(PREV_START, PREV_START + 1);
//         hMerge(CUR_START, CUR_START + 1);
//         hMerge(CUM_START, CUM_START + 1);
//         hMerge(REM_START, REM_START + 1);

//         // ---- data rows (flat — no sections for office supplies) ----
//         const rows = [row1, row2];

//         officeSuppliesinvoice.forEach((item, index) => {
//             const constMM = Number(item.boq_during_construction_period ?? item.officesupplies_details.during_construction_period) || 0;
//             const omMM = Number(item.boq_during_dlp_OM_period ?? item.officesupplies_details.during_dlp_OM_period) || 0;
//             const months = Number(item.boq_months ?? item.officesupplies_details?.months) || 0;
//             const rate = Number(item.boq_monthly_rate ?? item.officesupplies_details.monthly_rate) || 0;
//             const totalAmt = rate * months;

//             const matchedDeductions = deductionData?.filter((d) => d.item_id === item.id) || [];
//             const deductionMonthSum = matchedDeductions.reduce((s, n) => s + (Number(n.deduction_month) || 0), 0);
//             const deductionAmountSum = matchedDeductions.reduce((s, n) => s + ((Number(n.deduction_amount) + Number(n.withheld_deduction_amount)) || 0), 0);

//             const r = blankRow();
//             r[SNO_COL] = index + 1;
//             r[DESC_COL] = item?.boq_item ?? item.officesupplies_details.item ?? "";
//             r[CONTRACT_START] = r2(constMM);
//             r[CONTRACT_START + 1] = r2(omMM);
//             r[CONTRACT_START + 2] = r2(months);
//             r[CONTRACT_START + 3] = r2(rate);
//             r[CONTRACT_START + 4] = r2(totalAmt);
//             if (showDeduction) {
//                 r[DED_MONTH_COL] = r2(deductionMonthSum);
//                 r[DED_AMT_COL] = r2(deductionAmountSum);
//             }
//             (item.eot_details || []).forEach((e, i) => {
//                 const c = EOT_START + i * 5;
//                 r[c] = r2(e.cp);
//                 r[c + 1] = r2(e.dlp);
//                 r[c + 2] = r2(e.t_month);
//                 r[c + 3] = r2(e.rate);
//                 r[c + 4] = r2(e.total_amount);
//             });
//             r[PREV_START] = r2(item.actual_month_total_previous);
//             r[PREV_START + 1] = r2(item.previous_invoice_total);
//             r[CUR_START] = r2(item.actual_month);
//             r[CUR_START + 1] = r2(item.invoice_amount);
//             r[CUM_START] = r2(item.actual_month_cumulative_total);
//             r[CUM_START + 1] = r2(item.cumulative_invoice_total);
//             r[REM_START] = r2(item.actual_month_remaining);
//             r[REM_START + 1] = r2(item.remaining_amount);

//             rows.push(r);
//         });

//         // ---- totals row ----
//         const totalRow = blankRow();
//         totalRow[DESC_COL] = "Total:";
//         totalRow[CONTRACT_START] = r2(calculateTotal(officeSuppliesinvoice, item => Number(item.boq_during_construction_period ?? item.officesupplies_details.during_construction_period)));
//         totalRow[CONTRACT_START + 1] = r2(calculateTotal(officeSuppliesinvoice, item => Number(item.boq_during_dlp_OM_period ?? item.officesupplies_details.during_dlp_OM_period)));
//         totalRow[CONTRACT_START + 2] = r2(calculateTotal(officeSuppliesinvoice, item => Number(item.boq_months ?? item.officesupplies_details?.months)));
//         totalRow[CONTRACT_START + 3] = r2(calculateTotal(officeSuppliesinvoice, item => Number(item.boq_monthly_rate ?? item.officesupplies_details.monthly_rate)));
//         totalRow[CONTRACT_START + 4] = r2(calculateContractAmount);

//         if (showDeduction) {
//             totalRow[DED_MONTH_COL] = r2(officeSuppliesinvoice.reduce((gt, item) => {
//                 const m = deductionData?.filter(d => d.item_id === item.id) || [];
//                 return gt + m.reduce((s, d) => s + (Number(d?.deduction_month) || 0), 0);
//             }, 0));
//             totalRow[DED_AMT_COL] = r2(officeSuppliesinvoice.reduce((gt, item) => {
//                 const m = deductionData?.filter(d => d.item_id === item.id) || [];
//                 return gt + m.reduce((s, d) => s + ((Number(d?.deduction_amount) || 0) + (Number(d?.withheld_deduction_amount) || 0)), 0);
//             }, 0));
//         }

//         for (let eotIdx = 0; eotIdx < eotLengths; eotIdx++) {
//             const totals = officeSuppliesinvoice.reduce((acc, emp) => {
//                 const details = emp.eot_details?.length > 0 ? emp.eot_details : emp.data?.eot_details || [];
//                 const eot = details[eotIdx];
//                 if (!eot) return acc;
//                 acc.cp += Number(eot?.cp) || 0;
//                 acc.dlp += Number(eot?.dlp) || 0;
//                 acc.t_month += Number(eot?.t_month) || 0;
//                 acc.rate += Number(eot?.rate) || 0;
//                 acc.total_amount += Number(eot?.total_amount) || 0;
//                 return acc;
//             }, { cp: 0, dlp: 0, t_month: 0, rate: 0, total_amount: 0 });
//             const c = EOT_START + eotIdx * 5;
//             totalRow[c] = r2(totals.cp);
//             totalRow[c + 1] = r2(totals.dlp);
//             totalRow[c + 2] = r2(totals.t_month);
//             totalRow[c + 3] = r2(totals.rate);
//             totalRow[c + 4] = r2(totals.total_amount);
//         }

//         totalRow[PREV_START] = r2(calculateTotal(officeSuppliesinvoice, item => Number(item.actual_month_total_previous)));
//         totalRow[PREV_START + 1] = r2(calculatePreviousAmount);
//         totalRow[CUR_START] = r2(calculateTotal(officeSuppliesinvoice, item => Number(item.actual_month)));
//         totalRow[CUR_START + 1] = r2(calculateCurrentAmount);
//         totalRow[CUM_START] = r2(calculateTotal(officeSuppliesinvoice, item => Number(item.actual_month_cumulative_total)));
//         totalRow[CUM_START + 1] = r2(calculateCumulated);
//         totalRow[REM_START] = r2(calculateTotal(officeSuppliesinvoice, item => Number(item.actual_month_remaining)));
//         totalRow[REM_START + 1] = r2(calculateRemaining);
//         rows.push(totalRow);

//         const colWidths = new Array(TOTAL_COLS).fill({ wch: 14 });
//         colWidths[SNO_COL] = { wch: 6 };
//         colWidths[DESC_COL] = { wch: 22 };

//         return { rows, merges, colWidths, sheetName: "Office Supplies" };
//     };
//     useEffect(() => {
//         if (officeSuppliesinvoice.length > 0 && typeof setExcelRows === "function") {
//             setExcelRows(buildExcelSheetData());
//         }
//     }, [officeSuppliesinvoice, deductionData]);


//     // return (
//     //     <div className='table-css-backgrounds'>
//     //         <div className='print-center'>

//     //             <div className="table-css-background show-on-print">
//     //                 <div className='flex-column'>
//     //                     <div>
//     //                         <h3 style={{ fontSize: "15px", textAlign: "justify" }}>{projectData?.project_name}</h3>
//     //                     </div>
//     //                     <div className='flex-row justify-between' style={{ width: "90vw" }}>

//     //                         <div className='consultant-heading'>
//     //                             <h6>Client Name:{projectData?.client_name}</h6>
//     //                             <h6>Consultant (AE):{projectData?.lead}{projectData?.jv ? ` JV with ${projectData?.jv}.` : ""}{projectData?.association ? ` Association with ${projectData?.association}` : ""}</h6>
//     //                             <h6>GSTIN No:{projectData?.gst_no}</h6>
//     //                             <h6>PAN No:{projectData?.pan_no}</h6>
//     //                             <h6>Bid Due Submission Date:{formatDateDD_MM_YYYY(projectData?.bid_due_date)}</h6>
//     //                             <div className='flex-row justify-between' style={{ width: "86vw" }}>
//     //                                 <div>
//     //                                     <h6>Agreement Date:{formatDateDD_MM_YYYY(projectData?.agreement_date)}</h6>
//     //                                     <h6>Project Start Date:{formatDateDD_MM_YYYY(projectData?.commencement_date)}</h6>
//     //                                 </div>
//     //                                 <div>
//     //                                     <h6>Date: {getMonthName(month)}-{year}</h6>
//     //                                     <h6>Invoice Number: {invoice_num}</h6>
//     //                                 </div>

//     //                             </div>
//     //                         </div>

//     //                     </div>
//     //                 </div>
//     //                 <div className='heads-div'>
//     //                     <h5>6- Office Supplies, Utilities and Communication(Fixed Cost)<br /></h5>
//     //                     {role !== "ViewAccess" &&
//     //                         <div className='hide-on-print'>
//     //                             {usefor === "generateinvoice" ?
//     //                                 <OfficeSuppliesInvoice usedfor="InvoiceandDeduction" p_id={p_id ? p_id : project} invoice_id={invoice_id} getOfficeSuppliesinvoice={getOfficeSuppliesinvoice} month={month} year={year} logData={logData} />

//     //                                 :
//     //                                 <>
//     //                                     {
//     //                                         officeSuppliesinvoice.length === 0 ?

//     //                                             <OfficeSuppliesInvoice usedfor="OnlyDeduction" invoiceData={officeSuppliesinvoice} p_id={p_id ? p_id : project} invoice_id={invoice_id} getOfficeSuppliesinvoice={getOfficeSuppliesinvoice} month={month} year={year} logData={logData} />
//     //                                             :
//     //                                             <UpdateSuppliesDeductionInvoice invoiceData={officeSuppliesinvoice} getData={getOfficeSuppliesinvoice} />
//     //                                     }
//     //                                 </>


//     //                             }
//     //                         </div>
//     //                     }


//     //                 </div>
//     //                 <div className='table-box scroll-container-table'>
//     //                     <table className="nested-table-lightblue" >
//     //                         <thead>
//     //                             <tr className='theading'>
//     //                                 <th rowSpan="4">S.No</th>
//     //                                 <th rowSpan="4">Description</th>
//     //                                 <th colSpan="5" className='table-heading-text text-center'>Contract Amount</th>
//     //                                 {usefor !== "generateinvoice" && (
//     //                                     <>
//     //                                         <th className='table-heading-text text-center' rowSpan="4">Deduction Month</th>
//     //                                         <th className='table-heading-text text-center' rowSpan="4">Deduction Amount</th>

//     //                                     </>
//     //                                 )}
//     //                                 {isEotDataTrue &&

//     //                                     <th
//     //                                         className="table-heading-text text-center"
//     //                                         colSpan={eotLengths * 5 || 1}
//     //                                     >
//     //                                         ( COS/EOT)
//     //                                     </th>
//     //                                 }
//     //                                 <th colSpan="2" className='table-heading-text text-center'> Cumulative Total of Previous Months</th>
//     //                                 <th colSpan="2" className='table-heading-text text-center'>This Period</th>
//     //                                 <th colSpan="2" className='table-heading-text text-center'>Cumulative total Including Current Invoice</th>
//     //                                 <th colSpan="2" className='table-heading-text text-center'>Remaining amount against contract value</th>
//     //                                 {role !== "SiteManagement" && role !== "ViewAccess" &&

//     //                                     <th rowSpan="4" className='table-heading-text text-center hide-on-print'>Action</th>
//     //                                 }
//     //                             </tr>
//     //                             <tr className='nested-heading'>
//     //                                 <th rowSpan="2" className='table-heading-text'>Const</th>
//     //                                 <th rowSpan="2" className='table-heading-text'>Maint</th>
//     //                                 <th rowSpan="2" className='table-heading-text'>nO. OF MM</th>
//     //                                 <th rowSpan="2" className='table-heading-text'>Rate</th>
//     //                                 <th rowSpan="2" className='table-heading-text'>Total Amount</th>
//     //                                 {Array.from({ length: eotLengths }).map((_, idx) => (
//     //                                     <th key={idx} className="table-heading-text text-center" colSpan={5}>
//     //                                         {`Revised Contract Amount as per EOT ${idx + 1}`}
//     //                                     </th>
//     //                                 ))}
//     //                                 <th rowSpan="2" className='table-heading-text'>Month</th>
//     //                                 <th rowSpan="2" className='table-heading-text'>Amount</th>
//     //                                 <th rowSpan="2" className='table-heading-text'>Month</th>
//     //                                 <th rowSpan="2" className='table-heading-text'>Amount</th>
//     //                                 <th rowSpan="2" className='table-heading-text'>Month</th>
//     //                                 <th rowSpan="2" className='table-heading-text'>Amount</th>
//     //                                 <th rowSpan="2" className='table-heading-text'>Month</th>
//     //                                 <th rowSpan="2" className='table-heading-text'>Amount</th>



//     //                             </tr>
//     //                             <tr className='nested-heading'>
//     //                                 {Array.from({ length: eotLengths }).map((_, idx) => (
//     //                                     <React.Fragment key={idx}>
//     //                                         <th rowSpan="2" className='table-heading-text'>Const</th>
//     //                                         <th rowSpan="2" className='table-heading-text'>Maint</th>
//     //                                         <th rowSpan="2" className='table-heading-text'>Total MM</th>
//     //                                         <th rowSpan="2" className='table-heading-text'>Rate</th>

//     //                                         <th rowSpan="2" className='table-heading-text'>Total Amount</th>
//     //                                     </React.Fragment>
//     //                                 ))}

//     //                             </tr>
//     //                         </thead>
//     //                         <tbody>
//     //                             {officeSuppliesinvoice.map((item, index) => {
//     //                                 const matchedDeductions = deductionData?.filter(
//     //                                     (d) => d.item_id === item.id
//     //                                 ) || [];

//     //                                 return (

//     //                                     <tr className='tbody' key={item.id}>
//     //                                         <td className='table-body'> {index + 1}.</td>
//     //                                         <td className='table-body'><div className="whitespace-normal">{item?.boq_item ?? item.officesupplies_details.item}</div></td>
//     //                                         <td className='table-body text-end'>{formatCurrencyIndian(Number(item.boq_during_construction_period ?? item.officesupplies_details.during_construction_period))}</td>
//     //                                         <td className='table-body text-end'>{formatCurrencyIndian(Number(item.boq_during_dlp_OM_period ?? item.officesupplies_details.during_dlp_OM_period))}</td>
//     //                                         <td className='table-body text-end'>{formatCurrencyIndian(Number(item.boq_months ?? item.officesupplies_details?.months))}</td>
//     //                                         <td className='table-body text-end'>₹{formatCurrencyIndian(Number(item.boq_monthly_rate ?? item.officesupplies_details.monthly_rate))}</td>
//     //                                         <td className='table-body text-end'>₹{formatCurrencyIndian(Number(item.boq_monthly_rate ?? item.officesupplies_details.monthly_rate) * Number(item.boq_months ?? item.officesupplies_details.months))}</td>
//     //                                         {usefor !== "generateinvoice" && (
//     //                                             <td className='table-body text-end'>
//     //                                                 {matchedDeductions.length > 0 ?
//     //                                                     matchedDeductions.map((n, i) => (
//     //                                                         <td key={i} className='flex-column' style={{ marginBottom: "4px" }}>
//     //                                                             {n.deduction_month ?? "-"}
//     //                                                         </td>
//     //                                                     ))
//     //                                                     : <td className='flex-column' style={{ marginBottom: "4px" }}>-</td>
//     //                                                 }
//     //                                             </td>
//     //                                         )}

//     //                                         {usefor !== "generateinvoice" && (
//     //                                             <td className='table-body text-end'>
//     //                                                 {matchedDeductions?.length > 0 ?
//     //                                                     <>
//     //                                                         {matchedDeductions.map((n, i) => (
//     //                                                             <td key={i} className='flex-column' style={{ marginBottom: "4px" }}>
//     //                                                                 {Number(n.deduction_amount) + Number(n.withheld_deduction_amount) || 0}
//     //                                                             </td>
//     //                                                         ))}
//     //                                                     </>
//     //                                                     : <td className='flex-column' style={{ marginBottom: "4px" }}>0</td>
//     //                                                 }
//     //                                             </td>
//     //                                         )}
//     //                                         {item?.eot_details?.length > 0 ?
//     //                                             <>
//     //                                                 {item.eot_details.map((i) => (
//     //                                                     <>

//     //                                                         <td className="align-right">{i.cp} </td>
//     //                                                         <td className="align-right">{i.dlp} </td>
//     //                                                         <td className="align-right">{i.t_month} </td>
//     //                                                         <td className="align-right">{i.rate} </td>
//     //                                                         <td className="align-right">{i.total_amount} </td>

//     //                                                     </>
//     //                                                 ))}
//     //                                             </> :
//     //                                             <></>
//     //                                         }
//     //                                         <td className='table-body text-end'>{formatCurrencyIndian(Number(item.actual_month_total_previous))}</td>

//     //                                         <td className='table-body text-end'>₹{formatCurrencyIndian(Number(item.previous_invoice_total))}</td>
//     //                                         <td className='table-body text-end'>{formatCurrencyIndian(Number(item.actual_month))}</td>
//     //                                         <td className='table-body text-end'>₹{formatCurrencyIndian(Number(item.invoice_amount))}</td>
//     //                                         <td className='table-body text-end'>{formatCurrencyIndian(Number(item.actual_month_cumulative_total))}</td>
//     //                                         <td className='table-body text-end'>₹{formatCurrencyIndian(Number(item.cumulative_invoice_total))}</td>
//     //                                         <td className='table-body text-end'>{formatCurrencyIndian(Number(item.actual_month_remaining))}</td>
//     //                                         <td className='table-body text-end'>₹{formatCurrencyIndian(Number(item.remaining_amount))}</td>
//     //                                         {(usefor === "generateinvoice" || role !== "ViewAccess") &&
//     //                                             <>
//     //                                                 {(!["Checker", "SiteManagement"].includes(role) && true) ||
//     //                                                     (role === "Checker" && !isMoreThan24Hours(item.created_at)) ?
//     //                                                     <td className='table-body text-end hide-on-print'>
//     //                                                         {usefor === "generateinvoice" ?

//     //                                                             <DeleteOfficeSuppliesInvoice i={item} getOfficeSuppliesinvoice={getOfficeSuppliesinvoice} />
//     //                                                             : <DeleteOfficeSuppliesInvoiceDeduction i={item} getOfficeSuppliesinvoice={getOfficeSuppliesinvoice} />
//     //                                                         }
//     //                                                     </td>
//     //                                                     :
//     //                                                     <td className=" text-center hide-on-print">
//     //                                                         -
//     //                                                     </td>
//     //                                                 }
//     //                                             </>
//     //                                         }

//     //                                     </tr>
//     //                                 )
//     //                             })}
//     //                         </tbody>
//     //                         <tfoot>
//     //                             <tr className='tbody'>
//     //                                 <td></td>
//     //                                 <td className="total-label table-body">Total:</td>
//     //                                 <td className='table-body text-end'>{formatCurrencyIndian(calculateTotal(officeSuppliesinvoice, (item) => Number(item.boq_during_construction_period ?? item.officesupplies_details.during_construction_period)))}</td>
//     //                                 <td className='table-body text-end'>{formatCurrencyIndian(calculateTotal(officeSuppliesinvoice, (item) => Number(item.boq_during_dlp_OM_period ?? item.officesupplies_details.during_dlp_OM_period)))}</td>
//     //                                 <td className='table-body text-end'>{formatCurrencyIndian(calculateTotal(officeSuppliesinvoice, (item) => Number(item.boq_months ?? item.officesupplies_details?.months)))}</td>
//     //                                 <td className='table-body text-end'>₹{formatCurrencyIndian(calculateTotal(officeSuppliesinvoice, (item) => Number(item.boq_monthly_rate ?? item.officesupplies_details.monthly_rate)))}</td>
//     //                                 <td className='table-body text-end'>₹{formatCurrencyIndian(calculateTotal(officeSuppliesinvoice, (item) => Number(item.boq_monthly_rate ?? item.officesupplies_details.monthly_rate) * Number(item.boq_months ?? item.officesupplies_details.months)))}</td>
//     //                                 {usefor !== "generateinvoice" && (
//     //                                     <>
//     //                                         <td className="align-right">
//     //                                             {/* ✅ Use deductionData instead of item.deduction_amount */}
//     //                                             {(
//     //                                                 officeSuppliesinvoice.reduce((grandTotal, item) => {
//     //                                                     const matchedDeductions = deductionData?.filter(
//     //                                                         (d) => d.item_id === item.id
//     //                                                     ) || [];
//     //                                                     const rowTotal = matchedDeductions.reduce(
//     //                                                         (sum, d) => sum + (Number(d?.deduction_month) || 0), 0
//     //                                                     );
//     //                                                     return grandTotal + rowTotal;
//     //                                                 }, 0)
//     //                                             )}
//     //                                         </td>
//     //                                         <td className="align-right">
//     //                                             {/* ✅ Use deductionData instead of item.deduction_amount */}
//     //                                             ₹{formatCurrencyIndian(
//     //                                                 officeSuppliesinvoice.reduce((grandTotal, item) => {
//     //                                                     const matchedDeductions = deductionData?.filter(
//     //                                                         (d) => d.item_id === item.id
//     //                                                     ) || [];
//     //                                                     const rowTotal = matchedDeductions.reduce(
//     //                                                         (sum, d) => sum + (Number(d?.deduction_amount) || 0), 0
//     //                                                     );
//     //                                                     return grandTotal + rowTotal;
//     //                                                 }, 0)
//     //                                             )}
//     //                                         </td>
//     //                                     </>
//     //                                 )}
//     //                                 {isEotDataTrue && (
//     //                                     <>
//     //                                         {Array.from({ length: eotLengths }).map((_, eotIdx) => {
//     //                                             const totals = officeSuppliesinvoice.reduce(
//     //                                                 (acc, emp) => {
//     //                                                     const details =
//     //                                                         emp.eot_details?.length > 0
//     //                                                             ? emp.eot_details
//     //                                                             : emp.data?.eot_details || [];
//     //                                                     const eot = details[eotIdx];

//     //                                                     if (!eot) return acc;

//     //                                                     acc.cp += Number(eot?.cp) || 0;
//     //                                                     acc.dlp += Number(eot?.dlp) || 0;
//     //                                                     acc.t_month += Number(eot?.t_month) || 0;
//     //                                                     acc.rate += Number(eot?.rate) || 0;
//     //                                                     acc.total_amount += Number(eot?.total_amount) || 0;

//     //                                                     return acc;
//     //                                                 },
//     //                                                 { cp: 0, dlp: 0, t_month: 0, rate: 0, total_amount: 0 }
//     //                                             );

//     //                                             const grandTotal =
//     //                                                 totals.cp + totals.dlp + totals.t_month * totals.rate;

//     //                                             return (
//     //                                                 <React.Fragment key={eotIdx}>
//     //                                                     <td className="align-right">{formatCurrencyIndian(totals.cp)}</td>
//     //                                                     <td className="align-right">{formatCurrencyIndian(totals.dlp)}</td>
//     //                                                     <td className="align-right">{totals.t_month}</td>
//     //                                                     <td className="align-right">₹{formatCurrencyIndian(totals.rate)}</td>
//     //                                                     <td className="align-right">₹{formatCurrencyIndian(totals.total_amount)}</td>

//     //                                                 </React.Fragment>
//     //                                             );
//     //                                         })}
//     //                                     </>
//     //                                 )}
//     //                                 <td className='table-body text-end'>{formatCurrencyIndian(calculateTotal(officeSuppliesinvoice, (item) => Number(item.actual_month_total_previous)))}</td>
//     //                                 <td className='table-body text-end'>₹{formatCurrencyIndian(calculateTotal(officeSuppliesinvoice, (item) => Number(item.previous_invoice_total)))}</td>
//     //                                 <td className='table-body text-end'>{formatCurrencyIndian(calculateTotal(officeSuppliesinvoice, (item) => Number(item.actual_month)))}</td>
//     //                                 <td className='table-body text-end'>₹{formatCurrencyIndian(calculateTotal(officeSuppliesinvoice, (item) => Number(item.invoice_amount ?? item.current_invoice_amount)))}</td>
//     //                                 <td className='table-body text-end'>{formatCurrencyIndian(calculateTotal(officeSuppliesinvoice, (item) => Number(item.actual_month_cumulative_total)))}</td>
//     //                                 <td className='table-body text-end'>₹{formatCurrencyIndian(calculateTotal(officeSuppliesinvoice, (item) => Number(item.cumulative_invoice_total)))}</td>
//     //                                 <td className='table-body text-end'>{formatCurrencyIndian(calculateTotal(officeSuppliesinvoice, (item) => Number(item.actual_month_remaining)))}</td>
//     //                                 <td className='table-body text-end'>₹{formatCurrencyIndian(calculateTotal(officeSuppliesinvoice, (item) => Number(item.remaining_amount)))}</td>
//     //                                 {role !== "SiteManagement" && role !== "ViewAccess" &&

//     //                                     <td className="hide-on-print"></td>
//     //                                 }
//     //                             </tr>
//     //                         </tfoot>
//     //                     </table>
//     //                 </div>
//     //             </div>
//     //         </div >

//     //     </div >
//     // );

//     return (
//         <div className="boc-modern-wrapper" style={{ minHeight: "30vh" }}>
//             <div className="boc-modern-card">

//                 {/* Print header */}
//                 <div className="boc-modern-header bocx-modern-footer-total">
//                     <div className="boc-modern-header-content">
//                         <div className="boc-modern-project-info">
//                             <h3 className="boc-modern-project-title">{projectData?.project_name}</h3>
//                             <div className="boc-modern-project-meta">
//                                 <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Client:</span><span className="boc-modern-meta-value">{projectData?.client_name}</span></div>
//                                 <div className="boc-modern-meta-divider"></div>
//                                 <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Consultant (AE):</span><span className="boc-modern-meta-value">{projectData?.lead}{projectData?.jv ? ` JV with ${projectData?.jv}.` : ""}{projectData?.association ? ` Association with ${projectData?.association}` : ""}</span></div>
//                                 <div className="boc-modern-meta-divider"></div>
//                                 <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">GSTIN:</span><span className="boc-modern-meta-value">{projectData?.gst_no}</span></div>
//                                 <div className="boc-modern-meta-divider"></div>
//                                 <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">PAN:</span><span className="boc-modern-meta-value">{projectData?.pan_no}</span></div>
//                                 <div className="boc-modern-meta-divider"></div>
//                                 <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Bid Due:</span><span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.bid_due_date)}</span></div>
//                                 <div className="boc-modern-meta-divider"></div>
//                                 <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Agreement:</span><span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.agreement_date)}</span></div>
//                                 <div className="boc-modern-meta-divider"></div>
//                                 <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Start:</span><span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.commencement_date)}</span></div>
//                                 <div className="boc-modern-meta-divider"></div>
//                                 <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Invoice Number:</span><span className="boc-modern-meta-value">{invoice_num}</span></div>
//                                 <div className="boc-modern-meta-divider"></div>
//                                 <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Date:</span><span className="boc-modern-meta-value">{getMonthName(month)}-{year}</span></div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>

//                 {/* Section heading + action */}
//                 <div className="boc-modern-description-section">
//                     <div className="boc-modern-controls">
//                         <div className="boc-modern-controls-left">
//                             <h6 className="boc-modern-main-heading">6- Office Supplies, Utilities and Communication (Fixed Cost)</h6>
//                         </div>
//                         {role !== "ViewAccess" && (
//                             <div className="hide-on-print">
//                                 {usefor === "generateinvoice"
//                                     ? <OfficeSuppliesInvoice usedfor="InvoiceandDeduction" p_id={p_id ? p_id : project} invoice_id={invoice_id} getOfficeSuppliesinvoice={getOfficeSuppliesinvoice} month={month} year={year} logData={logData} />
//                                     : <>
//                                         {officeSuppliesinvoice.length === 0
//                                             ? <OfficeSuppliesInvoice usedfor="OnlyDeduction" invoiceData={officeSuppliesinvoice} p_id={p_id ? p_id : project} invoice_id={invoice_id} getOfficeSuppliesinvoice={getOfficeSuppliesinvoice} month={month} year={year} logData={logData} />
//                                             : <UpdateSuppliesDeductionInvoice invoiceData={officeSuppliesinvoice} getData={getOfficeSuppliesinvoice} />
//                                         }
//                                     </>
//                                 }
//                             </div>
//                         )}
//                     </div>
//                 </div>

//                 <div className="boc-modern-table-wrapper">
//                     <div className="boc-modern-table-scroll">
//                         <table className="boc-modern-table">
//                             <thead>
//                                 <tr className="boc-modern-table-header">
//                                     <th className="boc-modern-th text-center" rowSpan="4">S.No</th>
//                                     <th className="boc-modern-th text-center" rowSpan="4">Description</th>
//                                     <th className="boc-modern-th text-center" colSpan="5">Contract Amount</th>
//                                     {usefor !== "generateinvoice" && (
//                                         <>
//                                             <th className="boc-modern-th text-center" rowSpan="4">Deduction Month</th>
//                                             <th className="boc-modern-th text-center" rowSpan="4">Deduction Amount</th>
//                                         </>
//                                     )}
//                                     {isEotDataTrue && <th className="boc-modern-th text-center" colSpan={eotLengths * 5 || 1}>(COS/EOT)</th>}
//                                     <th className="boc-modern-th text-center" colSpan="2">Cumulative Total of Previous Months</th>
//                                     <th className="boc-modern-th text-center" colSpan="2">This Period</th>
//                                     <th className="boc-modern-th text-center" colSpan="2">Cumulative Total Including Current Invoice</th>
//                                     <th className="boc-modern-th text-center" colSpan="2">Remaining Amount Against Contract Value</th>
//                                     {role !== "SiteManagement" && role !== "ViewAccess" && <th className="boc-modern-th text-center hide-on-print" rowSpan="4">Action</th>}
//                                 </tr>
//                                 <tr className="boc-modern-table-subheader">
//                                     <th rowSpan="2" className="boc-modern-th boc-nowrap">Const</th>
//                                     <th rowSpan="2" className="boc-modern-th boc-nowrap">Maint</th>
//                                     <th rowSpan="2" className="boc-modern-th boc-nowrap">No. of MM</th>
//                                     <th rowSpan="2" className="boc-modern-th boc-nowrap">Rate</th>
//                                     <th rowSpan="2" className="boc-modern-th boc-nowrap">Total Amount</th>
//                                     {Array.from({ length: eotLengths }).map((_, idx) => (
//                                         <th key={idx} className="boc-modern-th text-center boc-nowrap" colSpan={5}>{`EOT ${idx + 1}`}</th>
//                                     ))}
//                                     <th rowSpan="2" className="boc-modern-th boc-nowrap">Month</th>
//                                     <th rowSpan="2" className="boc-modern-th boc-nowrap">Amount</th>
//                                     <th rowSpan="2" className="boc-modern-th boc-nowrap">Month</th>
//                                     <th rowSpan="2" className="boc-modern-th boc-nowrap">Amount</th>
//                                     <th rowSpan="2" className="boc-modern-th boc-nowrap">Month</th>
//                                     <th rowSpan="2" className="boc-modern-th boc-nowrap">Amount</th>
//                                     <th rowSpan="2" className="boc-modern-th boc-nowrap">Month</th>
//                                     <th rowSpan="2" className="boc-modern-th boc-nowrap">Amount</th>
//                                 </tr>
//                                 <tr className="boc-modern-table-subheader">
//                                     {Array.from({ length: eotLengths }).map((_, idx) => (
//                                         <React.Fragment key={idx}>
//                                             <th rowSpan="2" className="boc-modern-th boc-nowrap">Const</th>
//                                             <th rowSpan="2" className="boc-modern-th boc-nowrap">Maint</th>
//                                             <th rowSpan="2" className="boc-modern-th boc-nowrap">Total MM</th>
//                                             <th rowSpan="2" className="boc-modern-th boc-nowrap">Rate</th>
//                                             <th rowSpan="2" className="boc-modern-th boc-nowrap">Total Amount</th>
//                                         </React.Fragment>
//                                     ))}
//                                 </tr>
//                             </thead>

//                             <tbody>
//                                 {officeSuppliesinvoice.map((item, index) => {
//                                     const matchedDeductions = deductionData?.filter(d => d.item_id === item.id) || [];
//                                     return (
//                                         <tr className="boc-modern-row" key={item.id}>
//                                             <td className="boc-modern-td text-center">{index + 1}.</td>
//                                             <td className="boc-modern-td"><div style={{ whiteSpace: "normal", width: "120px" }}>{item?.boq_item ?? item.officesupplies_details.item}</div></td>
//                                             <td className="boc-modern-td boc-nowrap text-right">{formatCurrencyIndian(Number(item.boq_during_construction_period ?? item.officesupplies_details.during_construction_period))}</td>
//                                             <td className="boc-modern-td boc-nowrap text-right">{formatCurrencyIndian(Number(item.boq_during_dlp_OM_period ?? item.officesupplies_details.during_dlp_OM_period))}</td>
//                                             <td className="boc-modern-td boc-nowrap text-right">{formatCurrencyIndian(Number(item.boq_months ?? item.officesupplies_details?.months))}</td>
//                                             <td className="boc-modern-td boc-nowrap boc-modern-currency text-right">₹ {formatCurrencyIndian(Number(item.boq_monthly_rate ?? item.officesupplies_details.monthly_rate))}</td>
//                                             <td className="boc-modern-td boc-nowrap text-right">
//                                                 <span className="boc-modern-currency boc-modern-total-highlight">
//                                                     ₹ {formatCurrencyIndian(Number(item.boq_monthly_rate ?? item.officesupplies_details.monthly_rate) * Number(item.boq_months ?? item.officesupplies_details.months))}
//                                                 </span>
//                                             </td>

//                                             {usefor !== "generateinvoice" && (
//                                                 <td className="boc-modern-td boc-nowrap text-right justify-end" style={{ padding: 0 }}>
//                                                     {matchedDeductions.length > 0
//                                                         ? matchedDeductions.map((n, i) => <div key={i} className="boc-multi-item boc-nowrap">{n.deduction_month ?? "-"}</div>)
//                                                         : <div className="boc-multi-item">-</div>}
//                                                 </td>
//                                             )}
//                                             {usefor !== "generateinvoice" && (
//                                                 <td className="boc-modern-td boc-nowrap text-right justify-end" style={{ padding: 0 }}>
//                                                     {matchedDeductions.length > 0
//                                                         ? matchedDeductions.map((n, i) => <div key={i} className="boc-multi-item boc-nowrap">{Number(n.deduction_amount) + Number(n.withheld_deduction_amount) || 0}</div>)
//                                                         : <div className="boc-multi-item">0</div>}
//                                                 </td>
//                                             )}

//                                             {item?.eot_details?.length > 0 && item.eot_details.map((i, idx) => (
//                                                 <React.Fragment key={idx}>
//                                                     <td className="boc-modern-td boc-nowrap text-right">{i.cp}</td>
//                                                     <td className="boc-modern-td boc-nowrap text-right">{i.dlp}</td>
//                                                     <td className="boc-modern-td boc-nowrap text-right">{i.t_month}</td>
//                                                     <td className="boc-modern-td boc-nowrap boc-modern-currency text-right">₹ {formatCurrencyIndian(Number(i.rate))}</td>
//                                                     <td className="boc-modern-td boc-nowrap boc-modern-currency text-right">₹ {formatCurrencyIndian(Number(i.total_amount))}</td>
//                                                 </React.Fragment>
//                                             ))}

//                                             <td className="boc-modern-td boc-nowrap text-right">{formatCurrencyIndian(Number(item.actual_month_total_previous))}</td>
//                                             <td className="boc-modern-td boc-nowrap boc-modern-currency text-right">₹ {formatCurrencyIndian(Number(item.previous_invoice_total))}</td>
//                                             <td className="boc-modern-td boc-nowrap text-right">{formatCurrencyIndian(Number(item.actual_month))}</td>
//                                             <td className="boc-modern-td boc-nowrap boc-modern-currency text-right">₹ {formatCurrencyIndian(Number(item.invoice_amount))}</td>
//                                             <td className="boc-modern-td boc-nowrap text-right">{formatCurrencyIndian(Number(item.actual_month_cumulative_total))}</td>
//                                             <td className="boc-modern-td boc-nowrap boc-modern-currency text-right">₹ {formatCurrencyIndian(Number(item.cumulative_invoice_total))}</td>
//                                             <td className="boc-modern-td boc-nowrap text-right">{formatCurrencyIndian(Number(item.actual_month_remaining))}</td>
//                                             <td className="boc-modern-td boc-nowrap text-right">
//                                                 <span className="boc-modern-currency boc-modern-total-highlight">₹ {formatCurrencyIndian(Number(item.remaining_amount))}</span>
//                                             </td>

//                                             {(usefor === "generateinvoice" || role !== "ViewAccess") && (
//                                                 <>
//                                                     {(!["Checker", "SiteManagement"].includes(role)) || (role === "Checker" && !isMoreThan24Hours(item.created_at)) ? (
//                                                         <td className="boc-modern-td text-center hide-on-print">
//                                                             {usefor === "generateinvoice"
//                                                                 ? <DeleteOfficeSuppliesInvoice i={item} getOfficeSuppliesinvoice={getOfficeSuppliesinvoice} />
//                                                                 : <DeleteOfficeSuppliesInvoiceDeduction i={item} getOfficeSuppliesinvoice={getOfficeSuppliesinvoice} />}
//                                                         </td>
//                                                     ) : <td className="boc-modern-td text-center hide-on-print">-</td>}
//                                                 </>
//                                             )}
//                                         </tr>
//                                     );
//                                 })}
//                             </tbody>

//                             <tfoot>
//                                 <tr className="boc-modern-footer">
//                                     <td colSpan="2" className="boc-modern-footer-label">Total:</td>
//                                     <td className="boc-modern-td boc-nowrap text-right">{formatCurrencyIndian(calculateTotal(officeSuppliesinvoice, item => Number(item.boq_during_construction_period ?? item.officesupplies_details.during_construction_period)))}</td>
//                                     <td className="boc-modern-td boc-nowrap text-right">{formatCurrencyIndian(calculateTotal(officeSuppliesinvoice, item => Number(item.boq_during_dlp_OM_period ?? item.officesupplies_details.during_dlp_OM_period)))}</td>
//                                     <td className="boc-modern-td boc-nowrap text-right">{formatCurrencyIndian(calculateTotal(officeSuppliesinvoice, item => Number(item.boq_months ?? item.officesupplies_details?.months)))}</td>
//                                     <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatCurrencyIndian(calculateTotal(officeSuppliesinvoice, item => Number(item.boq_monthly_rate ?? item.officesupplies_details.monthly_rate)))}</span></td>
//                                     <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatCurrencyIndian(calculateTotal(officeSuppliesinvoice, item => Number(item.boq_monthly_rate ?? item.officesupplies_details.monthly_rate) * Number(item.boq_months ?? item.officesupplies_details.months)))}</span></td>

//                                     {usefor !== "generateinvoice" && (
//                                         <>
//                                             <td className="boc-modern-td boc-nowrap text-right">
//                                                 {officeSuppliesinvoice.reduce((gt, item) => {
//                                                     const m = deductionData?.filter(d => d.item_id === item.id) || [];
//                                                     return gt + m.reduce((s, d) => s + (Number(d?.deduction_month) || 0), 0);
//                                                 }, 0).toFixed(2)}
//                                             </td>
//                                             <td className="boc-modern-td boc-nowrap text-right">
//                                                 <span className="boc-modern-currency boc-modern-footer-total">
//                                                     ₹ {formatCurrencyIndian(
//                                                         Number(
//                                                             officeSuppliesinvoice.reduce((gt, item) => {
//                                                                 const m = deductionData?.filter(d => d.item_id === item.id) || [];
//                                                                 return gt + m.reduce((s, d) => s + ((Number(d?.deduction_amount) || 0) + (Number(d?.withheld_deduction_amount) || 0)), 0);
//                                                             }, 0).toFixed(2)
//                                                         )
//                                                     )}
//                                                 </span>
//                                             </td>
//                                         </>
//                                     )}
//                                     {isEotDataTrue && Array.from({ length: eotLengths }).map((_, eotIdx) => {
//                                         const totals = officeSuppliesinvoice.reduce((acc, emp) => {
//                                             const details = emp.eot_details?.length > 0 ? emp.eot_details : emp.data?.eot_details || [];
//                                             const eot = details[eotIdx];
//                                             if (!eot) return acc;
//                                             acc.cp += Number(eot?.cp) || 0; acc.dlp += Number(eot?.dlp) || 0;
//                                             acc.t_month += Number(eot?.t_month) || 0; acc.rate += Number(eot?.rate) || 0;
//                                             acc.total_amount += Number(eot?.total_amount) || 0;
//                                             return acc;
//                                         }, { cp: 0, dlp: 0, t_month: 0, rate: 0, total_amount: 0 });
//                                         return (
//                                             <React.Fragment key={eotIdx}>
//                                                 <td className="boc-modern-td boc-nowrap text-right">{formatCurrencyIndian(totals.cp)}</td>
//                                                 <td className="boc-modern-td boc-nowrap text-right">{formatCurrencyIndian(totals.dlp)}</td>
//                                                 <td className="boc-modern-td boc-nowrap text-right">{totals.t_month}</td>
//                                                 <td className="boc-modern-td boc-nowrap text-right">₹ {formatCurrencyIndian(totals.rate)}</td>
//                                                 <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatCurrencyIndian(totals.total_amount)}</span></td>
//                                             </React.Fragment>
//                                         );
//                                     })}

//                                     <td className="boc-modern-td boc-nowrap text-right">{formatCurrencyIndian(Number(calculateTotal(officeSuppliesinvoice, item => Number(item.actual_month_total_previous)).toFixed(2)))}</td>
//                                     <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatCurrencyIndian(Number(calculateTotal(officeSuppliesinvoice, item => Number(item.previous_invoice_total)).toFixed(2)))}</span></td>
//                                     <td className="boc-modern-td boc-nowrap text-right">{formatCurrencyIndian(Number(calculateTotal(officeSuppliesinvoice, item => Number(item.actual_month)).toFixed(2)))}</td>
//                                     <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatCurrencyIndian(Number(calculateTotal(officeSuppliesinvoice, item => Number(item.invoice_amount ?? item.current_invoice_amount)).toFixed(2)))}</span></td>
//                                     <td className="boc-modern-td boc-nowrap text-right">{formatCurrencyIndian(Number(calculateTotal(officeSuppliesinvoice, item => Number(item.actual_month_cumulative_total)).toFixed(2)))}</td>
//                                     <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatCurrencyIndian(Number(calculateTotal(officeSuppliesinvoice, item => Number(item.cumulative_invoice_total)).toFixed(2)))}</span></td>
//                                     <td className="boc-modern-td boc-nowrap text-right">{formatCurrencyIndian(Number(calculateTotal(officeSuppliesinvoice, item => Number(item.actual_month_remaining)).toFixed(2)))}</td>
//                                     <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatCurrencyIndian(Number(calculateTotal(officeSuppliesinvoice, item => Number(item.remaining_amount)).toFixed(2)))}</span></td>
//                                     {role !== "SiteManagement" && role !== "ViewAccess" && <td className="hide-on-print boc-modern-td"></td>}
//                                 </tr>
//                             </tfoot>
//                         </table>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };


const OfficeSupplies = ({ setEotDetails, deductionData, projectData, client, p_id, invoice_id, month, year, invoice_num, logData,

    setPreviousAmount,

    setCurrentAmount,

    setRemainingAmount,

    setContractAmount,

    setExcelRows,

    setCumulated,

    usefor

}) => {



    // let { id } = useParams();



    const role = sessionStorage.getItem('sitemanagement_role');

    const project = sessionStorage.getItem('sitemanagement_project');





    const [officeSuppliesinvoice, setOfficeSuppliesinvoice] = useState([]);



    const currentDate = new Date();

    const isFirstWeek = currentDate.getDate() <= 7;



    const calculateContractAmount = calculateTotal(officeSuppliesinvoice, (item) => Number(item.boq_monthly_rate ?? item.officesupplies_details.monthly_rate) * (Number(item.boq_months ?? item.officesupplies_details.months)))

    setContractAmount(calculateContractAmount);

    const calculatePreviousAmount = calculateTotal(officeSuppliesinvoice, (item) => Number(item.previous_invoice_total))

    setPreviousAmount(calculatePreviousAmount);

    const calculateCurrentAmount = calculateTotal(officeSuppliesinvoice, (item) => Number(item.invoice_amount ?? item.current_invoice_amount))

    setCurrentAmount(calculateCurrentAmount);

    const calculateCumulated = calculateTotal(officeSuppliesinvoice, (item) => Number(item.cumulative_invoice_total))

    setCumulated(calculateCumulated);

    const calculateRemaining = calculateTotal(officeSuppliesinvoice, (item) => Number(item.remaining_amount))

    setRemainingAmount(calculateRemaining);

    useEffect(() => {

        const eotGroups = [];

        officeSuppliesinvoice.forEach(item => {

            (item?.eot_details || []).forEach((eot, idx) => {

                if (!eotGroups[idx]) {

                    eotGroups[idx] = { ...eot, total_amount: 0 };

                }

                eotGroups[idx].total_amount += Number(eot.total_amount || 0);

            });

        });



        setEotDetails(eotGroups);

    }, [officeSuppliesinvoice]);



    const getOfficeSuppliesinvoice = async () => {

        try {

            let data;



            if (usefor === "generateinvoice") {

                const res = await axios.get(

                    `${BASE_URL}/siteproject/invoiceofficesuppliesbyprojectstatus/${p_id ? p_id : project}/${month}/${year}/`

                );

                data = res.data;

            } else {

                const response2 = await axios.get(

                    `${BASE_URL}/siteproject/newinvoiceofficesuppliesfiltermonthyear/${invoice_id}/null/null/`

                );

                data = response2.data;

            }



            const isAnyBoqJsonNull = data.length !== 0 && data.every(item => item.boq_json === null);





            const selectedData = isAnyBoqJsonNull ? data : data;

            setOfficeSuppliesinvoice(selectedData);

        } catch (err) { }



    };



    useEffect(() => {



        // getdocument();

        getOfficeSuppliesinvoice();

        // eslint-disable-next-line react-hooks/exhaustive-deps

    }, []);

    const isEotDataTrue = officeSuppliesinvoice.some(i =>

        (i.eot_details?.length > 0) || (i.data?.eot_details?.length > 0)

    );











    const eotLengths = Math.max(

        ...officeSuppliesinvoice.map(i => i?.eot_details?.length || i?.data?.eot_details?.length || 0),

        0

    );

    // Present month quantities at 2 decimals; retain full precision in source and totals.
    const formatMonth2 = (value) => {
        const n = Number(value ?? 0);
        return Number.isFinite(n) ? n.toFixed(2) : "0.00";
    };

    // For monetary fields, round the final calculated result to the nearest rupee.
    const roundAmount = (value) => {
        const n = Number(value ?? 0);
        return Number.isFinite(n) ? Math.round(n) : 0;
    };

    const formatAmountWhole = (value) => roundAmount(value).toLocaleString("en-IN", {
        minimumFractionDigits: 0, maximumFractionDigits: 0
    });

    // Excel AOA: month as fixed-2 text, amount/rate as numeric rounded integer.
    const r2 = formatMonth2;



    // ── Builds a fully formatted AOA sheet (merged headers, flat rows) ──

    const buildExcelSheetData = () => {

        const showDeduction = usefor !== "generateinvoice";



        // ---- figure out column layout ----

        let col = 0;

        const SNO_COL = col++;                  // 0

        const DESC_COL = col++;                 // 1

        const CONTRACT_START = col; col += 5;   // Const, Maint, No. of MM, Rate, Total Amount

        let DED_MONTH_COL = -1, DED_AMT_COL = -1;

        if (showDeduction) {

            DED_MONTH_COL = col++;

            DED_AMT_COL = col++;

        }

        const EOT_START = col; col += eotLengths * 5;   // 5 cols per EOT group (cp, dlp, t_month, rate, total_amount)

        const PREV_START = col; col += 2;   // Month, Amount

        const CUR_START = col; col += 2;

        const CUM_START = col; col += 2;

        const REM_START = col; col += 2;

        const TOTAL_COLS = col;



        const blankRow = () => new Array(TOTAL_COLS).fill("");



        // ---- header row 1 (group labels) ----

        const row1 = blankRow();

        row1[SNO_COL] = "S.No";

        row1[DESC_COL] = "Description";

        row1[CONTRACT_START] = "Contract Amount";

        if (showDeduction) {

            row1[DED_MONTH_COL] = "Deduction Month";

            row1[DED_AMT_COL] = "Deduction Amount";

        }

        for (let i = 0; i < eotLengths; i++) {

            row1[EOT_START + i * 5] = `EOT ${i + 1}`;

        }

        row1[PREV_START] = "Cumulative Total of Previous Months";

        row1[CUR_START] = "This Period";

        row1[CUM_START] = "Cumulative Total Including Current Invoice";

        row1[REM_START] = "Remaining Amount Against Contract Value";



        // ---- header row 2 (sub labels) ----

        const row2 = blankRow();

        row2[CONTRACT_START] = "Const";

        row2[CONTRACT_START + 1] = "Maint";

        row2[CONTRACT_START + 2] = "No. of MM";

        row2[CONTRACT_START + 3] = "Rate";

        row2[CONTRACT_START + 4] = "Total Amount";

        for (let i = 0; i < eotLengths; i++) {

            const c = EOT_START + i * 5;

            row2[c] = "Const";

            row2[c + 1] = "Maint";

            row2[c + 2] = "Total MM";

            row2[c + 3] = "Rate";

            row2[c + 4] = "Total Amount";

        }

        row2[PREV_START] = "Month"; row2[PREV_START + 1] = "Amount";

        row2[CUR_START] = "Month"; row2[CUR_START + 1] = "Amount";

        row2[CUM_START] = "Month"; row2[CUM_START + 1] = "Amount";

        row2[REM_START] = "Month"; row2[REM_START + 1] = "Amount";



        // ---- merges for the two header rows ----

        const merges = [];

        const vMerge = (c) => merges.push({ s: { r: 0, c }, e: { r: 1, c } });

        const hMerge = (c1, c2) => merges.push({ s: { r: 0, c: c1 }, e: { r: 0, c: c2 } });



        vMerge(SNO_COL); vMerge(DESC_COL);

        if (showDeduction) { vMerge(DED_MONTH_COL); vMerge(DED_AMT_COL); }

        hMerge(CONTRACT_START, CONTRACT_START + 4);

        for (let i = 0; i < eotLengths; i++) {

            const c = EOT_START + i * 5;

            hMerge(c, c + 4);

        }

        hMerge(PREV_START, PREV_START + 1);

        hMerge(CUR_START, CUR_START + 1);

        hMerge(CUM_START, CUM_START + 1);

        hMerge(REM_START, REM_START + 1);



        // ---- data rows (flat — no sections for office supplies) ----

        const rows = [row1, row2];



        officeSuppliesinvoice.forEach((item, index) => {

            const constMM = Number(item.boq_during_construction_period ?? item.officesupplies_details.during_construction_period) || 0;

            const omMM = Number(item.boq_during_dlp_OM_period ?? item.officesupplies_details.during_dlp_OM_period) || 0;

            const months = Number(item.boq_months ?? item.officesupplies_details?.months) || 0;

            const rate = Number(item.boq_monthly_rate ?? item.officesupplies_details.monthly_rate) || 0;

            const totalAmt = rate * months;



            const matchedDeductions = deductionData?.filter((d) => d.item_id === item.id) || [];

            const deductionMonthSum = matchedDeductions.reduce((s, n) => s + (Number(n.deduction_month) || 0), 0);

            const deductionAmountSum = matchedDeductions.reduce((s, n) => s + ((Number(n.deduction_amount) || 0) + (Number(n.withheld_deduction_amount) || 0)), 0);



            const r = blankRow();

            r[SNO_COL] = index + 1;

            r[DESC_COL] = item?.boq_item ?? item.officesupplies_details.item ?? "";

            r[CONTRACT_START] = r2(constMM);

            r[CONTRACT_START + 1] = r2(omMM);

            r[CONTRACT_START + 2] = r2(months);

            r[CONTRACT_START + 3] = roundAmount(rate);

            r[CONTRACT_START + 4] = roundAmount(totalAmt);

            if (showDeduction) {

                r[DED_MONTH_COL] = r2(deductionMonthSum);

                r[DED_AMT_COL] = roundAmount(deductionAmountSum);

            }

            (item.eot_details || []).forEach((e, i) => {

                const c = EOT_START + i * 5;

                r[c] = r2(e.cp);

                r[c + 1] = r2(e.dlp);

                r[c + 2] = r2(e.t_month);

                r[c + 3] = roundAmount(e.rate);

                r[c + 4] = roundAmount(e.total_amount);

            });

            r[PREV_START] = r2(item.actual_month_total_previous);

            r[PREV_START + 1] = roundAmount(item.previous_invoice_total);

            r[CUR_START] = r2(item.actual_month);

            r[CUR_START + 1] = roundAmount(item.invoice_amount);

            r[CUM_START] = r2(item.actual_month_cumulative_total);

            r[CUM_START + 1] = roundAmount(item.cumulative_invoice_total);

            r[REM_START] = r2(item.actual_month_remaining);

            r[REM_START + 1] = roundAmount(item.remaining_amount);



            rows.push(r);

        });



        // ---- totals row ----

        const totalRow = blankRow();

        totalRow[DESC_COL] = "Total:";

        totalRow[CONTRACT_START] = r2(calculateTotal(officeSuppliesinvoice, item => Number(item.boq_during_construction_period ?? item.officesupplies_details.during_construction_period)));

        totalRow[CONTRACT_START + 1] = r2(calculateTotal(officeSuppliesinvoice, item => Number(item.boq_during_dlp_OM_period ?? item.officesupplies_details.during_dlp_OM_period)));

        totalRow[CONTRACT_START + 2] = r2(calculateTotal(officeSuppliesinvoice, item => Number(item.boq_months ?? item.officesupplies_details?.months)));

        totalRow[CONTRACT_START + 3] = roundAmount(calculateTotal(officeSuppliesinvoice, item => Number(item.boq_monthly_rate ?? item.officesupplies_details.monthly_rate)));

        totalRow[CONTRACT_START + 4] = roundAmount(calculateContractAmount);



        if (showDeduction) {

            totalRow[DED_MONTH_COL] = r2(officeSuppliesinvoice.reduce((gt, item) => {

                const m = deductionData?.filter(d => d.item_id === item.id) || [];

                return gt + m.reduce((s, d) => s + (Number(d?.deduction_month) || 0), 0);

            }, 0));

            totalRow[DED_AMT_COL] = roundAmount(officeSuppliesinvoice.reduce((gt, item) => {

                const m = deductionData?.filter(d => d.item_id === item.id) || [];

                return gt + m.reduce((s, d) => s + ((Number(d?.deduction_amount) || 0) + (Number(d?.withheld_deduction_amount) || 0)), 0);

            }, 0));

        }



        for (let eotIdx = 0; eotIdx < eotLengths; eotIdx++) {

            const totals = officeSuppliesinvoice.reduce((acc, emp) => {

                const details = emp.eot_details?.length > 0 ? emp.eot_details : emp.data?.eot_details || [];

                const eot = details[eotIdx];

                if (!eot) return acc;

                acc.cp += Number(eot?.cp) || 0;

                acc.dlp += Number(eot?.dlp) || 0;

                acc.t_month += Number(eot?.t_month) || 0;

                acc.rate += Number(eot?.rate) || 0;

                acc.total_amount += Number(eot?.total_amount) || 0;

                return acc;

            }, { cp: 0, dlp: 0, t_month: 0, rate: 0, total_amount: 0 });

            const c = EOT_START + eotIdx * 5;

            totalRow[c] = r2(totals.cp);

            totalRow[c + 1] = r2(totals.dlp);

            totalRow[c + 2] = r2(totals.t_month);

            totalRow[c + 3] = roundAmount(totals.rate);

            totalRow[c + 4] = roundAmount(totals.total_amount);

        }



        totalRow[PREV_START] = r2(calculateTotal(officeSuppliesinvoice, item => Number(item.actual_month_total_previous)));

        totalRow[PREV_START + 1] = roundAmount(calculatePreviousAmount);

        totalRow[CUR_START] = r2(calculateTotal(officeSuppliesinvoice, item => Number(item.actual_month)));

        totalRow[CUR_START + 1] = roundAmount(calculateCurrentAmount);

        totalRow[CUM_START] = r2(calculateTotal(officeSuppliesinvoice, item => Number(item.actual_month_cumulative_total)));

        totalRow[CUM_START + 1] = roundAmount(calculateCumulated);

        totalRow[REM_START] = r2(calculateTotal(officeSuppliesinvoice, item => Number(item.actual_month_remaining)));

        totalRow[REM_START + 1] = roundAmount(calculateRemaining);

        rows.push(totalRow);



        const colWidths = new Array(TOTAL_COLS).fill({ wch: 14 });

        colWidths[SNO_COL] = { wch: 6 };

        colWidths[DESC_COL] = { wch: 22 };



        return { rows, merges, colWidths, sheetName: "Office Supplies" };

    };

    useEffect(() => {

        if (officeSuppliesinvoice.length > 0 && typeof setExcelRows === "function") {

            setExcelRows(buildExcelSheetData());

        }

    }, [officeSuppliesinvoice, deductionData]);






    return (

        <div className="boc-modern-wrapper" style={{ minHeight: "30vh" }}>

            <div className="boc-modern-card">



                {/* Print header */}

                <div className="boc-modern-header bocx-modern-footer-total">

                    <div className="boc-modern-header-content">

                        <div className="boc-modern-project-info">

                            <h3 className="boc-modern-project-title">{projectData?.project_name}</h3>

                            <div className="boc-modern-project-meta">

                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Client:</span><span className="boc-modern-meta-value">{projectData?.client_name}</span></div>

                                <div className="boc-modern-meta-divider"></div>

                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Consultant (AE):</span><span className="boc-modern-meta-value">{projectData?.lead}{projectData?.jv ? ` JV with ${projectData?.jv}.` : ""}{projectData?.association ? ` Association with ${projectData?.association}` : ""}</span></div>

                                <div className="boc-modern-meta-divider"></div>

                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">GSTIN:</span><span className="boc-modern-meta-value">{projectData?.gst_no}</span></div>

                                <div className="boc-modern-meta-divider"></div>

                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">PAN:</span><span className="boc-modern-meta-value">{projectData?.pan_no}</span></div>

                                <div className="boc-modern-meta-divider"></div>

                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Bid Due:</span><span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.bid_due_date)}</span></div>

                                <div className="boc-modern-meta-divider"></div>

                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Agreement:</span><span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.agreement_date)}</span></div>

                                <div className="boc-modern-meta-divider"></div>

                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Start:</span><span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.commencement_date)}</span></div>

                                <div className="boc-modern-meta-divider"></div>

                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Invoice Number:</span><span className="boc-modern-meta-value">{invoice_num}</span></div>

                                <div className="boc-modern-meta-divider"></div>

                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Date:</span><span className="boc-modern-meta-value">{getMonthName(month)}-{year}</span></div>

                            </div>

                        </div>

                    </div>

                </div>



                {/* Section heading + action */}

                <div className="boc-modern-description-section">

                    <div className="boc-modern-controls">

                        <div className="boc-modern-controls-left">

                            <h6 className="boc-modern-main-heading">6- Office Supplies, Utilities and Communication (Fixed Cost)</h6>

                        </div>

                        {role !== "ViewAccess" && (

                            <div className="hide-on-print">
                                {usefor === "generateinvoice" ? (
                                    <>
                                        {officeSuppliesinvoice.length === 0
                                            ? <OfficeSuppliesInvoice usedfor="InvoiceandDeduction" p_id={p_id ? p_id : project} invoice_id={invoice_id} getOfficeSuppliesinvoice={getOfficeSuppliesinvoice} month={month} year={year} logData={logData} />
                                            : <UpdateOfficeSuppliesInvoice usedfor="InvoiceandDeduction" invoiceData={officeSuppliesinvoice} p_id={p_id ? p_id : project} invoice_id={invoice_id} getOfficeSuppliesinvoice={getOfficeSuppliesinvoice} month={month} year={year} logData={logData} />
                                        }
                                    </>
                                ) : (
                                    <>
                                        {officeSuppliesinvoice.length === 0
                                            ? <OfficeSuppliesInvoice usedfor="OnlyDeduction" invoiceData={officeSuppliesinvoice} p_id={p_id ? p_id : project} invoice_id={invoice_id} getOfficeSuppliesinvoice={getOfficeSuppliesinvoice} month={month} year={year} logData={logData} />
                                            : <UpdateSuppliesDeductionInvoice invoiceData={officeSuppliesinvoice} getData={getOfficeSuppliesinvoice} />
                                        }
                                    </>
                                )}
                            </div>

                        )}

                    </div>

                </div>



                <div className="boc-modern-table-wrapper">

                    <div className="boc-modern-table-scroll">

                        <table className="boc-modern-table">

                            <thead>

                                <tr className="boc-modern-table-header">

                                    <th className="boc-modern-th text-center" rowSpan="4">S.No</th>

                                    <th className="boc-modern-th text-center" rowSpan="4">Description</th>

                                    <th className="boc-modern-th text-center" colSpan="5">Contract Amount</th>

                                    {usefor !== "generateinvoice" && (

                                        <>

                                            <th className="boc-modern-th text-center" rowSpan="4">Deduction Month</th>

                                            <th className="boc-modern-th text-center" rowSpan="4">Deduction Amount</th>

                                        </>

                                    )}

                                    {isEotDataTrue && <th className="boc-modern-th text-center" colSpan={eotLengths * 5 || 1}>(COS/EOT)</th>}

                                    <th className="boc-modern-th text-center" colSpan="2">Cumulative Total of Previous Months</th>

                                    <th className="boc-modern-th text-center" colSpan="2">This Period</th>

                                    <th className="boc-modern-th text-center" colSpan="2">Cumulative Total Including Current Invoice</th>

                                    <th className="boc-modern-th text-center" colSpan="2">Remaining Amount Against Contract Value</th>

                                    {role !== "SiteManagement" && role !== "ViewAccess" && <th className="boc-modern-th text-center hide-on-print" rowSpan="4">Action</th>}

                                </tr>

                                <tr className="boc-modern-table-subheader">

                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Const</th>

                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Maint</th>

                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">No. of MM</th>

                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Rate</th>

                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Total Amount</th>

                                    {Array.from({ length: eotLengths }).map((_, idx) => (

                                        <th key={idx} className="boc-modern-th text-center boc-nowrap" colSpan={5}>{`EOT ${idx + 1}`}</th>

                                    ))}

                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Month</th>

                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Amount</th>

                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Month</th>

                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Amount</th>

                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Month</th>

                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Amount</th>

                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Month</th>

                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Amount</th>

                                </tr>

                                <tr className="boc-modern-table-subheader">

                                    {Array.from({ length: eotLengths }).map((_, idx) => (

                                        <React.Fragment key={idx}>

                                            <th rowSpan="2" className="boc-modern-th boc-nowrap">Const</th>

                                            <th rowSpan="2" className="boc-modern-th boc-nowrap">Maint</th>

                                            <th rowSpan="2" className="boc-modern-th boc-nowrap">Total MM</th>

                                            <th rowSpan="2" className="boc-modern-th boc-nowrap">Rate</th>

                                            <th rowSpan="2" className="boc-modern-th boc-nowrap">Total Amount</th>

                                        </React.Fragment>

                                    ))}

                                </tr>

                            </thead>



                            <tbody>

                                {officeSuppliesinvoice.map((item, index) => {

                                    const matchedDeductions = deductionData?.filter(d => d.item_id === item.id) || [];

                                    return (

                                        <tr className="boc-modern-row" key={item.id}>

                                            <td className="boc-modern-td text-center">{index + 1}.</td>

                                            <td className="boc-modern-td"><div style={{ whiteSpace: "normal", width: "120px" }}>{item?.boq_item ?? item.officesupplies_details.item}</div></td>

                                            <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(Number(item.boq_during_construction_period ?? item.officesupplies_details.during_construction_period))}</td>

                                            <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(Number(item.boq_during_dlp_OM_period ?? item.officesupplies_details.during_dlp_OM_period))}</td>

                                            <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(Number(item.boq_months ?? item.officesupplies_details?.months))}</td>

                                            <td className="boc-modern-td boc-nowrap boc-modern-currency text-right">₹ {formatAmountWhole(Number(item.boq_monthly_rate ?? item.officesupplies_details.monthly_rate))}</td>

                                            <td className="boc-modern-td boc-nowrap text-right">

                                                <span className="boc-modern-currency boc-modern-total-highlight">

                                                    ₹ {formatAmountWhole(Number(item.boq_monthly_rate ?? item.officesupplies_details.monthly_rate) * Number(item.boq_months ?? item.officesupplies_details.months))}

                                                </span>

                                            </td>



                                            {usefor !== "generateinvoice" && (

                                                <td className="boc-modern-td boc-nowrap text-right justify-end" style={{ padding: 0 }}>

                                                    {matchedDeductions.length > 0

                                                        ? matchedDeductions.map((n, i) => <div key={i} className="boc-multi-item boc-nowrap">{n.deduction_month == null ? "-" : formatMonth2(n.deduction_month)}</div>)

                                                        : <div className="boc-multi-item">-</div>}

                                                </td>

                                            )}

                                            {usefor !== "generateinvoice" && (

                                                <td className="boc-modern-td boc-nowrap text-right justify-end" style={{ padding: 0 }}>

                                                    {matchedDeductions.length > 0

                                                        ? matchedDeductions.map((n, i) => <div key={i} className="boc-multi-item boc-nowrap">{formatAmountWhole((Number(n.deduction_amount) || 0) + (Number(n.withheld_deduction_amount) || 0))}</div>)

                                                        : <div className="boc-multi-item">0</div>}

                                                </td>

                                            )}



                                            {item?.eot_details?.length > 0 && item.eot_details.map((i, idx) => (

                                                <React.Fragment key={idx}>

                                                    <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(i.cp)}</td>

                                                    <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(i.dlp)}</td>

                                                    <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(i.t_month)}</td>

                                                    <td className="boc-modern-td boc-nowrap boc-modern-currency text-right">₹ {formatAmountWhole(Number(i.rate))}</td>

                                                    <td className="boc-modern-td boc-nowrap boc-modern-currency text-right">₹ {formatAmountWhole(Number(i.total_amount))}</td>

                                                </React.Fragment>

                                            ))}



                                            <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(Number(item.actual_month_total_previous))}</td>

                                            <td className="boc-modern-td boc-nowrap boc-modern-currency text-right">₹ {formatAmountWhole(Number(item.previous_invoice_total))}</td>

                                            <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(Number(item.actual_month))}</td>

                                            <td className="boc-modern-td boc-nowrap boc-modern-currency text-right">₹ {formatAmountWhole(Number(item.invoice_amount))}</td>

                                            <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(Number(item.actual_month_cumulative_total))}</td>

                                            <td className="boc-modern-td boc-nowrap boc-modern-currency text-right">₹ {formatAmountWhole(Number(item.cumulative_invoice_total))}</td>

                                            <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(Number(item.actual_month_remaining))}</td>

                                            <td className="boc-modern-td boc-nowrap text-right">

                                                <span className="boc-modern-currency boc-modern-total-highlight">₹ {formatAmountWhole(Number(item.remaining_amount))}</span>

                                            </td>



                                            {(usefor === "generateinvoice" || role !== "ViewAccess") && (

                                                <>

                                                    {(!["Checker", "SiteManagement"].includes(role)) || (role === "Checker" && !isMoreThan24Hours(item.created_at)) ? (

                                                        <td className="boc-modern-td text-center hide-on-print">

                                                            {usefor === "generateinvoice"

                                                                ? <DeleteOfficeSuppliesInvoice i={item} getOfficeSuppliesinvoice={getOfficeSuppliesinvoice} />

                                                                : <DeleteOfficeSuppliesInvoiceDeduction i={item} getOfficeSuppliesinvoice={getOfficeSuppliesinvoice} />}

                                                        </td>

                                                    ) : <td className="boc-modern-td text-center hide-on-print">-</td>}

                                                </>

                                            )}

                                        </tr>

                                    );

                                })}

                            </tbody>



                            <tfoot>

                                <tr className="boc-modern-footer">

                                    <td colSpan="2" className="boc-modern-footer-label">Total:</td>

                                    <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(calculateTotal(officeSuppliesinvoice, item => Number(item.boq_during_construction_period ?? item.officesupplies_details.during_construction_period)))}</td>

                                    <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(calculateTotal(officeSuppliesinvoice, item => Number(item.boq_during_dlp_OM_period ?? item.officesupplies_details.during_dlp_OM_period)))}</td>

                                    <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(calculateTotal(officeSuppliesinvoice, item => Number(item.boq_months ?? item.officesupplies_details?.months)))}</td>

                                    <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatAmountWhole(calculateTotal(officeSuppliesinvoice, item => Number(item.boq_monthly_rate ?? item.officesupplies_details.monthly_rate)))}</span></td>

                                    <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatAmountWhole(calculateTotal(officeSuppliesinvoice, item => Number(item.boq_monthly_rate ?? item.officesupplies_details.monthly_rate) * Number(item.boq_months ?? item.officesupplies_details.months)))}</span></td>



                                    {usefor !== "generateinvoice" && (

                                        <>

                                            <td className="boc-modern-td boc-nowrap text-right">

                                                {formatMonth2(officeSuppliesinvoice.reduce((gt, item) => {

                                                    const m = deductionData?.filter(d => d.item_id === item.id) || [];

                                                    return gt + m.reduce((s, d) => s + (Number(d?.deduction_month) || 0), 0);

                                                }, 0))}

                                            </td>

                                            <td className="boc-modern-td boc-nowrap text-right">

                                                <span className="boc-modern-currency boc-modern-footer-total">

                                                    ₹ {formatAmountWhole(

                                                        officeSuppliesinvoice.reduce((gt, item) => {

                                                            const m = deductionData?.filter(d => d.item_id === item.id) || [];

                                                            return gt + m.reduce((s, d) => s + ((Number(d?.deduction_amount) || 0) + (Number(d?.withheld_deduction_amount) || 0)), 0);

                                                        }, 0)

                                                    )}

                                                </span>

                                            </td>

                                        </>

                                    )}

                                    {isEotDataTrue && Array.from({ length: eotLengths }).map((_, eotIdx) => {

                                        const totals = officeSuppliesinvoice.reduce((acc, emp) => {

                                            const details = emp.eot_details?.length > 0 ? emp.eot_details : emp.data?.eot_details || [];

                                            const eot = details[eotIdx];

                                            if (!eot) return acc;

                                            acc.cp += Number(eot?.cp) || 0; acc.dlp += Number(eot?.dlp) || 0;

                                            acc.t_month += Number(eot?.t_month) || 0; acc.rate += Number(eot?.rate) || 0;

                                            acc.total_amount += Number(eot?.total_amount) || 0;

                                            return acc;

                                        }, { cp: 0, dlp: 0, t_month: 0, rate: 0, total_amount: 0 });

                                        return (

                                            <React.Fragment key={eotIdx}>

                                                <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(totals.cp)}</td>

                                                <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(totals.dlp)}</td>

                                                <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(totals.t_month)}</td>

                                                <td className="boc-modern-td boc-nowrap text-right">₹ {formatAmountWhole(totals.rate)}</td>

                                                <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatAmountWhole(totals.total_amount)}</span></td>

                                            </React.Fragment>

                                        );

                                    })}



                                    <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(calculateTotal(officeSuppliesinvoice, item => Number(item.actual_month_total_previous)))}</td>

                                    <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatAmountWhole(calculateTotal(officeSuppliesinvoice, item => Number(item.previous_invoice_total)))}</span></td>

                                    <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(calculateTotal(officeSuppliesinvoice, item => Number(item.actual_month)))}</td>

                                    <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatAmountWhole(calculateTotal(officeSuppliesinvoice, item => Number(item.invoice_amount ?? item.current_invoice_amount)))}</span></td>

                                    <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(calculateTotal(officeSuppliesinvoice, item => Number(item.actual_month_cumulative_total)))}</td>

                                    <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatAmountWhole(calculateTotal(officeSuppliesinvoice, item => Number(item.cumulative_invoice_total)))}</span></td>

                                    <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(calculateTotal(officeSuppliesinvoice, item => Number(item.actual_month_remaining)))}</td>

                                    <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatAmountWhole(calculateTotal(officeSuppliesinvoice, item => Number(item.remaining_amount)))}</span></td>

                                    {role !== "SiteManagement" && role !== "ViewAccess" && <td className="hide-on-print boc-modern-td"></td>}

                                </tr>

                            </tfoot>

                        </table>

                    </div>

                </div>

            </div>

        </div>

    );

};


const OfficeFurniture = ({ setEotDetails, deductionData, projectData, client, p_id, invoice_id, month, year, invoice_num, logData,

    setPreviousAmount,

    setCurrentAmount,

    setRemainingAmount,

    setContractAmount,

    setExcelRows,

    setCumulated,

    usefor }) => {



    // let { id } = useParams();



    const [officeFurnitureinvoice, setOfficeFurnitureinvoice] = useState([]);

    const currentDate = new Date();

    const isFirstWeek = currentDate.getDate() <= 7;

    const project = sessionStorage.getItem('sitemanagement_project');



    const calculateContractAmount = calculateTotal(officeFurnitureinvoice, (item) => Number(item.boq_rate_per_month ?? item.officefurniture_details.rate_per_month) * (Number(item.boq_num_of_months ?? item.officefurniture_details.num_of_months)))

    setContractAmount(calculateContractAmount);

    const calculatePreviousAmount = calculateTotal(officeFurnitureinvoice, (item) => Number(item.previous_invoice_total))

    setPreviousAmount(calculatePreviousAmount);

    const calculateCurrentAmount = calculateTotal(officeFurnitureinvoice, (item) => Number(item.invoice_amount ?? item.current_invoice_amount))

    setCurrentAmount(calculateCurrentAmount);

    const calculateCumulated = calculateTotal(officeFurnitureinvoice, (item) => Number(item.cumulative_invoice_total))

    setCumulated(calculateCumulated);

    const calculateRemaining = calculateTotal(officeFurnitureinvoice, (item) => Number(item.remaining_amount))

    setRemainingAmount(calculateRemaining);





    useEffect(() => {

        const eotGroups = [];

        officeFurnitureinvoice.forEach(item => {

            (item?.eot_details || []).forEach((eot, idx) => {

                if (!eotGroups[idx]) {

                    eotGroups[idx] = { ...eot, total_amount: 0 };

                }

                eotGroups[idx].total_amount += Number(eot.total_amount || 0);

            });

        });



        setEotDetails(eotGroups);

    }, [officeFurnitureinvoice]);





    const getOfficeFurnitureinvoice = async () => {

        try {

            let data;



            if (usefor === "generateinvoice") {

                const res = await axios.get(

                    `${BASE_URL}/siteproject/invoiceofficefurnitureandequipmentstatusbyproject/${p_id ? p_id : project}/${month}/${year}/`

                );

                data = res.data;

            } else {

                const response2 = await axios.get(

                    `${BASE_URL}/siteproject/newinvoiceofficefurnitureandequipmentfiltermonthyear/${invoice_id}/null/null/`

                );

                data = response2.data;

            }



            const isAnyBoqJsonNull = data.length !== 0 && data.every(item => item.boq_json === null);





            const selectedData = isAnyBoqJsonNull ? data : data;

            setOfficeFurnitureinvoice(selectedData);

        } catch (err) { }



    };



    useEffect(() => {



        // getdocument();

        getOfficeFurnitureinvoice();

        // eslint-disable-next-line react-hooks/exhaustive-deps

    }, []);







    const role = sessionStorage.getItem('sitemanagement_role');



    const isEotDataTrue = officeFurnitureinvoice.some(i =>

        (i.eot_details?.length > 0) || (i.data?.eot_details?.length > 0)

    );











    const eotLengths = Math.max(

        ...officeFurnitureinvoice.map(i => i?.eot_details?.length || i?.data?.eot_details?.length || 0),

        0

    );



    // Display/export formatting only. Original data, calculations, and API values remain unrounded.
    const formatMonth2 = (value) => {
        const n = Number(value ?? 0);
        return Number.isFinite(n) ? n.toFixed(2) : "0.00";
    };

    // Round currency values to the nearest whole rupee (e.g. 38571.43 -> 38571).
    const roundRupees = (value) => {
        const n = Number(value ?? 0);
        return Number.isFinite(n) ? Math.round(n) : 0;
    };

    const formatAmount0 = (value) =>
        roundRupees(value).toLocaleString("en-IN", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
        });

    // Excel: keep whole-rupee amount cells numeric; keep month text at exactly 2 decimal places.
    const r0 = roundRupees;
    const r2 = formatMonth2;



    // ── Builds a fully formatted AOA sheet (merged headers, flat rows) ──

    const buildExcelSheetData = () => {

        const showDeduction = usefor !== "generateinvoice";



        // ---- figure out column layout ----

        let col = 0;

        const SNO_COL = col++;                  // 0

        const CONTRACT_START = col; col += 5;   // Const, Maint, No. of MM, Rate, Total Amount

        let DED_MONTH_COL = -1, DED_AMT_COL = -1;

        if (showDeduction) {

            DED_MONTH_COL = col++;

            DED_AMT_COL = col++;

        }

        const EOT_START = col; col += eotLengths * 5;   // 5 cols per EOT group (cp, dlp, t_month, rate, total_amount)

        const PREV_START = col; col += 2;   // Month, Amount

        const CUR_START = col; col += 2;

        const CUM_START = col; col += 2;

        const REM_START = col; col += 2;

        const TOTAL_COLS = col;



        const blankRow = () => new Array(TOTAL_COLS).fill("");



        // ---- header row 1 (group labels) ----

        const row1 = blankRow();

        row1[SNO_COL] = "S.No";

        row1[CONTRACT_START] = "Contract Amount";

        if (showDeduction) {

            row1[DED_MONTH_COL] = "Deduction Month";

            row1[DED_AMT_COL] = "Deduction Amount";

        }

        for (let i = 0; i < eotLengths; i++) {

            row1[EOT_START + i * 5] = `EOT ${i + 1}`;

        }

        row1[PREV_START] = "Cumulative Total of Previous Months";

        row1[CUR_START] = "This Period";

        row1[CUM_START] = "Cumulative Total Including Current Invoice";

        row1[REM_START] = "Remaining Amount Against Contract Value";



        // ---- header row 2 (sub labels) ----

        const row2 = blankRow();

        row2[CONTRACT_START] = "Const";

        row2[CONTRACT_START + 1] = "Maint";

        row2[CONTRACT_START + 2] = "No. of MM";

        row2[CONTRACT_START + 3] = "Rate";

        row2[CONTRACT_START + 4] = "Total Amount";

        for (let i = 0; i < eotLengths; i++) {

            const c = EOT_START + i * 5;

            row2[c] = "Const";

            row2[c + 1] = "Maint";

            row2[c + 2] = "Total MM";

            row2[c + 3] = "Rate";

            row2[c + 4] = "Total Amount";

        }

        row2[PREV_START] = "Month"; row2[PREV_START + 1] = "Amount";

        row2[CUR_START] = "Month"; row2[CUR_START + 1] = "Amount";

        row2[CUM_START] = "Month"; row2[CUM_START + 1] = "Amount";

        row2[REM_START] = "Month"; row2[REM_START + 1] = "Amount";



        // ---- merges for the two header rows ----

        const merges = [];

        const vMerge = (c) => merges.push({ s: { r: 0, c }, e: { r: 1, c } });

        const hMerge = (c1, c2) => merges.push({ s: { r: 0, c: c1 }, e: { r: 0, c: c2 } });



        vMerge(SNO_COL);

        if (showDeduction) { vMerge(DED_MONTH_COL); vMerge(DED_AMT_COL); }

        hMerge(CONTRACT_START, CONTRACT_START + 4);

        for (let i = 0; i < eotLengths; i++) {

            const c = EOT_START + i * 5;

            hMerge(c, c + 4);

        }

        hMerge(PREV_START, PREV_START + 1);

        hMerge(CUR_START, CUR_START + 1);

        hMerge(CUM_START, CUM_START + 1);

        hMerge(REM_START, REM_START + 1);



        // ---- data rows (flat — no sections for office furniture) ----

        const rows = [row1, row2];



        officeFurnitureinvoice.forEach((item, index) => {

            const constMM = Number(item.boq_during_construction_period ?? item.officefurniture_details.during_construction_period) || 0;

            const omMM = Number(item.boq_during_dlp_OM_period ?? item.officefurniture_details.during_dlp_OM_period) || 0;

            const months = Number(item.boq_num_of_months ?? item.officefurniture_details?.num_of_months) || 0;

            const rate = Number(item.boq_rate_per_month ?? item.officefurniture_details.rate_per_month) || 0;

            const totalAmt = rate * months;



            const matchedDeductions = deductionData?.filter((d) => d.item_id === item.id) || [];

            const deductionMonthSum = matchedDeductions.reduce((s, n) => s + (Number(n.deduction_month) || 0), 0);

            const deductionAmountSum = matchedDeductions.reduce((s, n) => s + ((Number(n.deduction_amount) + Number(n.withheld_deduction_amount)) || 0), 0);



            const r = blankRow();

            r[SNO_COL] = index + 1;

            r[CONTRACT_START] = r2(constMM);

            r[CONTRACT_START + 1] = r2(omMM);

            r[CONTRACT_START + 2] = r2(months);

            r[CONTRACT_START + 3] = r0(rate);

            r[CONTRACT_START + 4] = r0(totalAmt);

            if (showDeduction) {

                r[DED_MONTH_COL] = r2(deductionMonthSum);

                r[DED_AMT_COL] = r0(deductionAmountSum);

            }

            (item.eot_details || []).forEach((e, i) => {

                const c = EOT_START + i * 5;

                r[c] = r2(e.cp);

                r[c + 1] = r2(e.dlp);

                r[c + 2] = r2(e.t_month);

                r[c + 3] = r0(e.rate);

                r[c + 4] = r0(e.total_amount);

            });

            r[PREV_START] = r2(item.actual_month_total_previous);

            r[PREV_START + 1] = r0(item.previous_invoice_total);

            r[CUR_START] = r2(item.actual_month);

            r[CUR_START + 1] = r0(item.invoice_amount);

            r[CUM_START] = r2(item.actual_month_cumulative_total);

            r[CUM_START + 1] = r0(item.cumulative_invoice_total);

            r[REM_START] = r2(item.actual_month_remaining);

            r[REM_START + 1] = r0(item.remaining_amount);



            rows.push(r);

        });



        // ---- totals row ----

        const totalRow = blankRow();

        totalRow[SNO_COL] = "Total:";

        totalRow[CONTRACT_START] = r2(calculateTotal(officeFurnitureinvoice, item => Number(item.boq_during_construction_period ?? item.officefurniture_details.during_construction_period)));

        totalRow[CONTRACT_START + 1] = r2(calculateTotal(officeFurnitureinvoice, item => Number(item.boq_during_dlp_OM_period ?? item.officefurniture_details.during_dlp_OM_period)));

        totalRow[CONTRACT_START + 2] = r2(calculateTotal(officeFurnitureinvoice, item => Number(item.boq_num_of_months ?? item.officefurniture_details?.num_of_months)));

        totalRow[CONTRACT_START + 3] = r0(calculateTotal(officeFurnitureinvoice, item => Number(item.boq_rate_per_month ?? item.officefurniture_details.rate_per_month)));

        totalRow[CONTRACT_START + 4] = r0(calculateContractAmount);



        if (showDeduction) {

            totalRow[DED_MONTH_COL] = r2(officeFurnitureinvoice.reduce((gt, item) => {

                const m = deductionData?.filter(d => d.item_id === item.id) || [];

                return gt + m.reduce((s, d) => s + (Number(d?.deduction_month) || 0), 0);

            }, 0));

            totalRow[DED_AMT_COL] = r0(officeFurnitureinvoice.reduce((gt, item) => {

                const m = deductionData?.filter(d => d.item_id === item.id) || [];

                return gt + m.reduce((s, d) => s + ((Number(d?.deduction_amount) || 0) + (Number(d?.withheld_deduction_amount) || 0)), 0);

            }, 0));

        }



        for (let eotIdx = 0; eotIdx < eotLengths; eotIdx++) {

            const totals = officeFurnitureinvoice.reduce((acc, emp) => {

                const details = emp.eot_details?.length > 0 ? emp.eot_details : emp.data?.eot_details || [];

                const eot = details[eotIdx];

                if (!eot) return acc;

                acc.cp += Number(eot?.cp) || 0;

                acc.dlp += Number(eot?.dlp) || 0;

                acc.t_month += Number(eot?.t_month) || 0;

                acc.rate += Number(eot?.rate) || 0;

                acc.total_amount += Number(eot?.total_amount) || 0;

                return acc;

            }, { cp: 0, dlp: 0, t_month: 0, rate: 0, total_amount: 0 });

            const c = EOT_START + eotIdx * 5;

            totalRow[c] = r2(totals.cp);

            totalRow[c + 1] = r2(totals.dlp);

            totalRow[c + 2] = r2(totals.t_month);

            totalRow[c + 3] = r0(totals.rate);

            totalRow[c + 4] = r0(totals.total_amount);

        }



        totalRow[PREV_START] = r2(calculateTotal(officeFurnitureinvoice, item => Number(item.actual_month_total_previous)));

        totalRow[PREV_START + 1] = r0(calculatePreviousAmount);

        totalRow[CUR_START] = r2(calculateTotal(officeFurnitureinvoice, item => Number(item.actual_month)));

        totalRow[CUR_START + 1] = r0(calculateCurrentAmount);

        totalRow[CUM_START] = r2(calculateTotal(officeFurnitureinvoice, item => Number(item.actual_month_cumulative_total)));

        totalRow[CUM_START + 1] = r0(calculateCumulated);

        totalRow[REM_START] = r2(calculateTotal(officeFurnitureinvoice, item => Number(item.actual_month_remaining)));

        totalRow[REM_START + 1] = r0(calculateRemaining);

        rows.push(totalRow);



        const colWidths = new Array(TOTAL_COLS).fill({ wch: 14 });

        colWidths[SNO_COL] = { wch: 6 };



        return { rows, merges, colWidths, sheetName: "Office Furniture" };

    };

    useEffect(() => {

        if (officeFurnitureinvoice.length > 0 && typeof setExcelRows === "function") {

            setExcelRows(buildExcelSheetData());

        }

    }, [officeFurnitureinvoice, deductionData]);








    return (

        <div className="boc-modern-wrapper" style={{ minHeight: "30vh" }}>

            <div className="boc-modern-card">



                <div className="boc-modern-header bocx-modern-footer-total">

                    <div className="boc-modern-header-content">

                        <div className="boc-modern-project-info">

                            <h3 className="boc-modern-project-title">{projectData?.project_name}</h3>

                            <div className="boc-modern-project-meta">

                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Client:</span><span className="boc-modern-meta-value">{projectData?.client_name}</span></div>

                                <div className="boc-modern-meta-divider"></div>

                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Consultant (AE):</span><span className="boc-modern-meta-value">{projectData?.lead}{projectData?.jv ? ` JV with ${projectData?.jv}.` : ""}{projectData?.association ? ` Association with ${projectData?.association}` : ""}</span></div>

                                <div className="boc-modern-meta-divider"></div>

                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">GSTIN:</span><span className="boc-modern-meta-value">{projectData?.gst_no}</span></div>

                                <div className="boc-modern-meta-divider"></div>

                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">PAN:</span><span className="boc-modern-meta-value">{projectData?.pan_no}</span></div>

                                <div className="boc-modern-meta-divider"></div>

                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Bid Due:</span><span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.bid_due_date)}</span></div>

                                <div className="boc-modern-meta-divider"></div>

                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Agreement:</span><span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.agreement_date)}</span></div>

                                <div className="boc-modern-meta-divider"></div>

                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Start:</span><span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.commencement_date)}</span></div>

                                <div className="boc-modern-meta-divider"></div>

                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Invoice Number:</span><span className="boc-modern-meta-value">{invoice_num}</span></div>

                                <div className="boc-modern-meta-divider"></div>

                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Date:</span><span className="boc-modern-meta-value">{getMonthName(month)}-{year}</span></div>

                            </div>

                        </div>

                    </div>

                </div>



                <div className="boc-modern-description-section">

                    <div className="boc-modern-controls">

                        <div className="boc-modern-controls-left">

                            <h6 className="boc-modern-main-heading">7- Office Furniture and Equipment (Rental)</h6>

                        </div>

                        {role !== "ViewAccess" && (
                            <div className="hide-on-print">
                                {usefor === "generateinvoice"
                                    ? <>
                                        {officeFurnitureinvoice.length === 0
                                            ? <OfficeFurnitureInvoice
                                                usedfor="InvoiceandDeduction"
                                                p_id={p_id ? p_id : project}
                                                invoice_id={invoice_id}
                                                getOfficeFurnitureinvoice={getOfficeFurnitureinvoice}
                                                month={month}
                                                year={year}
                                                logData={logData}
                                            />
                                            : <UpdateOfficeFurnitureInvoice
                                                usedfor="InvoiceandDeduction"
                                                invoiceData={officeFurnitureinvoice}
                                                p_id={p_id ? p_id : project}
                                                invoice_id={invoice_id}
                                                getOfficeFurnitureinvoice={getOfficeFurnitureinvoice}
                                                month={month}
                                                year={year}
                                                logData={logData}
                                            />}
                                    </>
                                    : <>
                                        {officeFurnitureinvoice.length === 0
                                            ? <OfficeFurnitureInvoice invoiceData={officeFurnitureinvoice} usedfor="OnlyDeduction" p_id={p_id ? p_id : project} invoice_id={invoice_id} getOfficeFurnitureinvoice={getOfficeFurnitureinvoice} month={month} year={year} logData={logData} />
                                            : <UpdateFurnitureDeductionInvoice invoiceData={officeFurnitureinvoice} getData={getOfficeFurnitureinvoice} />}
                                    </>
                                }
                            </div>
                        )}

                    </div>

                </div>



                <div className="boc-modern-table-wrapper">

                    <div className="boc-modern-table-scroll">

                        <table className="boc-modern-table">

                            <thead>

                                <tr className="boc-modern-table-header">

                                    <th className="boc-modern-th text-center" rowSpan="3">S.No</th>

                                    <th className="boc-modern-th text-center" colSpan="5">Contract Amount</th>

                                    {usefor !== "generateinvoice" && (

                                        <>

                                            <th className="boc-modern-th text-center" rowSpan="3">Deduction Month</th>

                                            <th className="boc-modern-th text-center" rowSpan="3">Deduction Amount</th>

                                        </>

                                    )}

                                    {isEotDataTrue && <th className="boc-modern-th text-center" colSpan={eotLengths * 5 || 1}>(COS/EOT)</th>}

                                    <th className="boc-modern-th text-center" colSpan="2">Cumulative Total of Previous Months</th>

                                    <th className="boc-modern-th text-center" colSpan="2">This Period</th>

                                    <th className="boc-modern-th text-center" colSpan="2">Cumulative Total Including Current Invoice</th>

                                    <th className="boc-modern-th text-center" colSpan="2">Remaining Amount Against Contract Value</th>

                                    {role !== "SiteManagement" && role !== "ViewAccess" && <th className="boc-modern-th text-center hide-on-print" rowSpan="3">Action</th>}

                                </tr>

                                <tr className="boc-modern-table-subheader">

                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Const</th>

                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Maint</th>

                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">No. of MM</th>

                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Rate</th>

                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Total Amount</th>

                                    {Array.from({ length: eotLengths }).map((_, idx) => (

                                        <th key={idx} className="boc-modern-th text-center boc-nowrap" colSpan={5}>{`EOT ${idx + 1}`}</th>

                                    ))}

                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Month</th>

                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Amount</th>

                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Month</th>

                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Amount</th>

                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Month</th>

                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Amount</th>

                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Month</th>

                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Amount</th>

                                </tr>

                                <tr className="boc-modern-table-subheader">

                                    {Array.from({ length: eotLengths }).map((_, idx) => (

                                        <React.Fragment key={idx}>

                                            <th rowSpan="2" className="boc-modern-th boc-nowrap">Const</th>

                                            <th rowSpan="2" className="boc-modern-th boc-nowrap">Maint</th>

                                            <th rowSpan="2" className="boc-modern-th boc-nowrap">Total MM</th>

                                            <th rowSpan="2" className="boc-modern-th boc-nowrap">Rate</th>

                                            <th rowSpan="2" className="boc-modern-th boc-nowrap">Total Amount</th>

                                        </React.Fragment>

                                    ))}

                                </tr>

                            </thead>



                            <tbody>

                                {officeFurnitureinvoice.map((item, index) => {

                                    const matchedDeductions = deductionData?.filter(d => d.item_id === item.id) || [];

                                    return (

                                        <tr className="boc-modern-row" key={item.id}>

                                            <td className="boc-modern-td text-center">{index + 1}.</td>

                                            <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(Number(item.boq_during_construction_period ?? item.officefurniture_details.during_construction_period))}</td>

                                            <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(Number(item.boq_during_dlp_OM_period ?? item.officefurniture_details.during_dlp_OM_period))}</td>

                                            <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(Number(item.boq_num_of_months ?? item.officefurniture_details?.num_of_months))}</td>

                                            <td className="boc-modern-td boc-nowrap boc-modern-currency text-right">₹ {formatAmount0(Number(item.boq_rate_per_month ?? item.officefurniture_details.rate_per_month))}</td>

                                            <td className="boc-modern-td boc-nowrap text-right">

                                                <span className="boc-modern-currency boc-modern-total-highlight">

                                                    ₹ {formatAmount0(Number(item.boq_rate_per_month ?? item.officefurniture_details.rate_per_month) * Number(item.boq_num_of_months ?? item.officefurniture_details.num_of_months))}

                                                </span>

                                            </td>



                                            {usefor !== "generateinvoice" && (

                                                <td className="boc-modern-td boc-nowrap text-right justify-end" style={{ padding: 0 }}>

                                                    {matchedDeductions.length > 0

                                                        ? matchedDeductions.map((n, i) => <div key={i} className="boc-multi-item boc-nowrap">{n.deduction_month == null ? "-" : formatMonth2(n.deduction_month)}</div>)

                                                        : <div className="boc-multi-item">-</div>}

                                                </td>

                                            )}

                                            {usefor !== "generateinvoice" && (

                                                <td className="boc-modern-td boc-nowrap text-right justify-end" style={{ padding: 0 }}>

                                                    {matchedDeductions.length > 0

                                                        ? matchedDeductions.map((n, i) => <div key={i} className="boc-multi-item boc-nowrap">{formatAmount0((Number(n.deduction_amount) || 0) + (Number(n.withheld_deduction_amount) || 0))}</div>)

                                                        : <div className="boc-multi-item">0</div>}

                                                </td>

                                            )}



                                            {item?.eot_details?.length > 0 && item.eot_details.map((i, idx) => (

                                                <React.Fragment key={idx}>

                                                    <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(i.cp)}</td>

                                                    <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(i.dlp)}</td>

                                                    <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(i.t_month)}</td>

                                                    <td className="boc-modern-td boc-nowrap boc-modern-currency text-right">₹ {formatAmount0(Number(i.rate))}</td>

                                                    <td className="boc-modern-td boc-nowrap boc-modern-currency text-right">₹ {formatAmount0(Number(i.total_amount))}</td>

                                                </React.Fragment>

                                            ))}



                                            <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(Number(item.actual_month_total_previous))}</td>

                                            <td className="boc-modern-td boc-nowrap boc-modern-currency text-right">₹ {formatAmount0(Number(item.previous_invoice_total))}</td>

                                            <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(Number(item.actual_month))}</td>

                                            <td className="boc-modern-td boc-nowrap boc-modern-currency text-right">₹ {formatAmount0(Number(item.invoice_amount))}</td>

                                            <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(Number(item.actual_month_cumulative_total))}</td>

                                            <td className="boc-modern-td boc-nowrap boc-modern-currency text-right">₹ {formatAmount0(Number(item.cumulative_invoice_total))}</td>

                                            <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(Number(item.actual_month_remaining))}</td>

                                            <td className="boc-modern-td boc-nowrap text-right">

                                                <span className="boc-modern-currency boc-modern-total-highlight">₹ {formatAmount0(Number(item.remaining_amount))}</span>

                                            </td>



                                            {(usefor === "generateinvoice" || role !== "ViewAccess") && (

                                                <>

                                                    {(!["Checker", "SiteManagement"].includes(role)) || (role === "Checker" && !isMoreThan24Hours(item.created_at)) ? (

                                                        <td className="boc-modern-td text-center hide-on-print">

                                                            {usefor === "generateinvoice"

                                                                ? <DeleteFurnitureInvoice i={item} getOfficeFurnitureinvoice={getOfficeFurnitureinvoice} />

                                                                : <DeleteFurnitureInvoiceDeduction i={item} getOfficeFurnitureinvoice={getOfficeFurnitureinvoice} />}

                                                        </td>

                                                    ) : <td className="boc-modern-td text-center hide-on-print">-</td>}

                                                </>

                                            )}

                                        </tr>

                                    );

                                })}

                            </tbody>



                            <tfoot>

                                <tr className="boc-modern-footer">

                                    <td className="boc-modern-footer-label">Total:</td>

                                    <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(calculateTotal(officeFurnitureinvoice, item => Number(item.boq_during_construction_period ?? item.officefurniture_details.during_construction_period)))}</td>

                                    <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(calculateTotal(officeFurnitureinvoice, item => Number(item.boq_during_dlp_OM_period ?? item.officefurniture_details.during_dlp_OM_period)))}</td>

                                    <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(calculateTotal(officeFurnitureinvoice, item => Number(item.boq_num_of_months ?? item.officefurniture_details?.num_of_months)))}</td>

                                    <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatAmount0(calculateTotal(officeFurnitureinvoice, item => Number(item.boq_rate_per_month ?? item.officefurniture_details.rate_per_month)))}</span></td>

                                    <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatAmount0(calculateTotal(officeFurnitureinvoice, item => Number(item.boq_rate_per_month ?? item.officefurniture_details.rate_per_month) * Number(item.boq_num_of_months ?? item.officefurniture_details.num_of_months)))}</span></td>



                                    {usefor !== "generateinvoice" && (

                                        <>

                                            <td className="boc-modern-td boc-nowrap text-right">

                                                {formatMonth2(officeFurnitureinvoice.reduce((gt, item) => { const m = deductionData?.filter(d => d.item_id === item.id) || []; return gt + m.reduce((s, d) => s + (Number(d?.deduction_month) || 0), 0); }, 0))}

                                            </td>

                                            <td className="boc-modern-td boc-nowrap text-right">



                                                <span className="boc-modern-currency boc-modern-footer-total">

                                                    ₹ {formatAmount0(

                                                        Number(

                                                            officeFurnitureinvoice.reduce((gt, item) => {

                                                                const m = deductionData?.filter(d => d.item_id === item.id) || [];

                                                                return gt + m.reduce((s, d) => s + ((Number(d?.deduction_amount) || 0) + (Number(d?.withheld_deduction_amount) || 0)), 0);

                                                            }, 0)

                                                        )

                                                    )}

                                                </span>

                                            </td>

                                        </>

                                    )}





                                    {isEotDataTrue && Array.from({ length: eotLengths }).map((_, eotIdx) => {

                                        const totals = officeFurnitureinvoice.reduce((acc, emp) => {

                                            const details = emp.eot_details?.length > 0 ? emp.eot_details : emp.data?.eot_details || [];

                                            const eot = details[eotIdx];

                                            if (!eot) return acc;

                                            acc.cp += Number(eot?.cp) || 0; acc.dlp += Number(eot?.dlp) || 0;

                                            acc.t_month += Number(eot?.t_month) || 0; acc.rate += Number(eot?.rate) || 0;

                                            acc.total_amount += Number(eot?.total_amount) || 0;

                                            return acc;

                                        }, { cp: 0, dlp: 0, t_month: 0, rate: 0, total_amount: 0 });

                                        return (

                                            <React.Fragment key={eotIdx}>

                                                <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(totals.cp)}</td>

                                                <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(totals.dlp)}</td>

                                                <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(totals.t_month)}</td>

                                                <td className="boc-modern-td boc-nowrap text-right">₹ {formatAmount0(totals.rate)}</td>

                                                <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatAmount0(totals.total_amount)}</span></td>

                                            </React.Fragment>

                                        );

                                    })}



                                    <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(calculateTotal(officeFurnitureinvoice, item => Number(item.actual_month_total_previous)))}</td>

                                    <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatAmount0(calculateTotal(officeFurnitureinvoice, item => Number(item.previous_invoice_total)))}</span></td>

                                    <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(calculateTotal(officeFurnitureinvoice, item => Number(item.actual_month)))}</td>

                                    <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatAmount0(calculateTotal(officeFurnitureinvoice, item => Number(item.invoice_amount ?? item.current_invoice_amount)))}</span></td>

                                    <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(calculateTotal(officeFurnitureinvoice, item => Number(item.actual_month_cumulative_total)))}</td>

                                    <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatAmount0(calculateTotal(officeFurnitureinvoice, item => Number(item.cumulative_invoice_total)))}</span></td>

                                    <td className="boc-modern-td boc-nowrap text-right">{formatMonth2(calculateTotal(officeFurnitureinvoice, item => Number(item.actual_month_remaining)))}</td>

                                    <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatAmount0(calculateTotal(officeFurnitureinvoice, item => Number(item.remaining_amount)))}</span></td>

                                    {role !== "SiteManagement" && role !== "ViewAccess" && <td className="hide-on-print boc-modern-td"></td>}

                                </tr>

                            </tfoot>

                        </table>

                    </div>

                </div>

            </div>

        </div>

    );

};

const ReportsPrintt = ({ setEotDetails, deductionData, projectData, client, p_id, invoice_id, month, year, invoice_num, logData,
    setPreviousAmount,
    setCurrentAmount,
    setRemainingAmount,
    setContractAmount,
    setExcelRows,
    setCumulated,
    usefor
}) => {

    const currentDate = new Date();
    const isFirstWeek = currentDate.getDate() <= 7;
    const [reportsPrinttinvoice, setReportsPrinttinvoice] = useState([]);
    const project = sessionStorage.getItem('sitemanagement_project');

    const calculateContractAmount = calculateTotal(reportsPrinttinvoice, (item) => Number(item.boq_rate_per_copy ?? item.reportanddoc_details.rate_per_copy) * ((Number(item.boq_num_of_copies_per_report ?? item.reportanddoc_details.num_of_copies_per_report) * Number(item.boq_num_of_reports ?? item.reportanddoc_details.num_of_reports))))
    setContractAmount(calculateContractAmount);
    const calculatePreviousAmount = calculateTotal(reportsPrinttinvoice, (item) => Number(item.previous_invoice_total))
    setPreviousAmount(calculatePreviousAmount);
    const calculateCurrentAmount = calculateTotal(reportsPrinttinvoice, (item) => Number(item.invoice_amount ?? item.current_invoice_amount))
    setCurrentAmount(calculateCurrentAmount);
    const calculateCumulated = calculateTotal(reportsPrinttinvoice, (item) => Number(item.cumulative_invoice_total))
    setCumulated(calculateCumulated);
    const calculateRemaining = calculateTotal(reportsPrinttinvoice, (item) => Number(item.remaining_amount))
    setRemainingAmount(calculateRemaining);

    useEffect(() => {
        const eotGroups = [];
        reportsPrinttinvoice.forEach(item => {
            (item?.eot_details || []).forEach((eot, idx) => {
                if (!eotGroups[idx]) {
                    eotGroups[idx] = { ...eot, total_amount: 0 };
                }
                eotGroups[idx].total_amount += Number(eot.total_amount || 0);
            });
        });

        setEotDetails(eotGroups);
    }, [reportsPrinttinvoice]);

    const role = sessionStorage.getItem('sitemanagement_role');

    const getReportsPrinttinvoice = async () => {
        try {
            let data;

            if (usefor === "generateinvoice") {
                const res = await axios.get(
                    `${BASE_URL}/siteproject/invoicereportsanddocprintstatusbyproject/${p_id ? p_id : project}/${month}/${year}/`
                );
                data = res.data;
            } else {
                const response2 = await axios.get(
                    `${BASE_URL}/siteproject/newinvoicereportsanddocumentprintingfiltermonthyear/${invoice_id}/null/null/`
                );
                data = response2.data;
            }

            const isAnyBoqJsonNull = data.length !== 0 && data.every(item => item.boq_json === null);


            const selectedData = isAnyBoqJsonNull ? data : data;
            setReportsPrinttinvoice(selectedData);
        } catch (err) { }

    };




    useEffect(() => {

        // getdocument();
        getReportsPrinttinvoice();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const isEotDataTrue = reportsPrinttinvoice.some(i =>
        (i.eot_details?.length > 0) || (i.data?.eot_details?.length > 0)
    );





    const eotLengths = Math.max(
        ...reportsPrinttinvoice.map(i => i?.eot_details?.length || i?.data?.eot_details?.length || 0),
        0
    );
    const r2 = (val) => {
        const n = Number(val);
        return isNaN(n) ? 0 : Math.round(n * 100) / 100;
    };

    // ── Builds a fully formatted AOA sheet (merged headers, flat rows) ──
    const buildExcelSheetData = () => {
        const showDeduction = usefor !== "generateinvoice";

        // ---- figure out column layout ----
        let col = 0;
        const SNO_COL = col++;                  // 0
        const DESC_COL = col++;                 // 1
        const CONTRACT_START = col; col += 5;   // No. of Reports, No. of Copies/Report, Total Copies, Rate/Copy, Total Amount
        let DED_REPORTS_COL = -1, DED_AMT_COL = -1;
        if (showDeduction) {
            DED_REPORTS_COL = col++;
            DED_AMT_COL = col++;
        }
        const EOT_START = col; col += eotLengths * 5;   // 5 cols per EOT group
        const PREV_START = col; col += 2;   // No of Reports, Amount
        const CUR_START = col; col += 2;
        const CUM_START = col; col += 2;
        const REM_START = col; col += 2;
        const TOTAL_COLS = col;

        const blankRow = () => new Array(TOTAL_COLS).fill("");

        // ---- header row 1 (group labels) ----
        const row1 = blankRow();
        row1[SNO_COL] = "S.No";
        row1[DESC_COL] = "Description";
        row1[CONTRACT_START] = "Contract Amount";
        if (showDeduction) {
            row1[DED_REPORTS_COL] = "Deduction Reports";
            row1[DED_AMT_COL] = "Deduction Amount";
        }
        for (let i = 0; i < eotLengths; i++) {
            row1[EOT_START + i * 5] = `EOT ${i + 1}`;
        }
        row1[PREV_START] = "Cumulative Total of Previous Months";
        row1[CUR_START] = "This Period";
        row1[CUM_START] = "Cumulative Total Including Current Invoice";
        row1[REM_START] = "Remaining Amount Against Contract Value";

        // ---- header row 2 (sub labels) ----
        const row2 = blankRow();
        row2[CONTRACT_START] = "No. of Reports";
        row2[CONTRACT_START + 1] = "No. of Copies/Report";
        row2[CONTRACT_START + 2] = "Total Copies";
        row2[CONTRACT_START + 3] = "Rate/Copy";
        row2[CONTRACT_START + 4] = "Total Amount";
        for (let i = 0; i < eotLengths; i++) {
            const c = EOT_START + i * 5;
            row2[c] = "No. of Reports";
            row2[c + 1] = "No. of Copies/Report";
            row2[c + 2] = "Total Copies";
            row2[c + 3] = "Rate/Copy";
            row2[c + 4] = "Total Amount";
        }
        row2[PREV_START] = "No of Reports"; row2[PREV_START + 1] = "Amount";
        row2[CUR_START] = "No of Reports"; row2[CUR_START + 1] = "Amount";
        row2[CUM_START] = "No of Reports"; row2[CUM_START + 1] = "Amount";
        row2[REM_START] = "No of Reports"; row2[REM_START + 1] = "Amount";

        // ---- merges for the two header rows ----
        const merges = [];
        const vMerge = (c) => merges.push({ s: { r: 0, c }, e: { r: 1, c } });
        const hMerge = (c1, c2) => merges.push({ s: { r: 0, c: c1 }, e: { r: 0, c: c2 } });

        vMerge(SNO_COL); vMerge(DESC_COL);
        if (showDeduction) { vMerge(DED_REPORTS_COL); vMerge(DED_AMT_COL); }
        hMerge(CONTRACT_START, CONTRACT_START + 4);
        for (let i = 0; i < eotLengths; i++) {
            const c = EOT_START + i * 5;
            hMerge(c, c + 4);
        }
        hMerge(PREV_START, PREV_START + 1);
        hMerge(CUR_START, CUR_START + 1);
        hMerge(CUM_START, CUM_START + 1);
        hMerge(REM_START, REM_START + 1);

        // ---- data rows (flat — no sections for reports & printing) ----
        const rows = [row1, row2];

        reportsPrinttinvoice.forEach((item, index) => {
            const numReports = Number(item.boq_num_of_reports ?? item.reportanddoc_details.num_of_reports) || 0;
            const copiesPerReport = Number(item.boq_num_of_copies_per_report ?? item.reportanddoc_details.num_of_copies_per_report) || 0;
            const totalCopies = numReports * copiesPerReport;
            const ratePerCopy = Number(item.boq_rate_per_copy ?? item.reportanddoc_details.rate_per_copy) || 0;
            const totalAmt = ratePerCopy * numReports * copiesPerReport;

            const matchedDeductions = deductionData?.filter((d) => d.item_id === item.id) || [];
            const deductionReportsSum = matchedDeductions.reduce((s, n) => s + (Number(n.deduction_month) || 0), 0);
            const deductionAmountSum = matchedDeductions.reduce((s, n) => s + ((Number(n.deduction_amount) + Number(n.withheld_deduction_amount)) || 0), 0);

            const r = blankRow();
            r[SNO_COL] = index + 1;
            r[DESC_COL] = item.boq_description ?? item.reportanddoc_details.description ?? "";
            r[CONTRACT_START] = r2(numReports);
            r[CONTRACT_START + 1] = r2(copiesPerReport);
            r[CONTRACT_START + 2] = r2(totalCopies);
            r[CONTRACT_START + 3] = r2(ratePerCopy);
            r[CONTRACT_START + 4] = r2(totalAmt);
            if (showDeduction) {
                r[DED_REPORTS_COL] = r2(deductionReportsSum);
                r[DED_AMT_COL] = r2(deductionAmountSum);
            }
            (item.eot_details || []).forEach((e, i) => {
                const c = EOT_START + i * 5;
                r[c] = r2(e.num_of_reports);
                r[c + 1] = r2(e.num_of_copies_per_report);
                r[c + 2] = r2(e.t_reports);
                r[c + 3] = r2(e.rate_per_copy);
                r[c + 4] = r2(e.total_amount);
            });
            r[PREV_START] = r2(item.actual_month_total_previous);
            r[PREV_START + 1] = r2(item.previous_invoice_total);
            r[CUR_START] = r2(item.actual_month);
            r[CUR_START + 1] = r2(item.invoice_amount);
            r[CUM_START] = r2(item.actual_month_cumulative_total);
            r[CUM_START + 1] = r2(item.cumulative_invoice_total);
            r[REM_START] = r2(item.actual_month_remaining);
            r[REM_START + 1] = r2(item.remaining_amount);

            rows.push(r);
        });

        // ---- totals row ----
        const totalRow = blankRow();
        totalRow[DESC_COL] = "Total:";
        totalRow[CONTRACT_START] = r2(calculateTotal(reportsPrinttinvoice, item => Number(item.boq_num_of_reports ?? item.reportanddoc_details.num_of_reports)));
        totalRow[CONTRACT_START + 1] = r2(calculateTotal(reportsPrinttinvoice, item => Number(item.boq_num_of_copies_per_report ?? item.reportanddoc_details.num_of_copies_per_report)));
        totalRow[CONTRACT_START + 2] = r2(calculateTotal(reportsPrinttinvoice, item => Number(item.boq_num_of_reports ?? item.reportanddoc_details.num_of_reports) * Number(item.boq_num_of_copies_per_report ?? item.reportanddoc_details.num_of_copies_per_report)));
        totalRow[CONTRACT_START + 3] = r2(calculateTotal(reportsPrinttinvoice, item => Number(item.boq_rate_per_copy ?? item.reportanddoc_details.rate_per_copy)));
        totalRow[CONTRACT_START + 4] = r2(calculateContractAmount);

        if (showDeduction) {
            totalRow[DED_REPORTS_COL] = r2(reportsPrinttinvoice.reduce((gt, item) => {
                const m = deductionData?.filter(d => d.item_id === item.id) || [];
                return gt + m.reduce((s, d) => s + (Number(d?.deduction_month) || 0), 0);
            }, 0));
            totalRow[DED_AMT_COL] = r2(reportsPrinttinvoice.reduce((gt, item) => {
                const m = deductionData?.filter(d => d.item_id === item.id) || [];
                return gt + m.reduce((s, d) => s + ((Number(d?.deduction_amount) || 0) + (Number(d?.withheld_deduction_amount) || 0)), 0);
            }, 0));
        }

        for (let eotIdx = 0; eotIdx < eotLengths; eotIdx++) {
            const totals = reportsPrinttinvoice.reduce((acc, emp) => {
                const details = emp.eot_details?.length > 0 ? emp.eot_details : emp.data?.eot_details || [];
                const eot = details[eotIdx];
                if (!eot) return acc;
                acc.num_of_reports += Number(eot?.num_of_reports) || 0;
                acc.num_of_copies_per_report += Number(eot?.num_of_copies_per_report) || 0;
                acc.t_reports += Number(eot?.t_reports) || 0;
                acc.rate_per_copy += Number(eot?.rate_per_copy) || 0;
                acc.total_amount += Number(eot?.total_amount) || 0;
                return acc;
            }, { num_of_reports: 0, num_of_copies_per_report: 0, t_reports: 0, rate_per_copy: 0, total_amount: 0 });
            const c = EOT_START + eotIdx * 5;
            totalRow[c] = r2(totals.num_of_reports);
            totalRow[c + 1] = r2(totals.num_of_copies_per_report);
            totalRow[c + 2] = r2(totals.t_reports);
            totalRow[c + 3] = r2(totals.rate_per_copy);
            totalRow[c + 4] = r2(totals.total_amount);
        }

        totalRow[PREV_START] = r2(calculateTotal(reportsPrinttinvoice, item => Number(item.actual_month_total_previous)));
        totalRow[PREV_START + 1] = r2(calculatePreviousAmount);
        totalRow[CUR_START] = r2(calculateTotal(reportsPrinttinvoice, item => Number(item.actual_month)));
        totalRow[CUR_START + 1] = r2(calculateCurrentAmount);
        totalRow[CUM_START] = r2(calculateTotal(reportsPrinttinvoice, item => Number(item.actual_month_cumulative_total)));
        totalRow[CUM_START + 1] = r2(calculateCumulated);
        totalRow[REM_START] = r2(calculateTotal(reportsPrinttinvoice, item => Number(item.actual_month_remaining)));
        totalRow[REM_START + 1] = r2(calculateRemaining);
        rows.push(totalRow);

        const colWidths = new Array(TOTAL_COLS).fill({ wch: 14 });
        colWidths[SNO_COL] = { wch: 6 };
        colWidths[DESC_COL] = { wch: 22 };

        return { rows, merges, colWidths, sheetName: "Reports & Printing" };
    };
    useEffect(() => {
        if (reportsPrinttinvoice.length > 0 && typeof setExcelRows === "function") {
            setExcelRows(buildExcelSheetData());
        }
    }, [reportsPrinttinvoice, deductionData]);


    return (
        <div className="boc-modern-wrapper" style={{ minHeight: "30vh" }}>
            <div className="boc-modern-card">

                <div className="boc-modern-header bocx-modern-footer-total">
                    <div className="boc-modern-header-content">
                        <div className="boc-modern-project-info">
                            <h3 className="boc-modern-project-title">{projectData?.project_name}</h3>
                            <div className="boc-modern-project-meta">
                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Client:</span><span className="boc-modern-meta-value">{projectData?.client_name}</span></div>
                                <div className="boc-modern-meta-divider"></div>
                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Consultant (AE):</span><span className="boc-modern-meta-value">{projectData?.lead}{projectData?.jv ? ` JV with ${projectData?.jv}.` : ""}{projectData?.association ? ` Association with ${projectData?.association}` : ""}</span></div>
                                <div className="boc-modern-meta-divider"></div>
                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">GSTIN:</span><span className="boc-modern-meta-value">{projectData?.gst_no}</span></div>
                                <div className="boc-modern-meta-divider"></div>
                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">PAN:</span><span className="boc-modern-meta-value">{projectData?.pan_no}</span></div>
                                <div className="boc-modern-meta-divider"></div>
                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Bid Due:</span><span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.bid_due_date)}</span></div>
                                <div className="boc-modern-meta-divider"></div>
                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Agreement:</span><span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.agreement_date)}</span></div>
                                <div className="boc-modern-meta-divider"></div>
                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Start:</span><span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.commencement_date)}</span></div>
                                <div className="boc-modern-meta-divider"></div>
                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Invoice Number:</span><span className="boc-modern-meta-value">{invoice_num}</span></div>
                                <div className="boc-modern-meta-divider"></div>
                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Date:</span><span className="boc-modern-meta-value">{getMonthName(month)}-{year}</span></div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="boc-modern-description-section">
                    <div className="boc-modern-controls">
                        <div className="boc-modern-controls-left">
                            <h6 className="boc-modern-main-heading">8- Report and Document Printing</h6>
                        </div>
                        {role !== "ViewAccess" && (
                            <div className="hide-on-print">
                                {usefor === "generateinvoice"
                                    ? <>
                                        {reportsPrinttinvoice.length === 0
                                            ? <ReportsPrinttInvoice
                                                usedfor="InvoiceandDeduction"
                                                p_id={p_id ? p_id : project}
                                                invoice_id={invoice_id}
                                                getReportsPrinttinvoice={getReportsPrinttinvoice}
                                                month={month}
                                                year={year}
                                                logData={logData}
                                            />
                                            : <UpdateReportsPrinttInvoice
                                                usedfor="InvoiceandDeduction"
                                                invoiceData={reportsPrinttinvoice}
                                                p_id={p_id ? p_id : project}
                                                invoice_id={invoice_id}
                                                getReportsPrinttinvoice={getReportsPrinttinvoice}
                                                month={month}
                                                year={year}
                                                logData={logData}
                                            />}
                                    </>
                                    : <>
                                        {reportsPrinttinvoice.length === 0
                                            ? <ReportsPrinttInvoice invoiceData={reportsPrinttinvoice} usedfor="OnlyDeduction" p_id={p_id ? p_id : project} invoice_id={invoice_id} getReportsPrinttinvoice={getReportsPrinttinvoice} month={month} year={year} logData={logData} />
                                            : <UpdateReportsDeductionInvoice invoiceData={reportsPrinttinvoice} getData={getReportsPrinttinvoice} />}
                                    </>
                                }
                            </div>
                        )}
                    </div>
                </div>

                <div className="boc-modern-table-wrapper">
                    <div className="boc-modern-table-scroll">
                        <table className="boc-modern-table">
                            <thead>
                                <tr className="boc-modern-table-header">
                                    <th className="boc-modern-th text-center" rowSpan="4">S.No</th>
                                    <th className="boc-modern-th text-center" rowSpan="4">Description</th>
                                    <th className="boc-modern-th text-center" colSpan="5">Contract Amount</th>
                                    {usefor !== "generateinvoice" && (
                                        <>
                                            <th className="boc-modern-th text-center" rowSpan="4">Deduction Reports</th>
                                            <th className="boc-modern-th text-center" rowSpan="4">Deduction Amount</th>
                                        </>
                                    )}
                                    {isEotDataTrue && <th className="boc-modern-th text-center" colSpan={eotLengths * 5 || 1}>(COS/EOT)</th>}
                                    <th className="boc-modern-th text-center" colSpan="2">Cumulative Total of Previous Months</th>
                                    <th className="boc-modern-th text-center" colSpan="2">This Period</th>
                                    <th className="boc-modern-th text-center" colSpan="2">Cumulative Total Including Current Invoice</th>
                                    <th className="boc-modern-th text-center" colSpan="2">Remaining Amount Against Contract Value</th>
                                    {role !== "SiteManagement" && role !== "ViewAccess" && <th className="boc-modern-th text-center hide-on-print" rowSpan="4">Action</th>}
                                </tr>
                                <tr className="boc-modern-table-subheader">
                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">No. of Reports</th>
                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">No. of Copies / Report</th>
                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Total Copies</th>
                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Rate / Copy</th>
                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Total Amount</th>
                                    {Array.from({ length: eotLengths }).map((_, idx) => (
                                        <th key={idx} className="boc-modern-th text-center boc-nowrap" colSpan={5}>{`EOT ${idx + 1}`}</th>
                                    ))}
                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">No of Reports</th>
                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Amount</th>
                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">No of Reports</th>
                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Amount</th>
                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">No of Reports</th>
                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Amount</th>
                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">No of Reports</th>
                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Amount</th>
                                </tr>
                                <tr className="boc-modern-table-subheader">
                                    {Array.from({ length: eotLengths }).map((_, idx) => (
                                        <React.Fragment key={idx}>
                                            <th rowSpan="2" className="boc-modern-th boc-nowrap">No. of Reports</th>
                                            <th rowSpan="2" className="boc-modern-th boc-nowrap">No. of Copies / Report</th>
                                            <th rowSpan="2" className="boc-modern-th boc-nowrap">Total Copies</th>
                                            <th rowSpan="2" className="boc-modern-th boc-nowrap">Rate / Copy</th>
                                            <th rowSpan="2" className="boc-modern-th boc-nowrap">Total Amount</th>
                                        </React.Fragment>
                                    ))}
                                </tr>
                            </thead>

                            <tbody>
                                {reportsPrinttinvoice.map((item, index) => {
                                    const matchedDeductions = deductionData?.filter(d => d.item_id === item.id) || [];
                                    return (
                                        <tr className="boc-modern-row" key={item.id}>
                                            <td className="boc-modern-td text-center">{index + 1}.</td>
                                            <td className="boc-modern-td"><div style={{ whiteSpace: "normal", width: "120px" }}>{item.boq_description ?? item.reportanddoc_details.description}</div></td>
                                            <td className="boc-modern-td boc-nowrap text-right">{formatCurrencyIndian(Number(item.boq_num_of_reports ?? item.reportanddoc_details.num_of_reports))}</td>
                                            <td className="boc-modern-td boc-nowrap text-right">{formatCurrencyIndian(Number(item.boq_num_of_copies_per_report ?? item.reportanddoc_details.num_of_copies_per_report))}</td>
                                            <td className="boc-modern-td boc-nowrap text-right">{formatCurrencyIndian(Number(item.boq_num_of_reports ?? item.reportanddoc_details.num_of_reports) * Number(item.boq_num_of_copies_per_report ?? item.reportanddoc_details.num_of_copies_per_report))}</td>
                                            <td className="boc-modern-td boc-nowrap boc-modern-currency text-right">₹ {formatCurrencyIndian(Number(item.boq_rate_per_copy ?? item.reportanddoc_details.rate_per_copy))}</td>
                                            <td className="boc-modern-td boc-nowrap text-right">
                                                <span className="boc-modern-currency boc-modern-total-highlight">
                                                    ₹ {formatCurrencyIndian(Number(item.boq_rate_per_copy ?? item.reportanddoc_details.rate_per_copy) * Number(item.boq_num_of_reports ?? item.reportanddoc_details.num_of_reports) * Number(item.boq_num_of_copies_per_report ?? item.reportanddoc_details.num_of_copies_per_report))}
                                                </span>
                                            </td>

                                            {usefor !== "generateinvoice" && (
                                                <td className="boc-modern-td boc-nowrap text-right justify-end" style={{ padding: 0 }}>
                                                    {matchedDeductions.length > 0
                                                        ? matchedDeductions.map((n, i) => <div key={i} className="boc-multi-item boc-nowrap">{n.deduction_month ?? "-"}</div>)
                                                        : <div className="boc-multi-item">-</div>}
                                                </td>
                                            )}
                                            {usefor !== "generateinvoice" && (
                                                <td className="boc-modern-td boc-nowrap text-right justify-end" style={{ padding: 0 }}>
                                                    {matchedDeductions.length > 0
                                                        ? matchedDeductions.map((n, i) => <div key={i} className="boc-multi-item boc-nowrap">{Number(n.deduction_amount) + Number(n.withheld_deduction_amount) || 0}</div>)
                                                        : <div className="boc-multi-item">0</div>}
                                                </td>
                                            )}

                                            {item?.eot_details?.length > 0 && item.eot_details.map((i, idx) => (
                                                <React.Fragment key={idx}>
                                                    <td className="boc-modern-td boc-nowrap text-right">{i.num_of_reports}</td>
                                                    <td className="boc-modern-td boc-nowrap text-right">{i.num_of_copies_per_report}</td>
                                                    <td className="boc-modern-td boc-nowrap text-right">{i.t_reports}</td>
                                                    <td className="boc-modern-td boc-nowrap boc-modern-currency text-right">₹ {formatCurrencyIndian(Number(i.rate_per_copy))}</td>
                                                    <td className="boc-modern-td boc-nowrap boc-modern-currency text-right">₹ {formatCurrencyIndian(Number(i.total_amount))}</td>
                                                </React.Fragment>
                                            ))}

                                            <td className="boc-modern-td boc-nowrap text-right">{formatCurrencyIndian(Number(item.actual_month_total_previous))}</td>
                                            <td className="boc-modern-td boc-nowrap boc-modern-currency text-right">₹ {formatCurrencyIndian(Number(item.previous_invoice_total))}</td>
                                            <td className="boc-modern-td boc-nowrap text-right">{formatCurrencyIndian(Number(item.actual_month))}</td>
                                            <td className="boc-modern-td boc-nowrap boc-modern-currency text-right">₹ {formatCurrencyIndian(Number(item.invoice_amount))}</td>
                                            <td className="boc-modern-td boc-nowrap text-right">{formatCurrencyIndian(Number(item.actual_month_cumulative_total))}</td>
                                            <td className="boc-modern-td boc-nowrap boc-modern-currency text-right">₹ {formatCurrencyIndian(Number(item.cumulative_invoice_total))}</td>
                                            <td className="boc-modern-td boc-nowrap text-right">{formatCurrencyIndian(Number(item.actual_month_remaining))}</td>
                                            <td className="boc-modern-td boc-nowrap text-right">
                                                <span className="boc-modern-currency boc-modern-total-highlight">₹ {formatCurrencyIndian(Number(item.remaining_amount))}</span>
                                            </td>

                                            {(usefor === "generateinvoice" || role !== "ViewAccess") && (
                                                <>
                                                    {(!["Checker", "SiteManagement"].includes(role)) || (role === "Checker" && !isMoreThan24Hours(item.created_at)) ? (
                                                        <td className="boc-modern-td text-center hide-on-print">
                                                            {usefor === "generateinvoice"
                                                                ? <DeleteReportsPrinttInvoice i={item} getReportsPrinttinvoice={getReportsPrinttinvoice} />
                                                                : <DeleteReportsPrinttInvoiceDeduction i={item} getReportsPrinttinvoice={getReportsPrinttinvoice} />}
                                                        </td>
                                                    ) : <td className="boc-modern-td text-center hide-on-print">-</td>}
                                                </>
                                            )}
                                        </tr>
                                    );
                                })}
                            </tbody>

                            <tfoot>
                                <tr className="boc-modern-footer">
                                    <td colSpan="2" className="boc-modern-footer-label">Total:</td>
                                    <td className="boc-modern-td boc-nowrap text-right">{formatCurrencyIndian(calculateTotal(reportsPrinttinvoice, item => Number(item.boq_num_of_reports ?? item.reportanddoc_details.num_of_reports)))}</td>
                                    <td className="boc-modern-td boc-nowrap text-right">{formatCurrencyIndian(calculateTotal(reportsPrinttinvoice, item => Number(item.boq_num_of_copies_per_report ?? item.reportanddoc_details.num_of_copies_per_report)))}</td>
                                    <td className="boc-modern-td boc-nowrap text-right">{formatCurrencyIndian(calculateTotal(reportsPrinttinvoice, item => Number(item.boq_num_of_reports ?? item.reportanddoc_details.num_of_reports) * Number(item.boq_num_of_copies_per_report ?? item.reportanddoc_details.num_of_copies_per_report)))}</td>
                                    <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatCurrencyIndian(calculateTotal(reportsPrinttinvoice, item => Number(item.boq_rate_per_copy ?? item.reportanddoc_details.rate_per_copy)))}</span></td>
                                    <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatCurrencyIndian(calculateTotal(reportsPrinttinvoice, item => Number(item.boq_rate_per_copy ?? item.reportanddoc_details.rate_per_copy) * Number(item.boq_num_of_reports ?? item.reportanddoc_details.num_of_reports) * Number(item.boq_num_of_copies_per_report ?? item.reportanddoc_details.num_of_copies_per_report)))}</span></td>
                                    {usefor !== "generateinvoice" && (
                                        <>
                                            <td className="boc-modern-td boc-nowrap text-right">
                                                {reportsPrinttinvoice.reduce((gt, item) => {
                                                    const m = deductionData?.filter(d => d.item_id === item.id) || [];
                                                    return gt + m.reduce((s, d) => s + (Number(d?.deduction_month) || 0), 0);
                                                }, 0)}
                                            </td>
                                            <td className="boc-modern-td boc-nowrap text-right">
                                                <span className="boc-modern-currency boc-modern-footer-total">
                                                    ₹ {formatCurrencyIndian(
                                                        reportsPrinttinvoice.reduce((gt, item) => {
                                                            const m = deductionData?.filter(d => d.item_id === item.id) || [];
                                                            return gt + m.reduce((s, d) => s + ((Number(d?.deduction_amount) || 0) + (Number(d?.withheld_deduction_amount) || 0)), 0);
                                                        }, 0)
                                                    )}
                                                </span>
                                            </td>
                                        </>
                                    )}

                                    {isEotDataTrue && Array.from({ length: eotLengths }).map((_, eotIdx) => {
                                        const totals = reportsPrinttinvoice.reduce((acc, emp) => {
                                            const details = emp.eot_details?.length > 0 ? emp.eot_details : emp.data?.eot_details || [];
                                            const eot = details[eotIdx];
                                            if (!eot) return acc;
                                            acc.num_of_reports += Number(eot?.num_of_reports) || 0;
                                            acc.num_of_copies_per_report += Number(eot?.num_of_copies_per_report) || 0;
                                            acc.t_reports += Number(eot?.t_reports) || 0;
                                            acc.rate_per_copy += Number(eot?.rate_per_copy) || 0;
                                            acc.total_amount += Number(eot?.total_amount) || 0;
                                            return acc;
                                        }, { num_of_reports: 0, num_of_copies_per_report: 0, t_reports: 0, rate_per_copy: 0, total_amount: 0 });
                                        return (
                                            <React.Fragment key={eotIdx}>
                                                <td className="boc-modern-td boc-nowrap text-right">{formatCurrencyIndian(totals.num_of_reports)}</td>
                                                <td className="boc-modern-td boc-nowrap text-right">{formatCurrencyIndian(totals.num_of_copies_per_report)}</td>
                                                <td className="boc-modern-td boc-nowrap text-right">{totals.t_reports}</td>
                                                <td className="boc-modern-td boc-nowrap text-right">₹ {formatCurrencyIndian(totals.rate_per_copy)}</td>
                                                <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatCurrencyIndian(totals.total_amount)}</span></td>
                                            </React.Fragment>
                                        );
                                    })}

                                    <td className="boc-modern-td boc-nowrap text-right">{formatCurrencyIndian(calculateTotal(reportsPrinttinvoice, item => Number(item.actual_month_total_previous)))}</td>
                                    <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatCurrencyIndian(calculateTotal(reportsPrinttinvoice, item => Number(item.previous_invoice_total)))}</span></td>
                                    <td className="boc-modern-td boc-nowrap text-right">{formatCurrencyIndian(calculateTotal(reportsPrinttinvoice, item => Number(item.actual_month)))}</td>
                                    <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatCurrencyIndian(calculateTotal(reportsPrinttinvoice, item => Number(item.invoice_amount)))}</span></td>
                                    <td className="boc-modern-td boc-nowrap text-right">{formatCurrencyIndian(calculateTotal(reportsPrinttinvoice, item => Number(item.actual_month_cumulative_total)))}</td>
                                    <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatCurrencyIndian(calculateTotal(reportsPrinttinvoice, item => Number(item.cumulative_invoice_total)))}</span></td>
                                    <td className="boc-modern-td boc-nowrap text-right">{formatCurrencyIndian(calculateTotal(reportsPrinttinvoice, item => Number(item.actual_month_remaining)))}</td>
                                    <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatCurrencyIndian(calculateTotal(reportsPrinttinvoice, item => Number(item.remaining_amount)))}</span></td>
                                    {role !== "SiteManagement" && role !== "ViewAccess" && <td className="hide-on-print boc-modern-td"></td>}
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );


};


// const RoadSurvey = ({ deductionData, projectData, client, p_id, invoice_id, year, month, invoice_num, logData,
//     setPreviousAmount,
//     setCurrentAmount,
//     setRemainingAmount,
//     setContractAmount,
//     setExcelRows,
//     setCumulated,
//     usefor,
//     setEotDetails
// }) => {

//     const [roadSurveyinvoice, setRoadSurveyinvoice] = useState([]);

//     const role = sessionStorage.getItem('sitemanagement_role');
//     const project = sessionStorage.getItem('sitemanagement_project');
//     const calculateContractAmount = calculateTotal(roadSurveyinvoice, (item) => Number(item.boq_rate_per_km_times ?? item.roadsurvey_details.rate_per_km_times) * (Number(item.boq_num_of_times_survey_concluded ?? item.roadsurvey_details.num_of_times_survey_concluded)) * Number(item.boq_KM ?? item.roadsurvey_details.KM))
//     setContractAmount(calculateContractAmount);
//     const calculatePreviousAmount = calculateTotal(roadSurveyinvoice, (item) => Number(item.previous_invoice_total))
//     setPreviousAmount(calculatePreviousAmount);
//     const calculateCurrentAmount = calculateTotal(roadSurveyinvoice, (item) => Number(item.invoice_amount ?? item.current_invoice_amount))
//     setCurrentAmount(calculateCurrentAmount);
//     const calculateCumulated = calculateTotal(roadSurveyinvoice, (item) => Number(item.cumulative_invoice_total))
//     setCumulated(calculateCumulated);
//     const calculateRemaining = calculateTotal(roadSurveyinvoice, (item) => Number(item.remaining_amount))
//     setRemainingAmount(calculateRemaining);

//     useEffect(() => {
//         const eotGroups = [];
//         roadSurveyinvoice.forEach(item => {
//             (item?.eot_details || []).forEach((eot, idx) => {
//                 if (!eotGroups[idx]) {
//                     eotGroups[idx] = { ...eot, total_amount: 0 };
//                 }
//                 eotGroups[idx].total_amount += Number(eot.total_amount || 0);
//             });
//         });

//         setEotDetails(eotGroups);
//     }, [roadSurveyinvoice]);

//     const currentDate = new Date();
//     const isFirstWeek = currentDate.getDate() <= 7;

//     const getRoadSurveyinvoice = async () => {
//         try {
//             let data;

//             if (usefor === "generateinvoice") {
//                 const res = await axios.get(
//                     `${BASE_URL}/siteproject/invoiceroadsurveyequipmentStatusbyproject/${p_id ? p_id : project}/${month}/${year}/`
//                 );
//                 data = res.data;
//             } else {
//                 const response2 = await axios.get(
//                     `${BASE_URL}/siteproject/newinvoiceroadsurveyequipmentfiltermonthyear/${invoice_id}/null/null/`
//                 );
//                 data = response2.data;
//             }

//             const isAnyBoqJsonNull = data.length !== 0 && data.every(item => item.boq_json === null);


//             const selectedData = isAnyBoqJsonNull ? data : data;
//             setRoadSurveyinvoice(selectedData);
//         } catch (err) { }

//     };

//     useEffect(() => {

//         // getdocument();
//         getRoadSurveyinvoice();
//         // eslint-disable-next-line react-hooks/exhaustive-deps
//     }, []);

//     const isEotDataTrue = roadSurveyinvoice.some(i =>
//         (i.eot_details?.length > 0) || (i.data?.eot_details?.length > 0)
//     );





//     const eotLengths = Math.max(
//         ...roadSurveyinvoice.map(i => i?.eot_details?.length || i?.data?.eot_details?.length || 0),
//         0
//     );

//     const r2 = (val) => {
//         const n = Number(val);
//         return isNaN(n) ? 0 : Math.round(n * 100) / 100;
//     };

//     // ── Builds a fully formatted AOA sheet (merged headers, flat rows) ──
//     const buildExcelSheetData = () => {
//         const showDeduction = usefor !== "generateinvoice";

//         // ---- figure out column layout ----
//         let col = 0;
//         const SNO_COL = col++;                  // 0
//         const ITEM_COL = col++;                 // 1
//         const CONTRACT_START = col; col += 4;   // KM, Rate Per KM, No. of Times Survey, Total Amount
//         let DED_MONTH_COL = -1, DED_AMT_COL = -1;
//         if (showDeduction) {
//             DED_MONTH_COL = col++;
//             DED_AMT_COL = col++;
//         }
//         const EOT_START = col; col += eotLengths * 4;   // 4 cols per EOT group
//         const PREV_START = col; col += 2;   // Month, Amount
//         const CUR_START = col; col += 2;
//         const CUM_START = col; col += 2;
//         const REM_START = col; col += 2;
//         const TOTAL_COLS = col;

//         const blankRow = () => new Array(TOTAL_COLS).fill("");

//         // ---- header row 1 (group labels) ----
//         const row1 = blankRow();
//         row1[SNO_COL] = "S.No";
//         row1[ITEM_COL] = "Item";
//         row1[CONTRACT_START] = "Contract Amount";
//         if (showDeduction) {
//             row1[DED_MONTH_COL] = "Deduction Month";
//             row1[DED_AMT_COL] = "Deduction Amount";
//         }
//         for (let i = 0; i < eotLengths; i++) {
//             row1[EOT_START + i * 4] = `EOT ${i + 1}`;
//         }
//         row1[PREV_START] = "Cumulative Total of Previous Months";
//         row1[CUR_START] = "This Period";
//         row1[CUM_START] = "Cumulative Total Including Current Invoice";
//         row1[REM_START] = "Remaining Amount Against Contract Value";

//         // ---- header row 2 (sub labels) ----
//         const row2 = blankRow();
//         row2[CONTRACT_START] = "KM";
//         row2[CONTRACT_START + 1] = "Rate Per KM";
//         row2[CONTRACT_START + 2] = "No. of Times Survey";
//         row2[CONTRACT_START + 3] = "Total Amount";
//         for (let i = 0; i < eotLengths; i++) {
//             const c = EOT_START + i * 4;
//             row2[c] = "KM";
//             row2[c + 1] = "Rate Per KM";
//             row2[c + 2] = "No. of Times";
//             row2[c + 3] = "Total Amount";
//         }
//         row2[PREV_START] = "Month"; row2[PREV_START + 1] = "Amount";
//         row2[CUR_START] = "Month"; row2[CUR_START + 1] = "Amount";
//         row2[CUM_START] = "Month"; row2[CUM_START + 1] = "Amount";
//         row2[REM_START] = "Month"; row2[REM_START + 1] = "Amount";

//         // ---- merges for the two header rows ----
//         const merges = [];
//         const vMerge = (c) => merges.push({ s: { r: 0, c }, e: { r: 1, c } });
//         const hMerge = (c1, c2) => merges.push({ s: { r: 0, c: c1 }, e: { r: 0, c: c2 } });

//         vMerge(SNO_COL); vMerge(ITEM_COL);
//         if (showDeduction) { vMerge(DED_MONTH_COL); vMerge(DED_AMT_COL); }
//         hMerge(CONTRACT_START, CONTRACT_START + 3);
//         for (let i = 0; i < eotLengths; i++) {
//             const c = EOT_START + i * 4;
//             hMerge(c, c + 3);
//         }
//         hMerge(PREV_START, PREV_START + 1);
//         hMerge(CUR_START, CUR_START + 1);
//         hMerge(CUM_START, CUM_START + 1);
//         hMerge(REM_START, REM_START + 1);

//         // ---- data rows (flat — no sections for road survey) ----
//         const rows = [row1, row2];

//         roadSurveyinvoice.forEach((item, index) => {
//             const km = Number(item.boq_KM ?? item.roadsurvey_details.KM) || 0;
//             const rate = Number(item.boq_rate_per_km_times ?? item.roadsurvey_details.rate_per_km_times) || 0;
//             const times = Number(item.boq_num_of_times_survey_concluded ?? item.roadsurvey_details.num_of_times_survey_concluded) || 0;
//             const totalAmt = km * rate * times;

//             const matchedDeductions = deductionData?.filter((d) => d.item_id === item.id) || [];
//             const deductionMonthSum = matchedDeductions.reduce((s, n) => s + (Number(n.deduction_month) || 0), 0);
//             const deductionAmountSum = matchedDeductions.reduce((s, n) => s + ((Number(n.deduction_amount) + Number(n.withheld_deduction_amount)) || 0), 0);

//             const r = blankRow();
//             r[SNO_COL] = index + 1;
//             r[ITEM_COL] = item.boq_description ?? item.roadsurvey_details.description ?? "";
//             r[CONTRACT_START] = r2(km);
//             r[CONTRACT_START + 1] = r2(rate);
//             r[CONTRACT_START + 2] = r2(times);
//             r[CONTRACT_START + 3] = r2(totalAmt);
//             if (showDeduction) {
//                 r[DED_MONTH_COL] = r2(deductionMonthSum);
//                 r[DED_AMT_COL] = r2(deductionAmountSum);
//             }
//             (item.eot_details || []).forEach((e, i) => {
//                 const c = EOT_START + i * 4;
//                 r[c] = r2(e.KM);
//                 r[c + 1] = r2(e.rate_per_km_times);
//                 r[c + 2] = r2(e.num_of_times_survey_concluded);
//                 r[c + 3] = r2(e.total_amount);
//             });
//             r[PREV_START] = r2(item.actual_month_total_previous);
//             r[PREV_START + 1] = r2(item.previous_invoice_total);
//             r[CUR_START] = r2(item.actual_month);
//             r[CUR_START + 1] = r2(item.invoice_amount);
//             r[CUM_START] = r2(item.actual_month_cumulative_total);
//             r[CUM_START + 1] = r2(item.cumulative_invoice_total);
//             r[REM_START] = r2(item.actual_month_remaining);
//             r[REM_START + 1] = r2(item.remaining_amount);

//             rows.push(r);
//         });

//         // ---- totals row ----
//         const totalRow = blankRow();
//         totalRow[ITEM_COL] = "Total:";
//         totalRow[CONTRACT_START] = r2(calculateTotal(roadSurveyinvoice, item => Number(item.boq_KM ?? item.roadsurvey_details.KM)));
//         totalRow[CONTRACT_START + 1] = r2(calculateTotal(roadSurveyinvoice, item => Number(item.boq_rate_per_km_times ?? item.roadsurvey_details.rate_per_km_times)));
//         totalRow[CONTRACT_START + 2] = r2(calculateTotal(roadSurveyinvoice, item => Number(item.boq_num_of_times_survey_concluded ?? item.roadsurvey_details.num_of_times_survey_concluded)));
//         totalRow[CONTRACT_START + 3] = r2(calculateContractAmount);

//         if (showDeduction) {
//             totalRow[DED_MONTH_COL] = r2(roadSurveyinvoice.reduce((gt, item) => {
//                 const m = deductionData?.filter(d => d.item_id === item.id) || [];
//                 return gt + m.reduce((s, d) => s + (Number(d?.deduction_month) || 0), 0);
//             }, 0));
//             totalRow[DED_AMT_COL] = r2(roadSurveyinvoice.reduce((gt, item) => {
//                 const m = deductionData?.filter(d => d.item_id === item.id) || [];
//                 return gt + m.reduce((s, d) => s + ((Number(d?.deduction_amount) || 0) + (Number(d?.withheld_deduction_amount) || 0)), 0);
//             }, 0));
//         }

//         for (let eotIdx = 0; eotIdx < eotLengths; eotIdx++) {
//             const totals = roadSurveyinvoice.reduce((acc, emp) => {
//                 const details = emp.eot_details?.length > 0 ? emp.eot_details : emp.data?.eot_details || [];
//                 const eot = details[eotIdx];
//                 if (!eot) return acc;
//                 acc.KM += Number(eot?.KM) || 0;
//                 acc.rate_per_km_times += Number(eot?.rate_per_km_times) || 0;
//                 acc.num_of_times_survey_concluded += Number(eot?.num_of_times_survey_concluded) || 0;
//                 acc.total_amount += Number(eot?.total_amount) || 0;
//                 return acc;
//             }, { KM: 0, rate_per_km_times: 0, num_of_times_survey_concluded: 0, total_amount: 0 });
//             const c = EOT_START + eotIdx * 4;
//             totalRow[c] = r2(totals.KM);
//             totalRow[c + 1] = r2(totals.rate_per_km_times);
//             totalRow[c + 2] = r2(totals.num_of_times_survey_concluded);
//             totalRow[c + 3] = r2(totals.total_amount);
//         }

//         totalRow[PREV_START] = r2(calculateTotal(roadSurveyinvoice, item => Number(item.actual_month_total_previous)));
//         totalRow[PREV_START + 1] = r2(calculatePreviousAmount);
//         totalRow[CUR_START] = r2(calculateTotal(roadSurveyinvoice, item => Number(item.actual_month)));
//         totalRow[CUR_START + 1] = r2(calculateCurrentAmount);
//         totalRow[CUM_START] = r2(calculateTotal(roadSurveyinvoice, item => Number(item.actual_month_cumulative_total)));
//         totalRow[CUM_START + 1] = r2(calculateCumulated);
//         totalRow[REM_START] = r2(calculateTotal(roadSurveyinvoice, item => Number(item.actual_month_remaining)));
//         totalRow[REM_START + 1] = r2(calculateRemaining);
//         rows.push(totalRow);

//         const colWidths = new Array(TOTAL_COLS).fill({ wch: 14 });
//         colWidths[SNO_COL] = { wch: 6 };
//         colWidths[ITEM_COL] = { wch: 22 };

//         return { rows, merges, colWidths, sheetName: "Road Survey Equipment" };
//     };
//     useEffect(() => {
//         if (roadSurveyinvoice.length > 0 && typeof setExcelRows === "function") {
//             setExcelRows(buildExcelSheetData());
//         }
//     }, [roadSurveyinvoice, deductionData]);

//     // return (
//     //     <div className='table-css-backgrounds'>
//     //         <div className='print-center'>

//     //             <div className="table-css-background show-on-print">
//     //                 <div className='flex-column'>
//     //                     <div>
//     //                         <h3 style={{ fontSize: "15px", textAlign: "justify" }}>{projectData?.project_name}</h3>
//     //                     </div>
//     //                     <div className='flex-row justify-between' style={{ width: "90vw" }}>

//     //                         <div className='consultant-heading'>
//     //                             <h6>Client Name:{projectData?.client_name}</h6>
//     //                             <h6>Consultant (AE):{projectData?.lead}{projectData?.jv ? ` JV with ${projectData?.jv}.` : ""}{projectData?.association ? ` Association with ${projectData?.association}` : ""}</h6>
//     //                             <h6>GSTIN No:{projectData?.gst_no}</h6>
//     //                             <h6>PAN No:{projectData?.pan_no}</h6>
//     //                             <h6>Bid Due Submission Date:{formatDateDD_MM_YYYY(projectData?.bid_due_date)}</h6>
//     //                             <div className='flex-row justify-between' style={{ width: "86vw" }}>
//     //                                 <div>
//     //                                     <h6>Agreement Date:{formatDateDD_MM_YYYY(projectData?.agreement_date)}</h6>
//     //                                     <h6>Project Start Date:{formatDateDD_MM_YYYY(projectData?.commencement_date)}</h6>
//     //                                 </div>
//     //                                 <div>
//     //                                     <h6>Date: {getMonthName(month)}-{year}</h6>
//     //                                     <h6>Invoice Number: {invoice_num}</h6>
//     //                                 </div>

//     //                             </div>
//     //                         </div>

//     //                     </div>
//     //                 </div>
//     //                 <div className='heads-div'>
//     //                     <h5>9- Road Survey Equipment <br /></h5>
//     //                     <div className="hide-on-print">
//     //                         {usefor === "generateinvoice" ?
//     //                             <RoadSurveyEquipmentInvoice usedfor="InvoiceandDeduction" p_id={p_id ? p_id : project} invoice_id={invoice_id} getRoadSurveyinvoice={getRoadSurveyinvoice} month={month} year={year} logData={logData} />

//     //                             :
//     //                             <>
//     //                                 {

//     //                                     roadSurveyinvoice.length === 0 ?
//     //                                         <RoadSurveyEquipmentInvoice invoiceData={roadSurveyinvoice} usedfor="OnlyDeduction" p_id={p_id ? p_id : project} invoice_id={invoice_id} getRoadSurveyinvoice={getRoadSurveyinvoice} month={month} year={year} logData={logData} />

//     //                                         :
//     //                                         <UpdateRoadSurveyDeductionInvoice invoiceData={roadSurveyinvoice} getData={getRoadSurveyinvoice} />


//     //                                 }
//     //                             </>

//     //                         }
//     //                     </div>
//     //                 </div>
//     //                 <div className='table-box scroll-container-table'>

//     //                     <table className=" nested-table-lightblue">
//     //                         <thead>
//     //                             <tr className="theading">
//     //                                 <th className='text-heading-text' rowSpan="4">S.No</th>
//     //                                 <th className='text-heading-text' rowSpan="4">Item</th>
//     //                                 <th colSpan="4" className='table-heading-text text-center'>Contract Amount</th>
//     //                                 {usefor !== "generateinvoice" && (
//     //                                     <>
//     //                                         <th className='table-heading-text text-center' rowSpan="4">Deduction Month</th>
//     //                                         <th className='table-heading-text text-center' rowSpan="4">Deduction Amount</th>

//     //                                     </>
//     //                                 )}
//     //                                 {isEotDataTrue &&

//     //                                     <th
//     //                                         className="table-heading-text text-center"
//     //                                         colSpan={eotLengths * 4 || 1}
//     //                                     >
//     //                                         ( COS/EOT)
//     //                                     </th>
//     //                                 }
//     //                                 <th colSpan="2" className='table-heading-text text-center'>Cumulative Total of Previous Months</th>
//     //                                 <th colSpan="2" className='table-heading-text text-center'>This Period</th>
//     //                                 <th colSpan="2" className='table-heading-text text-center'>Cumulative total Including Current Invoice</th>
//     //                                 <th colSpan="2" className='table-heading-text text-center'>Remaining amount against contract value</th>
//     //                                 {role !== "SiteManagement" && role !== "ViewAccess" &&

//     //                                     <th rowSpan="4" className='table-heading-text text-center hide-on-print'>Action</th>
//     //                                 }
//     //                             </tr>
//     //                             <tr className='nested-heading'>
//     //                                 <th rowSpan="2" className='text-heading-text'>KM</th>
//     //                                 <th rowSpan="2" className='text-heading-text'>Rate Per KM</th>
//     //                                 <th rowSpan="2" className='text-heading-text'>No. of times survey to be concluded</th>
//     //                                 <th rowSpan="2" className='text-heading-text'>Total Amount</th>
//     //                                 {Array.from({ length: eotLengths }).map((_, idx) => (
//     //                                     <th key={idx} className="table-heading-text text-center" colSpan={4}>
//     //                                         {`Revised Contract Amount as per EOT ${idx + 1}`}
//     //                                     </th>
//     //                                 ))}
//     //                                 <th rowSpan="2" className='text-heading-text'>Month</th>
//     //                                 <th rowSpan="2" className='text-heading-text'>Amount</th>
//     //                                 <th rowSpan="2" className='text-heading-text'>Month</th>
//     //                                 <th rowSpan="2" className='text-heading-text'>Amount</th>
//     //                                 <th rowSpan="2" className='text-heading-text'>Month</th>
//     //                                 <th rowSpan="2" className='text-heading-text'>Amount</th>
//     //                                 <th rowSpan="2" className='text-heading-text'>Month</th>
//     //                                 <th rowSpan="2" className='text-heading-text'>Amount</th>
//     //                             </tr>
//     //                             <tr className='nested-heading'>
//     //                                 {Array.from({ length: eotLengths }).map((_, idx) => (
//     //                                     <React.Fragment key={idx}>
//     //                                         <th rowSpan="2" className='text-heading-text'>KM</th>
//     //                                         <th rowSpan="2" className='text-heading-text'>Rate Per KM</th>
//     //                                         <th rowSpan="2" className='text-heading-text'>No. of times <br /> survey to be <br /> concluded</th>
//     //                                         <th rowSpan="2" className='text-heading-text'>Total Amount</th>
//     //                                     </React.Fragment>
//     //                                 ))}

//     //                             </tr>

//     //                         </thead>
//     //                         <tbody>
//     //                             {roadSurveyinvoice.map((item, index) => {
//     //                                 const matchedDeductions = deductionData?.filter(
//     //                                     (d) => d.item_id === item.id
//     //                                 ) || [];

//     //                                 return (
//     //                                     <tr className="tbody" key={item.id}>
//     //                                         <td className="table-body" >{index + 1}</td>
//     //                                         <td className="table-body"> {item.boq_description ?? item.roadsurvey_details.description}</td>
//     //                                         <td className='table-body text-end'>{formatCurrencyIndian(Number(item.boq_KM ?? item.roadsurvey_details.KM))}</td>
//     //                                         <td className='table-body text-end'>₹{formatCurrencyIndian(Number(item.boq_rate_per_km_times ?? item.roadsurvey_details.rate_per_km_times))}</td>
//     //                                         <td className='table-body text-end'>{formatCurrencyIndian(Number(item.boq_num_of_times_survey_concluded ?? item.roadsurvey_details.num_of_times_survey_concluded))}</td>
//     //                                         <td className='table-body text-end'>₹{formatCurrencyIndian(Number(item.boq_KM ?? item.roadsurvey_details.KM) * Number(item.boq_rate_per_km_times ?? item.roadsurvey_details.rate_per_km_times) * Number(item.boq_num_of_times_survey_concluded ?? item.roadsurvey_details.num_of_times_survey_concluded))}</td>
//     //                                         {usefor !== "generateinvoice" && (
//     //                                             <td className='table-body text-end'>
//     //                                                 {matchedDeductions.length > 0 ?
//     //                                                     matchedDeductions.map((n, i) => (
//     //                                                         <td key={i} className='flex-column' style={{ marginBottom: "4px" }}>
//     //                                                             {n.deduction_month ?? "-"}
//     //                                                         </td>
//     //                                                     ))
//     //                                                     : <td className='flex-column' style={{ marginBottom: "4px" }}>-</td>
//     //                                                 }
//     //                                             </td>
//     //                                         )}

//     //                                         {usefor !== "generateinvoice" && (
//     //                                             <td className='table-body text-end'>
//     //                                                 {matchedDeductions?.length > 0 ?
//     //                                                     <>
//     //                                                         {matchedDeductions.map((n, i) => (
//     //                                                             <td key={i} className='flex-column' style={{ marginBottom: "4px" }}>
//     //                                                                 {Number(n.deduction_amount) + Number(n.withheld_deduction_amount) || 0}
//     //                                                             </td>
//     //                                                         ))}
//     //                                                     </>
//     //                                                     : <td className='flex-column' style={{ marginBottom: "4px" }}>0</td>
//     //                                                 }
//     //                                             </td>
//     //                                         )}
//     //                                         {item?.eot_details?.length > 0 ?
//     //                                             <>
//     //                                                 {item.eot_details.map((i) => (
//     //                                                     <>

//     //                                                         <td className="align-right">{i.KM} </td>
//     //                                                         <td className="align-right">{i.rate_per_km_times} </td>
//     //                                                         <td className="align-right">{i.num_of_times_survey_concluded} </td>
//     //                                                         <td className="align-right">{i.total_amount} </td>

//     //                                                     </>
//     //                                                 ))}
//     //                                             </> :
//     //                                             <></>
//     //                                         }
//     //                                         <td className='table-body text-end'>{formatCurrencyIndian(Number(item.actual_month_total_previous))}</td>
//     //                                         <td className='table-body text-end'>₹{formatCurrencyIndian(Number(item.previous_invoice_total))}</td>
//     //                                         <td className='table-body text-end'>{formatCurrencyIndian(Number(item.actual_month))}</td>
//     //                                         <td className='table-body text-end'>₹{formatCurrencyIndian(Number(item.invoice_amount))}</td>
//     //                                         <td className='table-body text-end'>{formatCurrencyIndian(Number(item.actual_month_cumulative_total))}</td>
//     //                                         <td className='table-body text-end'>₹{formatCurrencyIndian(Number(item.cumulative_invoice_total))}</td>
//     //                                         <td className='table-body text-end'>{formatCurrencyIndian(Number(item.actual_month_remaining))}</td>
//     //                                         <td className='table-body text-end'>₹{formatCurrencyIndian(Number(item.remaining_amount))}</td>


//     //                                         {usefor === "generateinvoice" ?
//     //                                             <>
//     //                                                 {(!["Checker", "SiteManagement"].includes(role) && true) ||
//     //                                                     (role === "Checker" && !isMoreThan24Hours(item.created_at)) ? (
//     //                                                     <td className='table-body text-end hide-on-print'>
//     //                                                         {usefor === "generateinvoice" ?

//     //                                                             <DeleteRoadSurveyEquipmentInvoice
//     //                                                                 i={item}
//     //                                                                 getRoadSurveyinvoice={getRoadSurveyinvoice}
//     //                                                             /> :
//     //                                                             <DeleteRoadSurveyEquipmentInvoiceDeduction
//     //                                                                 i={item}
//     //                                                                 getRoadSurveyinvoice={getRoadSurveyinvoice}
//     //                                                             />
//     //                                                         }
//     //                                                     </td>
//     //                                                 ) :
//     //                                                     <td className=" text-center hide-on-print">
//     //                                                         -
//     //                                                     </td>
//     //                                                 }
//     //                                             </>

//     //                                             : ""
//     //                                         }

//     //                                     </tr>
//     //                                 )
//     //                             }
//     //                             )}
//     //                         </tbody>
//     //                         <tfoot>
//     //                             <tr className="tbody">

//     //                                 <td></td>
//     //                                 <td className="total-label">Total:</td>
//     //                                 <td className='table-body text-end'>
//     //                                     {formatCurrencyIndian(
//     //                                         calculateTotal(roadSurveyinvoice, (item) => Number(item.boq_KM ?? item.roadsurvey_details.KM))
//     //                                             .toFixed(2) // Ensure two decimal places
//     //                                     )}
//     //                                 </td>

//     //                                 <td className='table-body text-end'>₹{formatCurrencyIndian(calculateTotal(roadSurveyinvoice, (item) => Number(item.boq_rate_per_km_times ?? item.roadsurvey_details.rate_per_km_times)))}</td>
//     //                                 <td className='table-body text-end'>{formatCurrencyIndian(calculateTotal(roadSurveyinvoice, (item) => Number(item.boq_num_of_times_survey_concluded ?? item.roadsurvey_details.num_of_times_survey_concluded)))}</td>
//     //                                 <td className='table-body text-end'>₹{formatCurrencyIndian(calculateTotal(roadSurveyinvoice, (item) => Number(item.boq_KM ?? item.roadsurvey_details.KM) * Number(item.boq_rate_per_km_times ?? item.roadsurvey_details.rate_per_km_times) * Number(item.boq_num_of_times_survey_concluded ?? item.roadsurvey_details.num_of_times_survey_concluded)))}</td>
//     //                                 {usefor !== "generateinvoice" && (
//     //                                     <>
//     //                                         <td className="align-right">
//     //                                             {/* ✅ Use deductionData instead of item.deduction_amount */}
//     //                                             {(
//     //                                                 roadSurveyinvoice.reduce((grandTotal, item) => {
//     //                                                     const matchedDeductions = deductionData?.filter(
//     //                                                         (d) => d.item_id === item.id
//     //                                                     ) || [];
//     //                                                     const rowTotal = matchedDeductions.reduce(
//     //                                                         (sum, d) => sum + (Number(d?.deduction_month) || 0), 0
//     //                                                     );
//     //                                                     return grandTotal + rowTotal;
//     //                                                 }, 0)
//     //                                             )}
//     //                                         </td>
//     //                                         <td className="align-right">
//     //                                             {/* ✅ Use deductionData instead of item.deduction_amount */}
//     //                                             ₹{formatCurrencyIndian(
//     //                                                 roadSurveyinvoice.reduce((grandTotal, item) => {
//     //                                                     const matchedDeductions = deductionData?.filter(
//     //                                                         (d) => d.item_id === item.id
//     //                                                     ) || [];
//     //                                                     const rowTotal = matchedDeductions.reduce(
//     //                                                         (sum, d) => sum + (Number(d?.deduction_amount) || 0), 0
//     //                                                     );
//     //                                                     return grandTotal + rowTotal;
//     //                                                 }, 0)
//     //                                             )}
//     //                                         </td>
//     //                                     </>
//     //                                 )}
//     //                                 {isEotDataTrue && (
//     //                                     <>
//     //                                         {Array.from({ length: eotLengths }).map((_, eotIdx) => {
//     //                                             const totals = roadSurveyinvoice.reduce(
//     //                                                 (acc, emp) => {
//     //                                                     const details =
//     //                                                         emp.eot_details?.length > 0
//     //                                                             ? emp.eot_details
//     //                                                             : emp.data?.eot_details || [];
//     //                                                     const eot = details[eotIdx];

//     //                                                     if (!eot) return acc;

//     //                                                     acc.KM += Number(eot?.KM) || 0;
//     //                                                     acc.rate_per_km_times += Number(eot?.rate_per_km_times) || 0;
//     //                                                     acc.num_of_times_survey_concluded += Number(eot?.num_of_times_survey_concluded) || 0;

//     //                                                     acc.total_amount += Number(eot?.total_amount) || 0;

//     //                                                     return acc;
//     //                                                 },
//     //                                                 { KM: 0, rate_per_km_times: 0, num_of_times_survey_concluded: 0, total_amount: 0 }
//     //                                             );
//     //                                             return (
//     //                                                 <React.Fragment key={eotIdx}>
//     //                                                     <td className="align-right">{formatCurrencyIndian(totals.KM)}</td>
//     //                                                     <td className="align-right">₹{formatCurrencyIndian(totals.rate_per_km_times)}</td>
//     //                                                     <td className="align-right">{totals.num_of_times_survey_concluded}</td>
//     //                                                     <td className="align-right">₹{formatCurrencyIndian(totals.total_amount)}</td>

//     //                                                 </React.Fragment>
//     //                                             );
//     //                                         })}
//     //                                     </>
//     //                                 )}
//     //                                 <td className='table-body text-end'>{formatCurrencyIndian(calculateTotal(roadSurveyinvoice, (item) => Number(item.actual_month_total_previous)))}</td>
//     //                                 <td className='table-body text-end'>₹{formatCurrencyIndian(calculateTotal(roadSurveyinvoice, (item) => Number(item.previous_invoice_total)))}</td>
//     //                                 <td className='table-body text-end'>{formatCurrencyIndian(calculateTotal(roadSurveyinvoice, (item) => Number(item.actual_month)))}</td>
//     //                                 <td className='table-body text-end'>₹{formatCurrencyIndian(calculateTotal(roadSurveyinvoice, (item) => Number(item.invoice_amount)))}</td>
//     //                                 <td className='table-body text-end'>{formatCurrencyIndian(calculateTotal(roadSurveyinvoice, (item) => Number(item.actual_month_cumulative_total)))}</td>
//     //                                 <td className='table-body text-end'>₹{formatCurrencyIndian(calculateTotal(roadSurveyinvoice, (item) => Number(item.cumulative_invoice_total)))}</td>
//     //                                 <td className='table-body text-end'>{formatCurrencyIndian(calculateTotal(roadSurveyinvoice, (item) => Number(item.actual_month_remaining)))}</td>
//     //                                 <td className='table-body text-end'>₹{formatCurrencyIndian(calculateTotal(roadSurveyinvoice, (item) => Number(item.remaining_amount)))}</td>
//     //                                 {role !== "SiteManagement" && role !== "ViewAccess" &&

//     //                                     <td className="hide-on-print"></td>

//     //                                 }
//     //                             </tr>
//     //                         </tfoot>
//     //                     </table>
//     //                 </div>
//     //             </div>
//     //         </div>

//     //     </div>
//     // );

//     return (
//         <div className="boc-modern-wrapper" style={{ minHeight: "30vh" }}>
//             <div className="boc-modern-card">

//                 <div className="boc-modern-header bocx-modern-footer-total">
//                     <div className="boc-modern-header-content">
//                         <div className="boc-modern-project-info">
//                             <h3 className="boc-modern-project-title">{projectData?.project_name}</h3>
//                             <div className="boc-modern-project-meta">
//                                 <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Client:</span><span className="boc-modern-meta-value">{projectData?.client_name}</span></div>
//                                 <div className="boc-modern-meta-divider"></div>
//                                 <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Consultant (AE):</span><span className="boc-modern-meta-value">{projectData?.lead}{projectData?.jv ? ` JV with ${projectData?.jv}.` : ""}{projectData?.association ? ` Association with ${projectData?.association}` : ""}</span></div>
//                                 <div className="boc-modern-meta-divider"></div>
//                                 <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">GSTIN:</span><span className="boc-modern-meta-value">{projectData?.gst_no}</span></div>
//                                 <div className="boc-modern-meta-divider"></div>
//                                 <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">PAN:</span><span className="boc-modern-meta-value">{projectData?.pan_no}</span></div>
//                                 <div className="boc-modern-meta-divider"></div>
//                                 <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Bid Due:</span><span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.bid_due_date)}</span></div>
//                                 <div className="boc-modern-meta-divider"></div>
//                                 <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Agreement:</span><span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.agreement_date)}</span></div>
//                                 <div className="boc-modern-meta-divider"></div>
//                                 <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Start:</span><span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.commencement_date)}</span></div>
//                                 <div className="boc-modern-meta-divider"></div>
//                                 <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Invoice Number:</span><span className="boc-modern-meta-value">{invoice_num}</span></div>
//                                 <div className="boc-modern-meta-divider"></div>
//                                 <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Date:</span><span className="boc-modern-meta-value">{getMonthName(month)}-{year}</span></div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>

//                 <div className="boc-modern-description-section">
//                     <div className="boc-modern-controls">
//                         <div className="boc-modern-controls-left">
//                             <h6 className="boc-modern-main-heading">9- Road Survey Equipment</h6>
//                         </div>
//                         <div className="hide-on-print">
//                             {usefor === "generateinvoice"
//                                 ? <RoadSurveyEquipmentInvoice usedfor="InvoiceandDeduction" p_id={p_id ? p_id : project} invoice_id={invoice_id} getRoadSurveyinvoice={getRoadSurveyinvoice} month={month} year={year} logData={logData} />
//                                 : <>
//                                     {roadSurveyinvoice.length === 0
//                                         ? <RoadSurveyEquipmentInvoice invoiceData={roadSurveyinvoice} usedfor="OnlyDeduction" p_id={p_id ? p_id : project} invoice_id={invoice_id} getRoadSurveyinvoice={getRoadSurveyinvoice} month={month} year={year} logData={logData} />
//                                         : <UpdateRoadSurveyDeductionInvoice invoiceData={roadSurveyinvoice} getData={getRoadSurveyinvoice} />}
//                                 </>
//                             }
//                         </div>
//                     </div>
//                 </div>

//                 <div className="boc-modern-table-wrapper">
//                     <div className="boc-modern-table-scroll">
//                         <table className="boc-modern-table">
//                             <thead>
//                                 <tr className="boc-modern-table-header">
//                                     <th className="boc-modern-th text-center" rowSpan="4">S.No</th>
//                                     <th className="boc-modern-th text-center" rowSpan="4">Item</th>
//                                     <th className="boc-modern-th text-center" colSpan="4">Contract Amount</th>
//                                     {usefor !== "generateinvoice" && (
//                                         <>
//                                             <th className="boc-modern-th text-center" rowSpan="4">Deduction Month</th>
//                                             <th className="boc-modern-th text-center" rowSpan="4">Deduction Amount</th>
//                                         </>
//                                     )}
//                                     {isEotDataTrue && <th className="boc-modern-th text-center" colSpan={eotLengths * 4 || 1}>(COS/EOT)</th>}
//                                     <th className="boc-modern-th text-center" colSpan="2">Cumulative Total of Previous Months</th>
//                                     <th className="boc-modern-th text-center" colSpan="2">This Period</th>
//                                     <th className="boc-modern-th text-center" colSpan="2">Cumulative Total Including Current Invoice</th>
//                                     <th className="boc-modern-th text-center" colSpan="2">Remaining Amount Against Contract Value</th>
//                                     {role !== "SiteManagement" && role !== "ViewAccess" && <th className="boc-modern-th text-center hide-on-print" rowSpan="4">Action</th>}
//                                 </tr>
//                                 <tr className="boc-modern-table-subheader">
//                                     <th rowSpan="2" className="boc-modern-th boc-nowrap">KM</th>
//                                     <th rowSpan="2" className="boc-modern-th boc-nowrap">Rate Per KM</th>
//                                     <th rowSpan="2" className="boc-modern-th boc-nowrap">No. of Times Survey</th>
//                                     <th rowSpan="2" className="boc-modern-th boc-nowrap">Total Amount</th>
//                                     {Array.from({ length: eotLengths }).map((_, idx) => (
//                                         <th key={idx} className="boc-modern-th text-center boc-nowrap" colSpan={4}>{`EOT ${idx + 1}`}</th>
//                                     ))}
//                                     <th rowSpan="2" className="boc-modern-th boc-nowrap">Month</th>
//                                     <th rowSpan="2" className="boc-modern-th boc-nowrap">Amount</th>
//                                     <th rowSpan="2" className="boc-modern-th boc-nowrap">Month</th>
//                                     <th rowSpan="2" className="boc-modern-th boc-nowrap">Amount</th>
//                                     <th rowSpan="2" className="boc-modern-th boc-nowrap">Month</th>
//                                     <th rowSpan="2" className="boc-modern-th boc-nowrap">Amount</th>
//                                     <th rowSpan="2" className="boc-modern-th boc-nowrap">Month</th>
//                                     <th rowSpan="2" className="boc-modern-th boc-nowrap">Amount</th>
//                                 </tr>
//                                 <tr className="boc-modern-table-subheader">
//                                     {Array.from({ length: eotLengths }).map((_, idx) => (
//                                         <React.Fragment key={idx}>
//                                             <th rowSpan="2" className="boc-modern-th boc-nowrap">KM</th>
//                                             <th rowSpan="2" className="boc-modern-th boc-nowrap">Rate Per KM</th>
//                                             <th rowSpan="2" className="boc-modern-th boc-nowrap">No. of Times</th>
//                                             <th rowSpan="2" className="boc-modern-th boc-nowrap">Total Amount</th>
//                                         </React.Fragment>
//                                     ))}
//                                 </tr>
//                             </thead>

//                             <tbody>
//                                 {roadSurveyinvoice.map((item, index) => {
//                                     const matchedDeductions = deductionData?.filter(d => d.item_id === item.id) || [];
//                                     return (
//                                         <tr className="boc-modern-row" key={item.id}>
//                                             <td className="boc-modern-td text-center">{index + 1}.</td>
//                                             <td className="boc-modern-td"><div style={{ whiteSpace: "normal", width: "100px" }}>{item.boq_description ?? item.roadsurvey_details.description}</div></td>
//                                             <td className="boc-modern-td boc-nowrap text-right">{formatCurrencyIndian(Number(item.boq_KM ?? item.roadsurvey_details.KM))}</td>
//                                             <td className="boc-modern-td boc-nowrap boc-modern-currency text-right">₹ {formatCurrencyIndian(Number(item.boq_rate_per_km_times ?? item.roadsurvey_details.rate_per_km_times))}</td>
//                                             <td className="boc-modern-td boc-nowrap text-right">{formatCurrencyIndian(Number(item.boq_num_of_times_survey_concluded ?? item.roadsurvey_details.num_of_times_survey_concluded))}</td>
//                                             <td className="boc-modern-td boc-nowrap text-right">
//                                                 <span className="boc-modern-currency boc-modern-total-highlight">
//                                                     ₹ {formatCurrencyIndian(Number(item.boq_KM ?? item.roadsurvey_details.KM) * Number(item.boq_rate_per_km_times ?? item.roadsurvey_details.rate_per_km_times) * Number(item.boq_num_of_times_survey_concluded ?? item.roadsurvey_details.num_of_times_survey_concluded))}
//                                                 </span>
//                                             </td>

//                                             {usefor !== "generateinvoice" && (
//                                                 <td className="boc-modern-td boc-nowrap text-right justify-end" style={{ padding: 0 }}>
//                                                     {matchedDeductions.length > 0
//                                                         ? matchedDeductions.map((n, i) => <div key={i} className="boc-multi-item boc-nowrap">{n.deduction_month ?? "-"}</div>)
//                                                         : <div className="boc-multi-item">-</div>}
//                                                 </td>
//                                             )}
//                                             {usefor !== "generateinvoice" && (
//                                                 <td className="boc-modern-td boc-nowrap text-right justify-end" style={{ padding: 0 }}>
//                                                     {matchedDeductions.length > 0
//                                                         ? matchedDeductions.map((n, i) => <div key={i} className="boc-multi-item boc-nowrap">{Number(n.deduction_amount) + Number(n.withheld_deduction_amount) || 0}</div>)
//                                                         : <div className="boc-multi-item">0</div>}
//                                                 </td>
//                                             )}

//                                             {item?.eot_details?.length > 0 && item.eot_details.map((i, idx) => (
//                                                 <React.Fragment key={idx}>
//                                                     <td className="boc-modern-td boc-nowrap text-right">{i.KM}</td>
//                                                     <td className="boc-modern-td boc-nowrap boc-modern-currency text-right">₹ {formatCurrencyIndian(Number(i.rate_per_km_times))}</td>
//                                                     <td className="boc-modern-td boc-nowrap text-right">{i.num_of_times_survey_concluded}</td>
//                                                     <td className="boc-modern-td boc-nowrap boc-modern-currency text-right">₹ {formatCurrencyIndian(Number(i.total_amount))}</td>
//                                                 </React.Fragment>
//                                             ))}

//                                             <td className="boc-modern-td boc-nowrap text-right">{formatCurrencyIndian(Number(item.actual_month_total_previous))}</td>
//                                             <td className="boc-modern-td boc-nowrap boc-modern-currency text-right">₹ {formatCurrencyIndian(Number(item.previous_invoice_total))}</td>
//                                             <td className="boc-modern-td boc-nowrap text-right">{formatCurrencyIndian(Number(item.actual_month))}</td>
//                                             <td className="boc-modern-td boc-nowrap boc-modern-currency text-right">₹ {formatCurrencyIndian(Number(item.invoice_amount))}</td>
//                                             <td className="boc-modern-td boc-nowrap text-right">{formatCurrencyIndian(Number(item.actual_month_cumulative_total))}</td>
//                                             <td className="boc-modern-td boc-nowrap boc-modern-currency text-right">₹ {formatCurrencyIndian(Number(item.cumulative_invoice_total))}</td>
//                                             <td className="boc-modern-td boc-nowrap text-right">{formatCurrencyIndian(Number(item.actual_month_remaining))}</td>
//                                             <td className="boc-modern-td boc-nowrap text-right">
//                                                 <span className="boc-modern-currency boc-modern-total-highlight">₹ {formatCurrencyIndian(Number(item.remaining_amount).toFixed(2))}</span>
//                                             </td>

//                                             {usefor === "generateinvoice" && (
//                                                 <>
//                                                     {(!["Checker", "SiteManagement"].includes(role)) || (role === "Checker" && !isMoreThan24Hours(item.created_at)) ? (
//                                                         <td className="boc-modern-td text-center hide-on-print">
//                                                             {usefor === "generateinvoice"
//                                                                 ? <DeleteRoadSurveyEquipmentInvoice i={item} getRoadSurveyinvoice={getRoadSurveyinvoice} />
//                                                                 : <DeleteRoadSurveyEquipmentInvoiceDeduction i={item} getRoadSurveyinvoice={getRoadSurveyinvoice} />}
//                                                         </td>
//                                                     ) : <td className="boc-modern-td text-center hide-on-print">-</td>}
//                                                 </>
//                                             )}
//                                         </tr>
//                                     );
//                                 })}
//                             </tbody>

//                             <tfoot>
//                                 <tr className="boc-modern-footer">
//                                     <td colSpan="2" className="boc-modern-footer-label">Total:</td>
//                                     <td className="boc-modern-td boc-nowrap text-right">{formatCurrencyIndian(calculateTotal(roadSurveyinvoice, item => Number(item.boq_KM ?? item.roadsurvey_details.KM)).toFixed(2))}</td>
//                                     <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatCurrencyIndian(calculateTotal(roadSurveyinvoice, item => Number(item.boq_rate_per_km_times ?? item.roadsurvey_details.rate_per_km_times)))}</span></td>
//                                     <td className="boc-modern-td boc-nowrap text-right">{formatCurrencyIndian(calculateTotal(roadSurveyinvoice, item => Number(item.boq_num_of_times_survey_concluded ?? item.roadsurvey_details.num_of_times_survey_concluded)))}</td>
//                                     <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatCurrencyIndian(calculateTotal(roadSurveyinvoice, item => Number(item.boq_KM ?? item.roadsurvey_details.KM) * Number(item.boq_rate_per_km_times ?? item.roadsurvey_details.rate_per_km_times) * Number(item.boq_num_of_times_survey_concluded ?? item.roadsurvey_details.num_of_times_survey_concluded)))}</span></td>

//                                     {usefor !== "generateinvoice" && (
//                                         <>
//                                             <td className="boc-modern-td boc-nowrap text-right">
//                                                 {roadSurveyinvoice.reduce((gt, item) => {
//                                                     const m = deductionData?.filter(d => d.item_id === item.id) || [];
//                                                     return gt + m.reduce((s, d) => s + (Number(d?.deduction_month) || 0), 0);
//                                                 }, 0)}
//                                             </td>
//                                             <td className="boc-modern-td boc-nowrap text-right">
//                                                 <span className="boc-modern-currency boc-modern-footer-total">
//                                                     ₹ {formatCurrencyIndian(
//                                                         roadSurveyinvoice.reduce((gt, item) => {
//                                                             const m = deductionData?.filter(d => d.item_id === item.id) || [];
//                                                             return gt + m.reduce((s, d) => s + ((Number(d?.deduction_amount) || 0) + (Number(d?.withheld_deduction_amount) || 0)), 0);
//                                                         }, 0)
//                                                     )}
//                                                 </span>
//                                             </td>
//                                         </>
//                                     )}

//                                     {isEotDataTrue && Array.from({ length: eotLengths }).map((_, eotIdx) => {
//                                         const totals = roadSurveyinvoice.reduce((acc, emp) => {
//                                             const details = emp.eot_details?.length > 0 ? emp.eot_details : emp.data?.eot_details || [];
//                                             const eot = details[eotIdx];
//                                             if (!eot) return acc;
//                                             acc.KM += Number(eot?.KM) || 0;
//                                             acc.rate_per_km_times += Number(eot?.rate_per_km_times) || 0;
//                                             acc.num_of_times_survey_concluded += Number(eot?.num_of_times_survey_concluded) || 0;
//                                             acc.total_amount += Number(eot?.total_amount) || 0;
//                                             return acc;
//                                         }, { KM: 0, rate_per_km_times: 0, num_of_times_survey_concluded: 0, total_amount: 0 });
//                                         return (
//                                             <React.Fragment key={eotIdx}>
//                                                 <td className="boc-modern-td boc-nowrap text-right">{formatCurrencyIndian(totals.KM)}</td>
//                                                 <td className="boc-modern-td boc-nowrap text-right">₹ {formatCurrencyIndian(totals.rate_per_km_times)}</td>
//                                                 <td className="boc-modern-td boc-nowrap text-right">{totals.num_of_times_survey_concluded}</td>
//                                                 <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatCurrencyIndian(totals.total_amount)}</span></td>
//                                             </React.Fragment>
//                                         );
//                                     })}

//                                     <td className="boc-modern-td boc-nowrap text-right">{formatCurrencyIndian(calculateTotal(roadSurveyinvoice, item => Number(item.actual_month_total_previous)))}</td>
//                                     <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatCurrencyIndian(calculateTotal(roadSurveyinvoice, item => Number(item.previous_invoice_total)))}</span></td>
//                                     <td className="boc-modern-td boc-nowrap text-right">{formatCurrencyIndian(calculateTotal(roadSurveyinvoice, item => Number(item.actual_month)))}</td>
//                                     <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatCurrencyIndian(calculateTotal(roadSurveyinvoice, item => Number(item.invoice_amount)))}</span></td>
//                                     <td className="boc-modern-td boc-nowrap text-right">{formatCurrencyIndian(calculateTotal(roadSurveyinvoice, item => Number(item.actual_month_cumulative_total)))}</td>
//                                     <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatCurrencyIndian(calculateTotal(roadSurveyinvoice, item => Number(item.cumulative_invoice_total)))}</span></td>
//                                     <td className="boc-modern-td boc-nowrap text-right">{formatCurrencyIndian(calculateTotal(roadSurveyinvoice, item => Number(item.actual_month_remaining)))}</td>
//                                     <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatCurrencyIndian(calculateTotal(roadSurveyinvoice, item => Number(item.remaining_amount).toFixed(2)))}</span></td>
//                                     {role !== "SiteManagement" && role !== "ViewAccess" && <td className="hide-on-print boc-modern-td"></td>}
//                                 </tr>
//                             </tfoot>
//                         </table>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );


// };



const RoadSurvey = ({ deductionData, projectData, client, p_id, invoice_id, year, month, invoice_num, logData,

    setPreviousAmount,

    setCurrentAmount,

    setRemainingAmount,

    setContractAmount,

    setExcelRows,

    setCumulated,

    usefor,

    setEotDetails

}) => {



    const [roadSurveyinvoice, setRoadSurveyinvoice] = useState([]);



    const role = sessionStorage.getItem('sitemanagement_role');

    const project = sessionStorage.getItem('sitemanagement_project');

    const calculateContractAmount = calculateTotal(roadSurveyinvoice, (item) => Number(item.boq_rate_per_km_times ?? item.roadsurvey_details.rate_per_km_times) * (Number(item.boq_num_of_times_survey_concluded ?? item.roadsurvey_details.num_of_times_survey_concluded)) * Number(item.boq_KM ?? item.roadsurvey_details.KM))

    setContractAmount(calculateContractAmount);

    const calculatePreviousAmount = calculateTotal(roadSurveyinvoice, (item) => Number(item.previous_invoice_total))

    setPreviousAmount(calculatePreviousAmount);

    const calculateCurrentAmount = calculateTotal(roadSurveyinvoice, (item) => Number(item.invoice_amount ?? item.current_invoice_amount))

    setCurrentAmount(calculateCurrentAmount);

    const calculateCumulated = calculateTotal(roadSurveyinvoice, (item) => Number(item.cumulative_invoice_total))

    setCumulated(calculateCumulated);

    const calculateRemaining = calculateTotal(roadSurveyinvoice, (item) => Number(item.remaining_amount))

    setRemainingAmount(calculateRemaining);



    useEffect(() => {

        const eotGroups = [];

        roadSurveyinvoice.forEach(item => {

            (item?.eot_details || []).forEach((eot, idx) => {

                if (!eotGroups[idx]) {

                    eotGroups[idx] = { ...eot, total_amount: 0 };

                }

                eotGroups[idx].total_amount += Number(eot.total_amount || 0);

            });

        });



        setEotDetails(eotGroups);

    }, [roadSurveyinvoice]);



    const currentDate = new Date();

    const isFirstWeek = currentDate.getDate() <= 7;



    const getRoadSurveyinvoice = async () => {

        try {

            let data;



            if (usefor === "generateinvoice") {

                const res = await axios.get(

                    `${BASE_URL}/siteproject/invoiceroadsurveyequipmentStatusbyproject/${p_id ? p_id : project}/${month}/${year}/`

                );

                data = res.data;

            } else {

                const response2 = await axios.get(

                    `${BASE_URL}/siteproject/newinvoiceroadsurveyequipmentfiltermonthyear/${invoice_id}/null/null/`

                );

                data = response2.data;

            }



            const isAnyBoqJsonNull = data.length !== 0 && data.every(item => item.boq_json === null);





            const selectedData = isAnyBoqJsonNull ? data : data;

            setRoadSurveyinvoice(selectedData);

        } catch (err) { }



    };



    useEffect(() => {



        // getdocument();

        getRoadSurveyinvoice();

        // eslint-disable-next-line react-hooks/exhaustive-deps

    }, []);



    const isEotDataTrue = roadSurveyinvoice.some(i =>

        (i.eot_details?.length > 0) || (i.data?.eot_details?.length > 0)

    );











    const eotLengths = Math.max(

        ...roadSurveyinvoice.map(i => i?.eot_details?.length || i?.data?.eot_details?.length || 0),

        0

    );



    // Presentation / Excel only: rupee amounts and rates rounded to whole rupees.
    // KM, number of surveys and month-related quantities display 2 decimals.
    // Underlying calculations, parent callbacks and API values retain full precision.
    const formatQuantity2 = (value) => {
        const n = Number(value ?? 0);
        return Number.isFinite(n) ? n.toFixed(2) : "0.00";
    };

    const roundRupees = (value) => {
        const n = Number(value ?? 0);
        return Number.isFinite(n) ? Math.round(n) : 0;
    };

    const formatAmount0 = (value) => roundRupees(value).toLocaleString("en-IN", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    });

    // Excel AOA: amounts remain numeric integer cells; quantity cells have 2dp text.
    const r0 = roundRupees;
    const r2 = formatQuantity2;




    // ── Builds a fully formatted AOA sheet (merged headers, flat rows) ──

    const buildExcelSheetData = () => {

        const showDeduction = usefor !== "generateinvoice";



        // ---- figure out column layout ----

        let col = 0;

        const SNO_COL = col++;                  // 0

        const ITEM_COL = col++;                 // 1

        const CONTRACT_START = col; col += 4;   // KM, Rate Per KM, No. of Times Survey, Total Amount

        let DED_MONTH_COL = -1, DED_AMT_COL = -1;

        if (showDeduction) {

            DED_MONTH_COL = col++;

            DED_AMT_COL = col++;

        }

        const EOT_START = col; col += eotLengths * 4;   // 4 cols per EOT group

        const PREV_START = col; col += 2;   // Month, Amount

        const CUR_START = col; col += 2;

        const CUM_START = col; col += 2;

        const REM_START = col; col += 2;

        const TOTAL_COLS = col;



        const blankRow = () => new Array(TOTAL_COLS).fill("");



        // ---- header row 1 (group labels) ----

        const row1 = blankRow();

        row1[SNO_COL] = "S.No";

        row1[ITEM_COL] = "Item";

        row1[CONTRACT_START] = "Contract Amount";

        if (showDeduction) {

            row1[DED_MONTH_COL] = "Deduction Month";

            row1[DED_AMT_COL] = "Deduction Amount";

        }

        for (let i = 0; i < eotLengths; i++) {

            row1[EOT_START + i * 4] = `EOT ${i + 1}`;

        }

        row1[PREV_START] = "Cumulative Total of Previous Months";

        row1[CUR_START] = "This Period";

        row1[CUM_START] = "Cumulative Total Including Current Invoice";

        row1[REM_START] = "Remaining Amount Against Contract Value";



        // ---- header row 2 (sub labels) ----

        const row2 = blankRow();

        row2[CONTRACT_START] = "KM";

        row2[CONTRACT_START + 1] = "Rate Per KM";

        row2[CONTRACT_START + 2] = "No. of Times Survey";

        row2[CONTRACT_START + 3] = "Total Amount";

        for (let i = 0; i < eotLengths; i++) {

            const c = EOT_START + i * 4;

            row2[c] = "KM";

            row2[c + 1] = "Rate Per KM";

            row2[c + 2] = "No. of Times";

            row2[c + 3] = "Total Amount";

        }

        row2[PREV_START] = "Month"; row2[PREV_START + 1] = "Amount";

        row2[CUR_START] = "Month"; row2[CUR_START + 1] = "Amount";

        row2[CUM_START] = "Month"; row2[CUM_START + 1] = "Amount";

        row2[REM_START] = "Month"; row2[REM_START + 1] = "Amount";



        // ---- merges for the two header rows ----

        const merges = [];

        const vMerge = (c) => merges.push({ s: { r: 0, c }, e: { r: 1, c } });

        const hMerge = (c1, c2) => merges.push({ s: { r: 0, c: c1 }, e: { r: 0, c: c2 } });



        vMerge(SNO_COL); vMerge(ITEM_COL);

        if (showDeduction) { vMerge(DED_MONTH_COL); vMerge(DED_AMT_COL); }

        hMerge(CONTRACT_START, CONTRACT_START + 3);

        for (let i = 0; i < eotLengths; i++) {

            const c = EOT_START + i * 4;

            hMerge(c, c + 3);

        }

        hMerge(PREV_START, PREV_START + 1);

        hMerge(CUR_START, CUR_START + 1);

        hMerge(CUM_START, CUM_START + 1);

        hMerge(REM_START, REM_START + 1);



        // ---- data rows (flat — no sections for road survey) ----

        const rows = [row1, row2];



        roadSurveyinvoice.forEach((item, index) => {

            const km = Number(item.boq_KM ?? item.roadsurvey_details.KM) || 0;

            const rate = Number(item.boq_rate_per_km_times ?? item.roadsurvey_details.rate_per_km_times) || 0;

            const times = Number(item.boq_num_of_times_survey_concluded ?? item.roadsurvey_details.num_of_times_survey_concluded) || 0;

            const totalAmt = km * rate * times;



            const matchedDeductions = deductionData?.filter((d) => d.item_id === item.id) || [];

            const deductionMonthSum = matchedDeductions.reduce((s, n) => s + (Number(n.deduction_month) || 0), 0);

            const deductionAmountSum = matchedDeductions.reduce((s, n) => s + ((Number(n.deduction_amount) + Number(n.withheld_deduction_amount)) || 0), 0);



            const r = blankRow();

            r[SNO_COL] = index + 1;

            r[ITEM_COL] = item.boq_description ?? item.roadsurvey_details.description ?? "";

            r[CONTRACT_START] = r2(km);

            r[CONTRACT_START + 1] = r0(rate);

            r[CONTRACT_START + 2] = r2(times);

            r[CONTRACT_START + 3] = r0(totalAmt);

            if (showDeduction) {

                r[DED_MONTH_COL] = r2(deductionMonthSum);

                r[DED_AMT_COL] = r0(deductionAmountSum);

            }

            (item.eot_details || []).forEach((e, i) => {

                const c = EOT_START + i * 4;

                r[c] = r2(e.KM);

                r[c + 1] = r0(e.rate_per_km_times);

                r[c + 2] = r2(e.num_of_times_survey_concluded);

                r[c + 3] = r0(e.total_amount);

            });

            r[PREV_START] = r2(item.actual_month_total_previous);

            r[PREV_START + 1] = r0(item.previous_invoice_total);

            r[CUR_START] = r2(item.actual_month);

            r[CUR_START + 1] = r0(item.invoice_amount);

            r[CUM_START] = r2(item.actual_month_cumulative_total);

            r[CUM_START + 1] = r0(item.cumulative_invoice_total);

            r[REM_START] = r2(item.actual_month_remaining);

            r[REM_START + 1] = r0(item.remaining_amount);



            rows.push(r);

        });



        // ---- totals row ----

        const totalRow = blankRow();

        totalRow[ITEM_COL] = "Total:";

        totalRow[CONTRACT_START] = r2(calculateTotal(roadSurveyinvoice, item => Number(item.boq_KM ?? item.roadsurvey_details.KM)));

        totalRow[CONTRACT_START + 1] = r0(calculateTotal(roadSurveyinvoice, item => Number(item.boq_rate_per_km_times ?? item.roadsurvey_details.rate_per_km_times)));

        totalRow[CONTRACT_START + 2] = r2(calculateTotal(roadSurveyinvoice, item => Number(item.boq_num_of_times_survey_concluded ?? item.roadsurvey_details.num_of_times_survey_concluded)));

        totalRow[CONTRACT_START + 3] = r0(calculateContractAmount);



        if (showDeduction) {

            totalRow[DED_MONTH_COL] = r2(roadSurveyinvoice.reduce((gt, item) => {

                const m = deductionData?.filter(d => d.item_id === item.id) || [];

                return gt + m.reduce((s, d) => s + (Number(d?.deduction_month) || 0), 0);

            }, 0));

            totalRow[DED_AMT_COL] = r0(roadSurveyinvoice.reduce((gt, item) => {

                const m = deductionData?.filter(d => d.item_id === item.id) || [];

                return gt + m.reduce((s, d) => s + ((Number(d?.deduction_amount) || 0) + (Number(d?.withheld_deduction_amount) || 0)), 0);

            }, 0));

        }



        for (let eotIdx = 0; eotIdx < eotLengths; eotIdx++) {

            const totals = roadSurveyinvoice.reduce((acc, emp) => {

                const details = emp.eot_details?.length > 0 ? emp.eot_details : emp.data?.eot_details || [];

                const eot = details[eotIdx];

                if (!eot) return acc;

                acc.KM += Number(eot?.KM) || 0;

                acc.rate_per_km_times += Number(eot?.rate_per_km_times) || 0;

                acc.num_of_times_survey_concluded += Number(eot?.num_of_times_survey_concluded) || 0;

                acc.total_amount += Number(eot?.total_amount) || 0;

                return acc;

            }, { KM: 0, rate_per_km_times: 0, num_of_times_survey_concluded: 0, total_amount: 0 });

            const c = EOT_START + eotIdx * 4;

            totalRow[c] = r2(totals.KM);

            totalRow[c + 1] = r0(totals.rate_per_km_times);

            totalRow[c + 2] = r2(totals.num_of_times_survey_concluded);

            totalRow[c + 3] = r0(totals.total_amount);

        }



        totalRow[PREV_START] = r2(calculateTotal(roadSurveyinvoice, item => Number(item.actual_month_total_previous)));

        totalRow[PREV_START + 1] = r0(calculatePreviousAmount);

        totalRow[CUR_START] = r2(calculateTotal(roadSurveyinvoice, item => Number(item.actual_month)));

        totalRow[CUR_START + 1] = r0(calculateCurrentAmount);

        totalRow[CUM_START] = r2(calculateTotal(roadSurveyinvoice, item => Number(item.actual_month_cumulative_total)));

        totalRow[CUM_START + 1] = r0(calculateCumulated);

        totalRow[REM_START] = r2(calculateTotal(roadSurveyinvoice, item => Number(item.actual_month_remaining)));

        totalRow[REM_START + 1] = r0(calculateRemaining);

        rows.push(totalRow);



        const colWidths = new Array(TOTAL_COLS).fill({ wch: 14 });

        colWidths[SNO_COL] = { wch: 6 };

        colWidths[ITEM_COL] = { wch: 22 };



        return { rows, merges, colWidths, sheetName: "Road Survey Equipment" };

    };

    useEffect(() => {

        if (roadSurveyinvoice.length > 0 && typeof setExcelRows === "function") {

            setExcelRows(buildExcelSheetData());

        }

    }, [roadSurveyinvoice, deductionData]);

    return (

        <div className="boc-modern-wrapper" style={{ minHeight: "30vh" }}>

            <div className="boc-modern-card">



                <div className="boc-modern-header bocx-modern-footer-total">

                    <div className="boc-modern-header-content">

                        <div className="boc-modern-project-info">

                            <h3 className="boc-modern-project-title">{projectData?.project_name}</h3>

                            <div className="boc-modern-project-meta">

                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Client:</span><span className="boc-modern-meta-value">{projectData?.client_name}</span></div>

                                <div className="boc-modern-meta-divider"></div>

                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Consultant (AE):</span><span className="boc-modern-meta-value">{projectData?.lead}{projectData?.jv ? ` JV with ${projectData?.jv}.` : ""}{projectData?.association ? ` Association with ${projectData?.association}` : ""}</span></div>

                                <div className="boc-modern-meta-divider"></div>

                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">GSTIN:</span><span className="boc-modern-meta-value">{projectData?.gst_no}</span></div>

                                <div className="boc-modern-meta-divider"></div>

                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">PAN:</span><span className="boc-modern-meta-value">{projectData?.pan_no}</span></div>

                                <div className="boc-modern-meta-divider"></div>

                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Bid Due:</span><span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.bid_due_date)}</span></div>

                                <div className="boc-modern-meta-divider"></div>

                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Agreement:</span><span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.agreement_date)}</span></div>

                                <div className="boc-modern-meta-divider"></div>

                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Start:</span><span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectData?.commencement_date)}</span></div>

                                <div className="boc-modern-meta-divider"></div>

                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Invoice Number:</span><span className="boc-modern-meta-value">{invoice_num}</span></div>

                                <div className="boc-modern-meta-divider"></div>

                                <div className="boc-modern-meta-item"><span className="boc-modern-meta-label">Date:</span><span className="boc-modern-meta-value">{getMonthName(month)}-{year}</span></div>

                            </div>

                        </div>

                    </div>

                </div>



                <div className="boc-modern-description-section">

                    <div className="boc-modern-controls">

                        <div className="boc-modern-controls-left">

                            <h6 className="boc-modern-main-heading">9- Road Survey Equipment</h6>

                        </div>

                        <div className="hide-on-print">

                            {usefor === "generateinvoice"
                                ? (
                                    roadSurveyinvoice.length === 0
                                        ? <RoadSurveyEquipmentInvoice
                                            usedfor="InvoiceandDeduction"
                                            p_id={p_id ? p_id : project}
                                            invoice_id={invoice_id}
                                            getRoadSurveyinvoice={getRoadSurveyinvoice}
                                            month={month}
                                            year={year}
                                            logData={logData}
                                        />
                                        : <RoadSurveyEquipmentInvoiceUpdate
                                            usedfor="InvoiceandDeduction"
                                            invoiceData={roadSurveyinvoice}
                                            p_id={p_id ? p_id : project}
                                            invoice_id={invoice_id}
                                            getRoadSurveyinvoice={getRoadSurveyinvoice}
                                            month={month}
                                            year={year}
                                            logData={logData}
                                        />
                                )
                                : <>
                                    {roadSurveyinvoice.length === 0

                                        ? <RoadSurveyEquipmentInvoice invoiceData={roadSurveyinvoice} usedfor="OnlyDeduction" p_id={p_id ? p_id : project} invoice_id={invoice_id} getRoadSurveyinvoice={getRoadSurveyinvoice} month={month} year={year} logData={logData} />

                                        : <UpdateRoadSurveyDeductionInvoice invoiceData={roadSurveyinvoice} getData={getRoadSurveyinvoice} />}

                                </>

                            }

                        </div>

                    </div>

                </div>



                <div className="boc-modern-table-wrapper">

                    <div className="boc-modern-table-scroll">

                        <table className="boc-modern-table">

                            <thead>

                                <tr className="boc-modern-table-header">

                                    <th className="boc-modern-th text-center" rowSpan="4">S.No</th>

                                    <th className="boc-modern-th text-center" rowSpan="4">Item</th>

                                    <th className="boc-modern-th text-center" colSpan="4">Contract Amount</th>

                                    {usefor !== "generateinvoice" && (

                                        <>

                                            <th className="boc-modern-th text-center" rowSpan="4">Deduction Month</th>

                                            <th className="boc-modern-th text-center" rowSpan="4">Deduction Amount</th>

                                        </>

                                    )}

                                    {isEotDataTrue && <th className="boc-modern-th text-center" colSpan={eotLengths * 4 || 1}>(COS/EOT)</th>}

                                    <th className="boc-modern-th text-center" colSpan="2">Cumulative Total of Previous Months</th>

                                    <th className="boc-modern-th text-center" colSpan="2">This Period</th>

                                    <th className="boc-modern-th text-center" colSpan="2">Cumulative Total Including Current Invoice</th>

                                    <th className="boc-modern-th text-center" colSpan="2">Remaining Amount Against Contract Value</th>

                                    {role !== "SiteManagement" && role !== "ViewAccess" && <th className="boc-modern-th text-center hide-on-print" rowSpan="4">Action</th>}

                                </tr>

                                <tr className="boc-modern-table-subheader">

                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">KM</th>

                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Rate Per KM</th>

                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">No. of Times Survey</th>

                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Total Amount</th>

                                    {Array.from({ length: eotLengths }).map((_, idx) => (

                                        <th key={idx} className="boc-modern-th text-center boc-nowrap" colSpan={4}>{`EOT ${idx + 1}`}</th>

                                    ))}

                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Month</th>

                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Amount</th>

                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Month</th>

                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Amount</th>

                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Month</th>

                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Amount</th>

                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Month</th>

                                    <th rowSpan="2" className="boc-modern-th boc-nowrap">Amount</th>

                                </tr>

                                <tr className="boc-modern-table-subheader">

                                    {Array.from({ length: eotLengths }).map((_, idx) => (

                                        <React.Fragment key={idx}>

                                            <th rowSpan="2" className="boc-modern-th boc-nowrap">KM</th>

                                            <th rowSpan="2" className="boc-modern-th boc-nowrap">Rate Per KM</th>

                                            <th rowSpan="2" className="boc-modern-th boc-nowrap">No. of Times</th>

                                            <th rowSpan="2" className="boc-modern-th boc-nowrap">Total Amount</th>

                                        </React.Fragment>

                                    ))}

                                </tr>

                            </thead>



                            <tbody>

                                {roadSurveyinvoice.map((item, index) => {

                                    const matchedDeductions = deductionData?.filter(d => d.item_id === item.id) || [];

                                    return (

                                        <tr className="boc-modern-row" key={item.id}>

                                            <td className="boc-modern-td text-center">{index + 1}.</td>

                                            <td className="boc-modern-td"><div style={{ whiteSpace: "normal", width: "100px" }}>{item.boq_description ?? item.roadsurvey_details.description}</div></td>

                                            <td className="boc-modern-td boc-nowrap text-right">{formatQuantity2(Number(item.boq_KM ?? item.roadsurvey_details.KM))}</td>

                                            <td className="boc-modern-td boc-nowrap boc-modern-currency text-right">₹ {formatAmount0(Number(item.boq_rate_per_km_times ?? item.roadsurvey_details.rate_per_km_times))}</td>

                                            <td className="boc-modern-td boc-nowrap text-right">{formatQuantity2(Number(item.boq_num_of_times_survey_concluded ?? item.roadsurvey_details.num_of_times_survey_concluded))}</td>

                                            <td className="boc-modern-td boc-nowrap text-right">

                                                <span className="boc-modern-currency boc-modern-total-highlight">

                                                    ₹ {formatAmount0(Number(item.boq_KM ?? item.roadsurvey_details.KM) * Number(item.boq_rate_per_km_times ?? item.roadsurvey_details.rate_per_km_times) * Number(item.boq_num_of_times_survey_concluded ?? item.roadsurvey_details.num_of_times_survey_concluded))}

                                                </span>

                                            </td>



                                            {usefor !== "generateinvoice" && (

                                                <td className="boc-modern-td boc-nowrap text-right justify-end" style={{ padding: 0 }}>

                                                    {matchedDeductions.length > 0

                                                        ? matchedDeductions.map((n, i) => <div key={i} className="boc-multi-item boc-nowrap">{n.deduction_month == null ? "-" : formatQuantity2(n.deduction_month)}</div>)

                                                        : <div className="boc-multi-item">-</div>}

                                                </td>

                                            )}

                                            {usefor !== "generateinvoice" && (

                                                <td className="boc-modern-td boc-nowrap text-right justify-end" style={{ padding: 0 }}>

                                                    {matchedDeductions.length > 0

                                                        ? matchedDeductions.map((n, i) => <div key={i} className="boc-multi-item boc-nowrap">{formatAmount0((Number(n.deduction_amount) || 0) + (Number(n.withheld_deduction_amount) || 0))}</div>)

                                                        : <div className="boc-multi-item">0</div>}

                                                </td>

                                            )}



                                            {item?.eot_details?.length > 0 && item.eot_details.map((i, idx) => (

                                                <React.Fragment key={idx}>

                                                    <td className="boc-modern-td boc-nowrap text-right">{formatQuantity2(i.KM)}</td>

                                                    <td className="boc-modern-td boc-nowrap boc-modern-currency text-right">₹ {formatAmount0(Number(i.rate_per_km_times))}</td>

                                                    <td className="boc-modern-td boc-nowrap text-right">{formatQuantity2(i.num_of_times_survey_concluded)}</td>

                                                    <td className="boc-modern-td boc-nowrap boc-modern-currency text-right">₹ {formatAmount0(Number(i.total_amount))}</td>

                                                </React.Fragment>

                                            ))}



                                            <td className="boc-modern-td boc-nowrap text-right">{formatQuantity2(Number(item.actual_month_total_previous))}</td>

                                            <td className="boc-modern-td boc-nowrap boc-modern-currency text-right">₹ {formatAmount0(Number(item.previous_invoice_total))}</td>

                                            <td className="boc-modern-td boc-nowrap text-right">{formatQuantity2(Number(item.actual_month))}</td>

                                            <td className="boc-modern-td boc-nowrap boc-modern-currency text-right">₹ {formatAmount0(Number(item.invoice_amount))}</td>

                                            <td className="boc-modern-td boc-nowrap text-right">{formatQuantity2(Number(item.actual_month_cumulative_total))}</td>

                                            <td className="boc-modern-td boc-nowrap boc-modern-currency text-right">₹ {formatAmount0(Number(item.cumulative_invoice_total))}</td>

                                            <td className="boc-modern-td boc-nowrap text-right">{formatQuantity2(Number(item.actual_month_remaining))}</td>

                                            <td className="boc-modern-td boc-nowrap text-right">

                                                <span className="boc-modern-currency boc-modern-total-highlight">₹ {formatAmount0(Number(item.remaining_amount))}</span>

                                            </td>



                                            {usefor === "generateinvoice" && (

                                                <>

                                                    {(!["Checker", "SiteManagement"].includes(role)) || (role === "Checker" && !isMoreThan24Hours(item.created_at)) ? (

                                                        <td className="boc-modern-td text-center hide-on-print">

                                                            {usefor === "generateinvoice"

                                                                ? <DeleteRoadSurveyEquipmentInvoice i={item} getRoadSurveyinvoice={getRoadSurveyinvoice} />

                                                                : <DeleteRoadSurveyEquipmentInvoiceDeduction i={item} getRoadSurveyinvoice={getRoadSurveyinvoice} />}

                                                        </td>

                                                    ) : <td className="boc-modern-td text-center hide-on-print">-</td>}

                                                </>

                                            )}

                                        </tr>

                                    );

                                })}

                            </tbody>



                            <tfoot>

                                <tr className="boc-modern-footer">

                                    <td colSpan="2" className="boc-modern-footer-label">Total:</td>

                                    <td className="boc-modern-td boc-nowrap text-right">{formatQuantity2(calculateTotal(roadSurveyinvoice, item => Number(item.boq_KM ?? item.roadsurvey_details.KM)))}</td>

                                    <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatAmount0(calculateTotal(roadSurveyinvoice, item => Number(item.boq_rate_per_km_times ?? item.roadsurvey_details.rate_per_km_times)))}</span></td>

                                    <td className="boc-modern-td boc-nowrap text-right">{formatQuantity2(calculateTotal(roadSurveyinvoice, item => Number(item.boq_num_of_times_survey_concluded ?? item.roadsurvey_details.num_of_times_survey_concluded)))}</td>

                                    <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatAmount0(calculateTotal(roadSurveyinvoice, item => Number(item.boq_KM ?? item.roadsurvey_details.KM) * Number(item.boq_rate_per_km_times ?? item.roadsurvey_details.rate_per_km_times) * Number(item.boq_num_of_times_survey_concluded ?? item.roadsurvey_details.num_of_times_survey_concluded)))}</span></td>



                                    {usefor !== "generateinvoice" && (

                                        <>

                                            <td className="boc-modern-td boc-nowrap text-right">

                                                {formatQuantity2(roadSurveyinvoice.reduce((gt, item) => {

                                                    const m = deductionData?.filter(d => d.item_id === item.id) || [];

                                                    return gt + m.reduce((s, d) => s + (Number(d?.deduction_month) || 0), 0);

                                                }, 0))}

                                            </td>

                                            <td className="boc-modern-td boc-nowrap text-right">

                                                <span className="boc-modern-currency boc-modern-footer-total">

                                                    ₹ {formatAmount0(

                                                        roadSurveyinvoice.reduce((gt, item) => {

                                                            const m = deductionData?.filter(d => d.item_id === item.id) || [];

                                                            return gt + m.reduce((s, d) => s + ((Number(d?.deduction_amount) || 0) + (Number(d?.withheld_deduction_amount) || 0)), 0);

                                                        }, 0)

                                                    )}

                                                </span>

                                            </td>

                                        </>

                                    )}



                                    {isEotDataTrue && Array.from({ length: eotLengths }).map((_, eotIdx) => {

                                        const totals = roadSurveyinvoice.reduce((acc, emp) => {

                                            const details = emp.eot_details?.length > 0 ? emp.eot_details : emp.data?.eot_details || [];

                                            const eot = details[eotIdx];

                                            if (!eot) return acc;

                                            acc.KM += Number(eot?.KM) || 0;

                                            acc.rate_per_km_times += Number(eot?.rate_per_km_times) || 0;

                                            acc.num_of_times_survey_concluded += Number(eot?.num_of_times_survey_concluded) || 0;

                                            acc.total_amount += Number(eot?.total_amount) || 0;

                                            return acc;

                                        }, { KM: 0, rate_per_km_times: 0, num_of_times_survey_concluded: 0, total_amount: 0 });

                                        return (

                                            <React.Fragment key={eotIdx}>

                                                <td className="boc-modern-td boc-nowrap text-right">{formatQuantity2(totals.KM)}</td>

                                                <td className="boc-modern-td boc-nowrap text-right">₹ {formatAmount0(totals.rate_per_km_times)}</td>

                                                <td className="boc-modern-td boc-nowrap text-right">{formatQuantity2(totals.num_of_times_survey_concluded)}</td>

                                                <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatAmount0(totals.total_amount)}</span></td>

                                            </React.Fragment>

                                        );

                                    })}



                                    <td className="boc-modern-td boc-nowrap text-right">{formatQuantity2(calculateTotal(roadSurveyinvoice, item => Number(item.actual_month_total_previous)))}</td>

                                    <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatAmount0(calculateTotal(roadSurveyinvoice, item => Number(item.previous_invoice_total)))}</span></td>

                                    <td className="boc-modern-td boc-nowrap text-right">{formatQuantity2(calculateTotal(roadSurveyinvoice, item => Number(item.actual_month)))}</td>

                                    <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatAmount0(calculateTotal(roadSurveyinvoice, item => Number(item.invoice_amount)))}</span></td>

                                    <td className="boc-modern-td boc-nowrap text-right">{formatQuantity2(calculateTotal(roadSurveyinvoice, item => Number(item.actual_month_cumulative_total)))}</td>

                                    <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatAmount0(calculateTotal(roadSurveyinvoice, item => Number(item.cumulative_invoice_total)))}</span></td>

                                    <td className="boc-modern-td boc-nowrap text-right">{formatQuantity2(calculateTotal(roadSurveyinvoice, item => Number(item.actual_month_remaining)))}</td>

                                    <td className="boc-modern-td boc-nowrap text-right"><span className="boc-modern-currency boc-modern-footer-total">₹ {formatAmount0(calculateTotal(roadSurveyinvoice, item => Number(item.remaining_amount)))}</span></td>

                                    {role !== "SiteManagement" && role !== "ViewAccess" && <td className="hide-on-print boc-modern-td"></td>}

                                </tr>

                            </tfoot>

                        </table>

                    </div>

                </div>

            </div>

        </div>

    );





};



const ConsultancyInvoiceContingency = ({ projectData, setExcelRows,
    client, p_id, invoice_id, year, month, invoice_num }) => {

    const role = sessionStorage.getItem('sitemanagement_role');
    const project = sessionStorage.getItem('sitemanagement_project');

    const [projectContingencies, setProjectContingencies] = useState(null);
    // const [projectdata, setProjectdata] = useState([]);
    const getProjectContingencies = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/boqcontingenciesbyproject/${p_id ? p_id : project}/`
            );
            setProjectContingencies(res.data);
        } catch (err) {
            console.error("Error fetching consultant invoice data:", err);
        }
    };
    const [contigency, setContigency] = useState([]);

    const getContigency = async () => {
        try {
            const res = await axios.get(
                `${BASE_URL}/siteproject/invoicecontingenciesbyproject/${p_id ? p_id : project}/`
            );
            setContigency(res.data);
        } catch (err) {
            console.error("Error fetching consultant invoice data:", err);
        }
    };

    useEffect(() => {
        getProjectContingencies();

    }, [p_id, project, invoice_id]);

    useEffect(() => {
        getContigency();
    }, [p_id, project])
    const r2 = (val) => {
        const n = Number(val);
        return isNaN(n) ? 0 : Math.round(n * 100) / 100;
    };

    // ── Builds a simple flat sheet — no merged header groups needed here ──
    const buildExcelSheetData = () => {
        const TOTAL_COLS = 4; // Sr.No, Month, Actual Month, This Period

        const blankRow = () => new Array(TOTAL_COLS).fill("");

        const row1 = blankRow();
        row1[0] = "Sr.No";
        row1[1] = "Month";
        row1[2] = "Actual Month";
        row1[3] = "This Period";

        const rows = [row1];

        (contigency || []).forEach((item, index) => {
            const r = blankRow();
            r[0] = index + 1;
            r[1] = item.month ?? "";
            r[2] = item.actual_month ?? "";
            r[3] = r2(item.current_invoice_amount);
            rows.push(r);
        });

        // ---- totals row ----
        const totalRow = blankRow();
        totalRow[1] = "Total:";
        totalRow[3] = r2(
            (contigency || []).reduce((sum, item) => sum + (Number(item.current_invoice_amount) || 0), 0)
        );
        rows.push(totalRow);

        const colWidths = [
            { wch: 8 },
            { wch: 14 },
            { wch: 14 },
            { wch: 16 },
        ];

        return { rows, merges: [], colWidths, sheetName: "Contingencies" };
    };
    useEffect(() => {
        if (typeof setExcelRows === "function") {
            setExcelRows(buildExcelSheetData());
        }
    }, [contigency]);


    return (
        <div className="boc-modern-wrapper" style={{ minHeight: "20vh" }}>
            <div className="boc-modern-card">

                {/* Section heading + action */}
                <div className="boc-modern-description-section">
                    <div className="boc-modern-controls">
                        <div className="boc-modern-controls-left">
                            <h6 className="boc-modern-main-heading">10- Contingencies</h6>
                        </div>
                        <div className="hide-on-print">
                            <AddContingenciesinvoice
                                p_id={p_id ? p_id : project}
                                invoice_id={invoice_id}
                                getContingencies={getContigency}
                                dataInvoice={projectContingencies}
                                month={month}
                                year={year}
                            />
                        </div>
                    </div>
                </div>

                <p style={{ padding: "0 16px 8px", fontSize: "13px", color: "var(--color-text-secondary, #666)" }}>
                    A fixed amount of Indian Rupees ONE MILLION shall be included in the Financial Proposal. The provisions of Contingency shall be operated with the specific approval from the Authority.
                </p>

                <div className="boc-modern-table-wrapper">
                    <div className="boc-modern-table-scroll">
                        <table className="boc-modern-table">
                            <thead>
                                <tr className="boc-modern-table-header">
                                    <th className="boc-modern-th text-center">Sr.No</th>
                                    <th className="boc-modern-th text-center">Month</th>
                                    <th className="boc-modern-th text-center">Actual Month</th>
                                    <th className="boc-modern-th text-center">This Period</th>
                                    {role !== "SiteManagement" && role !== "ViewAccess" && (
                                        <th className="boc-modern-th text-center hide-on-print">Action</th>
                                    )}
                                </tr>
                            </thead>
                            <tbody>
                                {contigency?.map((item, index) => (
                                    <tr className="boc-modern-row" key={item.id}>
                                        <td className="boc-modern-td text-center">{index + 1}</td>
                                        <td className="boc-modern-td boc-nowrap text-right">{item.month}</td>
                                        <td className="boc-modern-td boc-nowrap text-right">{item.actual_month}</td>
                                        <td className="boc-modern-td boc-nowrap boc-modern-currency text-right">
                                            <span className="boc-modern-currency boc-modern-total-highlight">
                                                {formatCurrencyIndian(item.current_invoice_amount)}
                                            </span>
                                        </td>
                                        {(!["Checker", "SiteManagement"].includes(role)) || (role === "Checker" && !isMoreThan24Hours(item.created_at)) ? (
                                            <td className="boc-modern-td text-center hide-on-print">
                                                <DeleteUpdateContingenciestinvoice i={item} getContingencies={getContigency} />
                                            </td>
                                        ) : (
                                            <td className="boc-modern-td text-center hide-on-print">-</td>
                                        )}
                                    </tr>
                                ))}
                            </tbody>
                            <tfoot>
                                <tr className="boc-modern-footer">
                                    <td colSpan="4" className="boc-modern-footer-label"></td>
                                    {role !== "SiteManagement" && role !== "ViewAccess" && <td className="hide-on-print boc-modern-td"></td>}
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};


const PrintPaymentInvoiceFormat = React.forwardRef((props, ref) => {

    const location = useLocation();
    const p_id = location.state ? location.state.p_id : "";
    const invoice_id = location.state ? location.state.invoice_id : "";
    const month = location.state ? location.state.month : "";
    const year = location.state ? location.state.year : "";
    const invoice_num = location.state ? location.state.invoice_number : "";

    return (
        <div className='printSlip-container' ref={ref} >

            <PaymentReceipt p_id={p_id} invoice_id={invoice_id} month={month} year={year} invoice_num={invoice_num} />


        </div>
    )
})

const ConsultancyInvoiceFormat = React.forwardRef(({ usefor, onExportReady, p_id: p_idProp, invoice_id: invoice_idProp, month: monthProp, year: yearProp, invoice_number: invoiceNumProp }, ref) => {
    const location = useLocation();
    const p_id = p_idProp ?? (location.state ? location.state.p_id : "");
    const invoice_id = invoice_idProp ?? (location.state ? location.state.invoice_id : "");
    const month = monthProp ?? (location.state ? location.state.month : "");
    const year = yearProp ?? (location.state ? location.state.year : "");
    const invoice_num = invoiceNumProp ?? (location.state ? location.state.invoice_number : "");
    const nvoice_num = location.state ? location.state.invoice_number : "";
    const [project, setProject] = useState([]);
    const projectid = sessionStorage.getItem('sitemanagement_project');
    const [logChange, setlogChange] = useState([]);
    const [projectbyid, setprojectbyid] = useState({});
    const [deductionList, setDeductionList] = useState([]);
    const [professionalStaffExcelRows, setProfessionalStaffExcelRows] = useState(null);
    const [transportationExcelRows, setTransportationExcelRows] = useState(null);
    const [dutyTravelExcelRows, setDutyTravelExcelRows] = useState(null);
    const [officeRentExcelRows, setOfficeRentExcelRows] = useState(null);
    const [officeSuppliesExcelRows, setOfficeSuppliesExcelRows] = useState(null);
    const [officeFurnitureExcelRows, setOfficeFurnitureExcelRows] = useState(null);
    const [reportsPrinttExcelRows, setReportsPrinttExcelRows] = useState(null);
    const [roadSurveyExcelRows, setRoadSurveyExcelRows] = useState(null);
    const [contingencyExcelRows, setContingencyExcelRows] = useState(null);

    // All amounts → 2 decimals (Indian comma format)
    const formatCurrencyIndian = (v) =>
        Number(Number(v || 0).toFixed(2)).toLocaleString('en-IN', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    const n2 = (v) => Number(Number(v || 0).toFixed(2));
    useImperativeHandle(ref, () => ({
        exportExcel: handleExportToExcel,
    }));

    useEffect(() => {
        if (projectbyid && Object.keys(projectbyid).length > 0 && typeof onExportReady === "function") {
            onExportReady();
        }
    }, [projectbyid]);

    const addSheetTitle = (rows, merges, title, totalCols) => {
        const titleRow = new Array(totalCols).fill("");
        titleRow[0] = title;

        const newRows = [titleRow, ...rows];

        const newMerges = [
            { s: { r: 0, c: 0 }, e: { r: 0, c: Math.max(totalCols - 1, 0) } },
            ...(merges || []).map(m => ({
                s: { r: m.s.r + 1, c: m.s.c },
                e: { r: m.e.r + 1, c: m.e.c }
            }))
        ];

        return { rows: newRows, merges: newMerges };
    };

    const applyTitleStyle = (sheet, cellRef = 'A1') => {
        if (sheet[cellRef]) {
            sheet[cellRef].s = {
                font: { bold: true, sz: 14 },
                alignment: { horizontal: 'left', vertical: 'center' }
            };
        }
    };
    const getDeductionList = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/siteproject/invoicedeductionfilter/null/${invoice_id}/null/`);
            setDeductionList(response.data);
        } catch (error) {
            console.error("Error fetching project by ID:", error);
            handleErrorToast(error);
        }
    };

    const getProjectById = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/siteproject/project/${p_id ? p_id : project}/`);
            setprojectbyid(response.data);
        } catch (error) {
            console.error("Error fetching project by ID:", error);
            handleErrorToast(error);
        }
    };

    useEffect(() => {
        getProjectById();
        getDeductionList();
    }, [p_id, project, invoice_id]);


    const getEscalationPercent = (project, checkDate = new Date()) => {
        const baseDateStr =
            project.escalation_apllicable_on === "Bid Due Date"
                ? project.bid_due_date
                : project.escalation_apllicable_on === "Contract Agreement Date" ? project.agreement_date :
                    project.bid_due_date
            ;

        if (!baseDateStr) return 0;

        const baseDate = new Date(baseDateStr);
        const today = new Date(checkDate);

        let years = today.getFullYear() - baseDate.getFullYear();

        const anniversaryThisYear = new Date(baseDate);
        anniversaryThisYear.setFullYear(baseDate.getFullYear() + years);

        if (today < anniversaryThisYear) {
            years -= 1;
        }

        if (years < 1) return 0;

        return years * 5; // escalation percentage
    };

    // USAGE:
    const escalationPercent = getEscalationPercent(projectbyid);
    console.log("escalationPercent", escalationPercent); // e.g. 5, 10, 15...

    const getLogData = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/unifiedChangeLog/`);
            setlogChange(
                [...res.data].sort((a, b) => new Date(b.data.created_at) - new Date(a.data.created_at))
            );
        } catch (error) {
            console.error("Error fetching Log cost", error);
        }
    };

    useEffect(() => {
        getLogData();
    }, []);

    const getProject = async () => {
        try {
            const res = await axios.get(`${BASE_URL}/siteproject/projectbyid/${p_id ? p_id : projectid}/`);
            setProject(res.data);
        } catch (error) { }
    };

    useEffect(() => {
        getProject();
    }, [p_id, projectid]);

    const filterBOQEmployeeeLogChange = logChange.filter(i => i.model_name === "BOQEmployee" && i.data.project === p_id);
    const filterBOQTransportationLogChange = logChange.filter(i => i.model_name === "BOQTransportation" && i.data.project === p_id);
    const filterBOQOfficeFurnitureAndEquipmentLogChange = logChange.filter(i => i.model_name === "BOQOfficeFurnitureAndEquipment" && i.data.project === p_id);
    const filterBOQDutyTravelLogChange = logChange.filter(i => i.model_name === "BOQDutyTravel" && i.data.project === p_id);
    const filterBOQOfficeSuppliesLogChange = logChange.filter(i => i.model_name === "BOQOfficeSupplies" && i.data.project === p_id);
    const filterBOQReportsAndDocumentPrintingLogChange = logChange.filter(i => i.model_name === "BOQReportsAndDocumentPrinting" && i.data.project === p_id);
    const filterBOQOfficeRentLogChange = logChange.filter(i => i.model_name === "BOQOfficeRent" && i.data.project === p_id);
    const filterBOQRoadSurveyEquipmentLogChange = logChange.filter(i => i.model_name === "BOQRoadSurveyEquipment" && i.data.project === p_id);

    // ── Amount States ──────────────────────────────────────────────
    const [EmployeeContractAmount, setEmployeeContractAmount] = useState("");
    const [EmployeepreviousAmount, setEmployeePreviousAmount] = useState("");
    const [EmployeecurrentAmount, setEmployeecurrentAmount] = useState("");
    const [EmployeecumulatedAmount, setEmployeecumulatedAmount] = useState("");
    const [EmployeeremainingAmount, setEmployeeremainingAmount] = useState("");
    const [EmployeeEotDetails, setEmployeeEotDetails] = useState([]);

    const [dutyContractAmount, setDutyContractAmount] = useState("");
    const [dutypreviousAmount, setdutyPreviousAmount] = useState("");
    const [dutycurrentAmount, setdutycurrentAmount] = useState("");
    const [dutycumulatedAmount, setdutycumulatedAmount] = useState("");
    const [dutyremainingAmount, setdutyremainingAmount] = useState("");
    const [dutyEotDetails, setDutyEotDetails] = useState([]);

    const [transportContractAmount, settransportContractAmount] = useState("");
    const [transportpreviousAmount, settransportPreviousAmount] = useState("");
    const [transportcurrentAmount, settransportcurrentAmount] = useState("");
    const [transportcumulatedAmount, settransportcumulatedAmount] = useState("");
    const [transportremainingAmount, settransportremainingAmount] = useState("");
    const [transportEotDetails, setTransportEotDetails] = useState([]);

    const [officeRentContractAmount, setofficeRentContractAmount] = useState("");
    const [officeRentpreviousAmount, setofficeRentPreviousAmount] = useState("");
    const [officeRentcurrentAmount, setofficeRentcurrentAmount] = useState("");
    const [officeRentcumulatedAmount, setofficeRentcumulatedAmount] = useState("");
    const [officeRentremainingAmount, setofficeRentremainingAmount] = useState("");
    const [officeRentEotDetails, setOfficeRentEotDetails] = useState([]);

    const [officeSuppliesContractAmount, setofficeSuppliesContractAmount] = useState("");
    const [officeSuppliespreviousAmount, setofficeSuppliesPreviousAmount] = useState("");
    const [officeSuppliescurrentAmount, setofficeSuppliescurrentAmount] = useState("");
    const [officeSuppliescumulatedAmount, setofficeSuppliescumulatedAmount] = useState("");
    const [officeSuppliesremainingAmount, setofficeSuppliesremainingAmount] = useState("");
    const [officeSuppliesEotDetails, setOfficeSuppliesEotDetails] = useState([]);

    const [officeFurnitureContractAmount, setofficeFurnitureContractAmount] = useState("");
    const [officeFurniturepreviousAmount, setofficeFurniturePreviousAmount] = useState("");
    const [officeFurniturecurrentAmount, setofficeFurniturecurrentAmount] = useState("");
    const [officeFurniturecumulatedAmount, setofficeFurniturecumulatedAmount] = useState("");
    const [officeFurnitureremainingAmount, setofficeFurnitureremainingAmount] = useState("");
    const [officeFurnitureEotDetails, setOfficeFurnitureEotDetails] = useState([]);

    const [officeReportsContractAmount, setofficeReportsContractAmount] = useState("");
    const [officeReportspreviousAmount, setofficeReportsPreviousAmount] = useState("");
    const [officeReportscurrentAmount, setofficeReportscurrentAmount] = useState("");
    const [officeReportscumulatedAmount, setofficeReportscumulatedAmount] = useState("");
    const [officeReportsremainingAmount, setofficeReportsremainingAmount] = useState("");
    const [officeReportsEotDetails, setOfficeReportsEotDetails] = useState([]);

    const [officeRoadSurveyContractAmount, setofficeRoadSurveyContractAmount] = useState("");
    const [officeRoadSurveypreviousAmount, setofficeRoadSurveyPreviousAmount] = useState("");
    const [officeRoadSurveycurrentAmount, setofficeRoadSurveycurrentAmount] = useState("");
    const [officeRoadSurveycumulatedAmount, setofficeRoadSurveycumulatedAmount] = useState("");
    const [officeRoadSurveyremainingAmount, setofficeRoadSurveyremainingAmount] = useState("");
    const [officeRoadSurveyEotDetails, setOfficeRoadSurveyEotDetails] = useState([]);

    // ── Totals ─────────────────────────────────────────────────────
    const totalContractAmount = useMemo(() =>
        Number(EmployeeContractAmount) + Number(transportContractAmount) + Number(dutyContractAmount) +
        Number(officeRentContractAmount) + Number(officeSuppliesContractAmount) + Number(officeFurnitureContractAmount) +
        Number(officeReportsContractAmount) + Number(officeRoadSurveyContractAmount),
        [EmployeeContractAmount, transportContractAmount, dutyContractAmount, officeRentContractAmount,
            officeSuppliesContractAmount, officeFurnitureContractAmount, officeReportsContractAmount, officeRoadSurveyContractAmount]);

    const totalPreviousAmount = useMemo(() =>
        Number(EmployeepreviousAmount) + Number(transportpreviousAmount) + Number(dutypreviousAmount) +
        Number(officeRentpreviousAmount) + Number(officeSuppliespreviousAmount) + Number(officeFurniturepreviousAmount) +
        Number(officeReportspreviousAmount) + Number(officeRoadSurveypreviousAmount),
        [EmployeepreviousAmount, transportpreviousAmount, dutypreviousAmount, officeRentpreviousAmount,
            officeSuppliespreviousAmount, officeFurniturepreviousAmount, officeReportspreviousAmount, officeRoadSurveypreviousAmount]);

    const totalCurrentAmount = useMemo(() =>
        Number(EmployeecurrentAmount) + Number(transportcurrentAmount) + Number(dutycurrentAmount) +
        Number(officeRentcurrentAmount) + Number(officeSuppliescurrentAmount) + Number(officeFurniturecurrentAmount) +
        Number(officeReportscurrentAmount) + Number(officeRoadSurveycurrentAmount),
        [EmployeecurrentAmount, transportcurrentAmount, dutycurrentAmount, officeRentcurrentAmount,
            officeSuppliescurrentAmount, officeFurniturecurrentAmount, officeReportscurrentAmount, officeRoadSurveycurrentAmount]);

    const totalCumulatedAmount = useMemo(() =>
        Number(EmployeecumulatedAmount) + Number(transportcumulatedAmount) + Number(dutycumulatedAmount) +
        Number(officeRentcumulatedAmount) + Number(officeSuppliescumulatedAmount) + Number(officeFurniturecumulatedAmount) +
        Number(officeReportscumulatedAmount) + Number(officeRoadSurveycumulatedAmount),
        [EmployeecumulatedAmount, transportcumulatedAmount, dutycumulatedAmount, officeRentcumulatedAmount,
            officeSuppliescumulatedAmount, officeFurniturecumulatedAmount, officeReportscumulatedAmount, officeRoadSurveycumulatedAmount]);

    const totalRemainingAmount = useMemo(() =>
        Number(EmployeeremainingAmount) + Number(transportremainingAmount) + Number(dutyremainingAmount) +
        Number(officeRentremainingAmount) + Number(officeSuppliesremainingAmount) + Number(officeFurnitureremainingAmount) +
        Number(officeReportsremainingAmount) + Number(officeRoadSurveyremainingAmount),
        [EmployeeremainingAmount, transportremainingAmount, dutyremainingAmount, officeRentremainingAmount,
            officeSuppliesremainingAmount, officeFurnitureremainingAmount, officeReportsremainingAmount, officeRoadSurveyremainingAmount]);

    // ── EOT Columns ────────────────────────────────────────────────
    const allEotArrays = useMemo(() => [
        EmployeeEotDetails, transportEotDetails, dutyEotDetails, officeRentEotDetails,
        officeSuppliesEotDetails, officeFurnitureEotDetails, officeReportsEotDetails, officeRoadSurveyEotDetails,
    ], [EmployeeEotDetails, transportEotDetails, dutyEotDetails, officeRentEotDetails,
        officeSuppliesEotDetails, officeFurnitureEotDetails, officeReportsEotDetails, officeRoadSurveyEotDetails]);

    const maxEotCount = useMemo(() =>
        allEotArrays.reduce((max, e) => Math.max(max, e?.length || 0), 0),
        [allEotArrays]);

    const eotColumns = useMemo(() =>
        Array.from({ length: maxEotCount }, (_, i) => i),
        [maxEotCount]);

    // ── Summary Rows ───────────────────────────────────────────────
    const summaryRows = useMemo(() => [
        { sno: "1", label: "Remuneration for Local Professional Staff", contract: EmployeeContractAmount, previous: EmployeepreviousAmount, current: EmployeecurrentAmount, cumulated: EmployeecumulatedAmount, remaining: EmployeeremainingAmount, eots: EmployeeEotDetails },
        { sno: "2", label: "Transportation", contract: transportContractAmount, previous: transportpreviousAmount, current: transportcurrentAmount, cumulated: transportcumulatedAmount, remaining: transportremainingAmount, eots: transportEotDetails },
        { sno: "3", label: "Duty Travel", contract: dutyContractAmount, previous: dutypreviousAmount, current: dutycurrentAmount, cumulated: dutycumulatedAmount, remaining: dutyremainingAmount, eots: dutyEotDetails },
        { sno: "4", label: "Office Rent", contract: officeRentContractAmount, previous: officeRentpreviousAmount, current: officeRentcurrentAmount, cumulated: officeRentcumulatedAmount, remaining: officeRentremainingAmount, eots: officeRentEotDetails },
        { sno: "5", label: "Office Supplies", contract: officeSuppliesContractAmount, previous: officeSuppliespreviousAmount, current: officeSuppliescurrentAmount, cumulated: officeSuppliescumulatedAmount, remaining: officeSuppliesremainingAmount, eots: officeSuppliesEotDetails },
        { sno: "6", label: "Office Furniture", contract: officeFurnitureContractAmount, previous: officeFurniturepreviousAmount, current: officeFurniturecurrentAmount, cumulated: officeFurniturecumulatedAmount, remaining: officeFurnitureremainingAmount, eots: officeFurnitureEotDetails },
        { sno: "7", label: "Report and Document Printing", contract: officeReportsContractAmount, previous: officeReportspreviousAmount, current: officeReportscurrentAmount, cumulated: officeReportscumulatedAmount, remaining: officeReportsremainingAmount, eots: officeReportsEotDetails },
        { sno: "8", label: "Road Survey Equipment", contract: officeRoadSurveyContractAmount, previous: officeRoadSurveypreviousAmount, current: officeRoadSurveycurrentAmount, cumulated: officeRoadSurveycumulatedAmount, remaining: officeRoadSurveyremainingAmount, eots: officeRoadSurveyEotDetails },
    ], [
        EmployeeContractAmount, EmployeepreviousAmount, EmployeecurrentAmount, EmployeecumulatedAmount, EmployeeremainingAmount, EmployeeEotDetails,
        transportContractAmount, transportpreviousAmount, transportcurrentAmount, transportcumulatedAmount, transportremainingAmount, transportEotDetails,
        dutyContractAmount, dutypreviousAmount, dutycurrentAmount, dutycumulatedAmount, dutyremainingAmount, dutyEotDetails,
        officeRentContractAmount, officeRentpreviousAmount, officeRentcurrentAmount, officeRentcumulatedAmount, officeRentremainingAmount, officeRentEotDetails,
        officeSuppliesContractAmount, officeSuppliespreviousAmount, officeSuppliescurrentAmount, officeSuppliescumulatedAmount, officeSuppliesremainingAmount, officeSuppliesEotDetails,
        officeFurnitureContractAmount, officeFurniturepreviousAmount, officeFurniturecurrentAmount, officeFurniturecumulatedAmount, officeFurnitureremainingAmount, officeFurnitureEotDetails,
        officeReportsContractAmount, officeReportspreviousAmount, officeReportscurrentAmount, officeReportscumulatedAmount, officeReportsremainingAmount, officeReportsEotDetails,
        officeRoadSurveyContractAmount, officeRoadSurveypreviousAmount, officeRoadSurveycurrentAmount, officeRoadSurveycumulatedAmount, officeRoadSurveyremainingAmount, officeRoadSurveyEotDetails,
    ]);
    const currentUrl = window.location.href;
    const urlParts = currentUrl.split("/");
    const navigate = useNavigate();

    const ViewInvoiceDeduction = (invoice_id, month, invoice_number, year) => {
        navigate(`/${urlParts[3]}/ConsultancyInvoiceDeductions/${p_id}/${invoice_id}/`, { state: { invoice_id, p_id, month, year, invoice_number } });
    };
    const ViewInvoice = (invoice_id, month, invoice_number, year) => {
        navigate(`/${urlParts[3]}/ConsultancyInvoice/${p_id}/${invoice_id}/`, { state: { invoice_id, p_id, month, year, invoice_number } });
    };
    const ViewPaymentReceipt = (invoice_id, month, invoice_number, year) => {
        navigate(`/${urlParts[3]}/PrintInvoice/${p_id}/${invoice_id}/`, { state: { invoice_id, p_id, month, year, invoice_number } });
    };
    // const handleExportToExcel = () => {
    //     const eotTotalFor = (i) =>
    //         allEotArrays.reduce((sum, eots) => sum + (Number(eots?.[i]?.total_amount) || 0), 0);

    //     const headerRow = {
    //         "S.No.": "S.No.",
    //         "Description": "Description",
    //         "Contract Amount": "Contract Amount",
    //     };
    //     eotColumns.forEach(i => { headerRow[`EOT ${i + 1} Amount`] = `EOT ${i + 1} Amount`; });
    //     headerRow["Cumulated Total of Preceding Months"] = "Cumulated Total of Preceding Months";
    //     headerRow["This Period"] = "This Period";
    //     headerRow["Cumulated Total Including Current Invoice"] = "Cumulated Total Including Current Invoice";
    //     headerRow["Remaining Amount Against Contract Value"] = "Remaining Amount Against Contract Value";

    //     const dataRows = summaryRows.map((row) => {
    //         const r = {
    //             "S.No.": row.sno,
    //             "Description": row.label,
    //             "Contract Amount": Number(row.contract) || 0,
    //         };
    //         eotColumns.forEach(i => {
    //             r[`EOT ${i + 1} Amount`] = Number(row.eots?.[i]?.total_amount) || 0;
    //         });
    //         r["Cumulated Total of Preceding Months"] = Number(row.previous) || 0;
    //         r["This Period"] = Number(row.current) || 0;
    //         r["Cumulated Total Including Current Invoice"] = Number(row.cumulated) || 0;
    //         r["Remaining Amount Against Contract Value"] = Number(row.remaining) || 0;
    //         return r;
    //     });

    //     const buildFooterRow = (label, contractVal, prevVal, curVal, cumVal, remVal, eotVals) => {
    //         const r = {
    //             "S.No.": "",
    //             "Description": label,
    //             "Contract Amount": contractVal,
    //         };
    //         eotColumns.forEach((i, idx) => {
    //             r[`EOT ${i + 1} Amount`] = eotVals ? eotVals[idx] : "";
    //         });
    //         r["Cumulated Total of Preceding Months"] = prevVal;
    //         r["This Period"] = curVal;
    //         r["Cumulated Total Including Current Invoice"] = cumVal;
    //         r["Remaining Amount Against Contract Value"] = remVal;
    //         return r;
    //     };

    //     const escFrac = Number(escalationPercent) / 100;

    //     const totalRow = buildFooterRow(
    //         "Total Cost (Excluding Tax)",
    //         totalContractAmount, totalPreviousAmount, totalCurrentAmount, totalCumulatedAmount, totalRemainingAmount,
    //         eotColumns.map(i => eotTotalFor(i))
    //     );

    //     const escalationRow = buildFooterRow(
    //         `ADD ESCALATION @${escalationPercent}%`,
    //         "", totalPreviousAmount * escFrac, totalCurrentAmount * escFrac, totalCumulatedAmount * escFrac, totalRemainingAmount * escFrac
    //     );

    //     const gstRow = buildFooterRow(
    //         "GST @ 18%",
    //         "", totalPreviousAmount * 0.18, totalCurrentAmount * 0.18, totalCumulatedAmount * 0.18, totalRemainingAmount * 0.18
    //     );

    //     const grandTotalRow = buildFooterRow(
    //         "TOTAL (INCLUDING ESCALATION & GST)",
    //         "",
    //         totalPreviousAmount + totalPreviousAmount * escFrac + totalPreviousAmount * 0.18,
    //         totalCurrentAmount + totalCurrentAmount * escFrac + totalCurrentAmount * 0.18,
    //         totalCumulatedAmount + totalCumulatedAmount * escFrac + totalCumulatedAmount * 0.18,
    //         totalRemainingAmount + totalRemainingAmount * escFrac + totalRemainingAmount * 0.18
    //     );

    //     const sheetData = [...dataRows, totalRow, escalationRow, gstRow, grandTotalRow];

    //     const worksheet = XLSX.utils.json_to_sheet(sheetData, { header: Object.keys(headerRow) });

    //     const colWidths = [
    //         { wch: 6 }, { wch: 35 }, { wch: 16 },
    //         ...eotColumns.map(() => ({ wch: 14 })),
    //         { wch: 22 }, { wch: 14 }, { wch: 24 }, { wch: 22 },
    //     ];
    //     worksheet['!cols'] = colWidths;

    //     const workbook = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(workbook, worksheet, "Summary of Invoice Raised");

    //     // ─── NEW: second sheet — Professional Staff ────────────────────────
    //     // ─── Second sheet — Professional Staff (matches on-screen table look) ───
    //     if (professionalStaffExcelRows?.rows?.length > 0) {
    //         const staffSheet = XLSX.utils.aoa_to_sheet(professionalStaffExcelRows.rows);
    //         staffSheet['!merges'] = professionalStaffExcelRows.merges;
    //         staffSheet['!cols'] = professionalStaffExcelRows.colWidths;
    //         XLSX.utils.book_append_sheet(workbook, staffSheet, professionalStaffExcelRows.sheetName || "Professional Staff");
    //     }
    //     if (transportationExcelRows?.rows?.length > 0) {
    //         const transportSheet = XLSX.utils.aoa_to_sheet(transportationExcelRows.rows);
    //         transportSheet['!merges'] = transportationExcelRows.merges;
    //         transportSheet['!cols'] = transportationExcelRows.colWidths;
    //         XLSX.utils.book_append_sheet(workbook, transportSheet, transportationExcelRows.sheetName || "Transportation");
    //     }
    //     // ─── NEW: fourth sheet — Duty Travel ────────────────────────────────
    //     if (dutyTravelExcelRows?.rows?.length > 0) {
    //         const dutySheet = XLSX.utils.aoa_to_sheet(dutyTravelExcelRows.rows);
    //         dutySheet['!merges'] = dutyTravelExcelRows.merges;
    //         dutySheet['!cols'] = dutyTravelExcelRows.colWidths;
    //         XLSX.utils.book_append_sheet(workbook, dutySheet, dutyTravelExcelRows.sheetName || "Duty Travel");
    //     }
    //     // ─── NEW: fifth sheet — Office Rent ─────────────────────────────────
    //     if (officeRentExcelRows?.rows?.length > 0) {
    //         const rentSheet = XLSX.utils.aoa_to_sheet(officeRentExcelRows.rows);
    //         rentSheet['!merges'] = officeRentExcelRows.merges;
    //         rentSheet['!cols'] = officeRentExcelRows.colWidths;
    //         XLSX.utils.book_append_sheet(workbook, rentSheet, officeRentExcelRows.sheetName || "Office Rent");
    //     }
    //     // ─── NEW: sixth sheet — Office Supplies ─────────────────────────────
    //     if (officeSuppliesExcelRows?.rows?.length > 0) {
    //         const suppliesSheet = XLSX.utils.aoa_to_sheet(officeSuppliesExcelRows.rows);
    //         suppliesSheet['!merges'] = officeSuppliesExcelRows.merges;
    //         suppliesSheet['!cols'] = officeSuppliesExcelRows.colWidths;
    //         XLSX.utils.book_append_sheet(workbook, suppliesSheet, officeSuppliesExcelRows.sheetName || "Office Supplies");
    //     }
    //     // ─── NEW: seventh sheet — Office Furniture ──────────────────────────
    //     if (officeFurnitureExcelRows?.rows?.length > 0) {
    //         const furnitureSheet = XLSX.utils.aoa_to_sheet(officeFurnitureExcelRows.rows);
    //         furnitureSheet['!merges'] = officeFurnitureExcelRows.merges;
    //         furnitureSheet['!cols'] = officeFurnitureExcelRows.colWidths;
    //         XLSX.utils.book_append_sheet(workbook, furnitureSheet, officeFurnitureExcelRows.sheetName || "Office Furniture");
    //     }
    //     // ─── NEW: eighth sheet — Reports & Printing ─────────────────────────
    //     if (reportsPrinttExcelRows?.rows?.length > 0) {
    //         const reportsSheet = XLSX.utils.aoa_to_sheet(reportsPrinttExcelRows.rows);
    //         reportsSheet['!merges'] = reportsPrinttExcelRows.merges;
    //         reportsSheet['!cols'] = reportsPrinttExcelRows.colWidths;
    //         XLSX.utils.book_append_sheet(workbook, reportsSheet, reportsPrinttExcelRows.sheetName || "Reports & Printing");
    //     }
    //     // ─── NEW: ninth sheet — Road Survey Equipment ───────────────────────
    //     if (roadSurveyExcelRows?.rows?.length > 0) {
    //         const roadSurveySheet = XLSX.utils.aoa_to_sheet(roadSurveyExcelRows.rows);
    //         roadSurveySheet['!merges'] = roadSurveyExcelRows.merges;
    //         roadSurveySheet['!cols'] = roadSurveyExcelRows.colWidths;
    //         XLSX.utils.book_append_sheet(workbook, roadSurveySheet, roadSurveyExcelRows.sheetName || "Road Survey Equipment");
    //     }
    //     // ─── NEW: tenth sheet — Contingencies ────────────────────────────────
    //     if (contingencyExcelRows?.rows?.length > 0) {
    //         const contingencySheet = XLSX.utils.aoa_to_sheet(contingencyExcelRows.rows);
    //         if (contingencyExcelRows.merges?.length) {
    //             contingencySheet['!merges'] = contingencyExcelRows.merges;
    //         }
    //         contingencySheet['!cols'] = contingencyExcelRows.colWidths;
    //         XLSX.utils.book_append_sheet(workbook, contingencySheet, contingencyExcelRows.sheetName || "Contingencies");
    //     }
    //     // ──────────────────────────────────────────────────────────────────
    //     const fileName = `Consultancy_Invoice_${invoice_num || ''}_${getMonthName(month)}_${year}.xlsx`;
    //     XLSX.writeFile(workbook, fileName);
    // };

    const handleExportToExcel = () => {
        const eotTotalFor = (i) =>
            allEotArrays.reduce((sum, eots) => sum + (Number(eots?.[i]?.total_amount) || 0), 0);

        const headerRow = {
            "S.No.": "S.No.",
            "Description": "Description",
            "Contract Amount": "Contract Amount",
        };
        eotColumns.forEach(i => { headerRow[`EOT ${i + 1} Amount`] = `EOT ${i + 1} Amount`; });
        headerRow["Cumulated Total of Preceding Months"] = "Cumulated Total of Preceding Months";
        headerRow["This Period"] = "This Period";
        headerRow["Cumulated Total Including Current Invoice"] = "Cumulated Total Including Current Invoice";
        headerRow["Remaining Amount Against Contract Value"] = "Remaining Amount Against Contract Value";

        const dataRows = summaryRows.map((row) => {
            const r = {
                "S.No.": row.sno,
                "Description": row.label,
                "Contract Amount": Number(row.contract) || 0,
            };
            eotColumns.forEach(i => {
                r[`EOT ${i + 1} Amount`] = Number(row.eots?.[i]?.total_amount) || 0;
            });
            r["Cumulated Total of Preceding Months"] = Number(row.previous) || 0;
            r["This Period"] = Number(row.current) || 0;
            r["Cumulated Total Including Current Invoice"] = Number(row.cumulated) || 0;
            r["Remaining Amount Against Contract Value"] = Number(row.remaining) || 0;
            return r;
        });

        const buildFooterRow = (label, contractVal, prevVal, curVal, cumVal, remVal, eotVals) => {
            const r = {
                "S.No.": "",
                "Description": label,
                "Contract Amount": contractVal,
            };
            eotColumns.forEach((i, idx) => {
                r[`EOT ${i + 1} Amount`] = eotVals ? eotVals[idx] : "";
            });
            r["Cumulated Total of Preceding Months"] = prevVal;
            r["This Period"] = curVal;
            r["Cumulated Total Including Current Invoice"] = cumVal;
            r["Remaining Amount Against Contract Value"] = remVal;
            return r;
        };

        const escFrac = Number(escalationPercent) / 100;

        const totalRow = buildFooterRow(
            "Total Cost (Excluding Tax)",
            totalContractAmount, totalPreviousAmount, totalCurrentAmount, totalCumulatedAmount, totalRemainingAmount,
            eotColumns.map(i => eotTotalFor(i))
        );

        const escalationRow = buildFooterRow(
            `ADD ESCALATION @${escalationPercent}%`,
            "", totalPreviousAmount * escFrac, totalCurrentAmount * escFrac, totalCumulatedAmount * escFrac, totalRemainingAmount * escFrac
        );

        const gstRow = buildFooterRow(
            "GST @ 18%",
            "", totalPreviousAmount * 0.18, totalCurrentAmount * 0.18, totalCumulatedAmount * 0.18, totalRemainingAmount * 0.18
        );

        const grandTotalRow = buildFooterRow(
            "TOTAL (INCLUDING ESCALATION & GST)",
            "",
            totalPreviousAmount + totalPreviousAmount * escFrac + totalPreviousAmount * 0.18,
            totalCurrentAmount + totalCurrentAmount * escFrac + totalCurrentAmount * 0.18,
            totalCumulatedAmount + totalCumulatedAmount * escFrac + totalCumulatedAmount * 0.18,
            totalRemainingAmount + totalRemainingAmount * escFrac + totalRemainingAmount * 0.18
        );

        const sheetData = [...dataRows, totalRow, escalationRow, gstRow, grandTotalRow];

        const workbook = XLSX.utils.book_new();

        // ─── Sheet 1 — Summary of Invoice Raised (built as AOA so we can add a title row) ───
        const summaryHeaderKeys = Object.keys(headerRow);
        const summaryTitleRow = new Array(summaryHeaderKeys.length).fill("");
        summaryTitleRow[0] = "Summary of Invoice Raised";

        const summaryAOA = [
            summaryTitleRow,
            summaryHeaderKeys,
            ...sheetData.map(r => summaryHeaderKeys.map(k => r[k]))
        ];

        const summaryWorksheet = XLSX.utils.aoa_to_sheet(summaryAOA);
        summaryWorksheet['!merges'] = [
            { s: { r: 0, c: 0 }, e: { r: 0, c: summaryHeaderKeys.length - 1 } }
        ];
        summaryWorksheet['!cols'] = [
            { wch: 6 }, { wch: 35 }, { wch: 16 },
            ...eotColumns.map(() => ({ wch: 14 })),
            { wch: 22 }, { wch: 14 }, { wch: 24 }, { wch: 22 },
        ];
        applyTitleStyle(summaryWorksheet, 'A1');
        XLSX.utils.book_append_sheet(workbook, summaryWorksheet, "Summary of Invoice Raised");

        // ─── Helper to append a titled sheet built from a child component's { rows, merges, colWidths } ───
        const appendTitledSheet = (excelRows, title, fallbackSheetName) => {
            if (!excelRows?.rows?.length) return;
            const totalCols = excelRows.colWidths?.length || excelRows.rows[0].length;
            const { rows, merges } = addSheetTitle(excelRows.rows, excelRows.merges, title, totalCols);
            const sheet = XLSX.utils.aoa_to_sheet(rows);
            sheet['!merges'] = merges;
            sheet['!cols'] = excelRows.colWidths;
            applyTitleStyle(sheet, 'A1');
            XLSX.utils.book_append_sheet(workbook, sheet, excelRows.sheetName || fallbackSheetName);
        };

        appendTitledSheet(professionalStaffExcelRows, "Professional Staff Invoice", "Professional Staff");
        appendTitledSheet(transportationExcelRows, "Transportation Invoice", "Transportation");
        appendTitledSheet(dutyTravelExcelRows, "Duty Travel Invoice", "Duty Travel");
        appendTitledSheet(officeRentExcelRows, "Office Rent Invoice", "Office Rent");
        appendTitledSheet(officeSuppliesExcelRows, "Office Supplies Invoice", "Office Supplies");
        appendTitledSheet(officeFurnitureExcelRows, "Office Furniture Invoice", "Office Furniture");
        appendTitledSheet(reportsPrinttExcelRows, "Reports & Printing Invoice", "Reports & Printing");
        appendTitledSheet(roadSurveyExcelRows, "Road Survey Equipment Invoice", "Road Survey Equipment");
        appendTitledSheet(contingencyExcelRows, "Contingencies Invoice", "Contingencies");

        const fileName = `Consultancy_Invoice_${invoice_num || ''}_${getMonthName(month)}_${year}.xlsx`;
        XLSX.writeFile(workbook, fileName);
    };

    return (
        <div className='printSlip-container' ref={ref}>
            <div className="boc-modern-wrapper" style={{ minHeight: "90vh" }}>
                <div className="boc-modern-card">

                    {/* Print header */}
                    <div className="boc-modern-header bocx-modern-footer-total show-on-print">
                        <div className="boc-modern-header-content">
                            <div className="boc-modern-project-info">
                                <h3 className="boc-modern-project-title">{projectbyid?.project_name}</h3>
                                <div className="boc-modern-project-meta">
                                    <div className="boc-modern-meta-item">
                                        <span className="boc-modern-meta-label">Client Name:</span>
                                        <span className="boc-modern-meta-value">{projectbyid?.client_name}</span>
                                    </div>
                                    <div className="boc-modern-meta-divider"></div>
                                    <div className="boc-modern-meta-item">
                                        <span className="boc-modern-meta-label">Consultant (AE):</span>
                                        <span className="boc-modern-meta-value">
                                            {projectbyid?.lead}
                                            {projectbyid?.jv ? ` JV with ${projectbyid?.jv}.` : ""}
                                            {projectbyid?.association ? ` Association with ${projectbyid?.association}` : ""}
                                        </span>
                                    </div>
                                    <div className="boc-modern-meta-divider"></div>
                                    <div className="boc-modern-meta-item">
                                        <span className="boc-modern-meta-label">GSTIN:</span>
                                        <span className="boc-modern-meta-value">{projectbyid?.gst_no}</span>
                                    </div>
                                    <div className="boc-modern-meta-divider"></div>
                                    <div className="boc-modern-meta-item">
                                        <span className="boc-modern-meta-label">PAN:</span>
                                        <span className="boc-modern-meta-value">{projectbyid?.pan_no}</span>
                                    </div>
                                    <div className="boc-modern-meta-divider"></div>
                                    <div className="boc-modern-meta-item">
                                        <span className="boc-modern-meta-label">Bid Due:</span>
                                        <span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectbyid?.bid_due_date)}</span>
                                    </div>
                                    <div className="boc-modern-meta-divider"></div>
                                    <div className="boc-modern-meta-item">
                                        <span className="boc-modern-meta-label">Agreement Date:</span>
                                        <span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectbyid?.agreement_date)}</span>
                                    </div>
                                    <div className="boc-modern-meta-divider"></div>
                                    <div className="boc-modern-meta-item">
                                        <span className="boc-modern-meta-label">Project Start Date:</span>
                                        <span className="boc-modern-meta-value">{formatDateDD_MM_YYYY(projectbyid?.commencement_date)}</span>
                                    </div>
                                    <div className="boc-modern-meta-divider"></div>
                                    <div className="boc-modern-meta-item">
                                        <span className="boc-modern-meta-label">Date:</span>
                                        <span className="boc-modern-meta-value">{getMonthName(month)}-{year}</span>
                                    </div>
                                    <div className="boc-modern-meta-divider"></div>
                                    <div className="boc-modern-meta-item">
                                        <span className="boc-modern-meta-label">Invoice Number:</span>
                                        <span className="boc-modern-meta-value">{invoice_num}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Section heading */}
                    <div className="boc-modern-description-section">
                        <div className="boc-modern-controls">
                            <div className="boc-modern-controls-left" style={{ display: "flex ", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
                                <h6 className="boc-modern-main-heading">Final Summary Of Consultant Invoice</h6>
                                {usefor === "generateinvoice" && (
                                    <div className='form-field'>

                                        <button
                                            className="model-delete-button-modern actionn-icon" style={{ backgroundColor: "#00000075", borderRadius: "10px", display: "flex", alignItems: "center", gap: "5px", padding: "10px" }}
                                            onClick={() => ViewInvoiceDeduction(invoice_id, month, invoice_num, year)}
                                            title="View Invoice Deduction Details"
                                        >
                                            <FileText size={18} color="#fff" /><label style={{ color: "white" }}>View Deduction Invoice</label>

                                        </button>
                                        <button
                                            className="model-delete-button-modern actionn-icon"
                                            style={{ backgroundColor: "#1e7e34", borderRadius: "10px", display: "flex", alignItems: "center", gap: "5px", padding: "10px" }}
                                            onClick={handleExportToExcel}
                                            title="Download Excel"
                                        >
                                            <FileText size={18} color="#fff" /><label style={{ color: "white" }}>Download Excel</label>
                                        </button>
                                    </div>
                                )}
                                {usefor !== "generateinvoice" && (
                                    <div
                                        className="form-field"
                                        style={{ display: "flex", gap: "10px", flexWrap: "wrap", flexDirection: "row", }}
                                    >
                                        <button
                                            className="model-delete-button-modern actionn-icon"
                                            style={{ backgroundColor: "#1e7e34", borderRadius: "10px", display: "flex", alignItems: "center", gap: "5px", padding: "10px" }}
                                            onClick={handleExportToExcel}
                                            title="Download Excel"
                                        >
                                            <FileText size={18} color="#fff" /><label style={{ color: "white" }}>Download Excel</label>
                                        </button>

                                        <button
                                            className="model-delete-button-modern actionn-icon" style={{ backgroundColor: "#00000075", borderRadius: "10px", display: "flex", alignItems: "center", gap: "5px", padding: "10px" }}
                                            onClick={() => ViewInvoice(invoice_id, month, invoice_num, year)}
                                            title="View Invoice Details"
                                        >
                                            <FileText size={18} color="#fff" /><label style={{ color: "white" }}>View Raised Invoice</label>

                                        </button>
                                        <button
                                            className="model-delete-button-modern actionn-icon" style={{ backgroundColor: "#00000075", borderRadius: "10px", display: "flex", alignItems: "center", gap: "5px", padding: "10px" }}
                                            onClick={() => ViewPaymentReceipt(invoice_id, month, invoice_num, year)}
                                            title="View Payment Receipt"
                                        >
                                            <FileText size={18} color="#fff" /><label style={{ color: "white" }}>View Payment Receipt</label>

                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* Table */}
                    <div className="boc-modern-table-wrapper">
                        <div className="boc-modern-table-scroll">
                            <table className="boc-modern-table">
                                <thead>
                                    <tr className="boc-modern-table-header">
                                        <th className="boc-modern-th text-center">S.No.</th>
                                        <th className="boc-modern-th text-center">Description</th>
                                        <th className="boc-modern-th text-center boc-nowrap">Contract Amount</th>
                                        {eotColumns.map(i => (
                                            <th key={i} className="boc-modern-th text-center boc-nowrap">EOT {i + 1} Amount</th>
                                        ))}
                                        <th className="boc-modern-th text-center boc-nowrap">Cumulated Total of Preceding Months</th>
                                        <th className="boc-modern-th text-center boc-nowrap">This Period</th>
                                        <th className="boc-modern-th text-center boc-nowrap">Cumulated Total Including Current Invoice</th>
                                        <th className="boc-modern-th text-center boc-nowrap">Remaining Amount Against Contract Value</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {summaryRows.map((row) => (
                                        <tr className="boc-modern-row" key={row.sno}>
                                            <td className="boc-modern-td text-center">{row.sno}.</td>
                                            <td className="boc-modern-td">{row.label}</td>
                                            <td className="boc-modern-td boc-nowrap text-right">
                                                <span className="boc-modern-currency boc-modern-total-highlight">
                                                    ₹{formatCurrencyIndian(row.contract)}
                                                </span>
                                            </td>
                                            {eotColumns.map(i => (
                                                <td key={i} className="boc-modern-td boc-nowrap text-right">
                                                    <span className="boc-modern-currency">
                                                        ₹{formatCurrencyIndian(row.eots?.[i]?.total_amount || 0)}
                                                    </span>
                                                </td>
                                            ))}
                                            <td className="boc-modern-td boc-nowrap text-right">
                                                <span className="boc-modern-currency">
                                                    ₹{formatCurrencyIndian(row.previous)}
                                                </span>
                                            </td>
                                            <td className="boc-modern-td boc-nowrap text-right">
                                                <span className="boc-modern-currency">
                                                    ₹{formatCurrencyIndian(row.current)}
                                                </span>
                                            </td>
                                            <td className="boc-modern-td boc-nowrap text-right">
                                                <span className="boc-modern-currency">
                                                    ₹{formatCurrencyIndian(row.cumulated)}
                                                </span>
                                            </td>
                                            <td className="boc-modern-td boc-nowrap text-right">
                                                <span className="boc-modern-currency boc-modern-total-highlight">
                                                    ₹{formatCurrencyIndian(row.remaining)}
                                                </span>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                                <tfoot>
                                    <tr className="boc-modern-footer">
                                        <td colSpan={2} className="boc-modern-footer-label">Total Cost(Excluding Tax)</td>
                                        <td className="boc-modern-td boc-nowrap text-right">
                                            <span className="boc-modern-currency boc-modern-footer-total">
                                                ₹{formatCurrencyIndian(totalContractAmount)}
                                            </span>
                                        </td>
                                        {eotColumns.map(i => (
                                            <td key={i} className="boc-modern-td boc-nowrap text-right">
                                                <span className="boc-modern-currency boc-modern-footer-total">
                                                    ₹{formatCurrencyIndian(
                                                        allEotArrays.reduce((sum, eots) =>
                                                            sum + (Number(eots?.[i]?.total_amount) || 0), 0)
                                                    )}
                                                </span>
                                            </td>
                                        ))}
                                        <td className="boc-modern-td boc-nowrap text-right">
                                            <span className="boc-modern-currency boc-modern-footer-total">
                                                ₹{formatCurrencyIndian(totalPreviousAmount)}
                                            </span>
                                        </td>
                                        <td className="boc-modern-td boc-nowrap text-right">
                                            <span className="boc-modern-currency boc-modern-footer-total">
                                                ₹{formatCurrencyIndian(totalCurrentAmount)}
                                            </span>
                                        </td>
                                        <td className="boc-modern-td boc-nowrap text-right">
                                            <span className="boc-modern-currency boc-modern-footer-total">
                                                ₹{formatCurrencyIndian(totalCumulatedAmount)}
                                            </span>
                                        </td>
                                        <td className="boc-modern-td boc-nowrap text-right">
                                            <span className="boc-modern-currency boc-modern-footer-total">
                                                ₹{formatCurrencyIndian(totalRemainingAmount)}
                                            </span>
                                        </td>
                                    </tr>
                                    <tr className="boc-modern-footer">
                                        <td colSpan={2} className="boc-modern-footer-label">ADD ESCATION @{escalationPercent}%</td>
                                        <td className="boc-modern-td boc-nowrap text-right">

                                        </td>
                                        {eotColumns.map(i => (
                                            <td key={i} className="boc-modern-td boc-nowrap text-right">

                                            </td>
                                        ))}
                                        <td className="boc-modern-td boc-nowrap text-right">
                                            <span className="boc-modern-currency boc-modern-footer-total">
                                                ₹{formatCurrencyIndian(Number(totalPreviousAmount) * (Number(escalationPercent) / 100))}
                                            </span>
                                        </td>
                                        <td className="boc-modern-td boc-nowrap text-right">
                                            <span className="boc-modern-currency boc-modern-footer-total">
                                                ₹{formatCurrencyIndian(totalCurrentAmount * (Number(escalationPercent) / 100))}
                                            </span>
                                        </td>
                                        <td className="boc-modern-td boc-nowrap text-right">
                                            <span className="boc-modern-currency boc-modern-footer-total">
                                                ₹{formatCurrencyIndian(totalCumulatedAmount * (Number(escalationPercent) / 100))}
                                            </span>
                                        </td>
                                        <td className="boc-modern-td boc-nowrap text-right">
                                            <span className="boc-modern-currency boc-modern-footer-total">
                                                ₹{formatCurrencyIndian(totalRemainingAmount * (Number(escalationPercent) / 100))}
                                            </span>
                                        </td>
                                    </tr>
                                    <tr className="boc-modern-footer">
                                        <td colSpan={2} className="boc-modern-footer-label">GST @ 18%</td>
                                        <td className="boc-modern-td boc-nowrap text-right">

                                        </td>
                                        {eotColumns.map(i => (
                                            <td key={i} className="boc-modern-td boc-nowrap text-right">

                                            </td>
                                        ))}
                                        <td className="boc-modern-td boc-nowrap text-right">
                                            <span className="boc-modern-currency boc-modern-footer-total">
                                                ₹{formatCurrencyIndian(Number(totalPreviousAmount) * 0.18)}
                                            </span>
                                        </td>
                                        <td className="boc-modern-td boc-nowrap text-right">
                                            <span className="boc-modern-currency boc-modern-footer-total">
                                                ₹{formatCurrencyIndian(totalCurrentAmount * 0.18)}
                                            </span>
                                        </td>
                                        <td className="boc-modern-td boc-nowrap text-right">
                                            <span className="boc-modern-currency boc-modern-footer-total">
                                                ₹{formatCurrencyIndian(totalCumulatedAmount * 0.18)}
                                            </span>
                                        </td>
                                        <td className="boc-modern-td boc-nowrap text-right">
                                            <span className="boc-modern-currency boc-modern-footer-total">
                                                ₹{formatCurrencyIndian(totalRemainingAmount * 0.18)}
                                            </span>
                                        </td>
                                    </tr>
                                    <tr className="boc-modern-footer">
                                        <td colSpan={2} className="boc-modern-footer-label">TOTAL (INCLUDING ESCALATION & GST)</td>
                                        <td className="boc-modern-td boc-nowrap text-right">

                                        </td>
                                        {eotColumns.map(i => (
                                            <td key={i} className="boc-modern-td boc-nowrap text-right">

                                            </td>
                                        ))}
                                        <td className="boc-modern-td boc-nowrap text-right">
                                            <span className="boc-modern-currency boc-modern-footer-total">
                                                ₹{formatCurrencyIndian(
                                                    Number(totalPreviousAmount) +
                                                    Number(totalPreviousAmount) * (Number(escalationPercent) / 100) +
                                                    Number(totalPreviousAmount) * 0.18
                                                )}
                                            </span>
                                        </td>
                                        <td className="boc-modern-td boc-nowrap text-right">
                                            <span className="boc-modern-currency boc-modern-footer-total">
                                                ₹{formatCurrencyIndian(
                                                    totalCurrentAmount +
                                                    totalCurrentAmount * (Number(escalationPercent) / 100) +
                                                    totalCurrentAmount * 0.18
                                                )}
                                            </span>
                                        </td>
                                        <td className="boc-modern-td boc-nowrap text-right">
                                            <span className="boc-modern-currency boc-modern-footer-total">
                                                ₹{formatCurrencyIndian(
                                                    totalCumulatedAmount +
                                                    totalCumulatedAmount * (Number(escalationPercent) / 100) +
                                                    totalCumulatedAmount * 0.18
                                                )}
                                            </span>
                                        </td>
                                        <td className="boc-modern-td boc-nowrap text-right">
                                            <span className="boc-modern-currency boc-modern-footer-total">
                                                ₹{formatCurrencyIndian(
                                                    totalRemainingAmount +
                                                    totalRemainingAmount * (Number(escalationPercent) / 100) +
                                                    totalRemainingAmount * 0.18
                                                )}
                                            </span>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>

                </div>
            </div>

            <ProfessionalStaff
                p_id={p_id} deductionData={deductionList} projectData={projectbyid}
                invoice_id={invoice_id} month={month} year={year} invoice_num={invoice_num}
                getLogData={getLogData} logData={filterBOQEmployeeeLogChange}
                setContractAmount={setEmployeeContractAmount} setPreviousAmount={setEmployeePreviousAmount}
                setCurrentAmount={setEmployeecurrentAmount} setRemainingAmount={setEmployeeremainingAmount}
                setCumulated={setEmployeecumulatedAmount} setEotDetails={setEmployeeEotDetails}
                usefor={usefor}
                setExcelRows={setProfessionalStaffExcelRows}
            />
            <Transportation
                p_id={p_id} deductionData={deductionList} projectData={projectbyid}
                client={project.client_name} invoice_id={invoice_id} month={month} year={year} invoice_num={invoice_num}
                getLogData={getLogData} logData={filterBOQTransportationLogChange}
                setContractAmount={settransportContractAmount} setPreviousAmount={settransportPreviousAmount}
                setCurrentAmount={settransportcurrentAmount} setRemainingAmount={settransportremainingAmount}
                setCumulated={settransportcumulatedAmount} setEotDetails={setTransportEotDetails}
                usefor={usefor}
                setExcelRows={setTransportationExcelRows}

            />
            <DutyTravel
                p_id={p_id} deductionData={deductionList} projectData={projectbyid}
                client={project.client_name} invoice_id={invoice_id} month={month} year={year} invoice_num={invoice_num}
                getLogData={getLogData} logData={filterBOQDutyTravelLogChange}
                setContractAmount={setDutyContractAmount} setPreviousAmount={setdutyPreviousAmount}
                setCurrentAmount={setdutycurrentAmount} setRemainingAmount={setdutyremainingAmount}
                setCumulated={setdutycumulatedAmount} setEotDetails={setDutyEotDetails}
                usefor={usefor}
                setExcelRows={setDutyTravelExcelRows}
            />
            <OfficeRent
                p_id={p_id} deductionData={deductionList} projectData={projectbyid}
                client={project.client_name} invoice_id={invoice_id} month={month} year={year} invoice_num={invoice_num}
                logData={filterBOQOfficeRentLogChange}
                setContractAmount={setofficeRentContractAmount} setPreviousAmount={setofficeRentPreviousAmount}
                setCurrentAmount={setofficeRentcurrentAmount} setRemainingAmount={setofficeRentremainingAmount}
                setCumulated={setofficeRentcumulatedAmount} setEotDetails={setOfficeRentEotDetails}
                usefor={usefor}
                setExcelRows={setOfficeRentExcelRows}
            />
            <OfficeSupplies
                p_id={p_id} deductionData={deductionList} projectData={projectbyid}
                client={project.client_name} invoice_id={invoice_id} month={month} year={year} invoice_num={invoice_num}
                logData={filterBOQOfficeSuppliesLogChange}
                setContractAmount={setofficeSuppliesContractAmount} setPreviousAmount={setofficeSuppliesPreviousAmount}
                setCurrentAmount={setofficeSuppliescurrentAmount} setRemainingAmount={setofficeSuppliesremainingAmount}
                setCumulated={setofficeSuppliescumulatedAmount} setEotDetails={setOfficeSuppliesEotDetails}
                usefor={usefor}
                setExcelRows={setOfficeSuppliesExcelRows}

            />
            <OfficeFurniture
                p_id={p_id} deductionData={deductionList} projectData={projectbyid}
                client={project.client_name} invoice_id={invoice_id} month={month} year={year} invoice_num={invoice_num}
                logData={filterBOQOfficeFurnitureAndEquipmentLogChange}
                setContractAmount={setofficeFurnitureContractAmount} setPreviousAmount={setofficeFurniturePreviousAmount}
                setCurrentAmount={setofficeFurniturecurrentAmount} setRemainingAmount={setofficeFurnitureremainingAmount}
                setCumulated={setofficeFurniturecumulatedAmount} setEotDetails={setOfficeFurnitureEotDetails}
                usefor={usefor}
                setExcelRows={setOfficeFurnitureExcelRows}

            />
            <ReportsPrintt
                p_id={p_id} deductionData={deductionList} projectData={projectbyid}
                client={project.client_name} invoice_id={invoice_id} month={month} year={year} invoice_num={invoice_num}
                logData={filterBOQReportsAndDocumentPrintingLogChange}
                setContractAmount={setofficeReportsContractAmount} setPreviousAmount={setofficeReportsPreviousAmount}
                setCurrentAmount={setofficeReportscurrentAmount} setRemainingAmount={setofficeReportsremainingAmount}
                setCumulated={setofficeReportscumulatedAmount} setEotDetails={setOfficeReportsEotDetails}
                usefor={usefor}
                setExcelRows={setReportsPrinttExcelRows}

            />
            <RoadSurvey
                p_id={p_id} deductionData={deductionList} projectData={projectbyid}
                client={project.client_name} invoice_id={invoice_id} month={month} year={year} invoice_num={invoice_num}
                logData={filterBOQRoadSurveyEquipmentLogChange}
                setContractAmount={setofficeRoadSurveyContractAmount} setPreviousAmount={setofficeRoadSurveyPreviousAmount}
                setCurrentAmount={setofficeRoadSurveycurrentAmount} setRemainingAmount={setofficeRoadSurveyremainingAmount}
                setCumulated={setofficeRoadSurveycumulatedAmount} setEotDetails={setOfficeRoadSurveyEotDetails}
                usefor={usefor}
                setExcelRows={setRoadSurveyExcelRows}

            />
            <ConsultancyInvoiceContingency
                p_id={p_id} deductionData={deductionList} projectData={projectbyid}
                setExcelRows={setContingencyExcelRows}

                client={project.client_name} invoice_id={invoice_id} month={month} year={year} invoice_num={invoice_num}
            />
        </div>
    );
});

const ConsultancyInvoice = (i) => {
    const ref = useRef();
    const { projectid, invoiceid } = useParams();
    const [isPrinting, setIsPrinting] = useState(false);

    const handleBeforePrint = () => {
        setIsPrinting(true);
    };

    const handleAfterPrint = () => {
        setIsPrinting(false);
    };


    return (

        // <div className='flex-column flex-center  slip-container'>
        <div className=''>
            {/* <div className='printSlip-width flex-row justify-evenly button-margin'>
                < ReactToPrint
                    bodyClass="print-agreement"
                    content={() => ref.current}
                    onBeforeGetContent={handleBeforePrint}
                    onAfterPrint={handleAfterPrint}
                    trigger={() => (
                        <button className="model-button model-button-black">
                            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 20 18" fill="none">
                                <path d="M17 5H3C1.34 5 0 6.34 0 8V12C0 13.1 0.9 14 2 14H4V16C4 17.1 4.9 18 6 18H14C15.1 18 16 17.1 16 16V14H18C19.1 14 20 13.1 20 12V8C20 6.34 18.66 5 17 5ZM13 16H7C6.45 16 6 15.55 6 15V11H14V15C14 15.55 13.55 16 13 16ZM17 9C16.45 9 16 8.55 16 8C16 7.45 16.45 7 17 7C17.55 7 18 7.45 18 8C18 8.55 17.55 9 17 9ZM15 0H5C4.45 0 4 0.45 4 1V3C4 3.55 4.45 4 5 4H15C15.55 4 16 3.55 16 3V1C16 0.45 15.55 0 15 0Z" fill="white" />
                            </svg> Print
                        </button>
                    )}
                />
            </div > */}
            <ConsultancyInvoiceFormat ref={ref} isPrinting={isPrinting} project_id={projectid} usefor="generateinvoice" />
        </div >
    );
}
const ConsultancyDeduction = (i) => {
    const ref = useRef();
    const { projectid, invoiceid } = useParams();
    const [isPrinting, setIsPrinting] = useState(false);

    const handleBeforePrint = () => {
        setIsPrinting(true);
    };

    const handleAfterPrint = () => {
        setIsPrinting(false);
    };


    return (

        // <div className='flex-column flex-center  slip-container'>
        <div className=''>
            {/* <div className='printSlip-width flex-row justify-evenly button-margin'>
                < ReactToPrint
                    bodyClass="print-agreement"
                    content={() => ref.current}
                    onBeforeGetContent={handleBeforePrint}
                    onAfterPrint={handleAfterPrint}
                    trigger={() => (
                        <button className="model-button model-button-black">
                            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 20 18" fill="none">
                                <path d="M17 5H3C1.34 5 0 6.34 0 8V12C0 13.1 0.9 14 2 14H4V16C4 17.1 4.9 18 6 18H14C15.1 18 16 17.1 16 16V14H18C19.1 14 20 13.1 20 12V8C20 6.34 18.66 5 17 5ZM13 16H7C6.45 16 6 15.55 6 15V11H14V15C14 15.55 13.55 16 13 16ZM17 9C16.45 9 16 8.55 16 8C16 7.45 16.45 7 17 7C17.55 7 18 7.45 18 8C18 8.55 17.55 9 17 9ZM15 0H5C4.45 0 4 0.45 4 1V3C4 3.55 4.45 4 5 4H15C15.55 4 16 3.55 16 3V1C16 0.45 15.55 0 15 0Z" fill="white" />
                            </svg> Print
                        </button>
                    )}
                />
            </div > */}
            <ConsultancyInvoiceFormat ref={ref} isPrinting={isPrinting} project_id={projectid} />
        </div >
    );
}
const PrintPayment = (i) => {
    const ref = useRef();
    const [isPrinting, setIsPrinting] = useState(false);

    const handleBeforePrint = () => {
        setIsPrinting(true);
    };

    const handleAfterPrint = () => {
        setIsPrinting(false);
    };


    return (
        // <div>
        // <div>
        <div className='flex-column flex-center  slip-container'>
            <div className='printSlip-width flex-row justify-evenly button-margin'>
                {/* <button className="model-button  font-weight500    model-button-cancel font-size-heading" onClick={(e) => { backroute(firsttoggle, secondtoggle, accfirsttoggle) }}>Back</button> */}
                <ReactToPrint
                    bodyClass="print-agreement"
                    content={() => ref.current}
                    onBeforeGetContent={handleBeforePrint}
                    onAfterPrint={handleAfterPrint}
                    trigger={() => (
                        <button className="model-button model-button-black">
                            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 20 18" fill="none">
                                <path d="M17 5H3C1.34 5 0 6.34 0 8V12C0 13.1 0.9 14 2 14H4V16C4 17.1 4.9 18 6 18H14C15.1 18 16 17.1 16 16V14H18C19.1 14 20 13.1 20 12V8C20 6.34 18.66 5 17 5ZM13 16H7C6.45 16 6 15.55 6 15V11H14V15C14 15.55 13.55 16 13 16ZM17 9C16.45 9 16 8.55 16 8C16 7.45 16.45 7 17 7C17.55 7 18 7.45 18 8C18 8.55 17.55 9 17 9ZM15 0H5C4.45 0 4 0.45 4 1V3C4 3.55 4.45 4 5 4H15C15.55 4 16 3.55 16 3V1C16 0.45 15.55 0 15 0Z" fill="white" />
                            </svg>Print
                        </button>
                    )}
                />
            </div>
            <PrintPaymentInvoiceFormat ref={ref} isPrinting={isPrinting} />
        </div>
    );
}




export { ConsultancyInvoice, PrintPayment, ConsultancyDeduction, ConsultancyInvoiceFormat }
